import {Link} from "react-router";
import corporateTripsImg from "../../../assets/services/campbelltown-corporate-trips.jpeg";
import {allLocationsData2} from "./AllLocationData2";
export const allLocationsData = {
  "campbelltown-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26441.60751525321!2d150.8048336!3d-34.06436289999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ee5195038d7f%3A0x5017d681632af40!2sCampbelltown%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769792355520!5m2!1sen!2sbd",
    pageTitle: "24/7 Campbelltown Taxi & Maxi Cabs for Fast Pickups",
    metaDescription:
      "Reliable Campbelltown Taxi & Maxi Cabs – 24/7 local taxi service, Maxi Cabs, baby seats, and corporate rides. Call or book online for safe, comfortable transport.",
    heroTitle: "24/7 Campbelltown Taxi and Maxi Cabs for Fast Pickups",
    heroDescription: (
      <>
        When you need{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Campbelltown Taxi & Maxi Cabs,
        </Link>{" "}
        services, you want a ride that is fast, safe, and dependable. Many
        locals deal with long delays, last‑minute cancellations, or vehicles
        that are too small for their group or luggage. With our Campbelltown
        taxi and cab service, those issues are taken care of. Our fleet includes
        maxi cabs, SUVs, and standard taxis, so every passenger enjoys a
        comfortable journey. Whether you search for a taxi near you or a local
        taxi service in Campbelltown, we are available 24/7 for your trips.
        Families, students, shift workers, and business travellers regularly use
        us for airport transfers, medical visits, local trips, and group travel.
        Our experienced drivers know the Campbelltown area well, which helps
        keep every ride on time and stress‑free. With our premium vehicles and
        simple booking options, you always have a reliable ride when you need
        it.
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi Service in Campbelltown NSW",
    locationSectionTitle:
      "Reliable Corporate Taxi Services Across Campbelltown & Surrounding Areas",
    locationSectionDescription: (
      <>
        For professional and organized transport, our Campbelltown Taxi & Maxi
        Cabs team offers smooth corporate travel across Campbelltown and the
        wider Macarthur region. Businesses often struggle with late airport
        pickups, complicated inter‑office travel, or moving groups to meetings
        and events. Our corporate taxi and maxi cab services are designed to fix
        those problems. Only executives and larger teams can quickly book a taxi
        near them for efficient, stress‑free travel. Every vehicle is clean,
        well‑maintained, and set up for comfort. Our professional drivers focus
        on punctuality, safety, and a calm ride, which is why many local
        businesses choose us regularly. You can arrange airport transfers,
        office‑to‑office trips, and special corporate events without worrying
        about delays. With our Campbelltown taxi service, your staff arrive on
        time, and your corporate image remains strong.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Campbelltown NSW",
    serviceSubtitle: (
      <>
        Campbelltown Taxi & Maxi Cabs is a trusted local transport option for a
        safe, punctual ride. Whether you are going to work, catching a flight,
        or attending an event, our drivers provide comfortable, reliable, and
        hassle‑free journeys. We understand peak‑hour traffic, group travel, and
        luggage‑heavy trips. Our modern vehicles and strong local knowledge help
        you avoid long waits and cancelled bookings. You can book online or by
        phone with clear, upfront pricing. Choose our{" "}
        <a
          target="_blank"
          href={`https://www.transport.nsw.gov.au/operations/point-to-point-transport/`}
          className="underline font-semibold px-1"
        >
          Campbelltown taxi
        </a>
        service for daily commutes, airport transfers, family trips, or business
        travel.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel worry-free on your special day. Our
            <strong>Campbelltown taxi and cab services</strong> offer
            professional drivers, timely pickups, and luggage assistance. We
            ensure all guests arrive safely and on time. Book via our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Arrive in style for airport trips, VIP events, or corporate travel.
            Our <strong>Campbelltown taxi and cab services</strong> guarantees
            comfort, privacy, and punctuality. Learn more at{" "}
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Travel safely with your child. Our taxis include adjustable baby
            seats for school runs, medical visits, and family outings. Our{" "}
            <strong>Campbelltown taxi and cab services</strong> ensures secure
            and convenient rides. Visit
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Reliable and professional transport for office staff, meetings, and
            business trips. Our
            <strong>local taxi service Campbelltown </strong> provides punctual
            service, safe vehicles, and smooth journeys. Check corporate
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your cruise without travel stress. Our
            <strong>Campbelltown taxi cab service</strong> ensures timely
            pickups, luggage support, and comfortable journeys. Learn more at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend weddings, parties, or concerts without transportation
            worries. Our
            <strong>Campbelltown taxi cab service</strong> handles schedules
            efficiently, providing safe and timely rides. Details at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for groups, families, or luggage-heavy trips. Our
            <strong>maxi cab services Campbelltown</strong> accommodate up to 12
            passengers comfortably. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our
            <strong> Campbelltown taxi cab close to me </strong> service. Timely
            pickups, luggage assistance, and stress-free rides ensure smooth
            airport travel. Book at airport taxi service.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S009: {
        service_id: "S009",
        title: "Corporate Trips",
        description: (
          <>
            Move between offices or meetings with ease. Our
            <strong> local taxi cab service near me</strong> ensures
            professional, comfortable, and punctual rides every time. Learn more
            at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Campbelltown Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Campbelltown Taxi & Maxi Cabs offers a range of vehicles so you can
        match your ride to your needs. Whether you are travelling alone or with
        a group, every option focuses on comfort,{" "}
        <a
          target="_blank"
          href={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
        >
          safety,
        </a>{" "}
        and reliability. Our local drivers know the quickest routes around
        Campbelltown, which keeps your journey efficient. From short trips to{" "}
        <a
          target="_blank"
          href={`https://www.pointtopoint.nsw.gov.au/what-a-service-provider/taxi-service-providers`}
          className="underline font-semibold px-1"
        >
          corporate travel
        </a>{" "}
        and airport runs, we have a suitable vehicle ready for you.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for short trips, errands, and school runs. Our sedans are
            clean, spacious, and comfortable. With our
            <strong>Campbelltown taxi service</strong> , you can enjoy safe and
            reliable rides for daily travel. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style for airport transfers, corporate travel, or special
            occasions. Our
            <strong>Campbelltown taxi service</strong> provides privacy,
            comfort, and punctual service with professional drivers. Learn more
            at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Perfect for families, groups, or luggage-heavy trips. Our SUVs offer
            ample seating, smooth rides, and convenience. Our
            <strong>taxi services near me </strong> in Campbelltown ensure safe
            and comfortable travel. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Ideal for small groups or large families. With spacious seating and
            luggage capacity, our
            <strong> maxi cab near me in Campbelltown </strong> offers reliable,
            safe, and comfortable rides for airport or event travel. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious, safe, and comfortable for up to 12 passengers or
            luggage-heavy trips. Our
            <strong> maxi cab services Campbelltown </strong> are perfect for
            family outings, corporate travel, or group trips. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for accessibility and safety. Our
            <strong> local taxi service Campbelltown </strong> offers
            professional assistance, easy boarding, and comfortable rides for
            seniors or passengers with mobility needs. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Campbelltown Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Campbelltown taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Campbelltown taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Campbelltown?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Campbelltown
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Campbelltown taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride.
          </>
        ),
      },
      {
        question: "Can I request a taxi with a baby seat?",
        answer: (
          <>
            Yes. We can supply adjustable baby seats so children travel
            securely, whether you are heading to school, a medical appointment,
            or a family event.
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Campbelltown </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Campbelltown taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Campbelltown?",
        answer: (
          <>
            Yes. We cover Raby, Macarthur, Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Campbelltown Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Campbelltown taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "ambarvale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13216.97067225621!2d150.7943473!3d-34.08892335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ee288b33d48f%3A0x5017d681632ab70!2sAmbarvale%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769793320905!5m2!1sen!2sbd",
    pageTitle: "Ambarvale Taxi & Maxi Cabs | Reliable Local Taxi Service 24/7",
    metaDescription:
      "Enjoy safe, on-time travel with Ambarvale Taxi & Maxi Cabs – local drivers, clean vehicles. Book now for quick pickup & stress-free rides. 24/7 service",
    heroTitle: "Ambarvale Taxi & Maxi Cabs | Reliable Local Taxi Service 24/7",
    heroDescription: (
      <>
        Looking for{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Ambarvale Taxi & Maxi Cabs
        </Link>{" "}
        you can rely on? You're in the right place. We offer professional, 24/7
        local taxi services in Ambarvale and across the surrounding Macarthur
        suburbs. Whether you need a maxi cab near you, a taxi service in
        Ambarvale, or a dependable local cab for everyday trips, we are ready to
        help. <br />
        Our fleet includes standard taxis, spacious maxi cabs, SUVs, luxury
        vehicles, and wheelchair-accessible taxis. Every vehicle is clean, safe,
        and comfortable, making our service ideal for families, corporate
        travelers, and groups of all sizes. With experienced local drivers, you
        can sit back and relax while we handle your journey. <br />
        We provide airport transfers, cruise terminal pickups, corporate
        transport, and everyday local taxi services. From Ambarvale to
        Campbelltown, Narellan, and other nearby areas, we ensure you reach your
        destination safely and on time.
      </>
    ),
    bookingFormTitle: "Book  Taxi Sydney Airport Service in Ambarvale NSW",
    locationSectionTitle:
      "Reliable Corporate Taxi Services Across Ambarvale & Surrounding Areas",
    locationSectionDescription: (
      <>
        Need a{" "}
        <strong> professional corporate taxi service in Ambarvale</strong>? Our{" "}
        <strong>Ambarvale taxi cab service</strong> is tailored for executives,
        corporate teams, and business travellers. You can count on{" "}
        <strong>Ambarvale Taxi & Maxi Cabs</strong> for{" "}
        <strong>
          time-critical journeys, inter-office Travel, and airport transfers.
        </strong>
        <br />
        We support local businesses throughout Ambarvale and the Macarthur
        region. Our{" "}
        <strong>modern fleet and streamlined booking system </strong>make
        corporate Travel efficient and dependable. Whether you need a{" "}
        <strong>maxi cab service in Ambarvale</strong> or a{" "}
        <strong>local taxi service near you</strong>, we prioritize punctuality,
        safety, and comfort for every passenger.
        <br />
        With <strong> experienced drivers and professional service</strong>, you
        can trust us for the <strong>Ambarvale taxi cab service</strong> that
        keeps your schedule on track.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Ambarvale NSW",
    serviceSubtitle: (
      <>
        When you need a trusted ride, Ambarvale Taxi & Maxi Cabs is your go-to
        local option. Whether you are travelling to work, heading to the
        airport, attending an appointment, or going to a family function, you
        can rely on our punctual, safe, and friendly service. <br />
        We understand the challenges of peak-hour traffic and daily travel
        needs. With our modern fleet, local route knowledge, and experienced
        drivers, you never have to wait long for a taxi or maxi cab.
        <a
          target="_blank"
          href={`https://www.pointtopoint.nsw.gov.au/safety-and-compliance/`}
          className="underline font-semibold px-1"
        >
          Booking
        </a>{" "}
        is quick and easy online or over the phone, giving you transparent fares
        and stress-free travel every time. Enjoy the convenience of a reliable
        Ambarvale taxi service whenever you need it.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your big day stress-free. Our taxis and
            <strong>Ambarvale taxi cab services</strong> ensure on-time pickups,
            safe journeys, and assistance with luggage. Book your wedding
            transfer easily through our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              dedicated wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our luxury vehicles. Ideal for VIP trips,
            airport rides, or corporate events. Check out our
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer page.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep Your Little Ones Safe. We provide adjustable child seats for
            school runs, medical appointments, and family outings. Learn more at
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              Baby Seat Taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Professional and punctual, our corporate taxis handle office
            commutes, meetings, and business trips. Visit
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              corporate transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to or from cruise terminals without stress. Our
            <strong>local taxi service, Ambarvale</strong> ensures timely
            ensures timely arrivals and smooth luggage handling. Check the
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Arrive in style for concerts, parties, or weddings. Our
            <strong>Ambarvale taxi cab service</strong> handles manage your
            schedule efficiently. More info on
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for groups or families. Our
            <strong>maxi cab services in Ambarvale </strong> fit up to 12
            passengers comfortably. Learn more at
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our
            <strong>
              Ambarvale taxi service, available close to you.{" "}
            </strong>{" "}
            On-time pickups, safe journeys, and luggage help make your trip
            hassle-free. Book an
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport taxi service.
            </Link>{" "}
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S009: {
        service_id: "S009",
        title: "Corporate Trips",
        description: (
          <>
            Travel between offices or meetings with reliability and efficiency.
            Our
            <strong> local taxi service</strong> ensures professionalism and
            comfort in your area. Explore
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Ambarvale Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Your ride matters, and we make sure it suits your needs. With Ambarvale
        Taxi & Maxi Cabs, you can choose from a range of vehicles that match
        your travel style, group size, and comfort level. Our drivers know the
        local roads and traffic patterns, ensuring efficient routes and on-time
        arrivals.
        <br />
        From solo trips to group travel, short local journeys to long-distance
        rides, our fleet is designed for safety, comfort, and reliability.
        Whether you need a quick local taxi or a{" "}
        <a
          target="_blank"
          href={`https://www.nsw.gov.au/easy-read/transport`}
          className="underline font-semibold px-1"
        >
          more
        </a>{" "}
        luxurious airport transfer, we have the right option for you.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for daily commuting or errands. Our sedans offer a reliable
            <strong>Ambarvale taxi service</strong> , providing comfort and
            convenience. Book now at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for VIP travel or airport rides. Experience privacy,
            comfort, and punctuality with our
            <strong>Ambarvale taxi cab service</strong> Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Ideal for families or heavy luggage. Enjoy smooth rides with our
            <strong>taxi services near me </strong> iin Ambarvale. Explore our
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups. Our
            <strong>maxi cab near me in Ambarvale</strong> handles up to 12
            passengers comfortably. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and reliable for group travel. Our
            <strong> maxi cab services in Ambarvale</strong> are perfect for
            family trips and corporate outings. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped wheelchair-accessible{" "}
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              taxis
            </a>{" "}
            with trained drivers to ensure safe, comfortable, and dignified
            travel for passengers with mobility needs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Ambarvale  Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Ambarvale  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Campbelltown taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Ambarvale ?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Ambarvale
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Ambarvale taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Ambarvale taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Ambarvale </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Ambarvale taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Ambarvale ?",
        answer: (
          <>
            Yes. We cover Raby, Macarthur, Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            easily in our{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Campbelltown Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Ambarvale taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "appin-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105581.61797394945!2d150.80853134999998!3d-34.21215075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b13a9a7ea03d4cb%3A0x40609b490438d80!2sAppin%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769793398339!5m2!1sen!2sbd",
    pageTitle: "24/7 Appin Taxi & Maxi Cabs for Local & Long-Distance Trips",
    metaDescription:
      "Enjoy smooth rides with Appin Taxi & Maxi Cabs – perfect for groups, airport trips, and daily travel. Book today for reliable service",
    heroTitle: "24/7 Appin Taxi & Maxi Cabs for Local & Long-Distance Trips",
    heroDescription: (
      <>
        Looking for <strong>Appin Taxi & Maxi Cabs</strong> you can trust?
        You’ve found the right service. We provide{" "}
        <strong>safe, professional, and 24/7 local taxi service Appin</strong>{" "}
        and surrounding Macarthur suburbs. Whether you need a{" "}
        <strong>maxi cab near me</strong>, a taxi service close to me Appin, or
        a <strong>local taxi cab service near me</strong>, we are ready for you.{" "}
        <br />
        Our fleet includes{" "}
        <strong>
          standard taxis, maxi cabs, SUVs, luxury vehicles, and
          wheelchair-accessible taxis
        </strong>
        , giving you flexible transport for families, groups, or corporate
        travel. Every ride is{" "}
        <strong>
          clean, comfortable, and driven by experienced local drivers
        </strong>
        , so you can relax. <br />
        We cover Appin, Campbelltown, Camden, and nearby suburbs. From Sydney
        Airport transfers, cruise terminal pickups, to everyday local taxi
        service, our team ensures your journey is smooth, timely, and
        stress-free. <br />
      </>
    ),
    bookingFormTitle: "Book  Taxi Sydney Airport Service in Appin",
    locationSectionTitle:
      "Appin Taxi & Maxi Cabs – Professional Corporate & Group Travel",
    locationSectionDescription: (
      <>
        Need
        <strong>reliable Appin taxi and cab services</strong>for work or group
        travel? Our
        <strong>Appin Taxi & Maxi Cabs </strong> provide
        <strong>corporate transport and maxi cab services Appin</strong>across
        the Macarthur region. Solo executives, teams, and groups can rely on our
        <strong>modern, well-maintained fleet</strong>
        and efficient booking system. We proudly support
        <strong>local Appin businesses,</strong> including offices, professional
        service firms, and manufacturing facilities. Our services cover
        <strong>
          {" "}
          airport transfers, inter-office travel, and time-sensitive corporate
          journeys,
        </strong>{" "}
        ensuring safety, comfort, and punctuality every time. With
        <strong>
          experienced drivers and a commitment to professional service
        </strong>
        , we are the trusted choice for{" "}
        <strong> taxi cab service near me, local taxi service Appin</strong>,
        and <strong>maxi cabs near me in Appin.</strong>
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Appin",
    serviceSubtitle: (
      <>
        When you need a reliable ride,
        <strong> Appin Taxi & Maxi Cabs</strong>is here for you 24/7 with
        flexible options tailored to your needs. Whether it's a quick local
        trip, a long-distance journey, or a Sydney{" "}
        <a
          target="_blank"
          href={`https://www.transport.nsw.gov.au/operations/point-to-point-transport/taxi-information`}
          className="underline font-semibold px-1"
        >
          Airport transfer
        </a>
        , our professional drivers provide safe, timely, and comfortable rides
        every time. You can trust our Appin taxi service and Appin taxi cab
        service to take care of your luggage, schedule, and travel plans, so you
        never have to worry about delays or missed connections. With our modern
        fleet, maxi cab options, and knowledgeable local drivers, you avoid long
        waits and unreliable{" "}
        <a
          target="_blank"
          href={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle`}
          className="underline font-semibold px-1"
        >
          taxi services
        </a>{" "}
        that fail to show up when it matters most. Booking your Appin taxi cab
        is fast and simple, online or by phone, making it easy for families,
        students, professionals, and visitors to experience convenient local
        taxi cab service near me anytime.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel stress-free on your big day. Our
            <strong>Appin taxi cab services</strong> ensure on-time arrivals,
            comfortable rides, and help with luggage. Book via our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Enjoy VIP comfort for airport rides, corporate meetings, or special
            events. Our luxury vehicles provide privacy and style. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer page.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little one safe. We provide child seats for school trips,
            appointments, or family outings. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              Baby Seat Taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Punctual, professional drivers for office commutes, meetings, and
            business travel. Our <strong>local taxi service Appin </strong>{" "}
            ensures smooth corporate trips. See
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              corporate transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel stress-free to cruise terminals. Our Appin taxi cab service
            provides on-time pickups and luggage assistance. Visit
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Arrive on time for weddings, concerts, or parties. Our taxi service
            close to me Appin manages schedules efficiently. More info at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for groups and family trips. Our maxi cab services Appin
            handle up to 12 passengers comfortably. Learn more at
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S009",
        title: "Corporate Trips",
        description: (
          <>
            Reliable rides between offices and meetings. Our
            <strong> local taxi cab service near me </strong> provides safe and
            professional trips. Explore
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S008",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight. Our
            <strong>Appin taxi service, available close to you. </strong>{" "}
            service ensures on-time pickups, safe rides, and luggage help. Book
            at
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport taxi service.
            </Link>{" "}
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Appin Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Your ride matters, and{" "}
        <a
          target="_blank"
          href={`https://www.qld.gov.au/transport/public/operators/information-for-passengers/passenger-rights-and-fares/taxi-service-standards`}
          className="underline font-semibold px-1"
        >
          Appin Taxi & Maxi Cabs
        </a>{" "}
        gives you the flexibility to choose the right vehicle for your trip,
        whether it is a short local ride or a long-distance transfer. Our local
        drivers know Appin, Campbelltown, Camden, Liverpool, and the wider
        Macarthur region in detail, helping you avoid traffic delays and reach
        your destination on time. From everyday trips to VIP airport transfers,
        our fleet includes standard{" "}
        <a
          target="_blank"
          href={`https://en.wikipedia.org/wiki/Taxi`}
          className="underline font-semibold px-1"
        >
          taxis,
        </a>{" "}
        maxi cabs, SUVs, wagons, luxury vehicles, and wheelchair-accessible
        options to match your group size and comfort needs. Whether you search
        for maxi cabs near me, Appintaxi cab service, or taxi services near me,
        you can expect clean vehicles, safe driving, and a professional attitude
        on every journey.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for daily travel, errands, or short trips. Our
            <strong>Appin taxi service</strong> provides reliable, stress-free
            rides. Book at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style for airport transfers or special events. Experience
            privacy and comfort with our
            <strong>Appin taxi cab service</strong> See
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Perfect for families or luggage-heavy trips. Our
            <strong>taxi services near me </strong> iin Appin are spacious and
            comfortable.
            <a
              target="_blank"
              href={`https://www.accesscanberra.act.gov.au/driving-transport-and-parking/ride-share-taxis-and-hire-car/taxi-service-accreditation`}
              className="underline font-semibold px-1"
            >
              Learn more
            </a>{" "}
            at
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Great for large groups. Our
            <strong>maxi cab near me in Appin </strong> seats up to 12
            passengers comfortably. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Reliable and spacious for group travel. Our
            <strong> maxi cab services in Appin</strong> suit family trips,
            corporate outings, and airport journeys. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for safe, accessible travel. Our
            <strong> local taxi service Appin</strong> helps seniors and
            mobility-challenged passengers. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Appin  Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Appin  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Campbelltown taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Appin ?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Appin
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Appin taxi and cab services</strong> operate day and night,
            including weekends and holidays. You can rely on us whenever you
            need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Appin taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Appin </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Appin taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Appin ?",
        answer: (
          <>
            Yes. We cover Raby, Macarthur, Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            easily in our{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Campbelltown Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>
              Appin{" "}
              <a
                target="_blank"
                href={`https://en.wikipedia.org/wiki/Maxi_taxi`}
                className="underline font-semibold px-1"
              >
                taxi or maxi cab
              </a>{" "}
              service{" "}
            </strong>
            today.
          </>
        ),
      },
    ],
  },
  "currans-hills-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26447.279978857343!2d150.77377029999997!3d-34.04617974999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f1b8586089ad%3A0x5017d681632b3b0!2sCurrans%20Hill%20NSW%202567%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769793762600!5m2!1sen!2sbd",
    pageTitle:
      "Local Currans Hills Taxi & Maxi Cabs | Easy Booking & Fair Pricing",
    metaDescription:
      "Reliable Currans Hills Taxi & Maxi Cabs - 24/7 local taxi service, Maxi Cabs, baby seats, and corporate rides. Book online or call today for stress-free travel.",
    heroTitle:
      "Local Currans Hills Taxi & Maxi Cabs | Easy Booking & Fair Pricing",
    heroDescription: (
      <>
        Looking for a trusted, reliable, and convenient taxi service in Currans
        Hills?{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/`}
          className="underline font-semibold  px-1"
        >
          Currans Hills Taxi & Maxi Cabs
        </Link>{" "}
        is your go-to solution for all local travel needs. We provide 24/7 taxi
        and maxi cab services to ensure your journey is safe, punctual, and
        stress-free. Whether it's a short local ride,
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold  px-1"
        >
          airport transfer,
        </Link>
        or a group trip, our professional drivers ensure comfort, reliability,
        and peace of mind. Our fleet includes standard taxis, maxi cabs, and
        executive vehicles suitable for families, students, professionals, and
        seniors. With transparent pricing and easy booking, traveling around
        Currans Hills has never been easier. Experience top-quality service that
        caters to every passenger, whether you're commuting, running errands, or
        heading to an event. Trust Currans Hills Taxi & Maxi Cabs for a seamless
        ride every time.
      </>
    ),
    bookingFormTitle: "Book Baby Seat Taxi Sydney in Currans Hills ",
    locationSectionTitle:
      "Currans Hills Taxi & Maxi Cab Services | Corporate, Group & Airport Transfers",
    locationSectionDescription: (
      <>
        Need trustworthy Currans Hill taxi and cab services for business travel
        or group transport? Our Currans Hills Taxi & Maxi Cabs offer dependable
        rides for corporate clients, individuals, and families alike. With our
        modern, well-kept fleet and simple booking options, arranging your trip
        is quick and hassle-free. <br />
        We work closely with local Currans Hill businesses, including offices,
        warehouses, and service providers, offering corporate taxi solutions
        that support day-to-day operations. Whether you are looking for maxi cab
        services in Currans Hills, a taxi service close to me in Currans Hills,
        or a local taxi cab service near me, we focus on punctual, safe, and
        comfortable travel.
        <br />
        Our service operates 24/7 and covers{" "}
        <a
          target="_blank"
          href={`https://immi.homeaffairs.gov.au/settling-in-australia/settle-in-australia/key-settlement-topics/transport`}
          className="underline font-semibold px-1"
        >
          airport transfers,
        </a>{" "}
        corporate trips, group bookings, and urgent last-minute journeys. With
        professional drivers and spotless vehicles, you can rely on us for a
        relaxed and efficient ride every time. Currans Hills Taxi & Maxi Cabs is
        your trusted choice for airport, business, and group transport across
        Currans Hills and the wider Macarthur area.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Currans Hill",
    serviceSubtitle: (
      <>
        When you need a fast and reliable ride,
        <strong> Currans Hills Taxi & Maxi Cabs</strong>iis your go-to local
        service. Whether you’re heading to work, school, the airport, or a
        family event, you can rely on our professional, safe, and punctual
        drivers. We understand your daily travel needs and peak-hour challenges.
        Our modern fleet, local knowledge, and friendly drivers ensure you never
        wait long for a taxi or maxi cab. With simple phone or online bookings,
        transparent fares, and stress-free journeys, our
        <strong> Currans Hills taxi service </strong> is the most convenient
        choice for residents and visitors.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel smoothly and in style on your big day. Our Currans Hills{" "}
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              taxi cab
            </a>{" "}
            services manage your luggage, arrive on time, and make your trip
            relaxed. Book via our dedicated wedding transfer page.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort and style. Perfect for VIP trips, corporate
            travel, or airport rides. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer page.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your child safe with adjustable seats. Our Currans Hills taxi
            cab service is ideal for school runs, medical trips, and family
            outings. Book at
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              Baby Seat Taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Reliable rides for office staff, meetings, and business trips. Our
            local taxi service Currans Hills ensures professional and punctual
            service. See
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              corporate transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to or from cruise terminals with ease. Our Currans Hills taxi
            and cab services are timely, safe, and luggage-friendly. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Arrive on time for parties, concerts, or weddings. Our Currans Hills
            taxi service handles group rides efficiently. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Spacious taxis for families or groups. Our maxi cab services Currans
            Hills accommodate up to 12 passengers comfortably. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S009",
        title: "Corporate Trips",
        description: (
          <>
            Travel between offices or meetings smoothly. Our local taxi cab
            service near me ensures professional, reliable service. Learn more
            at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S008",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Our Currans Hills taxi cab close to me service guarantees on-time
            pickups, safe rides, and luggage help. Book your airport taxi at
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport taxi service.
            </Link>{" "}
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Currans Hills Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Travel in style and comfort with our executive fleet designed to meet
        every need. Currans Hills{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        offers a variety of vehicle options, including sedans, SUVs, and maxi
        cabs, all maintained to the highest standards. Whether you’re heading to
        a business meeting, airport, or social event, our vehicles provide
        safety, luxury, and reliability. Each ride is monitored to ensure
        punctuality, cleanliness, and passenger satisfaction. Our experienced
        drivers offer professional, courteous service for a seamless travel
        experience.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for daily commuting, errands, or short trips. Enjoy a
            comfortable and punctual Currans Hills taxi service. Book online at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for VIP travel, airport rides, or special events. Experience
            comfort and privacy with our Currans Hills taxi cab service. See
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Great for families or travelers with luggage. Smooth rides with our
            taxi services near me in Currans Hills. Learn more at
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups. Our maxi cab near me in Currans Hills can
            handle up to 12 passengers comfortably. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and reliable for family trips or corporate outings. Our
            maxi cab services Currans Hills guarantee comfort and punctuality.
            More info
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped vehicles for seniors and passengers with mobility
            needs. Our local taxi service Currans Hills ensures safe, smooth
            travel. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Currans Hills Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Currans Hills  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Campbelltown taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Currans Hills ?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Currans Hills
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Currans Hills taxi and cab services</strong> operate day
            and night, including weekends and holidays. You can rely on us
            whenever you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Currans Hills taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Currans Hills </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Currans Hills taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Currans Hills ?",
        answer: (
          <>
            Yes. We cover Raby, Macarthur, Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            easily in our{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "How can I contact Currans Hills Taxi & Maxi Cabs?",
        answer: (
          <>
            You can call 1300 450 428, email taxibookingcampbelltown@gmail.com,
            or reserve your trusted Currans Hills
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              taxi cab
            </a>
            service today.​
          </>
        ),
      },
      {
        question:
          "Are your vehicles accessible for passengers with mobility issues?",
        answer: (
          <>
            Yes. We offer wheelchair-accessible taxis equipped to provide a
            safe, comfortable, and convenient
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Travel`}
              className="underline font-semibold px-1"
            >
              journey
            </a>
            for all passengers.
          </>
        ),
      },
    ],
  },
  "claymore-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13223.492035077968!2d150.81187329999997!3d-34.04712849999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ee622c6c623d%3A0x5017d681632b1e0!2sClaymore%20NSW%202559%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769794056870!5m2!1sen!2sbd",
    pageTitle:
      "Claymore Taxi & Maxi Cabs Services – 24/7 Safe & Comfortable Rides",
    metaDescription:
      "Choose Claymore Taxi & Maxi Cabs for reliable transport, spacious maxi cabs, and 24/7 availability. Call today and enjoy smooth, affordable local travel.",
    heroTitle: "Claymore Taxi & Maxi Cabs: 24/7 Airport & Local Transfers",
    heroDescription: (
      <>
        Looking for dependable Claymore{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          taxi and maxi cab services
        </Link>{" "}
        for everyday or airport travel? You're in the right place. We deliver
        fast, safe, and comfortable rides across Claymore and the wider
        Macarthur region, whenever you need a taxi near you. <br />​ Our diverse
        fleet includes standard taxis, roomy maxi cabs, SUVs, and
        wheelchair-accessible vehicles for every passenger type. Families,
        groups, corporate clients, and solo travellers rely on us for daily
        commutes, station drop-offs, medical visits, and airport transfers with
        on-time, stress-free service.​ <br />
        You can depend on our Claymore{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          taxi and cab service
        </Link>{" "}
        across Claymore, Campbelltown, and surrounding Macarthur suburbs for
        both quick local trips and longer-distance journeys, making every ride
        simple, secure, and convenient.​
      </>
    ),
    bookingFormTitle: "Book Baby Seat Taxi Sydney in Claymore ",
    locationSectionTitle:
      "Trusted Claymore Taxi for Airport Transfers and Corporate Travel | 24/7 Taxi & Maxi Cab Services",
    locationSectionDescription: (
      <>
        Need a professional Claymore taxi for business meetings or airport
        transfers? Claymore{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        is a trusted local provider for solo travellers, executives, and groups,
        making it easy to book a taxi near you using our simple booking
        options.​ <br />
        We support Claymore businesses of all sizes with 24/7 transport for
        Sydney Airport transfers, inter-office travel, corporate events, and
        staff movements.​ <br />
        With experienced drivers, clean vehicles, and a strong focus on comfort
        and safety, every journey runs smoothly—whether you search for a maxi
        cab near you, a nearby taxi service, or a local Claymore cab.​
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Claymore",
    serviceSubtitle: (
      <>
        When you need a reliable ride, Claymore Taxi & Maxi Cabs is your local
        transport partner for work, airport trips, school runs, and family
        occasions. Our drivers understand peak-hour traffic, local routes, and
        customer needs, ensuring safe, punctual, and comfortable travel every
        day. We offer easy phone and online bookings, clear pricing, and a
        modern fleet, so your local taxi service in Claymore is always
        convenient and trustworthy, day or night.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Enjoy a worry-free wedding day with our Claymore taxi cab service.
            We arrive on time, help with luggage, and ensure your guests reach
            safely. More details on
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style for corporate trips or special occasions. Our luxury
            vehicles offer privacy, comfort, and punctual service. Check
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer page.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Ensure your child’s safety with our adjustable baby seats. Ideal for
            school runs, hospital visits, or family outings with Claymore taxi
            service. Learn more
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              Baby Seat Taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Reliable and professional rides for business trips, meetings, or
            airport transfers. Our local taxi cab service near me ensures
            smooth, stress-free travel. Explore
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              corporate transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start or finish your cruise on time. Our Claymore taxi cab close to
            me service handles luggage and schedules efficiently. See
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend concerts, weddings, or parties without worry. Our Claymore
            taxi service manages your schedule for prompt, comfortable rides.
            More info
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travelling with a large group? Our maxi cab services Claymore
            accommodate up to 12 passengers. Perfect for family trips or
            corporate outings. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S009",
        title: "Corporate Trips",
        description: (
          <>
            Get reliable office or business travel with our professional
            drivers. Our local taxi service Claymore ensures comfort, safety,
            and punctuality. Explore
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S008",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight. Our Claymore taxi cab close to me service
            offers on-time pickups, safe journeys, and luggage assistance. Book
            now via
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport taxi service.
            </Link>{" "}
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Claymore Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Your ride matters. With Claymore Taxi & Maxi Cabs, you can choose vehicles to suit your style, group size, and comfort needs. Our drivers know local routes well, ensuring safe, smooth, and timely trips. Whether you need a quick city ride, a luxury airport transfer, or a group journey, our fleet has the right option for you. Every vehicle is clean, modern, and maintained for your peace of mind.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for everyday travel. Our Claymore taxi service offers comfort,
            reliability, and short wait times. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for VIP travel, airport rides, or special occasions. Enjoy
            privacy, comfort, and punctuality with our Claymore taxi cab
            service. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Select spacious SUVs or wagons for family journeys or luggage-heavy
            trips using our
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </a>
            services near you in Claymore.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for groups or family travel. Our maxi cab near me in
            Claymore fits up to 12 passengers comfortably. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious rides for large groups. Our maxi cab services Claymore
            handle family trips, events, and corporate travel efficiently. Learn
            more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for safe travel. Our Claymore taxi cab service
            ensures accessible rides for seniors and passengers with mobility
            needs. Book via
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Claymore Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Claymore  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Campbelltown taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Claymore?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Claymore
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Claymore taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes, we supply adjustable baby seats so children can{" "}
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              travel
            </a>{" "}
            safely, making our Claymore taxi service suitable for school runs
            and family travel.
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Claymore </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Claymore taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Claymore ?",
        answer: (
          <>
            Yes. We cover Raby, Macarthur, Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            easily in our{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "How can I contact Campbelltown Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Claymore taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "macarthur-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d422862.0888993145!2d150.54837919999997!3d-34.10512829999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f980e34e2ded%3A0xcaa8c95c21253621!2sMacarthur%2C%20NSW%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769794562272!5m2!1sen!2sbd",
    pageTitle: "Macarthur Taxi & Maxi Cabs Services – Book 24/7",
    metaDescription:
      "Reliable Macarthur Taxi & Maxi Cabs - 24/7 local taxi service, safe rides, Maxi Cabs, corporate travel, and baby seats. Call or book online today!",
    heroTitle: "Macarthur Taxi & Maxi Cabs Services – Book 24/7",
    heroDescription: (
      <>
        Looking for reliable Macarthur{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        you can depend on? You're in the right place. We offer safe,
        comfortable, and professional taxi and maxi cab services across
        Macarthur and nearby Sydney suburbs. Whether you're searching for a
        MacArthur taxi cab near me, a taxi service near me, or a local taxi cab
        service near me, we are ready to help 24/7​ <br />
        Our fleet includes standard taxis, spacious maxi cabs, SUVs, luxury
        vehicles, and wheelchair-accessible taxis. Every ride is clean,
        air-conditioned, and driven by experienced local drivers familiar with
        Macarthur roads. We support families, groups, and corporate travelers
        with 24/7 airport transfers, corporate transport, cruise terminal
        pickups, and everyday taxi service in Macarthur. From Campbelltown to
        Camden, Narellan, and surrounding areas, we focus on smooth, stress-free
        travel every time.​
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi Service in Macarthur NSW",
    locationSectionTitle:
      "Reliable Taxi & Maxi Cab Services in Macarthur NSW | 24/7 Corporate & Airport Transfers",
    locationSectionDescription: (
      <>
        Need a <strong>Macarthur taxi cab service</strong> for business? Our{" "}
        <strong>Macarthur Taxi & Maxi Cabs</strong> handle corporate travel with
        ease. You can book solo executive trips, team transfers, or group
        journeys with <strong>maxi cab services Macarthur</strong> and enjoy{" "}
        <strong>reliable, on-time service</strong>. <br />
        We proudly support local Macarthur businesses, including manufacturing
        facilities and professional service firms. Our{" "}
        <strong>modern fleet</strong> and streamlined booking system make
        corporate transport efficient and dependable. Whether you need a{" "}
        <strong>
          taxi services near me, maxi cab near me, or local taxi service
          Macarthur
        </strong>
        , we meet{" "}
        <strong>
          early-morning, late-night, and time-critical travel needs
        </strong>
        . With <strong>experienced drivers and well-maintained vehicles</strong>
        , you can rely on us for{" "}
        <strong>professional corporate transport and airport transfers</strong>{" "}
        in Macarthur.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Macarthur NSW",
    serviceSubtitle: (
      <>
        When you need a dependable ride,{" "}
        <a
          target="_blank"
          href={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
          className="underline font-semibold px-1"
        >
          Macarthur Taxi & Maxi Cabs
        </a>{" "}
        is your trusted local option. From work and school runs to airport,
        medical, and event transfers, we deliver punctual, safe, and friendly
        service tailored to your needs. We understand local traffic patterns,
        peak-hour congestion, and the importance of passenger comfort. With a
        modern fleet, skilled drivers, and strong local knowledge, your trip
        stays simple and stress-free. Booking is quick online or by phone, with
        clear pricing and fast response times, so you enjoy the best MacArthur
        taxi service and maxi cab services every day.​
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your day stress-free. Our
            <strong>Macarthur taxi and cab services</strong> provide on-time
            pickups, elegant interiors, and luggage assistance. Celebrate
            without worrying about transport. Book via
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort and style for corporate events, airport trips, or
            personal occasions. Our
            <strong>Macarthur taxi and cab services</strong> ensures privacy,
            reliability, and punctuality. See more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your child safe. We provide baby and booster seats on demand
            for school runs or family outings. Learn more on
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Professional drivers, scheduled pickups, and on-time service make
            business travel seamless. Book your
            <strong>local taxi service Campbelltown </strong> provides punctual
            service, safe vehicles, and smooth journeys. Check corporate
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals without stress. Our
            <strong>taxi cab service near me </strong> ensures timely pickups,
            luggage assistance, and smooth journeys. Check
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Arrive on time for parties, concerts, or weddings. Our
            <strong>Macarthur taxi cab service</strong>manages schedules
            efficiently. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel comfortably with large groups. Our
            <strong>maxi cab services Macarthur</strong> fits up to 12
            passengers. Perfect for family or corporate trips. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Reliable rides between offices or meetings. Our
            <strong> local taxi cab service near me</strong> ensures smooth and
            professional service. Visit
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Avoid missing flights with Macarthur taxi cabs close to me, offering
            on-time pickups, luggage assistance, and relaxed airport{" "}
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              travel
            </a>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Macarthur Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Your ride should match your style, comfort, and needs. Macarthur Taxi & Maxi Cabs offers a modern fleet for solo trips, family outings, or group travel. Our drivers know the local roads and ensure punctuality. Whether you need a quick local trip or a luxury airport transfer, we provide safe, comfortable, and reliable rides.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for everyday travel. Our sedans offer a reliable
            <strong>Macarthur taxi service</strong> .Book online at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for airport rides, VIP travel, and special events. Our
            <strong>Macarthur taxi service</strong> provides comfort, privacy,
            and punctuality. Check
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious for families or luggage-heavy trips. Enjoy our
            <strong>taxi services near me </strong> in Macarthur. Learn more at
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups. Our
            <strong> maxi cab near me in Macarthur </strong> fits up to 12
            passengers. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Comfortable group travel with on-time service. Our
            <strong> maxi cab services Macarthur </strong> are perfect for
            family or corporate trips. Details
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped, accessible vehicles ensure safe, easy travel for
            seniors and passengers with mobility needs through our local
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </a>
            service near me.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Macarthur Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Macarthur  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Macarthur taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Macarthur?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Macarthur
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Macarthur taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Macarthur taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Macarthur </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Macarthur taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Macarthur?",
        answer: (
          <>
            Yes. We cover Raby, Macarthur, Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Macarthur Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Macarthur taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "menangle-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52839.76147907741!2d150.71858199999997!3d-34.13392955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12efee1a0907d9%3A0x5017d6816333c80!2sMenangle%20NSW%202568%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769794880492!5m2!1sen!2sbd",
    pageTitle: "24/7 Menangle Taxi & Maxi Cabs | Local & Long-Distance Travel",
    metaDescription:
      "Reliable transport you can trust with Menangle Taxi & Maxi Cabs – On-time service, modern cars & maxi cabs available. Book now and ride with confidence",
    heroTitle: "Macarthur Taxi & Maxi Cabs Services – Book 24/7",
    heroDescription: (
      <>
        Searching for reliable Menangle{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs?
        </Link>{" "}
        You've come to the right place. We deliver professional Menangle taxi
        and cab services 24/7. Whether you're after a local taxi service in
        Menangle, a maxi cab near me, or a smooth airport transfer, our skilled
        drivers make every trip hassle-free. <br />
        Our{" "}
        <Link to={`/fleet`} className="underline font-semibold px-1">
          fleet features standard taxis,?
        </Link>{" "}
        roomy maxi cabs, SUVs, and wheelchair-accessible vehicles. Every journey
        is clean, secure, and on schedule. From daily commutes and school runs
        to group outings and long-distance travel, we service Menangle and the
        wider Macarthur region. You can also schedule Menangle taxi cab service
        for events, corporate travel, or family trips, all handled by expert
        drivers who know the local area well.
      </>
    ),
    bookingFormTitle: "Book  Baby Taxi in Menangle NSW",
    locationSectionTitle:
      "Reliable Taxi & Maxi Cab Services in Menangle NSW | 24/7 Corporate, Group & Airport Transfers",
    locationSectionDescription: (
      <>
        Looking for a professional Menangle{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          taxi cab service
        </Link>
        taxi cab service for business trips or group travel? Our Menangle Taxi &
        Maxi Cabs deliver dependable corporate, airport, and group
        transportation. With a modern fleet and an easy booking system, you
        enjoy reliable, on-time service every ride. <br />
        We proudly support local Menangle customers and the broader Macarthur
        community. From solo executives and office teams to family groups and
        social outings, our maxi cab services in Menangle cover every travel
        need. You can also depend on us for taxi service near me, taxi cab
        service near me, and local taxi service near me whenever you need a
        quick ride. <br />
        Our drivers prioritize comfort, safety, and punctuality. Whether it's an
        airport transfer, inter-office travel, or a special event, Menangle Taxi
        & Maxi Cabs is your trusted option for professional taxi services in
        Menangle and surrounding suburbs.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Menangle NSW",
    serviceSubtitle: (
      <>
        When you need a reliable ride,
        <strong>Menangle Taxi & Maxi Cabs</strong> is your trusted partner.
        Whether it’s commuting to work, catching a flight, or travelling to a
        special event, our team ensures safe, punctual, and stress-free
        journeys. We understand your daily travel challenges, late-night needs,
        and group requirements. With a modern fleet, professional drivers, and
        local knowledge, you’ll never face long waits again. Booking is simple
        online or by phone, giving you transparent fares and peace of mind.
        Experience the best <strong>Menangle taxi service</strong> today.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your big day without transport worries. Our
            <strong>Menangle taxi and cab services</strong> ensure timely
            pickups, comfortable rides, and luggage assistance. Learn more on
            our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style and comfort for airport rides, business meetings, or
            special occasions. Book your
            <strong>local taxi service Menangle</strong> via
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little one safe. We provide baby and booster seats on
            demand for school runs, appointments, or family outings. See details
            on
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Professional drivers, scheduled pickups, and reliable vehicles for
            all corporate travel. Check our
            <strong>local taxi service Campbelltown </strong> provides punctual
            service, safe vehicles, and smooth journeys. Check corporate
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Arrive at cruise terminals safely and on time. Our Menangle taxi and
            cab services handle luggage efficiently. Learn more on
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Make a statement at weddings, concerts, or parties. Our Menangle
            taxi cab service keeps your group comfortable and punctual. See
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for families or groups, our maxi cab services Menangle
            accommodate up to 12 passengers. Learn more on
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Travel between offices or meetings safely. Our local taxi cab
            service near me ensures punctuality, comfort, and professional
            service. Explore
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight. Our Menangle taxi cab close to me service
            guarantees on-time pickups, safe journeys, and luggage help. Book at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Menangle Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Your travel experience matters. With Menangle{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs,
        </Link>{" "}
        you can pick vehicles that match your needs, style, and comfort level.
        From solo rides to larger group journeys, our fleet offers safe, smooth,
        and punctual transportation. Our drivers know Menangle and the nearby
        areas very well. Whether you're heading across town or taking a
        long-distance airport trip, we have the right vehicle for you.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for everyday travel, school runs, or errands. Our
            <strong>Menangle taxi service</strong> ensures a reliable,
            comfortable ride. Book at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for VIP trips, corporate travel, or airport transfers. Travel
            in comfort with our
            <strong>Menangle taxi service</strong> See
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Great for families or luggage-heavy trips. Enjoy our taxi services
            near me in Menangle. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Ideal for group travel. Our maxi cab near me in Menangle fits up to
            12 passengers comfortably. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and dependable for big groups or heavy luggage. Our maxi
            cab services in Menangle are ideal for family holidays and
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              group trips.
            </a>
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped vehicles for safe and accessible travel. Our local
            taxi service near me supports seniors and passengers with mobility
            needs. Book via our wheelchair
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </a>
            service page.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Menangle Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Menangle  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Menangle taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Menangle?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Menangle
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Menangle taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Menangle taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Menangle </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Menangle taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Menangle?",
        answer: (
          <>
            Yes. We cover Raby, Menangle, Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Menangle Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Menangle taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "leumeah-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13222.43819893756!2d150.83956699999993!3d-34.05388549999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12eebf89e270b1%3A0x5017d681632be10!2sLeumeah%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769795229971!5m2!1sen!2sbd",
    pageTitle: "Leumeah Taxi & Maxi Cabs – Comfortable, Reliable & Affordable",
    metaDescription:
      "Experience stress-free travel with Leumeah Taxi & Maxi Cabs – clean vehicles, friendly drivers & quick booking. Call now for 24/7 availability.",
    heroTitle: "Leumeah Taxi & Maxi Cabs – Comfortable, Reliable & Affordable",
    heroDescription: (
      <>
        Looking for{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Leumeah Taxi & Maxi Cabs
        </Link>{" "}
        you can trust every day? Our local team offers quick, safe, and
        reasonably priced rides for residents, workers, and visitors across
        Leumeah. Whether you are searching for a maxi cab near me, a Leumeah
        taxi close to me, or a dependable local taxi service near me, we make
        every trip simple and hassle-free. <br />
        Our updated fleet includes standard sedans, roomy maxi cabs,
        family‑friendly SUVs, and wheelchair-accessible vehicles to suit every
        type of traveler. From school runs and doctor visits to station
        pick‑ups, airport drop‑offs, and long-distance trips, we focus on
        punctual, stress-free transport. Whether you are heading from Leumeah to
        Campbelltown, Macarthur, or nearby suburbs, our experienced drivers help
        you arrive safely and on time. <br />
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Leumeah NSW",
    locationSectionTitle: (
      <>
        Trusted Leumeah Taxi & Maxi Cabs for{" "}
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers
        </Link>
        and{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Travel
        </Link>
        | 24/7 Taxi and Maxi Cab Services
      </>
    ),
    locationSectionDescription: (
      <>
        Need a dependable corporate taxi service in Leumeah for staff, clients,
        or guests? Our Leumeah Taxi & Maxi Cabs are ideal for solo travelers,
        office teams, and larger groups. With a carefully maintained fleet and a
        simple booking process, we deliver on-time, professional transport every
        day of the week. <br />
        We proudly support businesses throughout Leumeah and the wider Macarthur
        region with smooth airport transfers, inter-office travel, and group
        movements. Our maxi cab services in Leumeah provide a polished,
        comfortable experience for meetings, events, and company functions.
        Clean cars, polite drivers, and a strong focus on safety mean your
        Leumeah taxi cab service is always dependable —24/7, whether you book a
        taxi service near me, taxi services near me, or a local taxi service
        near me.​
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Leumeah",
    serviceSubtitle: (
      <>
        When you need a reliable ride,
        <strong>Leumeah Taxi & Maxi Cabs</strong> is your trusted local service.
        Whether you are commuting to work, heading to the airport, or attending
        a special event, our professional drivers ensure safe, comfortable, and
        punctual journeys. With modern vehicles and local knowledge, you can
        avoid long waits and unreliable rides. We make booking simple online or
        over the phone, offering transparent fares and stress-free travel every
        time. Trust our <strong>Leumeah taxi service</strong>for everyday trips,
        airport transfers, family outings, or special events.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your big day without travel stress. Our
            <strong>Leumeah taxi and cab services</strong> provide on-time
            pickups, professional drivers, and assistance with luggage. We
            ensure a smooth journey for all guests. Book your wedding ride
            easily via our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Arrive in style with our luxury taxis for airport rides, business
            meetings, or special occasions. Our Leumeah taxi cab service
            guarantees privacy, comfort, and punctuality. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe during every trip. Our taxis provide
            adjustable baby seats suitable for school runs, medical visits, or
            family outings. Trust our Leumeah taxi service for secure,
            comfortable journeys. Visit on
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Reliable, professional, and punctual rides for office staff,
            business meetings, and corporate events. Our local taxi service
            Leumeah ensures stress-free corporate travel with trained drivers
            and well-maintained vehicles. Check
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start or end your cruise without worry. Our Leumeah taxi cab service
            provides timely pickups, luggage assistance, and comfortable rides
            to the terminal. Enjoy a smooth, stress-free journey. Learn more at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend weddings, concerts, or social events without transportation
            worries. Our Leumeah taxi service handles schedules efficiently,
            providing safe and reliable rides. More information at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel comfortably with our spacious maxi cab services Leumeah.
            Ideal for groups, families, or luggage-heavy trips, these vehicles
            handle up to 12 passengers with ease. Learn more at
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Move between offices or meetings without stress. Our local taxi cab
            service near me ensures professional drivers, punctual service, and
            comfortable rides. Explore
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss your flight with our Leumeah taxi cab close to me
            service. We provide on-time pickups, luggage assistance, and safe,
            stress-free airport transfers. Book now at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Leumeah Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Your ride should match your needs, whether it is a quick local trip or a
        premium{" "}
        <Link
          target="_blank"
          to={`https://www.pointtopoint.nsw.gov.au/safety-and-compliance/safety-standards-for-taxis`}
          className="underline font-semibold px-1"
        >
          airport transfer.
        </Link>{" "}
        With Leumeah Taxi & Maxi Cabs, you can select from a range of vehicles
        built for comfort, space, or accessibility. Our drivers understand local
        roads, busy times, and the best routes, helping you avoid delays and
        unnecessary detours. From everyday errands to VIP transport, our Leumeah
        taxi and cab services give you a smooth, reliable journey.​
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for short trips, school runs, or errands. Our sedans are
            clean, spacious, and comfortable. You can trust our Leumeah taxi
            service for safe, reliable, and stress-free travel. Book quickly at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort with our luxury vehicles. Ideal for
            airport trips, corporate travel, or special occasions, our Leumeah
            taxi cab service guarantees privacy, punctuality, and professional
            drivers for a premium ride. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Ideal for families, group travel, or luggage-heavy journeys. Our
            SUVs provide spacious seating, smooth rides, and reliable service.
            Our taxi services near me in Leumeah ensures stress-free and
            comfortable transportation for every trip. Explore our fleet at
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for small groups or large families. This vehicle provides
            ample seating and luggage space. Our maxi cab near me in Leumeah
            ensures safe, reliable, and comfortable rides for airport transfers,
            events, or city travel. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and ideal for groups or heavy luggage. Our maxi cab
            services Leumeah offer professional drivers, on-time pickups, and
            safe journeys. Perfect for family trips, corporate outings, or
            social events. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for safe, accessible travel. Our local taxi service
            Leumeah provides professional assistance, easy boarding, and
            comfortable rides. Perfect for seniors or passengers with mobility
            challenges. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Leumeah  Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Leumeah  taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Leumeah taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Leumeah?",
        answer: (
          <>
            Yes, our maxi cab services in Leumeah can carry up to 12 passengers,
            making them ideal for family groups,
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport transfers,
            </Link>{" "}
            and social outings with extra luggage.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Yes, our Leumeah taxi and cab services operate day and night,
            including weekends and public holidays, so you can{" "}
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              travel
            </a>
            anytime you need.​
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Leumeah taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Leumeah </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes, we provide luxury vehicles for VIP transfers, business travel,
            and special occasions; you can book a Leumeah{" "}
            <a
              target="_blank"
              href={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi{" "}
            </a>{" "}
            cab service for a more premium experience.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Leumeah?",
        answer: (
          <>
            Yes. We cover Raby, Leumeah, Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Leumeah Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Leumeah taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "raby-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13227.693875770648!2d150.816272!3d-34.02017535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ec331a2ff577%3A0x5017d681632c7d0!2sRaby%20NSW%202566%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769795877024!5m2!1sen!2sbd",
    pageTitle: "Raby Taxi & Maxi Cabs Services – 24/7 Convenient Transport",
    metaDescription:
      "Get to your destination on time with Raby Taxi & Maxi Cabs – professional drivers & 24/7 service. Book your ride today!",
    heroTitle: "Raby Taxi & Maxi Cabs Services – 24/7 Convenient Transport",
    heroDescription: (
      <>
        Looking for reliable Raby{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs services
        </Link>{" "}
        you can trust? We have you covered with safe, professional, and 24/7
        local taxi service in Raby and nearby Sydney suburbs. Whether you are
        searching for a Raby taxi cab close to me, a taxi service near me, or a
        maxi cab near me, we provide the right vehicle for every trip.​ <br />
        Our fleet includes standard taxis, spacious maxi cabs, SUVs, luxury
        cars, and wheelchair-accessible taxis, all kept clean, comfortable, and
        well maintained. With experienced local drivers, your journey stays
        smooth, on time, and stress-free. We handle airport transfers, cruise
        terminal pickups, corporate travel, and everyday local rides from Raby
        to Campbelltown and surrounding areas so you always reach your
        destination safely.​
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Raby NSW",
    locationSectionTitle:
      "Reliable Taxi & Maxi Cab Services in Raby NSW | 24/7 Corporate & Airport Transfers",
    locationSectionDescription: (
      <>
        If you need a professional Raby{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          taxi cab service
        </Link>{" "}
        for work, meetings, or group travel, our Raby Taxi & Maxi Cabs are ideal
        for business and corporate passengers. You can confidently book taxi
        services near me or maxi cab services in Raby for individuals, teams,
        and larger groups. <br />
        Our modern, well-presented vehicles support local businesses across Raby
        by providing dependable transport solutions for day-to-day operations.
        Operating 24/7, we manage early-morning flights, late-night arrivals,
        and urgent airport transfers with a strong focus on safety, comfort, and
        punctuality. From inter-office travel to maxi cabs near me in Raby, our
        experienced drivers make us a trusted choice for local taxi service in
        Raby and corporate transport throughout the region.​
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Raby",
    serviceSubtitle: (
      <>
        When you need a reliable ride, Raby{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        is your trusted local service. Whether you are heading to work, the
        airport, or attending an event, our professional drivers ensure safe,
        comfortable, and punctual journeys. We understand your travel needs,
        including early-morning flights, late-night shifts, and group travel.
        With our modern fleet and local route knowledge, you will avoid long
        waits or cancelled rides. Booking is easy online or by phone, with
        transparent fares and hassle-free service. Choose our{" "}
        <strong>Raby taxi service</strong> for stress-free, reliable transport
        anytime.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your special day without travel stress. Our Raby taxi and
            cab services offer timely pickups, professional drivers, and
            assistance with luggage. We ensure smooth, comfortable rides for all
            wedding guests. Book through our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style for VIP trips, airport transfers, or corporate
            events. Our Raby taxi cab service guarantees comfort, privacy, and
            punctuality for a premium experience. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your children safe with adjustable baby seats in our taxis.
            Perfect for school runs, medical appointments, or family outings.
            Our Raby taxi service ensures secure, stress-free travel. Visit
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Reliable and professional rides for office staff, meetings, and
            business trips. Our local taxi service Raby ensures timely pickups
            and smooth corporate travel with trained drivers. Check
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals safely and on time. Our Raby taxi cab
            service offers luggage assistance and reliable rides for a
            hassle-free journey. Learn more at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend concerts, parties, or weddings without worrying about
            transport. Our Raby taxi service handles schedules efficiently,
            providing safe and timely rides for you and your group. Details at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for families or groups, our maxi cab services Raby
            accommodate up to 12 passengers comfortably, with ample luggage
            space. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Travel between offices or meetings with ease. Our local taxi cab
            service near me ensures professional, punctual, and comfortable
            rides every time. Learn more at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Avoid missing flights with Raby taxi cab close to me airport
            transfers offering on-time pickups, luggage help, and relaxed{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              travel
            </Link>
            to and from the terminal.​
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Raby Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Your comfort is a priority, and Raby{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        allows you to choose the vehicle that best suits your trip. From solo
        rides to large group transfers, our fleet is designed for safety,
        convenience, and punctual service across Raby and nearby suburbs.
        Whether you need a quick local trip or a premium airport transfer, our
        Raby taxi and cab options deliver a reliable experience every time.​
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for everyday travel, errands, or school runs. Our sedans are
            clean, spacious, and comfortable. With our Raby taxi service, you
            will enjoy stress-free, safe, and reliable trips. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style for airport transfers, VIP trips, or special
            occasions. Our Raby taxi cab service offers privacy, comfort, and
            punctual service with professional drivers. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Ideal for families, groups, or luggage-heavy trips. Our SUVs provide
            ample seating, smooth rides, and convenience. Our taxi services near
            me in Raby ensures safe and comfortable travel. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for small groups or larger families. With plenty of seating
            and luggage space, our maxi cab near me in Raby provides
            comfortable, reliable, and professional transport for airport or
            event travel. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious, safe, and reliable for up to 12 passengers or
            luggage-heavy trips. Our maxi cab services Raby are perfect for
            family outings, corporate travel, and group trips. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for accessibility, safety, and comfort. Our local
            taxi service Raby provides professional assistance, easy boarding,
            and convenient travel for seniors or passengers with mobility needs.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Raby   Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Raby   taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Raby taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Raby ?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Raby
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Raby taxi and cab services</strong> operate day and night,
            including weekends and holidays. You can rely on us whenever you
            need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Raby taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Raby </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes, we operate luxury vehicles that provide privacy and comfort,
            and you can book a Raby{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>{" "}
            cab service for VIP rides, airport transfers, or special events.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Raby ?",
        answer: (
          <>
            Yes. We cover Raby, Raby , Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Raby  Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Raby taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "st-andrews-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26453.89929474565!2d150.83060170000002!3d-34.02495065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ec3bc85445e7%3A0x442ae9119441f920!2sSt%20Andrews%20NSW%202566%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769796388084!5m2!1sen!2sbd",
    pageTitle: "St Andrew's Taxi & Maxi Cabs: 24/7 Airport & Local Transfers",
    metaDescription:
      "Need a stress-free ride? St Andrew's Taxi & Maxi Cabs offers reliable service anytime, anywhere in Campbelltown. Book online today!",
    heroTitle: "St Andrew's Taxi & Maxi Cabs: 24/7 Airport & Local Transfers",
    heroDescription: (
      <>
        Looking for reliable St. Andrew's{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs?
        </Link>{" "}
        You're in the right place. We offer fast, safe, and dependable taxi
        services across St. Andrew's and the wider Macarthur region. Whether you
        need a St. Andrew's taxi cab close to you, a maxi cab in St. Andrew's,
        or a trusted local taxi service, we are ready to help. <br />
        Our fleet includes{" "}
        <Link to={`/fleet`} className="underline font-semibold px-1">
          standard taxis,
        </Link>{" "}
        maxi cabs, SUVs, and wheelchair-accessible vehicles. Every ride is
        clean, comfortable, and hassle-free. Families, groups, solo travelers,
        and corporate passengers choose us for daily trips, train station
        drop-offs, medical visits, and airport transfers. Our experienced
        drivers know St. Andrew's and the surrounding routes well and focus on
        on-time, smooth journeys. <br />
        You can rely on our St. Andrew's{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          taxi and cab services
        </Link>{" "}
        anywhere in St. Andrew's, Campbelltown, and nearby Macarthur suburbs.
        From short local rides to long-distance travel, we make every trip
        simple, safe, and convenient.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Raby NSW",
    locationSectionTitle:
      "Trusted St Andrew's Taxi for Airport Transfers and Corporate Travel | 24/7 Taxi & Maxi Cab Services",
    locationSectionDescription: (
      <>
        Need a professional St. Andrews taxi cab service for{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          airport
        </Link>{" "}
        or{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          corporate travel?
        </Link>{" "}
        St Andrew's Taxi & Maxi Cabs is a trusted choice for both business and
        personal needs. Our maxi cab services in St. Andrew's are ideal for
        individuals, teams, and larger groups, with easy booking via search
        results for taxi service near you. <br />
        We proudly support local St. Andrew's businesses, including offices,
        professional services, and industrial sites. Our 24/7 operations cover{" "}
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Sydney Airport transfers,
        </Link>{" "}
        staff transport, inter-office trips, group outings, and special
        occasions. <br />
        With skilled drivers, well-maintained vehicles, and a focus on comfort
        and safety, every ride is smooth and reliable. Whether you need a maxi
        cab, a taxi close to you, or a regular local{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          taxi cab service
        </Link>
        taxi cab service, we provide punctual, consistent transport around the
        clock.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in St Andrews",
    serviceSubtitle: (
      <>
        At
        <strong> St Andrews Taxi Cab, </strong> we deliver reliable and
        efficient taxi and maxi cab services in{" "}
        <strong>St Andrews NSW and surrounding areas.</strong> Whether you
        require a fast Sydney Airport transfer, a spacious maxi taxi for group
        travel, or a luxury taxi service for special occasions, we are here to
        help. Our experienced drivers provide safe, punctual, and comfortable
        journeys, making us a trusted choice for airport, corporate, and local
        taxi services in St Andrews.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your special day without transport stress. Our St Andrew's
            taxi and cab services offer punctual pickups, professional drivers,
            and luggage assistance. We ensure smooth, comfortable journeys for
            all wedding guests. Book easily at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style for airport rides, business meetings, or VIP trips.
            Our St Andrew's taxi cab service guarantees privacy, comfort, and
            punctual service every time. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep children safe with fitted baby seats in selected vehicles.
            Ideal for school runs, medical appointments, and family outings, our
            St. Andrew's taxi service supports secure family travel. Check
            <Link
              target="_blank"
              to={`https://www.transport.nsw.gov.au/roadsafety/parents/child-car-seats`}
              className="underline font-semibold px-1"
            >
              the baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Dependable, professional, and punctual rides for office staff,
            meetings, and business trips. Our local taxi service St Andrew's
            ensures smooth corporate travel with trained drivers and modern
            vehicles. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Reach cruise terminals on time with stress-free, reliable transfers.
            Our St. Andrew's
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>{" "}
            cab service includes help with luggage and smooth pickup and
            drop-off.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend concerts, weddings, or parties without transportation
            worries. Our St Andrew's taxi service handles schedules efficiently,
            providing safe and timely rides for you and your guests. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel comfortably with our maxi cab services St Andrew's. Spacious
            vehicles accommodate up to 12 passengers and luggage. Perfect for
            family outings, airport trips, or group events. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Move between offices, meetings, or events efficiently. Our local
            taxi cab service near me ensures professional, punctual, and
            comfortable rides every time. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our St Andrew's taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by St Andrew's Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Comfort is important on every trip, and St. Andrew's{" "}
        <Link
          target="_blank"
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        offers a range of vehicles to suit your needs. From solo rides to group
        transfers, our fleet focuses on safety, comfort, and reliability. Local
        drivers know the best routes through St. Andrew's and nearby suburbs,
        helping you avoid delays. Whether you are heading into the city,
        catching a flight, or booking a luxury trip, we have a vehicle suited to
        your plans. Rely on our St. Andrew's taxi and cab services for
        professional and convenient transport at any time.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for everyday travel, errands, or school runs. Our sedans are
            clean, spacious, and comfortable. With our St Andrew's taxi service,
            you will enjoy stress-free, safe, and reliable trips. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style for airport transfers, VIP trips, or special
            occasions. Our St Andrew's taxi cab service offers privacy, comfort,
            and punctual service with professional drivers. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Ideal for families, groups, or luggage-heavy trips. Our SUVs provide
            ample seating, smooth rides, and convenience. Our taxi services near
            me in St Andrew's ensures safe and comfortable travel. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for small groups or larger families. With plenty of seating
            and luggage space, our maxi cab near me in St Andrew's provides
            comfortable, reliable, and professional transport for airport or
            event travel. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious, safe, and reliable for up to 12 passengers or
            luggage-heavy trips. Our maxi cab services St Andrew's are perfect
            for family outings, corporate travel, and group trips. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for accessibility, safety, and comfort. Our local
            taxi service St Andrew's provides professional assistance, easy
            boarding, and convenient travel for seniors or passengers with
            mobility needs. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About St Andrew's   Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a St Andrew's   taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>St Andrew's taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in St Andrew's ?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services St Andrew's
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> St Andrew's taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>St Andrew's taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service St Andrew's </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> St Andrew's taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside St Andrew's ?",
        answer: (
          <>
            Yes. We cover St Andrew's,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact St Andrew's  Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>St Andrew's taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "st-helens-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26428.694682494446!2d150.81491865!3d-34.10572335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ef86d8cd3e19%3A0x5017d681632cbd0!2sSt%20Helens%20Park%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769796991883!5m2!1sen!2sbd",
    pageTitle:
      "St Helen's Park Taxi & Maxi Cabs: 24/7 Airport & Local Transfers",
    metaDescription:
      "Need a stress-free ride? St Helen's Park Taxi & Maxi Cabs offers reliable service anytime, anywhere in Campbelltown. Book online today!",
    heroTitle:
      "St Helen's Park Taxi & Maxi Cabs: 24/7 Airport & Local Transfers",
    heroDescription: (
      <>
        Looking for <strong>St Helen's Park Taxi & Maxi Cabs </strong> you can
        rely on? You’re in the right place. We provide
        <strong>fast, safe, and reliable taxi services</strong> across St
        Andrew’s and the wider Macarthur region. Whether you need a
        <strong>St Helen's Park taxi cab close to me,</strong> a maxi cab near
        me in St Helen's Park, or a local taxi service near me, we’ve got you
        covered.
        <br />
        Our modern fleet includes
        <strong>
          standard taxis, spacious maxi cabs, SUVs, and wheelchair-accessible
          vehicles.
        </strong>
        Every ride is clean, comfortable, and stress-free. Families, groups,
        solo travellers, and corporate passengers trust us for
        <strong>
          daily travel, station drop-offs, medical appointments, and airport
          transfers.
        </strong>
        Our experienced drivers know St Andrew’s routes inside out and ensure
        on-time journeys every time.
        <br />
        You can count on us for
        <strong>St Helen's Park taxi and cab services</strong>
        anywhere in St Andrew’s, Campbelltown, and surrounding Macarthur
        suburbs. From <strong>short local trips to long-distance rides,</strong>
        we make your travel simple, safe, and convenient.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Raby NSW",
    locationSectionTitle:
      "Trusted St Helen's Park Taxi for Airport Transfers and Corporate Travel | 24/7 Taxi & Maxi Cab Services",
    locationSectionDescription: (
      <>
        Need a <strong> St Helen's Park taxi cab service </strong> for corporate
        or airport travel?
        <strong>St Helen's Park Taxi & Maxi Cabs</strong>is your trusted choice.
        Our
        <strong>maxi cab services St Helen's Park </strong> cater to solo
        travellers, corporate teams, and groups. You can book taxi service near
        me or taxi cab service near me easily with our streamlined system.
        <br />
        We proudly support
        <strong>local St Andrew’s businesses</strong> including offices,
        professional services, and manufacturing facilities. Our 24/7 services
        cover
        <strong>
          Sydney Airport transfers, inter-office travel, group outings, and
          special events.
        </strong>
        <br />
        With experienced drivers, clean vehicles, and a focus on comfort and
        safety, your journey is always smooth. Whether you need a maxi cab near
        me, taxi service close to me, or local taxi cab service near me, we
        provide dependable, timely service every time.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in St Andrews",
    serviceSubtitle: (
      <>
        At
        <strong> St Andrews Taxi Cab, </strong> we deliver reliable and
        efficient taxi and maxi cab services in{" "}
        <strong>St Andrews NSW and surrounding areas.</strong> Whether you
        require a fast Sydney Airport transfer, a spacious maxi taxi for group
        travel, or a luxury taxi service for special occasions, we are here to
        help. Our experienced drivers provide safe, punctual, and comfortable
        journeys, making us a trusted choice for airport, corporate, and local
        taxi services in St Andrews.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your special day without transport stress. Our St Helen's
            Park taxi and cab services offer punctual pickups, professional
            drivers, and luggage assistance. We ensure smooth, comfortable
            journeys for all wedding guests. Book easily at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style for airport rides, business meetings, or VIP trips.
            Our St Helen's Park taxi cab service guarantees privacy, comfort,
            and punctual service every time. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your children safe with adjustable baby seats in our vehicles.
            Ideal for school runs, medical visits, or family outings, our St
            Andrew's taxi service ensures secure and comfortable travel. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Dependable, professional, and punctual rides for office staff,
            meetings, and business trips. Our local taxi service St Helen's Park
            ensures smooth corporate travel with trained drivers and modern
            vehicles. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals safely and on time. Our St Helen's Park
            taxi cab service provides luggage assistance and reliable rides,
            ensuring stress-free journeys. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend concerts, weddings, or parties without transportation
            worries. Our St Helen's Park taxi service handles schedules
            efficiently, providing safe and timely rides for you and your
            guests. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel comfortably with our maxi cab services St Helen's Park.
            Spacious vehicles accommodate up to 12 passengers and luggage.
            Perfect for family outings, airport trips, or group events. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Move between offices, meetings, or events efficiently. Our local
            taxi cab service near me ensures professional, punctual, and
            comfortable rides every time. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our St Helen's Park taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by St Helen's Park Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Comfort matters on every trip. With St Helen's Park Taxi & Maxi Cabs, you can select the perfect vehicle for your journey. From solo trips to group travel, our fleet provides safety, comfort, and punctuality. Our local drivers know the fastest and safest routes across St Helen's Park and nearby suburbs. Whether it’s a city ride, airport transfer, or luxury trip, we have the ideal vehicle for your travel needs. Rely on our St Helen's Park taxi and cab services for professional, reliable, and convenient rides every time.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for everyday travel, errands, or school runs. Our sedans are
            clean, spacious, and comfortable. With our St Helen's Park taxi
            service, you will enjoy stress-free, safe, and reliable trips. Book
            easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style for airport transfers, VIP trips, or special
            occasions. Our St Helen's Park taxi cab service offers privacy,
            comfort, and punctual service with professional drivers. Learn more
            at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Ideal for families, groups, or luggage-heavy trips. Our SUVs provide
            ample seating, smooth rides, and convenience. Our taxi services near
            me in St Helen's Park ensures safe and comfortable travel. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for small groups or larger families. With plenty of seating
            and luggage space, our maxi cab near me in St Helen's Park provides
            comfortable, reliable, and professional transport for airport or
            event travel. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Spacious, safe, and reliable for up to 12 passengers or
            luggage-heavy trips. Our maxi cab services St Helen's Park are
            perfect for family outings, corporate travel, and group trips. Learn
            more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped for accessibility, safety, and comfort. Our local
            taxi service St Helen's Park provides professional assistance, easy
            boarding, and convenient travel for seniors or passengers with
            mobility needs. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About St Helen's Park   Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a St Helen's Park   taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>St Helen's Park taxi cab close to me</strong> service
            ensures fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in St Helen's Park ?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services St Helen's Park
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> St Helen's Park taxi and cab services</strong> operate day
            and night, including weekends and holidays. You can rely on us
            whenever you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>St Helen's Park taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service St Helen's Park </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> St Helen's Park taxi cab service</strong> for airport
            trips, VIP travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside St Helen's Park ?",
        answer: (
          <>
            Yes. We cover St Helen's Park,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact St Helen's Park  Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>St Helen's Park taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "ruse-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13220.066559110199!2d150.84005670000005!3d-34.0690877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12efa236828397%3A0x5017d681632c9b0!2sRuse%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769797099585!5m2!1sen!2sbd",
    pageTitle: "Best Ruse Taxi & Maxi Cabs Near You – Book Anytime",
    metaDescription:
      "Need a stress-free ride? Ruse Taxi & Maxi Cabs offers reliable service anytime, anywhere in Campbelltown. Book online today!",
    heroTitle: "Best Ruse Taxi & Maxi Cabs Near You – Book Anytime",
    heroDescription: (
      <>
        Looking for{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Ruse Taxi & Maxi Cabs
        </Link>{" "}
        you can rely on? You’ve found the right service. Our
        <strong>Ruse taxi cab service</strong>provides fast, safe, and
        dependable transport across Ruse and the Macarthur region. Whether you
        need a taxi service close to me Ruse, a maxi cab near you, or local taxi
        service Ruse, we are available 24/7. <br />
        You can book a <strong>taxi and cab service in Ruse</strong> for daily
        commuting, medical appointments, station drop-offs, or long-distance
        rides. Families and groups love our <strong>maxi cabs in Ruse</strong>
        for smooth travel with luggage. Professional drivers and clean vehicles
        make every journey comfortable and stress-free.
        <br />
        From local trips to Sydney Airport transfers or corporate travel, our
        Ruse taxi and cab services cover all your transport needs. We serve
        Ruse, Campbelltown, Narellan, and surrounding areas with reliable taxi
        service in Ruse options whenever you need them.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Ruse NSW",
    locationSectionTitle:
      "Reliable Ruse Taxi & Maxi Cabs for Corporate Travel & Airport Transfers",
    locationSectionDescription: (
      <>
        Our{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Ruse Taxi & Maxi Cabs
        </Link>{" "}
        provide professional corporate and group transport across Ruse and the
        wider Macarthur region. Need a
        <strong>Ruse taxi cab close to me </strong>for a business trip or a
        <strong>maxi cab services Ruse </strong> for a team outing? We have you
        covered.
        <br />
        With a modern, well-maintained fleet and a streamlined booking system,
        we cater to solo travellers, corporate teams, and families. You can rely
        on our
        <strong> taxi service near me </strong> or
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          local taxi cab service near Ruse
        </Link>{" "}
        for punctual, smooth rides every time.
        <br />
        We proudly support local Ruse businesses, including offices and
        professional service firms, offering dependable corporate transport
        solutions. From airport transfers to inter-office travel or group
        outings, our Ruse taxi cab service keeps you on schedule. Experienced
        drivers, clean vehicles, and a focus on safety make us the trusted
        choice for corporate, airport, and group travel.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Ruse",
    serviceSubtitle: (
      <>
        We offer a wide range of services to meet your every need. No matter
        where you’re going, our professional drivers provide safe and efficient
        travel for all passengers. Here’s how we help you move with comfort and
        ease
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate without stress. Our vehicles arrive on time. Perfect for
            weddings and receptions in Ruse. We ensure your guests travel safely
            and in style. Enjoy professional service for a smooth, memorable day
            at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our premium vehicles. Ideal for business
            meetings or special events. You get punctual, safe rides every time.
            Experience a ride that matches your lifestyle at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. We provide approved child seats for
            worry-free journeys. You can book easily online or over the phone.
            Perfect for family travel around Ruse. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients and staff with professional rides. We manage airport
            transfers, meetings, and corporate events. Reliable service, modern
            vehicles, and flexible scheduling. Trust your company travel with
            us. . Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Reach the cruise terminal without hassle. Our drivers handle luggage
            and schedule pickups on time. Stress-free transfers for your holiday
            or business cruise. Every journey is smooth and reliable. . Details
            at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend parties, concerts, or sports events in style. We manage large
            groups with spacious Maxi Cabs. Travel together safely, without
            parking worries. Enjoy prompt and professional service. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for families and groups. Large vehicles carry everyone and
            their luggage comfortably. No need for multiple trips. You’ll enjoy
            convenience, reliability, and safety in every ride. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for business travel in Ruse. We offer punctual pickups
            and professional drivers. Focus on work while we handle the
            transport. Every ride reflects reliability and professionalism .
            More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Ruse taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Ruse Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We pride ourselves on a modern, versatile fleet. Whether you’re travelling solo, with family, or in a group, we have the perfect vehicle for your needs. Every ride combines comfort, safety, and reliability, giving you peace of mind. You’ll never worry about long waits or cramped vehicles. Our expert drivers ensure timely, smooth journeys every time.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips around Ruse or nearby suburbs. You can use it
            for daily commuting, school runs, or short shopping trips. The
            vehicle is comfortable, fuel-efficient, and easy to park. Perfect
            for solo travellers or couples needing reliable transport. Your ride
            will always be prompt and hassle-free. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort for meetings, corporate events, or
            special occasions. You’ll enjoy modern interiors, smooth handling,
            and a professional driver. Impress clients or relax during your
            journey without worrying about traffic or parking. Luxury travel has
            never been simpler or more enjoyable. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe, this option is perfect for families, groups, or
            those carrying extra luggage. You can easily manage school runs,
            shopping, or weekend trips. The vehicle provides comfort for every
            passenger, while keeping your belongings secure. Enjoy flexibility
            and reliability for any journey in Ruse. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Designed for larger groups, this vehicle comfortably seats up to 7
            passengers. You can travel together without leaving anyone behind.
            Ideal for Maxi Cab services, airport runs, or family outings. The
            extra space makes long journeys relaxed and stress-free, while your
            luggage stays organised and safe. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for events, corporate trips, or social outings with friends.
            You can carry more passengers and luggage comfortably. Our drivers
            handle busy routes and parking efficiently. You’ll enjoy a
            stress-free group travel experience. Maxi Cabs give you flexibility
            without compromising on safety or punctuality. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            experience convenience, comfort, and professional assistance
            throughout your journey. Our vehicles are fully equipped to handle
            wheelchairs safely. Perfect for medical appointments, social visits,
            or airport transfers. Your comfort and safety are always our top
            priority. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Ruse  Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Ruse taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Ruse taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Ruse?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Ruse
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Ruse taxi and cab services</strong> operate day and night,
            including weekends and holidays. You can rely on us whenever you
            need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Ruse taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Ruse </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Ruse taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers experienced and trustworthy?",
        answer: (
          <>
            Yes. All{" "}
            <Link
              target="_blank"
              to={`https://simple.wikipedia.org/wiki/Driver%27s_license`}
              className="underline font-semibold px-1"
            >
              drivers are licensed,
            </Link>{" "}
            vetted, and familiar with Ruse and surrounding suburbs. Safety and
            punctuality are our top priorities.
          </>
        ),
      },

      {
        question: "Do you provide luxury or corporate transport?",
        answer: (
          <>
            Yes. Our Premium Corporate Transport Services and Luxury Transfers
            ensure professional{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Travel`}
              className="underline font-semibold px-1"
            >
              travel
            </Link>
            for clients or executives.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I book a taxi for events or weddings?",
        answer: (
          <>
            Yes. We offer Premium Wedding Transfers and Event Transfers with
            professional drivers.
          </>
        ),
      },
      {
        question: "Do you operate during late nights and weekends?",
        answer: (
          <>
            Yes. We understand travel demands. Our service is available 24/7 for
            Ruse residents and visitors.
          </>
        ),
      },
      {
        question: " How can I contact Ruse Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Ruse taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "minto-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26451.830616649077!2d150.85019885!3d-34.03158645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ec7d3ed567ff%3A0x5017d681632c160!2sMinto%20NSW%202566%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769797620994!5m2!1sen!2sbd",
    pageTitle: "Minto Taxi & Maxi Cabs Services – 24/7 Convenient Transport",
    metaDescription:
      "Get affordable and on-time transport – Ruse Taxi & Maxi Cabs provide clean vehicles and expert drivers. Call today for quick bookings and comfortable rides.",
    heroTitle: "Minto Taxi & Maxi Cabs Services – 24/7 Convenient Transport",
    heroDescription: (
      <>
        Looking for{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Minto Ruse Taxi & Maxi Cabs
        </Link>{" "}
        you can rely on? You’re in the right place. Our service offers
        <strong>
          fast, safe, and dependable taxi and maxi cab services in Minto{" "}
        </strong>{" "}
        and the wider Macarthur region. Whether you need a
        <strong>Minto taxi cab close to me, a maxi cab near me,</strong> or a
        local taxi service Minto, we provide 24/7 support with professional
        drivers and clean, modern vehicles.
        <br />
        We cover{" "}
        <strong>
          daily travel, station drop-offs, medical appointments, corporate
          trips, and long-distance rides.
        </strong>{" "}
        Our fleet includes standard taxis, spacious maxi cabs services Minto,
        and accessible vehicles for every passenger. From local journeys to{" "}
        <strong>airport transfers and group travel</strong>, our drivers ensure
        you reach your destination safely, comfortably, and on time.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Minto NSW",
    locationSectionTitle:
      "Reliable Minto Taxi & Maxi Cabs for Travel | 24/7 Taxi and Maxi Cab Services",
    locationSectionDescription: (
      <>
        Our{" "}
        <strong>
          {" "}
          Minto{" "}
          <Link
            to={`/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
          Taxi & Maxi Cabs{" "}
        </strong>{" "}
        provide professional corporate and group transport across Minto and the
        wider Macarthur region. Need a
        <strong>Minto taxi cab close to me </strong>for a business trip or a
        <strong>maxi cab services Minto </strong> for a team outing? We have you
        covered.
        <br />
        With a modern, well-maintained fleet and a streamlined booking system,
        we cater to solo travellers, corporate teams, and families. You can rely
        on our
        <strong> taxi service near me </strong> or{" "}
        <strong>local taxi cab service near me </strong> for punctual, smooth
        rides every time.
        <br />
        We proudly support local Minto businesses, including offices and
        professional service firms, offering dependable corporate transport
        solutions. From airport transfers to inter-office travel or group
        outings, our Minto taxi cab service keeps you on schedule. Experienced
        drivers, clean vehicles, and a focus on safety make us the trusted
        choice for corporate, airport, and group travel.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Minto",
    serviceSubtitle: (
      <>
        At Minto Taxi Cab, we deliver reliable and efficient taxi and maxi cab
        services in Minto NSW and surrounding areas. Whether you require a fast
        Sydney Airport transfer, a spacious maxi taxi for group{" "}
        <Link
          target="_blank"
          to={`https://en.wikipedia.org/wiki/Travel`}
          className="underline font-semibold px-1"
        >
          travel,
        </Link>{" "}
        or a luxury taxi service for special occasions, we are here to help. Our
        experienced drivers provide safe, punctual, and comfortable journeys,
        making us a trusted choice for airport, corporate, and local{" "}
        <Link
          target="_blank"
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
        >
          taxi
        </Link>{" "}
        services in Minto.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate without stress. Our vehicles arrive on time. Perfect for
            weddings and receptions in Minto. We ensure your guests travel
            safely and in style. Enjoy professional service for a smooth,
            memorable day at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our premium vehicles. Ideal for business
            meetings or special events. You get punctual, safe rides every time.
            Experience a ride that matches your lifestyle at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. We provide approved child seats for
            worry-free journeys. You can book easily online or over the phone.
            Perfect for family travel around Minto. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients and staff with professional rides. We manage airport
            transfers, meetings, and corporate events. Reliable service, modern
            vehicles, and flexible scheduling. Trust your company travel with
            us. . Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Reach the cruise terminal without hassle. Our drivers handle luggage
            and schedule pickups on time. Stress-free transfers for your holiday
            or business cruise. Every journey is smooth and reliable. . Details
            at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend parties, concerts, or sports events in style. We manage large
            groups with spacious Maxi Cabs. Travel together safely, without
            parking worries. Enjoy prompt and professional service. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for families and groups. Large vehicles carry everyone and
            their luggage comfortably. No need for multiple trips. You’ll enjoy
            convenience, reliability, and safety in every ride. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for business travel in Minto. We offer punctual pickups
            and professional drivers. Focus on work while we handle the
            transport. Every ride reflects reliability and professionalism .
            More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Minto taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Minto Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We pride ourselves on a modern, versatile fleet. Whether you’re travelling solo, with family, or in a group, we have the perfect vehicle for your needs. Every ride combines comfort, safety, and reliability, giving you peace of mind. You’ll never worry about long waits or cramped vehicles. Our expert drivers ensure timely, smooth journeys every time.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips around Minto or nearby suburbs. You can use it
            for daily commuting, school runs, or short shopping trips. The
            vehicle is comfortable, fuel-efficient, and easy to park. Perfect
            for solo travellers or couples needing reliable transport. Your ride
            will always be prompt and hassle-free. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort for meetings, corporate events, or
            special occasions. You’ll enjoy modern interiors, smooth handling,
            and a professional driver. Impress clients or relax during your
            journey without worrying about traffic or parking. Luxury travel has
            never been simpler or more enjoyable. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe, this option is perfect for families, groups, or
            those carrying extra luggage. You can easily manage school runs,
            shopping, or weekend trips. The vehicle provides comfort for every
            passenger, while keeping your belongings secure. Enjoy flexibility
            and reliability for any journey in Minto. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Designed for larger groups, this vehicle comfortably seats up to 7
            passengers. You can travel together without leaving anyone behind.
            Ideal for Maxi Cab services, airport runs, or family outings. The
            extra space makes long journeys relaxed and stress-free, while your
            luggage stays organised and safe. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for events, corporate trips, or social outings with friends.
            You can carry more passengers and luggage comfortably. Our drivers
            handle busy routes and parking efficiently. You’ll enjoy a
            stress-free group travel experience. Maxi Cabs give you flexibility
            without compromising on safety or punctuality. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            experience convenience, comfort, and professional assistance
            throughout your journey. Our vehicles are fully equipped to handle
            wheelchairs safely. Perfect for medical appointments, social visits,
            or airport transfers. Your comfort and safety are always our top
            priority. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Minto   Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Minto   taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Minto taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Minto?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Minto
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Minto taxi and cab services</strong> operate day and night,
            including weekends and holidays. You can rely on us whenever you
            need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Minto taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Minto </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Minto taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Minto?",
        answer: (
          <>
            Yes. We cover Minto,Appin , Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Minto  Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Minto taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "glenfield-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26470.706280134043!2d150.8924733!3d-33.970995800000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12eb34aa2ec725%3A0x5017d681632b840!2sGlenfield%20NSW%202167%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769797856084!5m2!1sen!2sbd",
    pageTitle:
      "Book Glenfield Taxi & Maxi Cabs Anytime – Local & Long-Distance",
    metaDescription:
      "Choose Glenfield Taxi & Maxi Cabs for smooth local and long-distance trips – licensed drivers and spacious vehicles. Book now, 24/7.",
    heroTitle:
      "Book Glenfield Taxi & Maxi Cabs Anytime – Local & Long-Distance",
    heroDescription: (
      <>
        <strong>
          Glenfield{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>{" "}
        delivers dependable and professional taxi and maxi cab services in
        Glenfield NSW and the nearby Macarthur suburbs. You can rely on us for
        <strong>
          Glenfield taxi cab close to me, Glenfield taxi and cab services,
        </strong>{" "}
        or a<strong>local taxi service Glenfield </strong> anytime. We cater to
        families, group travellers, and corporate passengers with clean, modern
        vehicles driven by experienced local drivers.
        <br />
        Our diverse fleet includes standard taxis, spacious maxi cabs, SUVs,
        premium vehicles, and wheelchair-accessible taxis. No matter your
        journey, we provide a comfortable ride. Available 24/7, we offer Sydney
        Airport transfers, cruise terminal pickups, corporate transport, and
        everyday taxi service near me across Glenfield, Campbelltown, Narellan,
        and surrounding areas. Whether you need a maxi cab near me or Maxi cabs
        near me in Glenfield, we have the right option for you.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Glenfield NSW",
    locationSectionTitle:
      "Reliable Taxi and Maxi Cab Services in Glenfield NSW | 24/7 Taxi & Maxi Cab Services for Safe, Comfortable Travel",
    locationSectionDescription: (
      <>
        You can trust{" "}
        <strong>
          {" "}
          <Link
            to={`/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Glenfield Taxi & Maxi Cabs
          </Link>
        </strong>{" "}
        for professional corporate taxi and maxi cab services across Glenfield
        and the wider Macarthur region. If you search for{" "}
        <strong>taxi service close to me, taxi cab service near me</strong>or
        <strong>local taxi cab service near me</strong> we are ready to serve.
        <br />
        Our modern, well-maintained fleet and streamlined booking system ensure
        efficient and reliable transport for solo executives, corporate teams,
        and group travel. We proudly support local Glenfield businesses,
        including manufacturing facilities and professional service firms,
        providing dependable maxi cab services Glenfield that improve daily
        operations and business mobility.
        <br />
        Available 24/7, our services cover airport transfers, inter-office
        travel, and time-critical corporate journeys, giving you a smooth,
        professional experience every time. With experienced drivers focused on
        safety, comfort, and punctuality, Glenfield Taxi & Maxi Cabs is the
        trusted choice for corporate, airport, and group taxi services in
        Glenfield and across Macarthur NSW.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Glenfield",
    serviceSubtitle: (
      <>
        We provide{" "}
        <Link
          to={`/services/taxi-sydney-service`}
          className="underline font-semibold px-1"
        >
          professional taxi services
        </Link>{" "}
        near you in Glenfield. Every ride is safe, comfortable, and stress-free.
        Our vehicles and drivers meet your every travel requirement. Here’s how
        we make your journey effortless:
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your big day unforgettable. Our professional drivers ensure
            timely pickups. You’ll enjoy spacious vehicles, safe travel for
            guests, and a stress-free experience. Perfect for weddings in
            Glenfield and nearby suburbs. We handle every detail so you focus on
            celebrating. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our luxury vehicles. Ideal for business
            trips, airport transfers, or special events. You’ll enjoy a smooth
            ride, modern interiors, and reliable service. Our drivers take care
            of traffic and parking so you can arrive relaxed and on time.
            Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. Our taxis provide approved child seats
            for families traveling in Glenfield. You can rely on us for school
            runs, family outings, or airport trips. Booking is simple online or
            by phone, ensuring a stress-free family journey. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or manage staff travel with professional rides.
            You’ll enjoy punctual pickups, modern vehicles, and friendly
            drivers. Perfect for business trips, meetings, and airport transfers
            in Glenfield. Focus on work while we handle your transport
            efficiently. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals safely and on time. Our drivers handle
            luggage and schedule pickups according to your itinerary. Enjoy
            smooth, reliable service for holiday or business cruises. We make
            group and solo transfers hassle-free in Glenfield. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Get to concerts, parties, or sporting events with ease. Large groups
            fit comfortably in our Maxi Cabs. You’ll avoid parking stress and
            enjoy prompt pickups. Our professional drivers ensure a smooth,
            safe, and fun travel experience for you and your friends. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for families or groups with luggage. You won’t need multiple
            vehicles for trips. Perfect for airport transfers, social outings,
            or corporate trips in Glenfield. Our Maxi Cabs provide space,
            comfort, and reliable service every time. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for professional business travel in Glenfield. Punctual
            pickups, friendly drivers, and modern vehicles ensure a smooth
            experience. You’ll arrive prepared and on time. Every ride reflects
            reliability, safety, and efficiency for your work needs. More
            details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Glenfield taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Glenfield  Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Our fleet is designed to suit any journey in Glenfield. Whether it’s a
        local trip or long-distance travel, you’ll enjoy comfort, safety, and
        reliability. Every{" "}
        <Link
          target="_blank"
          to={`https://en.wikipedia.org/wiki/Vehicle`}
          className="underline font-semibold px-1"
        >
          vehicle
        </Link>{" "}
        is well-maintained, clean, and driven by experienced professionals.
      </>
    ),
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips around Glenfield or nearby suburbs. You can
            use it for daily commuting, school runs, or short shopping trips.
            The vehicle is comfortable, fuel-efficient, and easy to park.
            Perfect for solo travellers or couples needing reliable transport.
            Your ride will always be prompt and hassle-free. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort for meetings, corporate events, or
            special occasions. You’ll enjoy modern interiors, smooth handling,
            and a professional driver. Impress clients or relax during your
            journey without worrying about traffic or parking. Luxury travel has
            never been simpler or more enjoyable. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe, this option is perfect for families, groups, or
            those carrying extra luggage. You can easily manage school runs,
            shopping, or weekend trips. The vehicle provides comfort for every
            passenger, while keeping your belongings secure. Enjoy flexibility
            and reliability for any journey in Glenfield . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Designed for larger groups, this vehicle comfortably seats up to 7
            passengers. You can travel together without leaving anyone behind.
            Ideal for Maxi Cab services, airport runs, or family outings. The
            extra space makes long journeys relaxed and stress-free, while your
            luggage stays organised and safe. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for events, corporate trips, or social outings with friends.
            You can carry more passengers and luggage comfortably. Our drivers
            handle busy routes and parking efficiently. You’ll enjoy a
            stress-free group travel experience. Maxi Cabs give you flexibility
            without compromising on safety or punctuality. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            experience convenience, comfort, and professional assistance
            throughout your journey. Our vehicles are fully equipped to handle
            wheelchairs safely. Perfect for medical appointments, social visits,
            or airport transfers. Your comfort and safety are always our top
            priority. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Glenfield    Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Glenfield taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Glenfield taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide Maxi Cab services in Glenfield?",
        answer: (
          <>
            Yes, our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              maxi cab services Glenfield
            </Link>{" "}
            accommodate up to 12 passengers. Perfect for families, group travel,
            and airport transfers with ample luggage space.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Glenfield taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable baby seats are available for safety. Travel
            comfortably for school runs, appointments, or family outings with
            our
            <strong>Glenfield taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Glenfield </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Do you provide luxury or corporate transfers?",
        answer: (
          <>
            Yes. Our Premium Corporate Transport and Luxury Transfers ensure
            professional, comfortable{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driving`}
              className="underline font-semibold px-1"
            >
              rides.
            </Link>
          </>
        ),
      },

      {
        question: " Do you operate outside Glenfield ?",
        answer: (
          <>
            Yes. We cover Glenfield ,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Glenfield   Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Glenfield taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "camden-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26443.38812605632!2d150.69372610000002!3d-34.058656049999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f100fc3b4915%3A0x5017d6816333c30!2sCamden%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769798143967!5m2!1sen!2sbd",
    pageTitle: "Affordable Camden Taxi & Maxi Cabs | Call for Instant Pickup",
    metaDescription:
      "Need safe transport today? Camden South Taxi & Maxi Cabs offers on-time service, friendly drivers & fair rates. Book your ride now. 24/7 availability.",
    heroTitle: "Affordable Camden Taxi & Maxi Cabs | Call for Instant Pickup",
    heroDescription: (
      <>
        Looking for Camden Taxi & Maxi Cabs you can rely on? You’ve found the
        right service. We provide professional and affordable Camden taxi and
        cab services 24/7. Whether you need a Camden taxi cab close to me, a
        taxi service near me, or a local taxi cab service near me, we are always
        ready to pick you up.
        <br />
        Our fleet includes standard taxis, spacious maxi cabs, SUVs, premium
        vehicles, and wheelchair-accessible taxis. Every ride is clean, safe,
        and comfortable. Families, groups, and corporate travellers trust us for
        smooth journeys. You can rely on us for airport transfers, corporate
        transport, cruise terminal pickups, or everyday local taxi services
        across Camden, Campbelltown, Narellan, and surrounding areas.
      </>
    ),
    bookingFormTitle: "Book Wheelchair Taxi in Camden,NSW",
    locationSectionTitle:
      "Reliable Taxi and Maxi Cab Services in Camden, NSW – Airport & Corporate Transfers",
    locationSectionDescription: (
      <>
        Need professional corporate taxi and maxi cab services in Camden? Our
        Camden Taxi & Maxi Cabs provide efficient and reliable transport for
        executives, teams, and groups. You can book easily through our
        streamlined system, and our well-maintained fleet ensures comfort and
        safety for every ride.
        <br />
        We support local Camden businesses, including offices and manufacturing
        facilities, with dependable corporate transport. From airport transfers
        to inter-office travel, we cover all time-critical journeys. You can
        trust our experienced drivers to deliver punctual, secure, and
        comfortable rides. For Camden taxi cab service, local taxi service
        Camden, or maxi cab services Camden, we are the reliable choice across
        Camden and the wider Macarthur region.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Camden",
    serviceSubtitle: (
      <>
        We provide reliable taxi services near you in Camden. Each ride is
        designed for your safety, comfort, and convenience. Our vehicles are
        clean, modern, and driven by friendly, professional drivers. Here’s how
        we make every journey easy:
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your big day unforgettable. Our professional drivers ensure
            timely pickups. You’ll enjoy spacious vehicles, safe travel for
            guests, and a stress-free experience. Perfect for weddings in and
            nearby suburbs. We handle every detail so you focus on celebrating.
            Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our luxury vehicles. Ideal for business
            trips, airport transfers, or special events. You’ll enjoy a smooth
            ride, modern interiors, and reliable service. Our drivers take care
            of traffic and parking so you can arrive relaxed and on time.
            Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. Our taxis provide approved child seats
            for families traveling in Camden South. You can rely on us for
            school runs, family outings, or airport trips. Booking is simple
            online or by phone, ensuring a stress-free family journey. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or manage staff travel with professional rides.
            You’ll enjoy punctual pickups, modern vehicles, and friendly
            drivers. Perfect for business trips, meetings, and airport transfers
            in Camden South. Focus on work while we handle your transport
            efficiently. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals safely and on time. Our drivers handle
            luggage and schedule pickups according to your itinerary. Enjoy
            smooth, reliable service for holiday or business cruises. We make
            group and solo transfers hassle-free in Camden South. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Get to concerts, parties, or sporting events with ease. Large groups
            fit comfortably in our Maxi Cabs. You’ll avoid parking stress and
            enjoy prompt pickups. Our professional drivers ensure a smooth,
            safe, and fun travel experience for you and your friends. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for families or groups with luggage. You won’t need multiple
            vehicles for trips. Perfect for airport transfers, social outings,
            or corporate trips in Camden South. Our Maxi Cabs provide space,
            comfort, and reliable service every time. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for professional business travel in Camden South.
            Punctual pickups, friendly drivers, and modern vehicles ensure a
            smooth experience. You’ll arrive prepared and on time. Every ride
            reflects reliability, safety, and efficiency for your work needs.
            More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Camden taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Camden  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Our fleet is designed to suit any journey in Camden. Whether it’s a local trip or long-distance travel, you’ll enjoy comfort, safety, and reliability. Every vehicle is well-maintained, clean, and driven by experienced professionals.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips around Camden or nearby suburbs. You can use
            it for daily commuting, school runs, or short shopping trips. The
            vehicle is comfortable, fuel-efficient, and easy to park. Perfect
            for solo travellers or couples needing reliable transport. Your ride
            will always be prompt and hassle-free. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort for meetings, corporate events, or
            special occasions. You’ll enjoy modern interiors, smooth handling,
            and a professional driver. Impress clients or relax during your
            journey without worrying about traffic or parking. Luxury travel has
            never been simpler or more enjoyable. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe, this option is perfect for families, groups, or
            those carrying extra luggage. You can easily manage school runs,
            shopping, or weekend trips. The vehicle provides comfort for every
            passenger, while keeping your belongings secure. Enjoy flexibility
            and reliability for any journey in Camden . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Designed for larger groups, this vehicle comfortably seats up to 7
            passengers. You can travel together without leaving anyone behind.
            Ideal for Maxi Cab services, airport runs, or family outings. The
            extra space makes long journeys relaxed and stress-free, while your
            luggage stays organised and safe. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for events, corporate trips, or social outings with friends.
            You can carry more passengers and luggage comfortably. Our drivers
            handle busy routes and parking efficiently. You’ll enjoy a
            stress-free group travel experience. Maxi Cabs give you flexibility
            without compromising on safety or punctuality. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            experience convenience, comfort, and professional assistance
            throughout your journey. Our vehicles are fully equipped to handle
            wheelchairs safely. Perfect for medical appointments, social visits,
            or airport transfers. Your comfort and safety are always our top
            priority. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Camden    Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Camden    taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Camden taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Camden.
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with . Safety,
            punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Camden taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Camden taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Camden </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Camden taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Camden ?",
        answer: (
          <>
            Yes. We cover Camden ,Appin , Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Camden   Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Camden taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "camden-south-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13218.005903756077!2d150.70061644999998!3d-34.08229164999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f0f84fddbf9b%3A0x5017d6816333c40!2sCamden%20South%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769798185288!5m2!1sen!2sbd",
    pageTitle: "Camden Taxi & Maxi Cabs - Reliable 24/7 Local Transport",
    metaDescription:
      "Camden Taxi & Maxi Cabs - Fast, safe rides in Camden. Book 24/7 online or call us now. Enjoy reliable, licensed service today!",
    heroTitle: "Camden Taxi & Maxi Cabs - Reliable 24/7 Local Transport",
    heroDescription: (
      <>
        Looking for
        <strong>
          Camden South{" "}
          <Link
            to={`/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>
        provides safe, reliable, and 24/7 transport services for local
        residents, students, professionals, families, and seniors. Our fleet
        includes modern taxis and spacious maxi cabs, ideal for individuals and
        groups. With flexible booking options, professional drivers, and
        transparent pricing, we ensure a comfortable journey every time. From
        airport transfers to corporate trips, our services cater to all travel
        needs. If you’re searching for a{" "}
        <strong>taxi service close to me</strong> or maxi cabs near me in
        Camden, we’re just a call or click away. Our local expertise, commitment
        to punctuality, and focus on safety make us the preferred choice for
        everyone in Camden. Trust us to provide hassle-free rides with
        convenient booking, reliable vehicles, and friendly drivers.
      </>
    ),
    bookingFormTitle: "Book Wheelchair Taxi in Camden,NSW",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Camden",
    locationSectionDescription: (
      <>
        Need professional{" "}
        <strong>
          corporate taxi and maxi cab services in Camden South? Our Camden South
          Taxi & Maxi Cabs
        </strong>
        provide efficient and reliable transport for executives, teams, and
        groups. You can book easily through our streamlined system, and our{" "}
        <Link to={`/fleet`} className="underline font-semibold px-1">
          well-maintained fleet
        </Link>{" "}
        ensures comfort and safety for every ride. <br />
        We support local Camden South businesses, including offices and
        manufacturing facilities, with dependable corporate transport. From
        airport transfers to inter-office travel, we cover all time-critical
        journeys. You can trust our experienced drivers to deliver punctual,
        secure, and comfortable rides. For
        <strong>
          Camden South taxi cab service, local taxi service Camden South,
        </strong>{" "}
        or
        <strong>maxi cab services Camden South,</strong>, we are the reliable
        choice across Camden South and the wider Macarthur region.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Camden",
    serviceSubtitle: (
      <>
        We provide reliable{" "}
        <Link
          to={`/services/taxi-sydney-service`}
          className="underline font-semibold px-1"
        >
          taxi services
        </Link>
        near you in Camden South. Each ride is designed for your safety,
        comfort, and convenience. Our vehicles are clean, modern, and driven by
        friendly, professional drivers. Here’s how we make every journey easy:
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your big day unforgettable. Our professional drivers ensure
            timely pickups. You’ll enjoy spacious vehicles, safe travel for
            guests, and a stress-free experience. Perfect for weddings in and
            nearby suburbs. We handle every detail so you focus on celebrating.
            Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style for business or special occasions. You’ll enjoy
            modern interiors, smooth rides, and{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
            >
              professional drivers.
            </Link>{" "}
            Perfect for airport trips, corporate meetings, or celebratory
            events. Arrive relaxed, on time, and ready to impress every time.
            Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. Our taxis provide approved child seats
            for families traveling in Camden. You can rely on us for school
            runs, family outings, or airport trips. Booking is simple online or
            by phone, ensuring a stress-free family journey. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or manage staff travel with professional rides.
            You’ll enjoy punctual pickups, modern vehicles, and friendly
            drivers. Perfect for business trips, meetings, and airport transfers
            in Camden. Focus on work while we handle your transport efficiently.
            Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals safely and on time. Our drivers handle
            luggage and schedule pickups according to your itinerary. Enjoy
            smooth, reliable service for holiday or business cruises. We make
            group and solo transfers hassle-free in Camden. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Get to concerts, parties, or sporting events with ease. Large groups
            fit comfortably in our Maxi Cabs. You’ll avoid parking stress and
            enjoy prompt pickups. Our professional drivers ensure a smooth,
            safe, and fun travel experience for you and your friends. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for families or groups with luggage. You won’t need multiple
            vehicles for trips. Perfect for airport transfers, social outings,
            or corporate trips in Camden. Our Maxi Cabs provide space, comfort,
            and reliable service every time. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for professional business travel in Camden. Punctual
            pickups, friendly drivers, and modern vehicles ensure a smooth
            experience. You’ll arrive prepared and on time. Every ride reflects
            reliability, safety, and efficiency for your work needs. More
            details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Camden taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Camden  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Our fleet is designed to suit any journey in Camden. Whether it’s a local trip or long-distance travel, you’ll enjoy comfort, safety, and reliability. Every vehicle is well-maintained, clean, and driven by experienced professionals.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips around Camden or nearby suburbs. You can use
            it for daily commuting, school runs, or short shopping trips. The
            vehicle is comfortable, fuel-efficient, and easy to park. Perfect
            for solo travellers or couples needing reliable transport. Your ride
            will always be prompt and hassle-free. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort for meetings, corporate events, or
            special occasions. You’ll enjoy modern interiors, smooth handling,
            and a professional driver. Impress clients or relax during your
            journey without worrying about traffic or parking. Luxury travel has
            never been simpler or more enjoyable. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe, this option is perfect for families, groups, or
            those carrying extra luggage. You can easily manage school runs,
            shopping, or weekend trips. The vehicle provides comfort for every
            passenger, while keeping your belongings secure. Enjoy flexibility
            and reliability for any journey in Camden . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Designed for larger groups, this vehicle comfortably seats up to 7
            passengers. You can travel together without leaving anyone behind.
            Ideal for Maxi Cab services, airport runs, or family outings. The
            extra space makes long journeys relaxed and stress-free, while your
            luggage stays organised and safe. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for events, corporate trips, or social outings with friends.
            You can carry more passengers and luggage comfortably. Our drivers
            handle busy routes and parking efficiently. You’ll enjoy a
            stress-free group travel experience. Maxi Cabs give you flexibility
            without compromising on safety or punctuality. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            experience convenience, comfort, and professional assistance
            throughout your journey. Our vehicles are fully equipped to handle
            wheelchairs safely. Perfect for medical appointments, social visits,
            or airport transfers. Your comfort and safety are always our top
            priority. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Camden    Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Camden    taxi near me?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Camden taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our Maxi Taxi Service accommodates large groups and
            luggage. Perfect for events, family trips, or corporate travel in
            Camden South.
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Camden taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Camden taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Camden </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Camden taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Camden ?",
        answer: (
          <>
            Yes. We cover Camden ,Appin , Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Do you provide luxury or corporate transfers?",
        answer: (
          <>
            Yes. Our Premium Corporate Transport Services and Luxury Transfers
            guarantee professional and
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driving`}
              className="underline font-semibold px-1"
            >
              comfortable rides.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I book taxis for weddings or events?",
        answer: (
          <>
            Yes. Our Premium Wedding Transfers and Event Transfers are perfect
            for group travel and special occasions.
          </>
        ),
      },
      {
        question: " How can I contact Camden South Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Camden taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "gregory-hills-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26451.814077142175!2d150.77705644999998!3d-34.03163950000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ee0339afd07b%3A0xdd01b13b920dd7e1!2sGregory%20Hills%20NSW%202557%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769798835792!5m2!1sen!2sbd",
    pageTitle: "Professional Gregory Hills Taxi & Maxi Cabs Near You",
    metaDescription:
      "Choose Gregory Hills Taxi & Maxi Cabs for safe, affordable rides – perfect for families and groups. Call today for instant booking. Spacious maxi cabs available.",
    heroTitle: "Professional Gregory Hills Taxi & Maxi Cabs Near You",
    heroDescription: (
      <>
        Looking for{" "}
        <Link to={`/fleet`} className="underline font-semibold px-1">
          Gregory Hills Taxi & Maxi Cabs
        </Link>{" "}
        you can trust? You've come to the right place. We provide dependable,
        24/7 local taxi service in Gregory Hills and the surrounding Macarthur
        suburbs. Whether you need a Gregory Hills taxi cab near you, a maxi cab,
        or a local taxi cab service in Gregory, we have the perfect ride for
        you.
        <br />
        Our fleet includes standard taxis, spacious maxi cabs, SUVs, premium
        vehicles, and wheelchair-accessible taxis. Every vehicle is clean, safe,
        and comfortable. Families, groups, and corporate travellers enjoy
        stress-free journeys with our experienced local drivers. <br />
        We offer{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Sydney Airport transfers,
        </Link>{" "}
        cruise terminal pickups, corporate transport, and everyday taxi service.
        From Gregory Hills to Campbelltown, Narellan, and nearby areas, we make
        your travel smooth, timely, and worry-free.
      </>
    ),
    bookingFormTitle: "Book Wheelchair Taxi in Gregory Hills, NSW",
    locationSectionTitle:
      "Trusted Taxi and Maxi Cab Services in Gregory Hills, NSW",
    locationSectionDescription: (
      <>
        Need reliable{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          taxi and cab services
        </Link>{" "}
        in Gregory Hills for work or group travel? Our Gregory Hills Taxi & Maxi
        Cabs provide professional, safe, and on-time corporate transport across
        Gregory Hills and the wider Macarthur region.
        <br />
        We make booking simple with a streamlined system and a well-maintained
        modern fleet. Whether you’re an executive, a corporate team, or a group,
        our maxi cab services in Gregory Hills handle your travel efficiently.
        <br />
        We proudly support local Gregory Hills businesses, from offices to
        manufacturing facilities. Our corporate taxi service covers airport
        transfers, inter-office travel, and time-sensitive journeys, ensuring
        you stay on schedule.
        <br />
        With experienced drivers focused on safety, comfort, and punctuality,
        you can trust Gregory Hills Taxi & Maxi Cabs for local taxi service near
        me, maxi cabs near me in Gregory Hills, and all your professional or
        family travel needs.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Gregory Hills",
    serviceSubtitle: (
      <>
        We offer professional Gregory Hills taxi and cab services designed for
        your convenience. Every ride is safe, comfortable, and tailored to meet
        your needs. Here’s how we make your travel effortless:
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your wedding day perfect with our professional drivers. We
            ensure timely pickups, spacious vehicles, and safe journeys. Guests
            enjoy comfort and style for venue transfers or family travel. You
            can relax knowing every ride is handled efficiently. Our service
            covers Gregory Hills and surrounding areas. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with modern, luxurious vehicles. Ideal for corporate
            events, airport transfers, or special occasions. You’ll enjoy smooth
            rides, professional drivers, and on-time arrivals. Forget parking or
            traffic worries while we take care of the route. Every ride is
            tailored to your comfort and schedule. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your children safe with our approved child seats. Perfect for
            school runs, family outings, or airport trips in Gregory Hills. You
            can book easily online or by phone. Enjoy worry-free travel while
            your little ones are secure and comfortable on every journey. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Manage business travel with ease. Our professional drivers provide
            punctual pickups, modern vehicles, and flexible scheduling. You’ll
            impress clients and ensure smooth airport or meeting transfers. We
            focus on efficiency and reliability so your work travel in Gregory
            Hills is stress-free. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals with confidence. Our drivers manage
            luggage and schedule pickups according to your itinerary. You’ll
            enjoy seamless and safe transfers. Perfect for holidays, business
            cruises, or group travel. Every journey is smooth, professional, and
            reliable. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend events, concerts, or sports games without the hassle. Large
            groups can travel together in our Maxi Cabs. You’ll enjoy timely
            pickups, safe travel, and professional service. No parking stress,
            no delays—just a smooth and enjoyable experience. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for families, friends, or corporate groups. Our Maxi Cabs
            provide ample seating and luggage space. You won’t need multiple
            vehicles for group travel. Perfect for airport trips, social
            outings, or special events in Gregory Hills. Comfort and reliability
            come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for professional business transport. Punctual pickups,
            courteous drivers, and modern vehicles make your work travel
            seamless. Whether it’s meetings, conferences, or airport transfers,
            you’ll arrive prepared and on time every time. Our service reflects
            reliability and trust. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Gregory Hills taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Gregory Hills Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        Our modern fleet is perfect for all types of trips in Gregory Hills.
        From short commutes to long-distance travel, we ensure comfort, safety,
        and efficiency. Every vehicle is clean, well-maintained, and driven by{" "}
        <Link
          target="_blank"
          to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
          className="underline font-semibold px-1"
        >
          experienced drivers.
        </Link>
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Gregory Hills or nearby suburbs. You can
            rely on it for shopping, work, or airport runs. Comfortable,
            fuel-efficient, and easy to park, it’s perfect for solo travelers or
            couples. You’ll enjoy reliable, stress-free rides every time. Book
            easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Gregory Hills. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            enjoy comfort, safety, and professional assistance. Perfect for
            medical appointments, social visits, or airport transfers. Every
            journey prioritises accessibility, reliability, and peace of mind.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Gregory Hills    Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a Gregory Hills taxi near me?",
        answer: (
          <>
            Book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Taxi Booking page
            </Link>{" "}
            or call <strong>1300 450 428.</strong> Bookings guarantee timely
            pickups and reliable service.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service
            </Link>
            accommodates large groups and luggage. Ideal for events, family
            trips, or corporate travel in Gregory Hills.
          </>
        ),
      },
      {
        question: "Are your drivers experienced and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Gregory
            Hills routes. Safety, punctuality, and professionalism are
            guaranteed.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Gregory Hills taxi and cab services</strong> operate day
            and night, including weekends and holidays. You can rely on us
            whenever you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Gregory Hills taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Gregory Hills taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Gregory Hills ?",
        answer: (
          <>
            Yes. We cover Gregory Hills ,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question: " How can I contact Gregory Hills   Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Gregory Hills taxi cab service </strong>
            today.
          </>
        ),
      },
    ],
  },
  "wilton-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105521.80591658501!2d150.68159464999997!3d-34.2598604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12fd9bcf11dc3b%3A0x40609b490439250!2sWilton%20NSW%202571%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769799284436!5m2!1sen!2sbd",
    pageTitle: "Wilton Taxi & Maxi Cabs – 24/7 Taxi & Maxi Cab Hire",
    metaDescription:
      "Wilton Taxi & Maxi Cabs provides dependable local transport – Ideal for families, groups, and airport trips. Call now for quick pickup.",
    heroTitle: "Wilton Taxi & Maxi Cabs – 24/7 Taxi & Maxi Cab Hire",
    heroDescription: (
      <>
        Looking for a reliable, safe, and professional taxi service in Wilton?{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Wilton Taxi & Maxi Cabs
        </Link>{" "}
        offers 24/7 taxi and maxi cab services tailored to meet the travel needs
        of residents, families, students, professionals, and seniors. Our fleet
        includes{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/fleet`}
          className="underline font-semibold px-1"
        >
          standard taxis,
        </Link>
        luxury vehicles, and spacious maxi cabs for group travel. With prompt
        pickups, professional drivers, and transparent pricing, we ensure a
        smooth and stress-free journey. Whether it’s a short trip across town,
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          airport transfer,
        </Link>{" "}
        or a special event, our team is committed to providing comfort, safety,
        and reliability every time. Experience Wilton’s most trusted taxi and
        maxi cab service today, designed to handle all travel requirements, from
        solo travelers to groups with luggage. Book easily online or via phone
        and enjoy a seamless ride with <strong>Wilton Taxi & Maxi Cabs</strong>.
      </>
    ),
    bookingFormTitle: "Book Wheelchair Taxi in Wilton",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Wilton, NSW",
    locationSectionDescription: (
      <>
        When it comes to{" "}
        <strong>trusted taxi and maxi cab services in Wilton</strong>, locals
        rely on us for prompt, safe, and reliable rides. Many residents face
        common travel issues such as long waits during peak hours, last-minute
        cancellations from ride-share apps, or vehicle limitations that don’t
        accommodate families or luggage.{" "}
        <strong>Wilton Taxi & Maxi Cabs</strong> solves these problems with a
        wide range of vehicle options, including standard taxis, maxi cabs, and
        luxury rides. Our drivers are professional, licensed, and experienced in
        navigating Wilton’s local routes, ensuring timely pickups and safe
        journeys. With 24/7 availability, easy phone booking, and advance
        scheduling options, we cater to both spontaneous trips and pre-planned
        journeys. Families, seniors, and professionals choose us for airport
        transfers, group travel, and local trips because we understand their
        unique travel needs. Trust our locally-based service for convenience,
        comfort, and peace of mind.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Wilton",
    serviceSubtitle: (
      <>
        At <strong>Wilton Taxi & Maxi Cabs</strong>, we offer a complete range
        of taxi and maxi cab services to cater to every travel requirement.
        Whether you need a ride for daily commuting, family outings, or special
        occasions, our vehicles and drivers ensure a seamless travel experience.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your wedding day perfect with our professional drivers. We
            ensure timely pickups, spacious vehicles, and safe journeys. Guests
            enjoy comfort and style for venue transfers or family travel. You
            can relax knowing every ride is handled efficiently. Our service
            covers Wilton and surrounding areas. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Need a premium travel experience? Choose our
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury taxi and maxi cab service
            </Link>
            for a stylish and comfortable ride. Ideal for corporate clients,
            special events, or those seeking extra comfort, our luxury vehicles
            combine elegance with reliability, ensuring a first-class experience
            in Wilton.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your children safe with our approved child seats. Perfect for
            school runs, family outings, or airport trips in Wilton. You can
            book easily online or by phone. Enjoy worry-free travel while your
            little ones are secure and comfortable on every journey. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Manage business travel with ease. Our professional drivers provide
            punctual pickups, modern vehicles, and flexible scheduling. You’ll
            impress clients and ensure smooth airport or meeting transfers. We
            focus on efficiency and reliability so your work travel in Wilton is
            stress-free. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Travel to cruise terminals with confidence. Our drivers manage
            luggage and schedule pickups according to your itinerary. You’ll
            enjoy seamless and safe transfers. Perfect for holidays, business
            cruises, or group travel. Every journey is smooth, professional, and
            reliable. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attend events, concerts, or sports games without the hassle. Large
            groups can travel together in our Maxi Cabs. You’ll enjoy timely
            pickups, safe travel, and professional service. No parking stress,
            no delays—just a smooth and enjoyable experience. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for families, friends, or corporate groups. Our Maxi Cabs
            provide ample seating and luggage space. You won’t need multiple
            vehicles for group travel. Perfect for airport trips, social
            outings, or special events in Wilton. Comfort and reliability come
            standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Depend on us for professional business transport. Punctual pickups,
            courteous drivers, and modern vehicles make your work travel
            seamless. Whether it’s meetings, conferences, or airport transfers,
            you’ll arrive prepared and on time every time. Our service reflects
            reliability and trust. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Wilton taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Wilton Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Our modern fleet is perfect for all types of trips in Wilton. From short commutes to long-distance travel, we ensure comfort, safety, and efficiency. Every vehicle is clean, well-maintained, and driven by experienced drivers.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Wilton or nearby suburbs. You can rely on
            it for shopping, work, or airport runs. Comfortable, fuel-efficient,
            and easy to park, it’s perfect for solo travelers or couples. You’ll
            enjoy reliable, stress-free rides every time. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Wilton. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Our Kia Carnival vehicles are ideal for
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              group travel,
            </Link>
            airport pickups, or family trips, offering ample seating and luggage
            space for stress-free travel.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            enjoy comfort, safety, and professional assistance. Perfect for
            medical appointments, social visits, or airport transfers. Every
            journey prioritises accessibility, reliability, and peace of mind.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Wilton Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Wilton?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Wilton taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups. Advance bookings are recommended for
            airport transfers or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Wilton.
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Wilton taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Wilton taxi service</strong>
          </>
        ),
      },
      {
        question: "Can I request a child seat for my ride?",
        answer: (
          <>
            Yes, we offer baby seat{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>
            services to ensure children's safety during the journey.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Wilton taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Wilton ?",
        answer: (
          <>
            Yes. We cover Wilton ,Appin , Camden, Liverpool, and nearby suburbs.
            Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question:
          "Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>
            services are fully equipped to provide safe and comfortable
            transportation for passengers with mobility needs.
          </>
        ),
      },
      {
        question: " How can I contact Wilton   Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Wilton taxi cab service </strong>
            today.
          </>
        ),
      },
      {
        question: "  Is pricing transparent?",
        answer: (
          <>
            All rides have clear pricing with no hidden charges. We also offer
            fixed-price bookings for added convenience.
          </>
        ),
      },
    ],
  },
  "phesant-nest-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105521.80591658501!2d150.68159464999997!3d-34.2598604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b13010d92f18e6f%3A0x40609b490439120!2sPheasants%20Nest%20NSW%202574%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769799904103!5m2!1sen!2sbd",
    pageTitle: "Phesant Nest Taxi & Maxi Cabs | Reliable Local Transport",
    metaDescription:
      "Looking for reliable rides? Phesant Nest Taxi & Maxi Cabs delivers convenient local transport across Campbelltown. Book today and ride with confidence.",
    heroTitle: "Phesant Nest Taxi & Maxi Cabs | Reliable Local Transport",
    heroDescription: (
      <>
        Looking for reliable taxi and maxi cab services in Phesant Nest?
        <strong>
          Phesant Nest{" "}
          <Link
            to={`/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>
        offers 24/7 professional transportation for residents, students,
        professionals, and families. Our locally based service ensures fast
        pickups, safe journeys, and convenient travel options tailored to your
        schedule. Whether it’s{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          airport transfers,
        </Link>
        corporate travel, or group trips, our fleet of taxis and maxi cabs
        caters to all your travel needs. With punctual drivers, affordable
        fares, and a customer-first approach, we make commuting stress-free.
        Trust us to deliver a comfortable, dependable, and safe ride every time
        you choose
        <strong>Phesant Nest Taxi & Maxi Cabs.</strong>.
      </>
    ),
    bookingFormTitle: "Book Corporate Transport in Phesant Nest",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Phesant Nest",
    locationSectionDescription: (
      <>
        At
        <strong>Phesant Nest Taxi & Maxi Cabs</strong>, we understand the
        frustration of long wait times, unavailable rides, and unsafe transport
        options. Our service solves these problems by offering 24/7
        availability, professional drivers, and a diverse fleet including
        standard taxis and maxi cabs near me in Phesant Nest. Whether you are a
        student needing a safe ride to class, a professional commuting to work,
        or a family traveling with luggage, our team ensures you reach your
        destination promptly. We focus on safety, reliability, and convenience,
        addressing common pain points like vehicle limitations, cost concerns,
        and ride cancellations. With our local knowledge and community-focused
        service, you can enjoy
        <strong>trustworthy taxi cab service near me </strong> anytime, anywhere
        in Phesant Nest.{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Book online or call us
        </Link>{" "}
        for quick dispatch and enjoy a smooth, stress-free journey.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Phesant Nest",
    serviceSubtitle: (
      <>
        We offer a wide range of services to meet your unique transportation
        requirements. From short local trips to long-distance airport transfers,{" "}
        <strong>Phesant Nest Taxi & Maxi Cabs</strong> provides dependable
        travel solutions.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate special occasions without transport worries. Our
            professional drivers ensure timely pickups, comfortable rides, and
            stress-free travel for weddings, keeping you focused on the event.
            Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Enjoy a premium travel experience with our luxury vehicle options,
            perfect for corporate clients, business meetings, or special nights
            out in Phesant Nest. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety for your little ones is our priority. We provide child seats
            in our taxis for secure and comfortable travel for families with
            young children. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Dependable rides for employees, executives, and business meetings.
            Our corporate transport ensures punctuality, professionalism, and
            convenience. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Hassle-free pickups and drop-offs at nearby cruise terminals. Our
            drivers help you travel with comfort and ease while managing luggage
            efficiently. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From conferences to parties, our taxis and maxi cabs provide
            reliable transport to ensure your guests arrive on time and in
            comfort. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for groups, families, or luggage-heavy travel. Our spacious
            maxi cabs guarantee comfort without sacrificing reliability or
            safety. Comfort and reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Seamless long-distance rides for corporate clients, airport
            transfers, or group business travel, with on-time service and
            professional drivers. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Phesant Nest taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Phesant Nest Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Choose from a wide range of executive vehicles that cater to every occasion. Phesant Nest Taxi & Maxi Cabs offers comfort, style, and safety across all trips, whether you’re commuting locally or traveling for business. Our fleet ensures every ride is professional, reliable, and tailored to your requirements.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Phesant Nest or nearby suburbs. You can
            rely on it for shopping, work, or airport runs. Comfortable,
            fuel-efficient, and easy to park, it’s perfect for solo travelers or
            couples. You’ll enjoy reliable, stress-free rides every time. Book
            easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Phesant Nest. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            enjoy comfort, safety, and professional assistance. Perfect for
            medical appointments, social visits, or airport transfers. Every
            journey prioritises accessibility, reliability, and peace of mind.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Phesant Nest    Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Phesant Nest?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Phesant Nest taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups. Advance bookings are recommended
            for airport transfers or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Phesant Nest.
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Phesant Nest taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Do you provide child seats in taxis?",
        answer: (
          <>
            Yes, our baby seat taxi service ensures children's safety during{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Travel`}
              className="underline font-semibold px-1"
            >
              travel.
            </Link>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Phesant Nest </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Phesant Nest taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Phesant Nest ?",
        answer: (
          <>
            Yes. We cover Phesant Nest ,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              service areas.
            </Link>{" "}
          </>
        ),
      },
      {
        question:
          "How do I find a local taxi service near you in Phesant Nest?",
        answer: (
          <>
            Simply search for Phesant Nest{" "}
            <Link
              target="_blank"
              to={`https://ablis.business.gov.au/service/nsw/authorisation-to-provide-a-taxi-service/40027`}
              className="underline font-semibold px-1"
            >
              taxi service
            </Link>{" "}
            or taxi service, and we’ll be ready for quick dispatch.
          </>
        ),
      },
      {
        question: " How can I contact Phesant Nest   Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.au.
            </Link>{" "}
            Book your trusted
            <strong>Phesant Nest taxi cab service </strong>
            today.
          </>
        ),
      },
      {
        question: "  Is pricing transparent?",
        answer: (
          <>
            All rides have clear pricing with no hidden charges. We also offer
            fixed-price bookings for added convenience.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "austral-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52970.409150210464!2d150.80886895!3d-33.9243918!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1292e0b4940d81%3A0x5017d681632ac30!2sAustral%20NSW%202179%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769800365132!5m2!1sen!2sbd",
    pageTitle: "Austral Taxi & Maxi Cabs | Reliable Local Cab Service",
    metaDescription:
      "Fast & reliable local transport – Austral Taxi & Maxi Cabs offers 24/7 taxi & maxi cab services. Call now to book your ride with trusted local drivers.",
    heroTitle: "Austral Taxi & Maxi Cabs | Reliable Local Cab Service",
    heroDescription: (
      <>
        Looking for a trustworthy taxi service in Austral?
        <strong>Austral Taxi & Maxi Cabs </strong> provides 24/7 professional
        taxi and maxi cab services for local residents, families, students, and
        business travelers. Our reliable fleet is perfect for short trips,
        airport transfers, and group travel. With experienced drivers, easy
        booking, and a variety of vehicle options, your ride is safe,
        comfortable, and punctual. Say goodbye to long wait times, cancelled
        bookings, and small vehicles that don’t meet your needs. Whether it’s a
        late-night trip, early morning airport transfer, or a special event,
        <strong>Austral Taxi & Maxi Cabs</strong>ensures convenience,
        reliability, and peace of mind. Serving Austral and surrounding areas,
        we are committed to making every journey seamless, safe, and
        stress-free. Trust our local knowledge, modern fleet, and customer-first
        approach for all your taxi and maxi cab needs.
      </>
    ),
    bookingFormTitle: "Book Corporate Transport in Austral",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Phesant Nest",
    locationSectionDescription: (
      <>
        When it comes to
        <strong>reliable Austral taxi and cab services,</strong> we understand
        the unique travel needs of our local community. From busy students to
        working professionals, families, and seniors, our services cater to
        everyone. Many residents face problems such as unavailable taxis during
        peak hours, small vehicles for group travel, or safety concerns for
        late-night trips. <strong>Austral Taxi & Maxi Cabs</strong> addresses
        these issues with prompt, 24/7 service, professional drivers, and a
        fleet that includes standard taxis and{" "}
        <strong>maxi cabs near me in Austral</strong>. We offer easy phone
        booking, pre-scheduled rides, and transparent fares for worry-free
        travel. Our team is committed to ensuring punctual airport transfers,
        school drop-offs, shopping trips, corporate travel, and event
        transportation with comfort and reliability. With our local knowledge
        and dedication to customer safety, choosing Austral Taxi & Maxi Cabs
        means no more stress, no cancellations, and no long waits—just smooth,
        dependable journeys every time.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Austral",
    serviceSubtitle: (
      <>
        We provide a wide range of <strong>taxi services in Austral</strong>,
        designed to meet your everyday and special travel needs. From individual
        trips to large groups, our vehicles are equipped to ensure safe and
        comfortable journeys.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day stress-free with our luxurious wedding
            transfer options. Our professional drivers will ensure timely
            arrivals and elegant transport, making your big day memorable and
            smooth. Enjoy a comfortable ride for your bridal party and guests,
            while leaving transportation logistics to the experts. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our luxury taxi services. Whether it’s for
            business meetings, airport pickups, or special occasions, our
            high-end vehicles and courteous drivers provide a premium experience
            that prioritizes comfort, punctuality, and convenience. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first with our baby seat-equipped taxis. Perfect for
            families with infants and toddlers, our vehicles are fitted with
            age-appropriate child restraints, giving parents peace of mind while
            traveling across Austral or for airport transfers. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or ensure smooth staff commutes with our corporate
            transport solutions. We provide punctual, professional, and
            comfortable rides tailored for meetings, events, and business trips
            across Austral. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Heading to a cruise? Our dedicated cruise terminal transfer service
            ensures you reach your ship on time, stress-free, with ample luggage
            space and professional drivers familiar with the routes. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From conferences to parties, our event transfer services make group
            travel simple and organized. Count on Austral Taxi & Maxi Cabs to
            handle large bookings efficiently, ensuring timely arrivals and
            departures. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Need space for a group or extra luggage? Our maxi cabs in Austral
            are perfect for families, tours, and group events. Enjoy spacious,
            comfortable rides that cater to your size requirements.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            For day-long business travel or client visits, we provide reliable,
            well-maintained taxis and maxi cabs. Our professional drivers
            prioritize punctuality and smooth rides, making your corporate
            travel hassle-free. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Austral taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Austral  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Traveling in comfort has never been easier. Austral Taxi & Maxi Cabs offers an executive fleet designed to cater to every type of journey, whether it’s a short local ride, airport transfer, or corporate travel. Our fleet combines convenience, safety, and style, ensuring passengers have an unmatched travel experience. From efficient sedans for solo trips to spacious maxi cabs for group journeys, our vehicles are meticulously maintained for comfort and reliability. We focus on catering to the specific needs of Austral residents and visitors, including late-night rides, airport pickups, and special event transfers.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Austral or nearby suburbs. You can rely on
            it for shopping, work, or airport runs. Comfortable, fuel-efficient,
            and easy to park, it’s perfect for solo travelers or couples. You’ll
            enjoy reliable, stress-free rides every time. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Austral . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            enjoy comfort, safety, and professional assistance. Perfect for
            medical appointments, social visits, or airport transfers. Every
            journey prioritises accessibility, reliability, and peace of mind.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Austral Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Austral ?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Austral taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups. Advance bookings are recommended for
            airport transfers or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Austral .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Austral taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Austral taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Austral taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: "How are your fares calculated?",
        answer: (
          <>
            Our fares are transparent, with no hidden charges. Fixed pricing is
            available for pre-booked trips and airport transfers.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: " Are your drivers licensed and professional?",
        answer: (
          <>
            All drivers are fully licensed, insured, and trained to provide
            safe, courteous, and professional service.
          </>
        ),
      },
      {
        question: "  Is pricing transparent?",
        answer: (
          <>
            All rides have clear pricing with no hidden charges. We also offer
            fixed-price bookings for added convenience.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
      {
        question: " What areas do you serve in Austral?",
        answer: (
          <>
            We cover the Austral and surrounding suburbs, including local
            pickups, airport transfers, and event{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              travel.
            </Link>
          </>
        ),
      },
    ],
  },
  "thilmere-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52795.143920690345!2d150.54883935!3d-34.2052303!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b130010574da411%3A0x40609b4904391c0!2sThirlmere%20NSW%202572%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769800512956!5m2!1sen!2sbd",
    pageTitle: "Thilmere Taxi & Maxi Cabs – 24/7 Taxi Service",
    metaDescription:
      "Need a dependable ride? Thilmere Taxi & Maxi Cabs delivers safe and convenient transport. Call today and enjoy reliable local taxi service.",
    heroTitle: "Thilmere Taxi & Maxi Cabs – 24/7 Taxi Service",
    heroDescription: (
      <>
        Looking for a
        <strong>
          {" "}
          reliable taxi and maxi cab service in Thilmere? Thilmere Taxi & Maxi
          Cabs{" "}
        </strong>{" "}
        offers 24/7 professional taxi and maxi cab services designed to meet the
        diverse travel needs of local residents, students, families, and
        professionals. Whether it’s commuting to work, airport transfers, school
        drop-offs, or group outings, our modern fleet ensures safe, punctual,
        and comfortable rides every time. With competitive fares, convenient
        booking options, and professional drivers, we provide a seamless travel
        experience for everyone. Say goodbye to unreliable taxis and long wait
        times—experience convenience, safety, and reliability with Thilmere Taxi
        & Maxi Cabs today. Our services cater to all ages, from busy students
        and professionals to families and seniors, ensuring everyone in Thilmere
        has access to trusted local transport solutions.
      </>
    ),
    bookingFormTitle: "Book for Wedding Transfer in Thilmere",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Thilmere",
    locationSectionDescription: (
      <>
        At Thilmere Taxi & Maxi Cabs, we understand the frustration of long
        waits, unreliable rides, and safety concerns. That’s why our team
        provides 24/7 taxi service in Thilmere, ensuring that you never miss a
        flight, appointment, or important event. Whether you’re looking for a
        local taxi service Thilmere, a taxi cab service near me, or a maxi cab
        near me, we are your go-to solution for reliable and convenient
        transportation. <br />
        Our drivers are professionally trained, licensed, and familiar with all
        local routes, guaranteeing safe and punctual journeys. Families can rely
        on our baby seat taxi options, seniors can trust our courteous and
        patient drivers, and corporate clients can enjoy executive service and
        fixed-price bookings. With Thilmere taxi and cab services, you’ll always
        have a dependable vehicle ready, whether it’s a short trip across town
        or a longer airport transfer. Convenience, affordability, and safety are
        at the core of everything we do, making us the most trusted choice for
        residents and visitors alike.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Thilmere",
    serviceSubtitle: (
      <>
        We provide a wide range of taxi and maxi cab services designed to meet
        every travel requirement. From personal trips to group outings, our
        fleet is ready to serve you. Our goal is to eliminate travel stress and
        provide a safe, comfortable ride every time.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day stress-free with our professional wedding
            transfer services. Our drivers ensure timely arrivals at ceremonies
            and receptions, and our luxury vehicles provide comfort and elegance
            for you and your guests throughout the day. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our luxury taxi services. Whether it’s for
            business meetings, airport pickups, or special occasions, our
            high-end vehicles and courteous drivers provide a premium experience
            that prioritizes comfort, punctuality, and convenience. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first with our baby seat-equipped taxis. Perfect for
            families with infants and toddlers, our vehicles are fitted with
            age-appropriate child restraints, giving parents peace of mind while
            traveling across Thilmere or for airport transfers. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or ensure smooth staff commutes with our corporate
            transport solutions. We provide punctual, professional, and
            comfortable rides tailored for meetings, events, and business trips
            across Thilmere. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Heading to a cruise? Our dedicated cruise terminal transfer service
            ensures you reach your ship on time, stress-free, with ample luggage
            space and professional drivers familiar with the routes. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From conferences to parties, our event transfer services make group
            travel simple and organized. Count on Thilmere Taxi & Maxi Cabs to
            handle large bookings efficiently, ensuring timely arrivals and
            departures. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Need space for a group or extra luggage? Our maxi cabs in Thilmere
            are perfect for families, tours, and group events. Enjoy spacious,
            comfortable rides that cater to your size requirements.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            For day-long business travel or client visits, we provide reliable,
            well-maintained taxis and maxi cabs. Our professional drivers
            prioritize punctuality and smooth rides, making your corporate
            travel hassle-free. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Thilmere taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Thilmere  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Traveling in comfort has never been easier. Thilmere Taxi & Maxi Cabs offers an executive fleet designed to cater to every type of journey, whether it’s a short local ride, airport transfer, or corporate travel. Our fleet combines convenience, safety, and style, ensuring passengers have an unmatched travel experience. From efficient sedans for solo trips to spacious maxi cabs for group journeys, our vehicles are meticulously maintained for comfort and reliability. We focus on catering to the specific needs of Thilmere residents and visitors, including late-night rides, airport pickups, and special event transfers.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Thilmere or nearby suburbs. You can rely on
            it for shopping, work, or airport runs. Comfortable, fuel-efficient,
            and easy to park, it’s perfect for solo travelers or couples. You’ll
            enjoy reliable, stress-free rides every time. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Thilmere . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            enjoy comfort, safety, and professional assistance. Perfect for
            medical appointments, social visits, or airport transfers. Every
            journey prioritises accessibility, reliability, and peace of mind.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Thilmere     Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Thilmere ?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Thilmere taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups. Advance bookings are recommended for
            airport transfers or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Thilmere .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Thilmere taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Thilmere taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Thilmere taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },
      {
        question: "Are wheelchair-accessible taxis available?",
        answer: (
          <>
            Yes. Our
            <strong>local taxi cab service near me</strong>
            ensures safe, accessible, and comfortable rides for seniors or
            passengers with mobility challenges.
          </>
        ),
      },
      {
        question: " Do you operate outside Thilmere  ?",
        answer: (
          <>
            Yes. We cover Thilmere ,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "How are your fares calculated?",
        answer: (
          <>
            Our fares are transparent, with no hidden charges. Fixed pricing is
            available for pre-booked trips and airport transfers.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: " Are your drivers licensed and professional?",
        answer: (
          <>
            All drivers are fully licensed, insured, and trained to provide
            safe, courteous, and professional service.
          </>
        ),
      },
      {
        question: "Can I pre-book a maxi cab for group travel?",
        answer: (
          <>
            Yes, our maxi cabs can be pre-booked for groups, family trips, or
            corporate outings, with ample luggage space.
          </>
        ),
      },
      {
        question: " Do you provide wheelchair-accessible taxis?",
        answer: (
          <>
            Yes, our wheelchair{" "}
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold  px-1"
            >
              taxi
            </Link>
            service ensures safe and accessible{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Travel`}
              className="underline font-semibold  px-1"
            >
              travel
            </Link>
            for passengers with mobility needs.
          </>
        ),
      },
      {
        question: "Can I book a taxi for late-night travel?",
        answer: (
          <>
            Absolutely. Our 24/7 taxi service ensures safe, reliable rides at
            any time, including late nights and early mornings.
          </>
        ),
      },
    ],
  },
  "goulburn-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d104909.82089540572!2d149.71510619999998!3d-34.7447115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b16aee4c4caa029%3A0xcb4a391116a3e191!2sGoulburn%20NSW%202580%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769800779234!5m2!1sen!2sbd",
    pageTitle: "Goulburn Taxi & Maxi Cabs | 24/7 Reliable Local Service",
    metaDescription:
      "Reliable local transport – Goulburn Taxi & Maxi Cabs offers safe, affordable rides for individuals & groups. Book now for fast pickup & 24/7 service.",
    heroTitle: "Goulburn Taxi & Maxi Cabs | 24/7 Reliable Local Service",
    heroDescription: (
      <>
        Looking for a
        <strong>
          trusted taxi service in Goulburn?{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/`}
            className="underline font-semibold  px-1"
          >
            Goulburn Taxi & Maxi Cabs
          </Link>
        </strong>
        offers 24/7 professional taxi and maxi cab services for local residents,
        students, families, professionals, and seniors. Whether you need a quick
        ride across town,{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold  px-1"
        >
          airport transfers,
        </Link>{" "}
        or group travel, our reliable service ensures you reach your destination
        safely and on time.
        <br />
        With a modern fleet, experienced drivers, and affordable rates, we make
        traveling in Goulburn stress-free. No matter your schedule, our local
        taxi service Goulburn guarantees punctuality, comfort, and safety. From
        early morning airport trips to late-night social rides, we cater to all
        your transportation needs. Book your ride easily via{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold  px-1"
        >
          phone or online
        </Link>{" "}
        for a seamless experience. <br />
        Travel with confidence knowing our team is licensed, insured, and
        dedicated to providing a superior taxi experience for every passenger in
        Goulburn.
      </>
    ),
    bookingFormTitle: "Book for Group Transfer in Goulburn",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Goulburn",
    locationSectionDescription: (
      <>
        At Goulburn Taxi & Maxi Cabs, we understand the frustration of long
        waits, unreliable rides, and safety concerns. That’s why our team
        provides 24/7 taxi service in Goulburn, ensuring that you never miss a
        flight, appointment, or important event. Whether you’re looking for a
        local taxi service Goulburn, a taxi cab service near me, or a maxi cab
        near me, we are your go-to solution for reliable and convenient
        transportation. <br />
        Our drivers are professionally trained, licensed, and familiar with all
        local routes, guaranteeing safe and punctual journeys. Families can rely
        on our baby seat taxi options, seniors can trust our courteous and
        patient drivers, and corporate clients can enjoy executive service and
        fixed-price bookings. With Goulburn taxi and cab services, you’ll always
        have a dependable vehicle ready, whether it’s a short trip across town
        or a longer airport transfer. Convenience, affordability, and safety are
        at the core of everything we do, making us the most trusted choice for
        residents and visitors alike.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Goulburn",
    serviceSubtitle: (
      <>
        We provide a wide range of taxi and maxi cab services designed to meet
        every travel requirement. From personal trips to group outings, our
        fleet is ready to serve you. Our goal is to eliminate travel stress and
        provide a safe, comfortable ride every time.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day stress-free with our professional wedding
            transfer services. Our drivers ensure timely arrivals at ceremonies
            and receptions, and our luxury vehicles provide comfort and elegance
            for you and your guests throughout the day. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our luxury taxi services. Whether it’s for
            business meetings, airport pickups, or special occasions, our
            high-end vehicles and courteous drivers provide a premium experience
            that prioritizes comfort, punctuality, and convenience. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first with our baby seat-equipped taxis. Perfect for
            families with infants and toddlers, our vehicles are fitted with
            age-appropriate child restraints, giving parents peace of mind while
            traveling across Goulburn or for airport transfers. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or ensure smooth staff commutes with our corporate
            transport solutions. We provide punctual, professional, and
            comfortable rides tailored for meetings, events, and business trips
            across Goulburn. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Heading to a cruise? Our dedicated cruise terminal transfer service
            ensures you reach your ship on time, stress-free, with ample luggage
            space and professional drivers familiar with the routes. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From conferences to parties, our event transfer services make group
            travel simple and organized. Count on Goulburn Taxi & Maxi Cabs to
            handle large bookings efficiently, ensuring timely arrivals and
            departures. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Need space for a group or extra luggage? Our maxi cabs in Goulburn
            are perfect for families, tours, and group events. Enjoy spacious,
            comfortable rides that cater to your size requirements.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            For day-long business travel or client visits, we provide reliable,
            well-maintained taxis and maxi cabs. Our professional drivers
            prioritize punctuality and smooth rides, making your corporate
            travel hassle-free. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Goulburn taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Goulburn  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Traveling in comfort has never been easier. Goulburn Taxi & Maxi Cabs offers an executive fleet designed to cater to every type of journey, whether it’s a short local ride, airport transfer, or corporate travel. Our fleet combines convenience, safety, and style, ensuring passengers have an unmatched travel experience. From efficient sedans for solo trips to spacious maxi cabs for group journeys, our vehicles are meticulously maintained for comfort and reliability. We focus on catering to the specific needs of Goulburn residents and visitors, including late-night rides, airport pickups, and special event transfers.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Goulburn or nearby suburbs. You can rely on
            it for shopping, work, or airport runs. Comfortable, fuel-efficient,
            and easy to park, it’s perfect for solo travelers or couples. You’ll
            enjoy reliable, stress-free rides every time. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Goulburn . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully equipped
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              vehicles
            </Link>
            and trained drivers ensure safe and comfortable travel for
            passengers with mobility needs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Goulburn     Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Goulburn ?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Goulburn taxi cab close to me</strong> service ensures fast,
            safe, and reliable pickups. Advance bookings are recommended for
            airport transfers or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Goulburn .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Goulburn taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Are baby seats available in your taxis?",
        answer: (
          <>
            Yes, we provide properly installed baby and booster seats for
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Safe_Travels`}
              className="underline font-semibold px-1"
            >
              safe travel
            </Link>{" "}
            with young children.
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Goulburn taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Goulburn  ?",
        answer: (
          <>
            Yes. We cover Goulburn ,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: " Are your drivers licensed and professional?",
        answer: (
          <>
            All drivers are fully licensed, insured, and trained to provide
            safe, courteous, and professional service.
          </>
        ),
      },
      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "leppington-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52938.2456030044!2d150.80039725!3d-33.9760824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ed91330965f3%3A0x5017d681632bdf0!2sLeppington%20NSW%202179%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769801166069!5m2!1sen!2sbd",
    pageTitle: "Leppington Taxi & Maxi Cabs | 24/7 Local Transport",
    metaDescription:
      "24/7 local taxi service – Leppington Taxi & Maxi Cabs ensure quick response & fair pricing. Call now for reliable pickups.",
    heroTitle: "Leppington Taxi & Maxi Cabs | 24/7 Local Transport",
    heroDescription: (
      <>
        When it comes to reliable local transport in Leppington,{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/`}
          className="underline font-semibold  px-1"
        >
          Leppington Taxi & Maxi Cabs
        </Link>
        stands out for its 24/7 professional service. Whether you are a student,
        a busy professional, or a family looking for a safe ride, our team
        ensures punctual and comfortable travel. We cater to airport transfers,
        group trips, and daily commutes, offering a wide range of vehicles, from
        standard taxis to spacious maxi cabs. With experienced drivers,
        transparent fares, and convenient booking through our{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold  px-1"
        >
          online taxi booking system,
        </Link>{" "}
        your travel experience becomes stress-free. Whether you're searching for
        a taxi service near me or maxi cabs near me in Leppington, we provide
        prompt solutions. Safety, convenience, and reliability are at the heart
        of our service, making us the go-to local transport provider for
        residents and visitors alike. Enjoy peace of mind, quick pickups, and
        hassle-free travel with
        <strong>Leppington Taxi & Maxi Cabs</strong>, your trusted partner for
        every journey.
      </>
    ),
    bookingFormTitle: "Book for Group Transfer in Leppington",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Leppington",
    locationSectionDescription: (
      <>
        At <strong>Leppington Taxi & Maxi Cabs</strong>, we understand that your
        travel needs require more than just a ride—it requires trust,
        punctuality, and convenience. We are committed to providing 24/7 taxi
        and maxi cab services that cater to local residents, students,
        professionals, families, and seniors. Our services are designed to solve
        common travel pain points like long wait times, ride cancellations, and
        limited vehicle options. Searching for a{" "}
        <strong>Leppington taxi cab close to me</strong>? Our experienced
        drivers ensure safe pickups, timely drop-offs, and clear communication.
        From local taxi services Leppington to airport transfers and group
        trips, we offer a range of vehicles including sedans, SUVs, and maxi
        cabs. With easy phone booking, online scheduling, and competitive fares,
        we make local travel stress-free. Residents trust us for{" "}
        <strong>taxi service near me</strong> and maxi cab services Leppington
        because of our professionalism, reliability, and customer-first
        approach.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Leppington",
    serviceSubtitle: (
      <>
        We provide flexible and reliable taxi and maxi cab services tailored to
        Leppington’s local travel demands. Whether it’s a quick ride across town
        or a large group journey, our services cater to every scenario.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day stress-free with our professional wedding
            transfer services. Our drivers ensure timely arrivals at ceremonies
            and receptions, and our luxury vehicles provide comfort and elegance
            for you and your guests throughout the day. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our luxury taxi services. Whether it’s for
            business meetings, airport pickups, or special occasions, our
            high-end vehicles and courteous drivers provide a premium experience
            that prioritizes comfort, punctuality, and convenience. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first with our baby seat-equipped taxis. Perfect for
            families with infants and toddlers, our vehicles are fitted with
            age-appropriate child restraints, giving parents peace of mind while
            traveling across Leppington or for airport transfers. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or ensure smooth staff commutes with our corporate
            transport solutions. We provide punctual, professional, and
            comfortable rides tailored for meetings, events, and business trips
            across Leppington. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Heading to a cruise? Our dedicated cruise terminal transfer service
            ensures you reach your ship on time, stress-free, with ample luggage
            space and professional drivers familiar with the routes. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From conferences to parties, our event transfer services make group
            travel simple and organized. Count on Leppington Taxi & Maxi Cabs to
            handle large bookings efficiently, ensuring timely arrivals and
            departures. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Need space for a group or extra luggage? Our maxi cabs in Leppington
            are perfect for families, tours, and group events. Enjoy spacious,
            comfortable rides that cater to your size requirements.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            For day-long business travel or client visits, we provide reliable,
            well-maintained taxis and maxi cabs. Our professional drivers
            prioritize punctuality and smooth rides, making your corporate
            travel hassle-free. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Leppington taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Leppington  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Traveling in comfort has never been easier. Leppington Taxi & Maxi Cabs offers an executive fleet designed to cater to every type of journey, whether it’s a short local ride, airport transfer, or corporate travel. Our fleet combines convenience, safety, and style, ensuring passengers have an unmatched travel experience. From efficient sedans for solo trips to spacious maxi cabs for group journeys, our vehicles are meticulously maintained for comfort and reliability. We focus on catering to the specific needs of Leppington residents and visitors, including late-night rides, airport pickups, and special event transfers.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Leppington or nearby suburbs. You can rely
            on it for shopping, work, or airport runs. Comfortable,
            fuel-efficient, and easy to park, it’s perfect for solo travelers or
            couples. You’ll enjoy reliable, stress-free rides every time. Book
            easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Leppington . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible travel for passengers with mobility challenges. You’ll
            enjoy comfort, safety, and professional assistance. Perfect for
            medical appointments, social visits, or airport transfers. Every
            journey prioritises accessibility, reliability, and peace of mind.
            Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Leppington     Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Leppington ?",
        answer: (
          <>
            You can book a
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>
            via our website, by phone, or via our mobile app. We offer instant
            booking for immediate rides and advance scheduling for planned
            trips.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Leppington .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Leppington taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Leppington taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our
            <strong> local taxi service Leppington </strong>
            handles office commutes, meetings, and corporate travel.
            Professional drivers ensure safe, on-time, and stress-free rides
            every time.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Leppington taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Leppington  ?",
        answer: (
          <>
            Yes. We cover Leppington ,Appin , Camden, Liverpool, and nearby
            suburbs. Find your
            <strong> local taxi service near me </strong>
            at{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I pre-book a taxi for a specific time?",
        answer: (
          <>
            Yes, booking is available for scheduled pickups, airport transfers,
            and corporate{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Travel`}
              className="underline font-semibold  px-1"
            >
              travel.
            </Link>
          </>
        ),
      },

      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
      {
        question: "Are your taxis safe for solo travelers, women, and seniors?",
        answer: (
          <>
            Yes, our drivers prioritize passenger safety, especially for
            late-night, solo, or senior travelers, providing a secure and
            comfortable journey.
          </>
        ),
      },
    ],
  },
  "eagle-vale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13224.927128931937!2d150.81110139999998!3d-34.03792504999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ee7d16a927b9%3A0x5017d681632b550!2sEagle%20Vale%20NSW%202558%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769802101432!5m2!1sen!2sbd",
    pageTitle: "24/7 Eagle Vale Taxi & Maxi Cabs – Licensed & Insured",
    metaDescription:
      "Safe & reliable Eagle Vale Taxi & Maxi Cabs - 24/7 service for airport, corporate & group travel. Book now for comfort & stress-free rides!",
    heroTitle: "24/7 Eagle Vale Taxi & Maxi Cabs – Licensed & Insured",
    heroDescription: (
      <>
        Looking for a<strong>reliable Eagle Vale Taxi & Maxi Cabs</strong>{" "}
        service? You've come to the right place. We provide fast, safe, and
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          professional taxi and maxi cab services
        </Link>
        in Eagle Vale. Whether you need an airport transfer, a group ride, or a
        corporate trip, we've got you covered. Our drivers are licensed,
        insured, and highly experienced. You can count on punctuality and
        comfort every time. Book your ride in minutes online or over the phone.
        Enjoy a seamless travel experience with our modern fleet, including maxi
        cabs for larger groups. At
        <strong>Eagle Vale Taxi & Maxi Cabs,</strong>your convenience and safety
        come first.
      </>
    ),
    bookingFormTitle: "Book for Group Transfer in Eagle Vale",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Eagle Vale",
    locationSectionDescription: (
      <>
        When you need a
        <strong> trusted Eagle Vale Taxi & Maxi Cabs service</strong>, you want
        reliability, safety, and local expertise. That's exactly what we offer.
        Our drivers know every route in Eagle Vale and the surrounding areas,
        ensuring you reach your destination on time. From short local trips to
        airport transfers, you can rely on us for a smooth, stress-free journey.
        <br />
        We specialize in<strong>taxi cab services near you </strong>with
        flexible scheduling and 24/7 availability. Whether it's an urgent
        airport transfer or a planned group trip, we handle every ride
        professionally. You can book through our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          online taxi booking system
        </Link>
        or call us directly at 1300 450 428. With our premium fleet, including{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/fleet`}
          className="underline font-semibold px-1"
        >
          luxury vehicles
        </Link>
        and maxi cabs for large groups, your comfort and convenience are
        guaranteed. We also provide
        <Link
          to={`https://campbelltowntaxicabs.com.au/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi services
        </Link>{" "}
        for easy payment and corporate accounts. Our goal is to give you safe,
        affordable, and reliable transport, making your travel experience
        effortless every time.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Eagle Vale",
    serviceSubtitle: (
      <>
        We provide flexible and reliable taxi and maxi cab services tailored to
        Eagle Vale’s local travel demands. Whether it’s a quick ride across town
        or a large group journey, our services cater to every scenario.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day stress-free with our professional wedding
            transfer services. Our drivers ensure timely arrivals at ceremonies
            and receptions, and our luxury vehicles provide comfort and elegance
            for you and your guests throughout the day. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our luxury taxi services. Whether it’s for
            business meetings, airport pickups, or special occasions, our
            high-end vehicles and courteous drivers provide a premium experience
            that prioritizes comfort, punctuality, and convenience. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first with our baby seat-equipped taxis. Perfect for
            families with infants and toddlers, our vehicles are fitted with
            age-appropriate child restraints, giving parents peace of mind while
            traveling across Eagle Vale or for airport transfers. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or ensure smooth staff commutes with our corporate
            transport solutions. We provide punctual, professional, and
            comfortable rides tailored for meetings, events, and business trips
            across Eagle Vale. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Heading to a cruise? Our dedicated cruise terminal transfer service
            ensures you reach your ship on time, stress-free, with ample luggage
            space and professional drivers familiar with the routes. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From conferences to parties, our event transfer services make group
            travel simple and organized. Count on Eagle Vale Taxi & Maxi Cabs to
            handle large bookings efficiently, ensuring timely arrivals and
            departures. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Need space for a group or extra luggage? Our maxi cabs in Eagle Vale
            are perfect for families, tours, and group events. Enjoy spacious,
            comfortable rides that cater to your size requirements.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            For day-long business travel or client visits, we provide reliable,
            well-maintained taxis and maxi cabs. Our professional drivers
            prioritize punctuality and smooth rides, making your corporate
            travel hassle-free. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Eagle Vale taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Eagle Vale  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Traveling in comfort has never been easier. Eagle Vale Taxi & Maxi Cabs offers an executive fleet designed to cater to every type of journey, whether it’s a short local ride, airport transfer, or corporate travel. Our fleet combines convenience, safety, and style, ensuring passengers have an unmatched travel experience. From efficient sedans for solo trips to spacious maxi cabs for group journeys, our vehicles are meticulously maintained for comfort and reliability. We focus on catering to the specific needs of Eagle Vale residents and visitors, including late-night rides, airport pickups, and special event transfers.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for quick trips in Eagle Vale or nearby suburbs. You can rely
            on it for shopping, work, or airport runs. Comfortable,
            fuel-efficient, and easy to park, it’s perfect for solo travelers or
            couples. You’ll enjoy reliable, stress-free rides every time. Book
            easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in comfort and style for meetings, events, or special
            occasions. Modern interiors, smooth rides, and professional drivers
            make every trip enjoyable. Perfect for corporate transfers or
            luxurious airport journeys. Focus on your schedule while we manage
            traffic and parking. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and safe for families or groups with luggage. Ideal for
            school runs, shopping trips, or weekend getaways. Every passenger
            rides comfortably while your belongings are secure. Our vehicles
            combine convenience, safety, and reliability for your travel needs
            in Eagle Vale . Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or family trips. Seats up to 7 passengers
            with room for luggage. Ideal for Maxi Cab services, airport
            transfers, or group outings. Enjoy relaxed, stress-free journeys
            with organised seating and ample space. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Designed for group travel, events, or corporate trips. Carry large
            groups and luggage comfortably without compromising on comfort. Our
            professional drivers provide safe, efficient, and timely transport.
            Flexible booking options make group travel easy. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Safe, reliable, and accessible transport for passengers with
            mobility needs. Our wheelchair-accessible
            <Link
              target="_blank"
              to={`https://nt.gov.au/driving/industry/commercial-passenger-vehicles/taxi-areas-meters-and-fares`}
              className="underline font-semibold px-1"
            >
              vehicles
            </Link>{" "}
            make travel smooth and stress-free.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Eagle Vale     Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Eagle Vale ?",
        answer: (
          <>
            You can book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              booking page
            </Link>
            or call 1300 450 428. We offer 24/7 service for your convenience.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Eagle Vale .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Eagle Vale taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Eagle Vale taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Eagle Vale taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Eagle Vale  ?",
        answer: (
          <>
            Yes. We cover Eagle Vale Ambarvale, Leumeah, Minto, Campbelltown,
            and surrounding suburbs. Check full coverage{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge?",
        answer: (
          <>
            Yes, we offer CabCharge
            <Link
              target="_blank"
              to="https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges"
              className="underline font-semibold px-1"
            >
              Taxi
            </Link>{" "}
            services for easy, secure payments.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I arrange corporate transport in Eagle Vale?",
        answer: (
          <>
            You can schedule rides in advance for meetings, events, or airport
            transfers. We provide professional, punctual service.
          </>
        ),
      },
      {
        question: " Do you offer event and wedding transfers?",
        answer: (
          <>
            Yes, we handle weddings, corporate events, and private parties with
            professionalism and comfort. Your guests travel safely and on time.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "spring-farm-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26440.368013990577!2d150.72513164999998!3d-34.068335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f084b9e7e251%3A0x5017d681632cba0!2sSpring%20Farm%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769802559053!5m2!1sen!2sbd",
    pageTitle: "Spring Farm Taxi & Maxi Cabs – Book Online Today",
    metaDescription:
      "Safe & reliable Spring Farm Taxi & Maxi Cabs – 24/7 airport, event, and group rides. Book now for comfort and stress-free travel!",
    heroTitle: "Spring Farm Taxi & Maxi Cabs – Book Online Today",
    heroDescription: (
      <>
        Looking for a reliable taxi service in Spring Farm? Your search ends
        here. At <strong>Spring Farm Taxi & Maxi Cabs</strong>, we provide fast,
        safe, and convenient transport for everyone. Whether you need a quick
        ride to work, airport transfers, or a{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab
        </Link>{" "}
        for a group, we’ve got you covered. Our friendly drivers know Spring
        Farm and surrounding areas well. You can count on punctual pickups and
        professional service every time. Book online or call us today. Your
        comfort, safety, and convenience are our priority.
      </>
    ),
    bookingFormTitle: "Book for Wedding Transfer in Spring Farm",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Spring Farm",
    locationSectionDescription: (
      <>
        When you choose <strong>Spring Farm Taxi & Maxi Cabs</strong>, you
        choose a service that puts your needs first. We understand the local
        area, from Spring Farm to nearby suburbs, ensuring timely and reliable
        rides. Our team is trained to handle everything—from airport trips to
        social events, corporate transport, and more. You won’t face the
        frustration of long waits or cancellations like ride-share apps. You can
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          book a taxi
        </Link>{" "}
        in advance or on-demand, with options for Maxi Cabs, baby seats, and
        wheelchair-accessible vehicles. Your safety is guaranteed with
        experienced drivers who prioritise care, especially during late-night or
        early-morning trips. Whether you’re commuting, travelling with family,
        or carrying luggage, we provide a seamless and stress-free ride. Trust a
        service that locals rely on for{" "}
        <strong>Spring Farm taxi cab service</strong>{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          Book your ride today.
        </Link>
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Spring Farm",
    serviceSubtitle: (
      <>
        At Spring Farm Taxi & Maxi Cabs, we offer a full range of services for
        your convenience. From solo trips to group travel, you’ll always find a
        solution tailored to your needs.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day seamless. Our luxury vehicles ensure you
            arrive in style, on time, and stress-free. Perfect for brides,
            grooms, and wedding parties needing reliable transport. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our premium sedans and SUVs. Ideal for
            business meetings, airport trips, or a special night out in Spring
            Farm. You’ll enjoy a smooth, elegant, and private ride every time.
            Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. We provide approved baby seats for
            infants and toddlers. Perfect for school runs, medical appointments,
            or family outings. Safety and peace of mind are guaranteed. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients and staff. Our professional drivers provide
            punctual, discreet, and reliable corporate travel. Whether it’s
            meetings, events, or airport pickups, we cater to your business
            needs Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday stress-free. We provide timely transfers to
            Sydney cruise terminals with luggage assistance. Travel with
            confidence and enjoy a smooth, organised journey. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Heading to concerts, sports, or social events? We make sure you
            arrive on time and return safely. Flexible booking options suit your
            schedule and group size. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel comfortably with family or friends. Our Maxi Cabs fit large
            groups and luggage. Perfect for airport runs, outings, and local
            trips. You won’t worry about space or comfort.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Reliable and professional rides for all corporate needs. Efficient
            pick-ups, executive vehicles, and friendly drivers make business
            travel stress-free. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Spring Farm taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Spring Farm Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We know that every ride matters. That’s why we offer a wide range of vehicles for your comfort. From everyday trips to luxury travel, you can choose the perfect vehicle. Our fleet is maintained to the highest standards for safety, cleanliness, and comfort. You can book easily online or by phone, and our drivers will ensure your journey is smooth. Whether it’s a short ride across Spring Farm or a long airport transfer, we deliver a professional and friendly experience.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for solo travellers or small groups. Comfortable, affordable,
            and efficient for everyday trips around Spring Farm.Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for business or special occasions. Ride in style with
            premium interiors and modern amenities. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Travel with extra space and comfort. Suitable for families, luggage,
            or small group outings. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Spacious, practical, and perfect for groups. Great for airport
            transfers or city tours in Spring Farm. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Larger groups travel easily with our Maxi Cabs. Comfortable seating
            and ample luggage space guaranteed. Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessible vehicles designed to make travel safe and comfortable for
            everyone. Our drivers provide assistance where needed. Book at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Spring Farm Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Spring Farm ?",
        answer: (
          <>
            You can book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              taxi booking page
            </Link>{" "}
            or call 1300 450 428. Advance bookings and on-demand rides are
            available.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },

      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Spring Farm taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Spring Farm taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes. We offer reliable corporate transport services with
            professional{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driving`}
              className="underline font-semibold px-1"
            >
              drivers
            </Link>
            for business needs.
          </>
        ),
      },

      {
        question: " Do you operate outside Spring Farm  ?",
        answer: (
          <>
            Yes. We cover Spring Farm Ambarvale, Leumeah, Minto, Campbelltown,
            and surrounding suburbs. Check full coverage{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge?",
        answer: (
          <>
            Yes, we provide{" "}
            <Link to="/cabcharge-taxi" className="underline font-semibold px-1">
              CabCharge Taxi services
            </Link>{" "}
            for easy and secure payments.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I arrange corporate transport in Spring Farm?",
        answer: (
          <>
            You can schedule rides in advance for meetings, events, or airport
            transfers. We provide professional, punctual service.
          </>
        ),
      },
      {
        question: "Are your vehicles wheelchair accessible?",
        answer: (
          <>
            Yes. Our wheelchair{" "}
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>
            service is designed for safe and easy mobility.
          </>
        ),
      },
      {
        question: " Do you offer event and wedding transfers?",
        answer: (
          <>
            Yes, we handle weddings, corporate events, and private parties with
            professionalism and comfort. Your guests travel safely and on time.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
      {
        question: "Do you operate late at night or early morning?",
        answer: (
          <>
            Yes. We cover early airport trips, night shifts, and weekend travel
            in Spring Farm and nearby areas.
          </>
        ),
      },
      {
        question: "How reliable is your taxi service?",
        answer: (
          <>
            Our drivers are punctual, experienced, and familiar with Spring
            Farm. You can trust us for safe, timely journeys.
          </>
        ),
      },
    ],
  },
  "cowdor-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52863.51792461724!2d150.66637964999998!3d-34.09591230000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12fa1e3f1dc3a1%3A0x5017d6816333c50!2sCawdor%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769802941608!5m2!1sen!2sbd",
    pageTitle: "Reliable Cowdor Taxi & Maxi Cabs – 24/7 Local Service",
    metaDescription:
      "Fast and safe Cowdor Taxi & Maxi Cabs for airport, events, and corporate trips. Call now and experience professional local travel.",
    heroTitle: "Reliable Cowdor Taxi & Maxi Cabs – 24/7 Local Service",
    heroDescription: (
      <>
        Looking for a dependable Cowdor Taxi & Maxi Cabs service? You've come to
        the right place. We offer safe, prompt, and affordable rides around
        Cowdor and nearby areas. Whether you need a quick trip,{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          airport transfer,
        </Link>
        or group travel, we're ready 24/7. You can trust our experienced drivers
        to get you to your destination on time. Our fleet includes modern
        sedans, maxi cabs, and luxury vehicles. Booking is easy, either online
        or over the phone. Count on us for comfort, reliability, and local
        expertise every time you ride with Campbelltown Taxi Cabs.
      </>
    ),
    bookingFormTitle: "Book for Wedding Transfer in Cowdor",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Cowdor",
    locationSectionDescription: (
      <>
        When you choose our <strong>Cowdor Taxi & Maxi Cabs</strong>, you’re
        choosing reliability. We understand your travel needs, whether you’re
        heading to work, school, or the airport. You’ll never wait long because
        we maintain a wide fleet across Cowdor. Our drivers prioritise safety,
        punctuality, and professionalism. You can even request a{" "}
        <strong> maxi cab near me in Cowdor </strong>for group trips or airport
        runs. We make booking simple through{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          our Taxi booking page.
        </Link>
        Many locals trust our service because we know the roads and shortcuts
        around Campbelltown, Cowdor, and surrounding suburbs. For families,
        seniors, and professionals, we provide a smooth, stress-free experience.
        Your satisfaction is our top priority. Whether you need a{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Cowdor taxi cab close to me
        </Link>{" "}
        or a special service, we’ve got you covered.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Cowdor",
    serviceSubtitle: (
      <>
        We provide a wide range of services for every travel need. You can rely
        on our Cowdor taxi cab service for short trips, airport transfers, and
        group travel. Our drivers are trained, courteous, and local experts.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Arrive in style for your big day. We provide fully decorated,
            punctual, and professional taxi and maxi cab services. You can rely
            on us for stress-free travel with family and friends. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Perfect for business or VIP travel. Enjoy comfort, privacy, and a
            smooth ride in our premium fleet. We cater to every requirement and
            ensure timely arrivals. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety first for your little ones. Our vehicles come equipped with
            secure baby seats, perfect for families travelling with young
            children. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Professional and reliable for all your business trips. Impress
            clients or get to meetings without delays. Punctuality and
            professionalism guaranteed. Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Reach cruise terminals on time. We manage luggage, plan routes, and
            provide comfortable rides for you and your family. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From parties to concerts, our cabs handle large groups efficiently.
            Enjoy a hassle-free experience with our reliable service. Learn more
            at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travelling with a group? Our spacious maxi cabs fit everyone
            comfortably, including luggage. Perfect for airport trips or family
            outings.Comfort and reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Efficient and stress-free transport for office commutes or meetings.
            Our drivers are trained to offer professional, timely service. More
            details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Cowdor taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed. Book now at{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              airport Transfers.
            </Link>
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Cowdor Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Our fleet is designed to suit every traveller. You’ll get safe, clean, and reliable vehicles for every ride. Whether it’s a solo trip, group travel, or VIP transfer, we have options to meet your needs.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Affordable, comfortable, and perfect for daily travel. Ideal for
            short trips or quick commutes around Cowdor.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ride in style with extra comfort and privacy. Perfect for business,
            VIP clients, or special occasions.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and ideal for families or group trips. Provides smooth
            travel with plenty of luggage space.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Our popular choice for group travel. Comfortable seating, roomy
            interiors, and reliable performance.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for large groups, airport transfers, or corporate outings.
            Travel together without multiple vehicles.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessibility made easy. We offer safe, comfortable rides for
            seniors and passengers with mobility needs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Cowdor  Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Cowdor ?",
        answer: (
          <>
            You can book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              taxi booking page
            </Link>{" "}
            or call 1300 450 428. Advance bookings and on-demand rides are
            available.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Cowdor .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Cowdor taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I request a baby seat taxi in Cowdor?",
        answer: (
          <>
            Certainly, we provide secure baby seats to keep children safe during
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              travel.
            </Link>{" "}
            Just mention it while booking.
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Cowdor taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Cowdor   ?",
        answer: (
          <>
            Yes. We cover Cowdor Ambarvale, Leumeah, Minto, Campbelltown, and
            surrounding suburbs. Check full coverage{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge?",
        answer: (
          <>
            Yes, we provide{" "}
            <Link to="/cabcharge-taxi" className="underline font-semibold px-1">
              CabCharge Taxi services
            </Link>{" "}
            for easy and secure payments.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I arrange corporate transport in Cowdor ?",
        answer: (
          <>
            You can schedule rides in advance for meetings, events, or airport
            transfers. We provide professional, punctual service.
          </>
        ),
      },
      {
        question: " Do you offer event and wedding transfers?",
        answer: (
          <>
            Yes, we handle weddings, corporate events, and private parties with
            professionalism and comfort. Your guests travel safely and on time.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
      {
        question: " Do you offer luxury or premium taxi services?",
        answer: (
          <>
            Yes, our fleet includes luxury{" "}
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              vehicles
            </Link>{" "}
            for VIP travel, events, and executive transfers.
          </>
        ),
      },
      {
        question: "How do I contact Cowdor Taxi & Maxi Cabs?",
        answer: (
          <>
            Call 1300 450 428, email taxibookingcampbelltown@gmail.com, or visit{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            Our team is always ready to assist.
          </>
        ),
      },
    ],
  },
  "razorback-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52823.53861610221!2d150.64417165!3d-34.1598695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12fea74615d92d%3A0x40609b490439140!2sRazorback%20NSW%202571%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769803269039!5m2!1sen!2sbd",
    pageTitle: "Razorback Taxi & Maxi Cabs – 24/7 Reliable Rides Near You",
    metaDescription:
      "Book Razorback Taxi & Maxi Cabs – Fast, professional service with maxi cabs for groups. Reserve your ride today and travel with ease!",
    heroTitle: "Razorback Taxi & Maxi Cabs – 24/7 Reliable Rides Near You",
    heroDescription: (
      <>
        Looking for Razorback Taxi & Maxi Cabs you can trust? You’re in the
        right place. Our taxis and maxi cabs are available 24/7. Whether you
        need a quick ride to work,{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          airport transfer,
        </Link>{" "}
        or group travel, we’ve got you covered. You can book easily by phone or
        online. We provide safe, punctual, and comfortable rides for everyone.
        Our friendly drivers know Razorback and nearby areas well. You’ll never
        face long waits or last-minute cancellations. From solo commuters to
        families, seniors, and students, we have vehicles suited for every trip.{" "}
        <strong>Razorback Taxi & Maxi Cabs</strong> are your local solution for
        reliable transport anytime you need.
      </>
    ),
    bookingFormTitle: "Book for Wedding Transfer in Razorback",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Razorback",
    locationSectionDescription: (
      <>
        When you need a <strong>Razorback taxi service</strong>, you want a
        provider who values safety, reliability, and convenience. Our team
        ensures you get a<strong> taxi cab service near me </strong>that’s
        always punctual. You can rely on us for airport transfers, school
        drop-offs, medical appointments, or even late-night travel. We
        understand your daily travel needs, whether it’s commuting to work or
        visiting friends. Our professional drivers are fully licensed and
        trained to make your journey smooth. We operate a premium fleet,
        including maxi cabs for group travel. With easy phone booking at 1300
        450 428 or
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          out Taxi booking page.
        </Link>
        your Razorback taxi ride is just a click away. Enjoy peace of mind
        knowing your ride is safe, reliable, and affordable. Learn more about
        our
        <Link to={`/fleet`} className="underline font-semibold  px-1">
          fleet options
        </Link>
        and{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/area-covered`}
          className="underline font-semibold px-1"
        >
          service areas
        </Link>{" "}
        today.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Razorback",
    serviceSubtitle: (
      <>
        We offer a full range of Razorback taxi and cab services for every need.
        From solo trips to family outings, your travel is our priority.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Arrive on time in style. Our luxury taxis and maxi cabs make your
            wedding day smooth. Our drivers coordinate every detail, ensuring a
            stress-free, elegant journey. You can trust our professional team to
            handle your wedding transport with care.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Treat yourself or clients with premium vehicles. Experience comfort,
            privacy, and punctuality. Whether for business or special occasions,
            our luxury taxi service in Razorback ensures a first-class ride.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Travel safely with your little ones. We provide{" "}
            <Link
              target="_blank"
              to={`https://www.transport.nsw.gov.au/roadsafety/parents/child-car-seats`}
              className="underline font-semibold px-1"
            >
              child seats
            </Link>
            on request, ensuring a secure journey for families. Our drivers are
            trained to help with installation and comfort.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients and employees with reliable, professional corporate
            transport. From meetings to airport pickups, your company benefits
            from our punctual and well-maintained fleet.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Make your holiday smooth with prompt cruise transfers. We ensure
            timely arrivals and luggage handling, giving you a relaxed start or
            end to your trip.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Get to your events without stress. Our maxi cabs and taxis handle
            group bookings for parties, sports, or conferences. You focus on the
            event; we handle transport.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for groups and family trips. Our spacious maxi cabs
            accommodate luggage and multiple passengers comfortably. No one gets
            left behind during your Razorback journey.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            From airport pickups to boardroom meetings, our corporate trips
            ensure professionalism and comfort. Count on us for safe, reliable,
            and punctual rides every time.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Razorback taxi cab close to me service.
            Timely pickups, luggage support, and stress-free journeys are
            guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Razorback  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "When it comes to comfort and reliability, our Razorback taxi cab service has you covered. You can choose from a range of vehicles suited for any travel requirement. We maintain all vehicles to the highest standards, giving you safe and clean rides. Whether you need a solo ride, family trip, or group travel, we have a fleet ready for you. Our drivers are trained, friendly, and punctual. Each ride is designed to meet your needs, providing convenience, safety, and a professional experience.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Affordable, comfortable, and perfect for daily travel. Ideal for
            short trips or quick commutes around Cowdor.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ride in style with extra comfort and privacy. Perfect for business,
            VIP clients, or special occasions.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious and ideal for families or group trips. Provides smooth
            travel with plenty of luggage space.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Our popular choice for group travel. Comfortable seating, roomy
            interiors, and reliable performance.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for large groups, airport transfers, or corporate outings.
            Travel together without multiple vehicles.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessibility made easy. We offer safe, comfortable rides for
            seniors and passengers with mobility needs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Razorback  Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Razorback ?",
        answer: (
          <>
            You can book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              taxi booking page
            </Link>{" "}
            or call 1300 450 428. Advance bookings and on-demand rides are
            available.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Razorback .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
            >
              drivers
            </Link>{" "}
            are licensed, vetted, and familiar with Camden South. Safety,
            punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Razorback taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Razorback taxi service</strong>
          </>
        ),
      },
      {
        question: "Do you offer corporate transport services?",
        answer: (
          <>
            Yes, our corporate transport services provide professional, reliable{" "}
            <Link
              target="_blank"
              to={`https://rct.fandom.com/wiki/Car_Ride`}
              className="underline font-semibold px-1"
            >
              rides
            </Link>
            for meetings and events.
          </>
        ),
      },

      {
        question: " Do you operate outside Razorback?",
        answer: (
          <>
            Yes. We cover Razorback Ambarvale, Leumeah, Minto, Campbelltown, and
            surrounding suburbs. Check full coverage{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge?",
        answer: (
          <>
            Yes, we provide{" "}
            <Link to="/cabcharge-taxi" className="underline font-semibold px-1">
              CabCharge Taxi services
            </Link>{" "}
            for easy and secure payments.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I arrange corporate transport in Razorback?",
        answer: (
          <>
            You can schedule rides in advance for meetings, events, or airport
            transfers. We provide professional, punctual service.
          </>
        ),
      },
      {
        question: " Do you offer event and wedding transfers?",
        answer: (
          <>
            Yes, we handle weddings, corporate events, and private parties with
            professionalism and comfort. Your guests travel safely and on time.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "bargo-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105487.71708425588!2d150.5869286!3d-34.28702559999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1300e537c1f0cb%3A0x40609b490438df0!2sBargo%20NSW%202574%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769803590392!5m2!1sen!2sbd",
    pageTitle: "Book Bargo Taxi & Maxi Cabs Near You – Fast, Safe & Affordable",
    metaDescription:
      "Book professional Bargo Taxi & Maxi Cabs near you – fast, affordable, and comfortable rides for families, students, and business trips.",
    heroTitle: "Book Bargo Taxi & Maxi Cabs Near You – Fast, Safe & Affordable",
    heroDescription: (
      <>
        Looking for a reliable ride in Bargo? You’ve come to the right place.
        Our{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Bargo Taxi & Maxi Cabs
        </Link>{" "}
        are perfect for your daily commute, airport transfers, or group trips.
        We provide safe, punctual, and{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          affordable taxi services
        </Link>{" "}
        tailored to your needs. With a professional team and a modern fleet, you
        can enjoy a smooth, stress-free journey every time. Whether you need a
        local taxi service in Bargo or a maxi cab for large groups, we are ready
        to serve you. Trust us to get you where you need to go safely. Our easy
        phone booking and online options make scheduling your ride simple and
        fast. Ride with confidence, knowing our drivers prioritise your comfort
        and safety at all times. Experience the convenience of a premium Bargo
        taxi cab service that locals trust.
      </>
    ),
    bookingFormTitle: "Book for Event Transfer in Bargo",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Bargo",
    locationSectionDescription: (
      <>
        When it comes to <strong> Bargo taxi and cab services</strong>,you
        deserve reliability and comfort. Our team understands the local roads
        and traffic patterns, ensuring you reach your destination on time. You
        can rely on our taxis for
        <strong>
          {" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/book-taxi-sydney-airport`}
            className="underline font-semibold px-1"
          >
            airport transfers,
          </Link>{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/corporate-tips`}
            className="underline font-semibold px-1"
          >
            corporate trips,
          </Link>{" "}
          or family outings.
        </strong>
        We provide maxi cab services in Bargo for groups and luggage-heavy
        trips. You can book easily by phone or online, and our friendly drivers
        assist you from start to finish. Safety is a priority—our vehicles are
        regularly inspected and cleaned for your peace of mind. With transparent
        pricing, you never face hidden charges. We also offer CabCharge options
        for corporate clients. Whether you need a quick ride to the city or a
        luxurious transfer for a special event, our Bargo taxi service is always
        ready. Make your journey stress-free and dependable today. <br />
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          Book a Taxi
        </Link>
        <Link to={`/about`} className="underline font-semibold  px-1">
          About Us
        </Link>
        <Link to={`/area-covered`} className="underline font-semibold  px-1">
          Service Area
        </Link>
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Bargo",
    serviceSubtitle: (
      <>
        We offer a full range of taxi and maxi cab services in Bargo to meet all
        travel needs. Whether you’re heading to the airport or attending a
        special event, we’ve got you covered.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Arrive in style on your special day. Our professional drivers ensure
            timely and elegant transfers, perfect for weddings in Bargo and
            surrounding areas. We make your big day seamless, stress-free, and
            memorable.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort with our premium vehicles. Ideal for corporate
            clients or special occasions. Enjoy smooth rides with
            well-maintained cars and experienced drivers.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first for families. We provide certified baby seats,
            giving parents peace of mind. Perfect for school runs, airport
            trips, or family outings.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Reliable service for business trips and meetings. Punctual pickups,
            professional drivers, and CabCharge options make your commute
            stress-free.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Catch your cruise without worry. Our drivers know the fastest
            routes, ensuring timely arrivals for cruise departures from local
            terminals.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Arrive safely at concerts, parties, or sports events. Group travel
            is easy with our spacious maxi cabs. Hassle-free service for every
            occasion.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for groups and family trips. Our spacious maxi cabs
            accommodate luggage and multiple passengers comfortably. No one gets
            left behind during your Razorback journey.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            From airport pickups to boardroom meetings, our corporate trips
            ensure professionalism and comfort. Count on us for safe, reliable,
            and punctual rides every time.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Efficient rides for staff or clients. Flexible scheduling and
            professional service make business travel smooth and reliable.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Bargo Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We offer a modern, well-maintained fleet in Bargo to suit every journey. Each vehicle is designed for safety, comfort, and reliability. You can choose the perfect ride for solo trips, family outings, or corporate events. Our team ensures your ride meets your needs with expert guidance and punctual service. Whether you need a small taxi or a large maxi cab, we provide hassle-free bookings and professional drivers who know Bargo inside out.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for solo travel or small groups. Comfortable,
            fuel-efficient, and punctual for short trips or airport runs.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style for business or special occasions. Fully equipped
            interiors for comfort and premium experience.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Spacious rides for families and groups. Handles luggage easily,
            ideal for weekend getaways or corporate trips.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Maxi cab comfort with room for passengers and luggage. Ideal for
            airport transfers or group outings.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Perfect for larger groups or families. Handles multiple passengers
            and luggage with ease, ensuring safe travel.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Inclusive travel for everyone. Our wheelchair-accessible vehicles
            make mobility convenient and safe.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Bargo Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Bargo ?",
        answer: (
          <>
            You can book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              taxi booking page
            </Link>{" "}
            or call 1300 450 428. Advance bookings and on-demand rides are
            available.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Bargo .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Bargo taxi and cab services</strong> operate day and night,
            including weekends and holidays. You can rely on us whenever you
            need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Bargo taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Bargo taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Bargo?",
        answer: (
          <>
            Yes. We cover Bargo Ambarvale, Leumeah, Minto, Campbelltown, and
            surrounding suburbs. Check full coverage{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge?",
        answer: (
          <>
            Yes, we provide{" "}
            <Link to="/cabcharge-taxi" className="underline font-semibold px-1">
              CabCharge Taxi services
            </Link>{" "}
            for easy and secure payments.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I arrange corporate transport in Bargo?",
        answer: (
          <>
            You can schedule rides in advance for meetings, events, or airport
            transfers. We provide professional, punctual service.
          </>
        ),
      },
      {
        question: " Do you offer event and wedding transfers?",
        answer: (
          <>
            Yes, we handle weddings, corporate events, and private parties with
            professionalism and comfort. Your guests travel safely and on time.
          </>
        ),
      },
      {
        question: "Are your vehicles wheelchair accessible?",
        answer: (
          <>
            Yes. We have wheelchair{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxis
            </Link>
            for easy and safe mobility.
          </>
        ),
      },
      {
        question: "What if I need a taxi late at night or early morning?",
        answer: (
          <>We operate 24/7. You can rely on us for safe early or late rides.</>
        ),
      },
    ],
  },
  "rosemeadow-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13214.231474690321!2d150.7917544!3d-34.106465199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12e547a5d87e31%3A0x5017d681632c930!2sRosemeadow%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769803867065!5m2!1sen!2sbd",
    pageTitle: "24/7 Rosemeadow Taxi & Maxi Cabs – Fast, Safe & Reliable Rides",
    metaDescription:
      "Reliable Rosemeadow Taxi & Maxi Cabs – 24/7 service for airport, events & groups. Book now for safe, punctual rides with comfort guaranteed.",
    heroTitle: "24/7 Rosemeadow Taxi & Maxi Cabs – Fast, Safe & Reliable Rides",
    heroDescription: (
      <>
        When you need a
        <strong>
          Rosemeadow{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>
        , you want service that’s fast, safe, and reliable. Our local team knows
        every street in Rosemeadow and surrounding areas. We cater to families,
        students, professionals, and seniors. With 24/7 availability, you can
        book rides anytime. Our fleet includes maxi cabs, sedans, and luxury
        vehicles. We make airport transfers, event rides, and daily commutes
        effortless. Trust us for convenient booking and friendly drivers.
      </>
    ),
    bookingFormTitle: "Book for Event Transfer in Rosemeadow",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Rosemeadow",
    locationSectionDescription: (
      <>
        When you choose our <strong>Rosemeadow taxi and cab services,</strong>
        you get punctuality and peace of mind. We understand your busy lifestyle
        and daily travel needs. Whether you’re heading to work, a flight, or a
        social event, our drivers ensure smooth rides. You can book over the
        phone, online, or through our
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          Taxi Booking page.
        </Link>
        Our community trusts us for{" "}
        <strong>safe baby taxis, wheelchair-accessible rides,</strong> and
        luxury transfers. You don’t need to worry about long waits or hidden
        costs. We make your journey seamless. With local knowledge and modern
        vehicles, we are your first choice for{" "}
        <strong>Rosemeadow taxi cab service.</strong>
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Rosemeadow",
    serviceSubtitle: (
      <>
        We offer tailored services to meet all your travel needs. From airport
        trips to group travel, we have the right vehicle and driver for you.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Celebrate your special day without stress. Our professional drivers
            ensure timely pickups, elegant vehicles, and a smooth journey to
            your wedding venue. You can rely on us for comfort and style. Book
            easily via our
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              Wedding Transfer Page
            </Link>
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Arrive in style for business meetings or special events. Our premium
            sedans and SUVs guarantee comfort and punctuality. Choose Rosemeadow
            luxury taxi services for a seamless ride.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. We provide certified baby seats in all
            vehicles. Perfect for family trips or airport transfers.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients and employees with reliable, professional transport.
            Our corporate fleet offers punctuality, comfort, and convenience.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Avoid last-minute stress with airport and cruise terminal transfers.
            We handle luggage, schedules, and comfort.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Heading to concerts, sports, or festivals? We offer timely pick-ups,
            group-friendly vehicles, and hassle-free rides.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travelling in a group or with lots of luggage? Our spacious maxi
            cabs in Rosemeadow ensure everyone rides together comfortably.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Travel smart for business. Our premium corporate taxi services
            provide a professional, reliable experience.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Efficient rides for staff or clients. Flexible scheduling and
            professional service make business travel smooth and reliable.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Rosemeadow Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We offer a wide range of vehicles to suit your needs. Whether you need a solo ride or a group transfer, we have a solution. Every vehicle is regularly serviced and cleaned for safety and comfort. You can choose from sedans, luxury cars, maxi cabs, and wheelchair-accessible options. Our drivers are friendly, licensed, and highly experienced. Booking is easy through phone or online. We focus on reliable Rosemeadow taxi service with professional care.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for short trips and solo travellers. Comfort and efficiency
            are guaranteed.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Arrive in style with premium sedans and SUVs. Ideal for special
            events or corporate clients.Learn more about{" "}
            <Link
              to={`https://campbelltowntaxicabs.com.au/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              Luxury Transfer.
            </Link>
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Travel with family or friends comfortably. Spacious interiors and
            smooth rides make every trip enjoyable.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Our multi-seat vans are perfect for group travel or airport pickups.
            Reliable and convenient.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Large groups and luggage? Our maxi cabs carry up to 12 passengers
            easily.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Our vehicles are accessible and safe for passengers with mobility
            needs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Bargo Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Rosemeadow?",
        answer: (
          <>
            You can book online via our
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              taxi booking page
            </Link>{" "}
            or call 1300 450 428. Advance bookings and on-demand rides are
            available.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Rosemeadow .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Rosemeadow taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Do you provide baby seats and child safety options?",
        answer: (
          <>
            Yes. We have certified baby seats available upon request for safe{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Family_Travel_Forum`}
              className="underline font-semibold px-1"
            >
              family travel.
            </Link>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Rosemeadow taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Do you operate outside Rosemeadow?",
        answer: (
          <>
            Yes. We cover Rosemeadow Ambarvale, Leumeah, Minto, Campbelltown,
            and surrounding suburbs. Check full coverage{" "}
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              here
            </Link>{" "}
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge?",
        answer: (
          <>
            Yes, we provide{" "}
            <Link to="/cabcharge-taxi" className="underline font-semibold px-1">
              CabCharge Taxi services
            </Link>{" "}
            for easy and secure payments.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I arrange corporate transport in Rosemeadow?",
        answer: (
          <>
            You can schedule rides in advance for meetings, events, or airport
            transfers. We provide professional, punctual service.
          </>
        ),
      },
      {
        question: "Do you offer event and wedding transfers?",
        answer: (
          <>
            Yes, we handle weddings, corporate events, and private parties with
            professionalism and comfort. Your guests travel safely and on time.
          </>
        ),
      },
      {
        question: "Do you offer wheelchair-accessible taxis?",
        answer: (
          <>
            Yes. Our fleet includes wheelchair-accessible
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              vehicles
            </Link>{" "}
            for easy mobility.
          </>
        ),
      },
      {
        question: "How much does a taxi ride in Rosemeadow cost?",
        answer: (
          <>
            Our fares are competitive. Exact pricing depends on distance and
            service type. Call us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule airport or cruise terminal transfers?",
        answer: (
          <>
            Absolutely. We specialise in airport and cruise terminal transfers,
            handling luggage efficiently.
          </>
        ),
      },
    ],
  },
  "smeaton-grange-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13225.046166150634!2d150.75760985!3d-34.03716155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f1801acf8fc1%3A0x5017d681632cb10!2sSmeaton%20Grange%20NSW%202567%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769804218723!5m2!1sen!2sbd",
    pageTitle: "Smeaton Grange Taxi & Maxi Cabs – 24/7 Reliable Local Service",
    metaDescription:
      "Book Smeaton Grange Taxi & Maxi Cabs for fast, professional rides. Enjoy on-time service, modern vehicles & hassle-free travel every time.",
    heroTitle: "Smeaton Grange Taxi & Maxi Cabs – 24/7 Reliable Local Service",
    heroDescription: (
      <>
        Looking for a reliable taxi service in Smeaton Grange? Your search ends
        here. With{" "}
        <strong>
          Smeaton Grange{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs,
          </Link>
        </strong>{" "}
        you enjoy fast, safe, and comfortable rides any time of the day. Whether
        you need a quick trip to work, a school drop-off, or an airport
        transfer, our experienced drivers are always ready to serve. <br />
        We pride ourselves on punctuality, professional service, and vehicles
        that suit every need. From solo travellers to large groups, our fleet
        ensures smooth, stress-free journeys. Safety and comfort are our top
        priorities, making us the most{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          trusted local taxi service.
        </Link>{" "}
        You can book easily via phone, online, or through our website. <br />
        Our team knows Smeaton Grange and surrounding suburbs like the back of
        their hands. Every ride is tailored to your schedule, whether it’s an
        early morning airport trip or a late-night event transfer. We also offer
        Maxi Cabs for groups or families with luggage, ensuring everyone travels
        together comfortably. <br />
        With <strong>Smeaton Grange Taxi & Maxi Cabs</strong> , you never have
        to wait long. Our transparent pricing, friendly drivers, and flexible
        booking options make your travel experience hassle-free. Book today and
        enjoy a ride that prioritises your convenience, safety, and peace of
        mind.
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi in Smeaton Grange",
    locationSectionTitle:
      "Trusted Taxi and Maxi Cab Services in Smeaton Grange",
    locationSectionDescription: (
      <>
        When you choose{" "}
        <strong>
          {" "}
          Smeaton Grange{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
            className="underline font-semibold px-1"
          >
            taxi and cab services,
          </Link>{" "}
        </strong>{" "}
        you’re opting for reliability. You get on-time pickups, modern vehicles,
        and drivers who understand your local routes. Our service covers short
        local trips and long-distance journeys, including airport and event
        transfers. <br />
        We know your pain points. You might worry about late-night availability,
        small vehicles, or unreliable rides. That’s why we maintain a fleet
        ready 24/7, including
        <strong>Maxi Cabs near you in Smeaton Grange</strong>for families and
        large groups. Every trip is planned to save you time and stress.
        <br />
        Booking is simple. You can call 1300 450 428, email
        <strong>taxibookingcampbelltown@gmail.com,</strong> or reserve online at{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          book a taxi.
        </Link>{" "}
        From airport shuttles to corporate transport, we ensure you travel
        safely and comfortably. Our local expertise means your journey is
        smooth, efficient, and personalised.
        <br />
        <Link to={`/area-covered`} className="underline font-semibold  px-1">
          Learn more about our service areas
        </Link>{" "}
        and see why we’re the go-to local taxi service in Smeaton Grange.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Smeaton Grange",
    serviceSubtitle: (
      <>
        We offer a wide range of services designed for your needs. Every ride is
        handled with care, whether you travel alone or in a group. Our goal is
        to provide convenience, safety, and comfort for all travellers.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day stress-free. Our professional drivers ensure
            timely arrivals and departures. Vehicles are immaculate, and we
            accommodate bridal parties, guests, and luggage. Your wedding
            transport will be seamless and memorable. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our premium vehicles. Perfect for corporate
            meetings or special occasions. You’ll enjoy comfort, punctuality,
            and personalised service. Arrive confidently with our luxury taxi
            and maxi cab options. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety comes first for your little ones. Our vehicles include secure
            child seats on request. Ideal for family trips, airport transfers,
            and school runs. Relax knowing your child is protected. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients with timely, reliable corporate rides. Our fleet
            handles business travellers efficiently. You’ll enjoy stress-free
            transport for meetings, conferences, and executive trips. Learn more
            at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Avoid the rush and make your cruise departure smooth. Our drivers
            help with luggage and ensure punctual arrivals at Sydney cruise
            terminals. Travel relaxed and on schedule. Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Attending weddings, parties, or social events? Our vehicles handle
            large groups and busy schedules. You’ll arrive together and in
            comfort, without worrying about parking or traffic. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for groups, families, or airport trips. Our spacious Maxi
            Cabs in Smeaton Grange accommodate everyone with luggage. Travel
            together without splitting into multiple vehicles.Comfort and
            reliability come standard Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Dependable, professional rides for business purposes. Efficient
            routes, punctual service, and comfort are guaranteed. Make{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Business_travel`}
              className="underline font-semibold px-1"
            >
              work travel
            </Link>{" "}
            stress-free with our executive fleet. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our Leppington taxi cab close to me
            service. Timely pickups, luggage support, and stress-free journeys
            are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Smeaton Grange  Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We offer a fleet designed for every need. Whether you travel alone, with family, or in a group, you’ll find the perfect vehicle. Each ride combines safety, comfort, and reliability. Our drivers are trained to provide the best experience possible.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for solo or small group travel. Comfortable, quick, and
            perfect for city or airport trips. Reliable for short or long
            journeys. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort. Suited for special events, corporate
            meetings, or premium airport transfers. Make an impression while
            enjoying smooth rides. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More space for passengers and luggage. Perfect for families,
            business travellers, or social outings. You’ll travel stress-free
            and comfortably. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and practical, ideal for groups or families. Perfect for
            airport runs and long-distance trips. Comfortable seating and smooth
            ride guaranteed. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Large groups? Our Maxi Cabs ensure everyone travels together. Great
            for weddings, events, or group outings. Luggage space included.
            Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessibility is our priority. Wheelchair-friendly vehicles with
            trained drivers ensure easy, safe mobility for all passengers. Book
            at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Smeaton Grange Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Smeaton Grange?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              campbelltowntaxicabs.com.
            </Link>{" "}
            campbelltowntaxicabs.com. Our{" "}
            <strong>Smeaton Grange taxi cab close to me</strong> service ensures
            fast, safe, and reliable pickups. Advance bookings are recommended
            for airport transfers or special occasions.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Smeaton Grange .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Camden
            South. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Smeaton Grange taxi and cab services</strong> operate day
            and night, including weekends and holidays. You can rely on us
            whenever you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Smeaton Grange taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Smeaton Grange taxi cab service</strong> for airport
            trips, VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Can I book late-night or early-morning rides?",
        answer: (
          <>
            Absolutely. Our taxi service operates 24/7, perfect for shift
            workers, night travellers, and airport runs.
          </>
        ),
      },
      {
        question: "Are your fares transparent?",
        answer: (
          <>
            Yes. No hidden costs. You'll know the fare before your
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Rides`}
              className="underline font-semibold px-1"
            >
              ride
            </Link>
            begins. Fair pricing is guaranteed.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I pay for my ride?",
        answer: (
          <>
            We accept cash, card, and CabCharge for convenience. Payment options
            are flexible and secure.
          </>
        ),
      },
      {
        question: " Are your drivers licensed and professional?",
        answer: (
          <>
            All drivers are fully licensed, insured, and trained to provide
            safe, courteous, and professional service.
          </>
        ),
      },
      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question: "Is your fleet wheelchair accessible?",
        answer: (
          <>
            Yes. We have dedicated wheelchair
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              taxis
            </Link>{" "}
            with trained drivers to ensure smooth mobility.
          </>
        ),
      },
    ],
  },
  "douglas-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52802.42505945942!2d150.7127046!3d-34.19360365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12fbf56a209ce1%3A0x40609b490438f10!2sDouglas%20Park%20NSW%202569%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769804546771!5m2!1sen!2sbd",
    pageTitle: "Fast, Reliable Douglas Park Taxi & Maxi Cabs Near You",
    metaDescription:
      "Douglas Park Taxi & Maxi Cabs – Affordable, safe, and reliable rides. Perfect for families, students, and professionals. Book online today!",
    heroTitle: "Fast, Reliable Douglas Park Taxi & Maxi Cabs Near You",
    heroDescription: (
      <>
        Looking for a
        <strong>
          reliable Douglas Park{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>
        service? You’ve come to the right place. Whether you need a quick ride
        to work, school, the airport, or a special event, we are here for you.
        Our local drivers know Douglas Park inside out. You’ll enjoy prompt
        pickups, safe journeys, and comfortable rides. We offer{" "}
        <strong> Maxi Cabs for groups</strong>, child seats for families, and
        wheelchair-accessible options. Booking is simple, either online or by
        phone. Trust us to make your travel stress-free and affordable.
      </>
    ),
    bookingFormTitle: "Book Corporate Tips in Douglas Park",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Douglas Park",
    locationSectionDescription: (
      <>
        When you choose{" "}
        <strong>
          {" "}
          Douglas{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Park taxi and cab services,
          </Link>{" "}
        </strong>{" "}
        you get
        <strong>peace of mind with every ride.</strong>Our team prioritises
        safety, reliability, and punctuality. We understand that missing
        flights, appointments, or school pickups is stressful. That’s why our
        drivers arrive on time and assist with luggage and boarding. You can
        rely on our local taxi service in Douglas Park for airport transfers,
        event travel, and corporate rides. Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          Taxi Booking Page
        </Link>
        makes scheduling easy. From casual trips to professional transfers, we
        ensure your journey is smooth and comfortable. With a diverse fleet,
        including Maxi Cabs, luxury vehicles, and baby-friendly taxis, your
        travel needs are always covered.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Douglas Park",
    serviceSubtitle: (
      <>
        We offer a wide range of Douglas Park taxi and cab services tailored to
        your needs. You can trust us for punctual, safe, and friendly transport.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day flawless. Our taxis and Maxi Cabs arrive on
            time. Drivers handle your luggage carefully. We ensure smooth
            journeys for you and your guests. You’ll enjoy professional service
            with luxury options to match your wedding style. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our premium vehicles. Perfect for corporate
            trips, VIP airport pickups, or special nights out. Our fleet
            includes sedans, SUVs, and Kia Carnival vehicles. We provide
            comfort, privacy, and punctuality for every ride. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. Our vehicles include child seats and
            boosters. You’ll have peace of mind knowing your child is secure.
            Drivers are trained to assist with children, making family travel
            stress-free. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or colleagues. Our corporate taxis arrive promptly.
            We offer tailored services for meetings, airport transfers, or
            corporate events. Your professionalism is reflected in every ride.
            Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Never miss your cruise. Our taxis provide timely pickups and
            drop-offs. We handle luggage efficiently. Enjoy a smooth journey
            from Douglas Park to Sydney cruise terminals.Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From sports to parties, we cover all events. Our Maxi Cabs
            accommodate groups comfortably. Drivers are experienced with busy
            locations. Your travel is stress-free and reliable. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel with friends, family, or colleagues. Our Maxi Cabs fit up to
            8 passengers with luggage. Perfect for group outings, airport trips,
            or tours. Comfort and space are guaranteed. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Dependable transport for professionals. We offer flexible bookings,
            on-demand rides, and long-distance trips. Focus on your work, while
            we handle your travel. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Douglas Park Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We offer modern and comfortable vehicles designed for every need. Our fleet meets local travel demands in Douglas Park. You’ll find options for individual trips, group travel, and special services. Each vehicle is cleaned, maintained, and insured. You can trust our drivers for safe and professional service.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for solo or small group travel. Comfortable, quick, and
            perfect for city or airport trips. Reliable for short or long
            journeys. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort. Suited for special events, corporate
            meetings, or premium airport transfers. Make an impression while
            enjoying smooth rides. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More space for passengers and luggage. Perfect for families,
            business travellers, or social outings. You’ll travel stress-free
            and comfortably. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and practical, ideal for groups or families. Perfect for
            airport runs and long-distance trips. Comfortable seating and smooth
            ride guaranteed. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Large groups? Our Maxi Cabs ensure everyone travels together. Great
            for weddings, events, or group outings. Luggage space included.
            Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessibility is our priority. Wheelchair-friendly vehicles with
            trained drivers ensure easy, safe mobility for all passengers. Book
            at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Cobbity Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Douglas Park?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Taxi Booking Page.
            </Link>
            Scheduling in advance ensures timely pickups.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Douglas Park .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Douglas
            Park. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: " Are your Maxi Cabs suitable for groups?",
        answer: (
          <>
            Yes, our Maxi Cabs fit up to 8 passengers comfortably. They’re ideal
            for airport transfers, family trips, or events.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Douglas Park taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I request a baby seat in my taxi?",
        answer: (
          <>
            Yes, we provide safe baby seat
            <Link
              target="_blank"
              to={`https://www.pointtopoint.nsw.gov.au/what-a-service-provider/taxi-service-providers`}
              className="underline font-semibold px-1"
            >
              taxis
            </Link>{" "}
            Your child's safety is our top priority.
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Douglas Park taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Can I book late-night or early-morning rides?",
        answer: (
          <>
            Absolutely. Our taxi service operates 24/7, perfect for shift
            workers, night travellers, and airport runs.
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I pay for my ride?",
        answer: (
          <>
            We accept cash, card, and CabCharge for convenience. Payment options
            are flexible and secure.
          </>
        ),
      },

      {
        question: "Do you accept corporate payments or CabCharge?",
        answer: (
          <>
            Yes, we accept{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Cabcharge`}
              className="underline font-semibold px-1"
            >
              CabCharge
            </Link>{" "}
            and corporate accounts for convenient billing. Check the Cab Charge
            Taxi page for details.
          </>
        ),
      },
      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "cobbity-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105849.22235332457!2d150.6799902!3d-33.99797365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f13ed251ef45%3A0x5017d681632b230!2sCobbitty%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769804803649!5m2!1sen!2sbd",
    pageTitle:
      "Reliable Cobbity Taxi & Maxi Cabs – 24/7 Airport & Local Services",
    metaDescription:
      "Safe & reliable Cobbity Taxi & Maxi Cabs – 24/7 airport, corporate, and group transfers. Book now for comfort and stress-free rides.",
    heroTitle:
      "Reliable Cobbity Taxi & Maxi Cabs – 24/7 Airport & Local Services",
    heroDescription: (
      <>
        Looking for a reliable taxi in Cobbity? You’ve come to the right place.
        At
        <strong>
          Cobbity{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs,
          </Link>
        </strong>
        we provide 24/7 airport transfers, local trips, and group travel
        solutions. Our team ensures you reach your destination safely and on
        time. We cater to families, students, professionals, and seniors.
        Whether you need a maxi cab for a group or a quiet sedan for business,
        we have the right vehicle for you. You can easily book online or by
        phone. Experience comfort, reliability, and convenience with every ride.
        Trust us for all your local travel and airport needs.
      </>
    ),
    bookingFormTitle: "Book Corporate Tips in Cobbity",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Cobbity",
    locationSectionDescription: (
      <>
        When you choose <strong> Douglas taxi and cab services, </strong> you
        get
        <strong>peace of mind with every ride.</strong>Our team prioritises
        safety, reliability, and punctuality. We understand that missing
        flights, appointments, or school pickups is stressful. That’s why our
        drivers arrive on time and assist with luggage and boarding. You can
        rely on our local taxi service in Cobbity for airport transfers, event
        travel, and corporate rides. Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          Taxi Booking Page
        </Link>
        makes scheduling easy. From casual trips to professional transfers, we
        ensure your journey is smooth and comfortable. With a diverse fleet,
        including Maxi Cabs, luxury vehicles, and baby-friendly taxis, your
        travel needs are always covered.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Cobbity",
    serviceSubtitle: (
      <>
        We offer a wide range of{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Cobbity taxi and cab services
        </Link>{" "}
        tailored to your needs. You can trust us for punctual, safe, and
        friendly transport.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Make your special day flawless. Our taxis and Maxi Cabs arrive on
            time. Drivers handle your luggage carefully. We ensure smooth
            journeys for you and your guests. You’ll enjoy professional service
            with luxury options to match your wedding style. Here
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in style with our premium vehicles. Perfect for corporate
            trips, VIP airport pickups, or special nights out. Our fleet
            includes sedans, SUVs, and Kia Carnival vehicles. We provide
            comfort, privacy, and punctuality for every ride. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. Our vehicles include child seats and
            boosters. You’ll have peace of mind knowing your child is secure.
            Drivers are trained to assist with children, making family travel
            stress-free. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or colleagues. Our corporate taxis arrive promptly.
            We offer tailored services for meetings, airport transfers, or
            corporate events. Your professionalism is reflected in every ride.
            Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Never miss your cruise. Our taxis provide timely pickups and
            drop-offs. We handle luggage efficiently. Enjoy a smooth journey
            from Cobbity to Sydney cruise terminals.Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From sports to parties, we cover all events. Our Maxi Cabs
            accommodate groups comfortably. Drivers are experienced with busy
            locations. Your travel is stress-free and reliable. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel with friends, family, or colleagues. Our Maxi Cabs fit up to
            8 passengers with luggage. Perfect for group outings, airport trips,
            or tours. Comfort and space are guaranteed. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Dependable transport for professionals. We offer flexible bookings,
            on-demand rides, and long-distance trips. Focus on your work, while
            we handle your travel. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Cobbity Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We offer modern and comfortable vehicles designed for every need. Our fleet meets local travel demands in Cobbity. You’ll find options for individual trips, group travel, and special services. Each vehicle is cleaned, maintained, and insured. You can trust our drivers for safe and professional service.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              solo traveller
            </Link>{" "}
            or couples. Comfortable, fuel-efficient, and ideal for local trips.
            Quick pickups and smooth rides are guaranteed.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort. Suited for special events, corporate
            meetings, or premium airport transfers. Make an impression while
            enjoying smooth rides. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More space for passengers and luggage. Perfect for families,
            business travellers, or social outings. You’ll travel stress-free
            and comfortably. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and practical, ideal for groups or families. Perfect for
            airport runs and long-distance trips. Comfortable seating and smooth
            ride guaranteed. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Large groups? Our Maxi Cabs ensure everyone travels together. Great
            for weddings, events, or group outings. Luggage space included.
            Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accessibility is our priority. Wheelchair-friendly vehicles with
            trained drivers ensure easy, safe mobility for all passengers. Book
            at
            <Link
              to={`/services/wheelchair-accessible-taxi`}
              className="underline font-semibold px-1"
            >
              wheelchair taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Cobbity Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Cobbity?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Taxi Booking Page.
            </Link>
            Scheduling in advance ensures timely pickups.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our{" "}
            <Link
              to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              maxi cabs
            </Link>{" "}
            can accommodate families, corporate groups, and travelers with
            luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Cobbity .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Cobbity.
            Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },

      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Cobbity taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Cobbity taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Cobbity taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Can I book late-night or early-morning rides?",
        answer: (
          <>
            Absolutely. Our taxi service operates 24/7, perfect for shift
            workers, night travellers, and airport runs.
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I pay for my ride?",
        answer: (
          <>
            We accept cash, card, and CabCharge for convenience. Payment options
            are flexible and secure.
          </>
        ),
      },

      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question: "Why should I choose Cobbity Taxi & Maxi Cabs?",
        answer: (
          <>
            We offer reliability, safety, local expertise, and 24/7
            availability. Our fleet suits every{" "}
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              travel
            </Link>{" "}
            need, from solo trips to large groups.
          </>
        ),
      },
    ],
  },
  "denham-court-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52934.82518046566!2d150.83072995!3d-33.98157535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ec3f7e58014b%3A0x5017d681632b450!2sDenham%20Court%20NSW%202565%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769805060589!5m2!1sen!2sbd",
    pageTitle: "24/7 Denham Court Taxi & Maxi Cabs – Safe, Reliable Ride",
    metaDescription:
      "Book Denham Court Taxi & Maxi Cabs online – quick, secure rides for families, students, and professionals. Call now for fast pickups!",
    heroTitle: "24/7 Denham Court Taxi & Maxi Cabs – Safe, Reliable Ride",
    heroDescription: (
      <>
        Looking for a reliable ride in Denham Court? You’ve come to the right
        place. Our{" "}
        <strong>
          Denham Court{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs,
          </Link>
        </strong>
        operate 24/7 to ensure you reach your destination safely and on time.
        Whether it’s a short local trip, airport transfer, or a group journey in
        a maxi cab, we provide professional, punctual, and comfortable service.
        Our fleet includes sedans, SUVs, and luxury vehicles for any travel
        need. You can trust our experienced drivers who know Denham Court routes
        inside out. Book your ride easily via{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          our taxi booking page
        </Link>
        or call us for immediate assistance. Safety, reliability, and
        convenience are our promises, making your journey stress-free every
        time.
      </>
    ),
    bookingFormTitle: "Book Corporate Tips in Denham Court",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Denham Court",
    locationSectionDescription: (
      <>
        When you choose our<strong> Denham taxi and cab services, </strong> you
        get more than just a ride. We understand your need for reliable, safe,
        and timely transportation, especially during peak hours or late-night
        travel. You no longer have to worry about ride cancellations, unclear
        fares, or unavailable taxis. Our service covers airport transfers,
        corporate travel, special events, and everyday trips. You can book in
        advance or call us anytime for an urgent ride. With a focus on safety,
        comfort, and punctuality, you’ll enjoy a smooth journey every time.
        Learn more about{" "}
        <Link to={`/fleet`} className="underline font-semibold  px-1">
          our fleet options
        </Link>
        and experience the difference of a local taxi service tailored for
        Denham Court.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Denham Court",
    serviceSubtitle: (
      <>
        We provide a range of services designed to meet all your travel needs.
        Our Denham Court taxi cab service ensures you travel with comfort and
        safety.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Arrive in style for your special day. Our professional drivers
            ensure punctuality and comfort. We provide luxury vehicles and
            mini-buses suitable for groups of any size. Here at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Travel in comfort and elegance. Our sedans and SUVs are perfect for
            business or leisure. Enjoy quiet, air-conditioned rides with
            experienced drivers. Details at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer.
            </Link>{" "}
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Keep your little ones safe. Our vehicles include child seats and
            boosters. You’ll have peace of mind knowing your child is secure.
            Drivers are trained to assist with children, making family travel
            stress-free. Check
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seat taxi.
            </Link>{" "}
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress clients or colleagues. Our corporate taxis arrive promptly.
            We offer tailored services for meetings, airport transfers, or
            corporate events. Your professionalism is reflected in every ride.
            Learn more at
            <Link
              to={`/services/corporate-transport-services`}
              className="underline font-semibold px-1"
            >
              transport services.
            </Link>{" "}
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Never miss your cruise. Our taxis provide timely pickups and
            drop-offs. We handle luggage efficiently. Enjoy a smooth journey
            from Denham Court to Sydney cruise terminals.Details at
            <Link
              to={`/services/cruise-terminal-transfer`}
              className="underline font-semibold px-1"
            >
              cruise terminal transfer.
            </Link>{" "}
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            From sports to parties, we cover all events. Our Maxi Cabs
            accommodate groups comfortably. Drivers are experienced with busy
            locations. Your travel is stress-free and reliable. Learn more at
            <Link
              to={`/services/event-transfer`}
              className="underline font-semibold px-1"
            >
              event transfer.
            </Link>{" "}
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Travel with friends, family, or colleagues. Our Maxi Cabs fit up to
            8 passengers with luggage. Perfect for group outings, airport trips,
            or tours. Comfort and space are guaranteed. Explore
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Dependable transport for professionals. We offer flexible bookings,
            on-demand rides, and long-distance trips. Focus on your work, while
            we handle your travel. More details at
            <Link
              to={`/services/corporate-tips`}
              className="underline font-semibold px-1"
            >
              corporate trips.
            </Link>{" "}
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Denham Court Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "We offer modern and comfortable vehicles designed for every need. Our fleet meets local travel demands in Denham Court. You’ll find options for individual trips, group travel, and special services. Each vehicle is cleaned, maintained, and insured. You can trust our drivers for safe and professional service.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for solo or small group travel. Comfortable, quick, and
            perfect for city or airport trips. Reliable for short or long
            journeys. Book easily at
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              book a taxi.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Travel in style and comfort. Suited for special events, corporate
            meetings, or premium airport transfers. Make an impression while
            enjoying smooth rides. Learn more at
            <Link
              to={`/services/luxury-transfer`}
              className="underline font-semibold px-1"
            >
              luxury transfer
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More space for passengers and luggage. Perfect for families,
            business travellers, or social outings. You’ll travel stress-free
            and comfortably. Explore
            <Link to={`/fleet`} className="underline font-semibold px-1">
              premium fleet.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Spacious and practical, ideal for groups or families. Perfect for
            airport runs and long-distance trips. Comfortable seating and smooth
            ride guaranteed. Check
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Maxi Taxi Service.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Large groups? Our Maxi Cabs ensure everyone travels together. Great
            for weddings, events, or group outings. Luggage space included.
            Learn more
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              here.
            </Link>{" "}
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fully accessible vehicles with
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driver%27s_education`}
              className="underline font-semibold px-1"
            >
              trained drivers
            </Link>
            to assist passengers. Safe and reliable.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Denham Court Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Denham Court?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Taxi Booking Page.
            </Link>
            Scheduling in advance ensures timely pickups.
          </>
        ),
      },
      {
        question: "Are your drivers licensed and professional?",
        answer: (
          <>
            Yes, all our drivers are fully licensed, insured, and trained to
            provide safe and courteous service.
          </>
        ),
      },
      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },

      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Denham
            Court. Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: " Are your Maxi Cabs suitable for groups?",
        answer: (
          <>
            Yes, our Maxi Cabs fit up to 8 passengers comfortably. They’re ideal
            for airport transfers, family trips, or events.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Denham Court taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Denham Court taxi service</strong>
          </>
        ),
      },

      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Denham Court taxi cab service</strong> for airport trips,
            VIP travel, or special occasions.
          </>
        ),
      },

      {
        question: " Can I book late-night or early-morning rides?",
        answer: (
          <>
            Absolutely. Our taxi service operates 24/7, perfect for shift
            workers, night travellers, and airport runs.
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "What payment methods are accepted?",
        answer: (
          <>
            We accept cash, cards, and{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Cabcharge`}
              className="underline font-semibold px-1"
            >
              CabCharge
            </Link>{" "}
            for easy payments.
          </>
        ),
      },

      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "liverpool-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26486.119043651972!2d150.9160342!3d-33.9214504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129610b02d4195%3A0x5017d681632bea0!2sLiverpool%20NSW%202170%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769805255379!5m2!1sen!2sbd",
    pageTitle: "24/7 Liverpool Taxi & Maxi Cabs – Fast, Safe & Reliable Rides",
    metaDescription:
      "[24/7 Liverpool Taxi & Maxi Cabs] - [Reliable airport transfers, group travel, and baby seats near 1 Hurley St.] [Book your safe ride now!] [Call 1300 450 428]",
    heroTitle: "24/7 Liverpool Taxi & Maxi Cabs – Fast, Safe & Reliable Rides",
    heroDescription: (
      <>
        Experience the best{" "}
        <strong>
          Liverpool{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>{" "}
        for all your travel needs. We provide prompt pickups and professional
        drivers near <strong>1 Hurley St, Campbelltown.</strong> Our fleet
        handles solo trips or large groups with absolute ease. You can enjoy
        fixed rates and clean vehicles for every journey. We prioritise your
        safety and comfort throughout the entire Sydney region. Book your
        reliable local taxi service Liverpool now for a premium experience. Book
        your ride easily via{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          our taxi booking page.
        </Link>
      </>
    ),
    bookingFormTitle: "Book Corporate Tips in Liverpool",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Denham Court",
    locationSectionDescription: (
      <>
        Are you tired of ride-share apps cancelling your important trips? You
        deserve a <strong> Liverpool taxi and cab services, </strong> provider
        that values your time. We offer a dependable{" "}
        <strong>taxi service close to me</strong>
        for every resident. Our team understands the stress of reaching 1 Hurley
        St, Campbelltown on time. You will find our{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Liverpool taxi cab service
        </Link>
        operates around the clock. We solve the common pain point of long wait
        times during peak hours. Our drivers know the quickest routes to avoid
        heavy local traffic. You can rely on our local taxi service near me for
        school runs. We provide a safe environment for women and seniors
        travelling late at night. Your comfort is our mission while navigating
        the busy suburban streets. We use modern tracking to ensure your maxi
        cab arrives exactly when promised. Trust our expert team for your next
        ride across the local area.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Liverpool",
    serviceSubtitle: (
      <>
        Finding a high-quality <strong>taxi service near me</strong> shouldn't
        be a difficult task. We offer versatile transport solutions for
        families, corporate clients, and social groups. Our Liverpool taxi cab
        fleet stays ready for immediate dispatch or advanced bookings.
        Experience a seamless journey with our dedicated team of professional
        local drivers.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You need elegant transport for your special day near{" "}
            <strong>1 Hurley St, Campbelltown</strong>. Our{" "}
            <strong>Liverpool Taxi & Maxi Cabs</strong> provide stylish vehicles
            for the bridal party. We ensure every guest arrives at the venue on
            time and safely. You can relax knowing our drivers handle the
            logistics with total professionalism. Your wedding photos will look
            great with our pristine, polished fleet. Here at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Treat yourself to a premium ride with our local taxi cab service
            near me. We use high-end vehicles to give you a first-class
            experience every time. You will enjoy leather seats and a quiet
            cabin during your commute. This service is perfect for special dates
            or important business meetings. We maintain our
            <Link to={`/fleet`} className="underline font-semibold px-1">
              Taxi Cabs Premium Fleet
            </Link>
            to the highest possible standards.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety for your children is our highest priority during any trip. We
            provide
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              Taxi Booking
            </Link>
            options that include pre-installed, certified child seats. You don't
            have to carry your own heavy equipment when you travel. Our drivers
            ensure the seats are secure before you begin your journey. It makes
            family travel to 1 Hurley St, Campbelltown much easier for parents.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            mpress your clients with our punctual and professional Liverpool
            taxi service. We offer
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              CabCharge Taxi Campbelltown
            </Link>
            options for easy business expense management. Your staff will
            appreciate the reliable pickups for early morning meetings. We
            provide quiet environments so you can work while on the move. Our
            drivers maintain total discretion for all your sensitive corporate
            conversations.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday without the stress of driving to the docks. Our
            maxi cab services Liverpool have plenty of room for all your
            suitcases. We drop you off right at the terminal entrance for
            convenience. You won't have to worry about expensive long-term
            parking fees at the port. We monitor ship schedules to ensure your
            return pickup is perfectly timed.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Head to the big game or a concert without any parking hassles. Our
            maxi cab near me is the best way to travel with friends. We handle
            the navigation while you enjoy the pre-event excitement with your
            group. You can book a return ride to avoid the post-event crowds. We
            pick you up from designated areas for a fast exit.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Moving a large group requires a spacious and comfortable maxi cab.
            Our vehicles accommodate up to eleven passengers in a single trip.
            This is a cost-effective choice for large families or social clubs.
            You get ample legroom and a dedicated area for your bulky luggage.
            We are the top choice for
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              Service Areas We Cover
            </Link>
            in the region.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Coordinate your team building events with our reliable
            <Link to={`/about`} className="underline font-semibold px-1">
              About Us
            </Link>
            transport team. We manage multiple pickups for large office groups
            heading to local venues. You can track all your bookings through our
            easy online system. Our fleet handles high-volume requests without
            sacrificing any service quality. We help your business stay on
            schedule for every important regional event.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Liverpool Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Choosing the right vehicle makes your journey through 1 Hurley St, Campbelltown much better. Our diverse fleet meets every specific travel requirement for our multicultural community. We maintain each car to ensure mechanical safety and interior cleanliness. You can select a vehicle that fits your budget and passenger count. Our taxi services near me offer everything from compact cars to large vans. We use the latest GPS technology for efficient routing in every vehicle. You will find our drivers are experts at handling these modern machines. Read our Blogs to learn more about our vehicle standards.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo travellers or couples. You get a
            comfortable ride for short trips around the suburb. It is an
            affordable and efficient way to reach your destination.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Enjoy a superior level of comfort with our executive car range.
            These cars feature premium interiors for a more sophisticated travel
            experience. You can impress your guests with this high-end transport
            option today.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Do you have extra bags or sports equipment to carry? Our SUVs
            provide the additional cargo space you need for daily errands. They
            offer a smooth ride for families with a few small children.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This vehicle is a favourite for medium-sized families in the area.
            It offers a perfect balance of passenger seating and storage space.
            You will love the easy access and modern safety features included.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our Maxi cabs near me in Liverpool are built for big groups. You can
            fit your entire party into one clean, air-conditioned van. It is the
            most social way to travel to any local event.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide inclusive transport for passengers with specific mobility
            needs. Our vehicles feature professional ramps and secure tie-down
            points for your{" "}
            <Link
              target="_blank"
              to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
              className="underline font-semibold px-1"
            >
              safety.
            </Link>{" "}
            Our drivers are trained to assist you with care and patience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Liverpool Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Liverpool?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Taxi Booking Page.
            </Link>
            Scheduling in advance ensures timely pickups.
          </>
        ),
      },

      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },
      {
        question: "Can I get a Maxi Cab for group travel?",
        answer: (
          <>
            Absolutely. Our
            <Link
              to={`/services/maxi-taxi-service`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            accommodates large groups and luggage. Perfect for events, family
            trips, or corporate travel in Liverpool .
          </>
        ),
      },
      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Liverpool.
            Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },

      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Liverpool taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Liverpool taxi service</strong>
          </>
        ),
      },
      {
        question: "Is your taxi service available on public holidays?",
        answer: (
          <>
            We operate every day of the year, including Christmas and New Year.
            You can always find a reliable ride with our professional local
            team.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Liverpool taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Can I book late-night or early-morning rides?",
        answer: (
          <>
            Absolutely. Our taxi service operates 24/7, perfect for shift
            workers, night travellers, and airport runs.
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question: "How do I pay for my ride?",
        answer: (
          <>
            We accept cash, card, and CabCharge for convenience. Payment options
            are flexible and secure.
          </>
        ),
      },

      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
    ],
  },
  "bowral-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52620.592732552046!2d150.43002019999997!3d-34.48292615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b13a298402fbfcf%3A0x50609b490442490!2sBowral%20NSW%202576%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769805506197!5m2!1sen!2sbd",
    pageTitle: "Bowral Taxi & Maxi Cabs Near Me – Book Your Ride Today",
    metaDescription:
      "Fast & reliable Bowral Taxi & Maxi Cabs – Safe rides for airport, events & groups. Call now 1300 450 428 or book online for stress-free travel.",
    heroTitle: "Bowral Taxi & Maxi Cabs Near Me – Book Your Ride Today",
    heroDescription: (
      <>
        Are you searching for a reliable{" "}
        <strong>
          Bowral{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>{" "}
        provider? We offer premium transport solutions for residents and
        visitors in the Southern Highlands. Our team provides 24/7 support for
        all your local travel requirements. You can book a{" "}
        <strong>maxi cab</strong> for group outings or airport runs. We ensure
        every journey is safe, comfortable, and always on time. Experience the
        best{" "}
        <strong>
          {" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
            className="underline font-semibold px-1"
          >
            local taxi service
          </Link>{" "}
          Bowral
        </strong>{" "}
        has to offer with our fleet.
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi in Bowral NSW, Australia",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Denham Court",
    locationSectionDescription: (
      <>
        Finding a dependable{" "}
        <strong>
          {" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
            className="underline font-semibold px-1"
          >
            taxi service near me
          </Link>
        </strong>{" "}
        often feels like a gamble. Many passengers deal with late drivers or
        cancelled bookings on apps. You deserve a{" "}
        <strong>Bowral Taxi Service</strong> that values your precious time. We
        focus on punctuality for every trip near 1 Hurley St. Our professional
        drivers know every shortcut in the local area perfectly. You will enjoy
        a clean, modern vehicle for your daily commute. We solve the common pain
        point of unreliable transport for seniors. Our team offers assisted
        door-to-door service for those needing extra help. You can trust our
        local taxi service near me for late-night safety. We never use surge
        pricing during busy holiday peak periods. Your fare remains transparent
        and fair for every single journey. We provide peace of mind for families
        and solo female travellers. Choose Bowral taxi and cab services for a
        stress-free experience today. You can rely on our expertise for all your
        Southern Highlands transport.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Bowral, Australia",
    serviceSubtitle: (
      <>
        You can access a wide range of professional transport options here. We
        cater to diverse needs, from solo trips to group tours. Our Taxi Booking
        system is fast and very easy to use. You get high-quality service for
        every mile we drive together.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You need elegant transport for your special day near{" "}
            <strong>1 Hurley St, Campbelltown</strong>. Our{" "}
            <strong>Bowral Taxi & Maxi Cabs</strong> provide stylish vehicles
            for the bridal party. We ensure every guest arrives at the venue on
            time and safely. You can relax knowing our drivers handle the
            logistics with total professionalism. Your wedding photos will look
            great with our pristine, polished fleet. Here at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Treat yourself to a premium ride with our local taxi cab service
            near me. We use high-end vehicles to give you a first-class
            experience every time. You will enjoy leather seats and a quiet
            cabin during your commute. This service is perfect for special dates
            or important business meetings. We maintain our
            <Link to={`/fleet`} className="underline font-semibold px-1">
              Taxi Cabs Premium Fleet
            </Link>
            to the highest possible standards.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety for your children is our highest priority during any trip. We
            provide
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              Taxi Booking
            </Link>
            options that include pre-installed, certified child seats. You don't
            have to carry your own heavy equipment when you travel. Our drivers
            ensure the seats are secure before you begin your journey. It makes
            family travel to 1 Hurley St, Campbelltown much easier for parents.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress your clients with our punctual and professional Bowral taxi
            service. We offer
            <Link
              to={`/cabcharge-taxi`}
              className="underline font-semibold px-1"
            >
              CabCharge Taxi Campbelltown
            </Link>
            options for easy business expense management. Your staff will
            appreciate the reliable pickups for early morning meetings. We
            provide quiet environments so you can work while on the move. Our
            drivers maintain total discretion for all your sensitive corporate
            conversations.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday without the stress of driving to the docks. Our
            maxi cab services Bowral have plenty of room for all your suitcases.
            We drop you off right at the terminal entrance for convenience. You
            won't have to worry about expensive long-term parking fees at the
            port. We monitor ship schedules to ensure your return pickup is
            perfectly timed.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Head to the big game or a concert without any parking hassles. Our
            maxi cab near me is the best way to travel with friends. We handle
            the navigation while you enjoy the pre-event excitement with your
            group. You can book a return ride to avoid the post-event crowds. We
            pick you up from designated areas for a fast exit.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Moving a large group requires a spacious and comfortable maxi cab.
            Our vehicles accommodate up to eleven passengers in a single trip.
            This is a cost-effective choice for large families or social clubs.
            You get ample legroom and a dedicated area for your bulky luggage.
            We are the top choice for
            <Link to={`/area-covered`} className="underline font-semibold px-1">
              Service Areas We Cover
            </Link>
            in the region.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Coordinate your team building events with our reliable
            <Link to={`/about`} className="underline font-semibold px-1">
              About Us
            </Link>
            transport team. We manage multiple pickups for large office groups
            heading to local venues. You can track all your bookings through our
            easy online system. Our fleet handles high-volume requests without
            sacrificing any service quality. We help your business stay on
            schedule for every important regional event.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Bowral Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Choosing the right vehicle makes your journey through 1 Hurley St, Campbelltown much better. Our diverse fleet meets every specific travel requirement for our multicultural community. We maintain each car to ensure mechanical safety and interior cleanliness. You can select a vehicle that fits your budget and passenger count. Our taxi services near me offer everything from compact cars to large vans. We use the latest GPS technology for efficient routing in every vehicle. You will find our drivers are experts at handling these modern machines. Read our Blogs to learn more about our vehicle standards.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo travellers or couples. You get a
            comfortable ride for short trips around the suburb. It is an
            affordable and efficient way to reach your destination.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Enjoy a superior level of comfort with our executive car range.
            These cars feature premium interiors for a more sophisticated travel
            experience. You can impress your guests with this high-end transport
            option today.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Do you have extra bags or sports equipment to carry? Our SUVs
            provide the additional cargo space you need for daily errands. They
            offer a smooth ride for families with a few small children.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This vehicle is a favourite for medium-sized families in the area.
            It offers a perfect balance of passenger seating and storage space.
            You will love the easy access and modern safety features included.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our Maxi cabs near me in Bowral are built for big groups. You can
            fit your entire party into one clean, air-conditioned van. It is the
            most social way to travel to any local event.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide inclusive transport for passengers with specific mobility
            needs. Our vehicles feature professional ramps and secure tie-down
            points for your safety. Our drivers are trained to assist you with
            care and patience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Bowral Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How can I book a taxi in Bowral?",
        answer: (
          <>
            Call 1300 450 428 or book online at{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Taxi Booking Page.
            </Link>
            Scheduling in advance ensures timely pickups.
          </>
        ),
      },

      {
        question: "Do you offer maxi cab services for large groups?",
        answer: (
          <>
            Absolutely. Our maxi cabs can accommodate families, corporate
            groups, and travelers with luggage or equipment.
          </>
        ),
      },
      {
        question: "Do you provide airport transfers ?",
        answer: (
          <>
            Yes, our
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Fast and Reliable Taxi Airport Service
            </Link>{" "}
            ensures on-time arrivals. We handle your luggage safely and track
            flights for stress-free travel.
          </>
        ),
      },

      {
        question: "Are your drivers professional and trustworthy?",
        answer: (
          <>
            Yes. All drivers are licensed, vetted, and familiar with Bowral.
            Safety, punctuality, and professionalism are our priorities.
          </>
        ),
      },
      {
        question: " Are your Maxi Cabs suitable for groups?",
        answer: (
          <>
            Yes, our Maxi Cabs fit up to 8 passengers comfortably. They’re ideal
            for airport transfers, family trips, or events.
          </>
        ),
      },
      {
        question: "Are your taxis available 24/7?",
        answer: (
          <>
            Absolutely. Our
            <strong> Bowral taxi and cab services</strong> operate day and
            night, including weekends and holidays. You can rely on us whenever
            you need a ride..
          </>
        ),
      },
      {
        question: "Can I get a taxi with a baby seat?",
        answer: (
          <>
            Yes. Adjustable{" "}
            <Link
              to={`/services/baby-seat-taxi-sydney`}
              className="underline font-semibold px-1"
            >
              baby seats
            </Link>{" "}
            are available for safety. Travel comfortably for school runs,
            appointments, or family outings with our
            <strong>Bowral taxi service</strong>
          </>
        ),
      },
      {
        question: "What are the taxi rates near me?",
        answer: (
          <>
            Our rates follow standard meter pricing with no hidden surge fees.
            You get an honest price for your local{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>{" "}
            service in Bowral.
          </>
        ),
      },
      {
        question: "Is there a luxury or corporate transfer option?",
        answer: (
          <>
            Yes. Luxury vehicles provide comfort, privacy, and punctuality. Book
            a<strong> Bowral taxi cab service</strong> for airport trips, VIP
            travel, or special occasions.
          </>
        ),
      },

      {
        question: " Can I book late-night or early-morning rides?",
        answer: (
          <>
            Absolutely. Our taxi service operates 24/7, perfect for shift
            workers, night travellers, and airport runs.
          </>
        ),
      },
      {
        question: "How much do your taxi rides cost?",
        answer: (
          <>
            Our pricing is transparent and competitive. You can check fares
            online or contact us for a quote.
          </>
        ),
      },
      {
        question: "Can I schedule a taxi in advance?",
        answer: (
          <>
            Yes. You can pre-book taxis or maxi cabs in advance to ensure
            punctual service at your preferred time.
          </>
        ),
      },
      {
        question:
          "Can I pay for my Bowral taxi and cab services with CabCharge?",
        answer: (
          <>
            We proudly accept CabCharge for all corporate and personal{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Travel`}
              className="underline font-semibold px-1"
            >
              travel
            </Link>{" "}
            needs. It makes expense tracking for your business trips very
            simple.
          </>
        ),
      },

      {
        question: "Can I book a ride for special events?",
        answer: (
          <>
            Yes, we cater to weddings, parties, sporting events, and other
            occasions with reliable and spacious transport options.
          </>
        ),
      },
      {
        question:
          " Do you provide accessible vehicles for passengers with disabilities?",
        answer: (
          <>
            Yes, our wheelchair taxi services are fully equipped to provide safe
            and comfortable transportation for passengers with mobility needs.
          </>
        ),
      },
      {
        question: "Are your drivers experienced with the local Bowral area?",
        answer: (
          <>
            Our drivers are local experts who know every street and landmark
            well. They use this knowledge to avoid traffic and get you there
            faster.
          </>
        ),
      },
    ],
  },
  "airds-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13217.43702992732!2d150.83296045!3d-34.085936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ef9a6edcde1b%3A0x5017d681632ab20!2sAirds%20NSW%202560%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769805743852!5m2!1sen!2sbd",
    pageTitle: "Airds Taxi & Maxi Cabs | 24/7 Reliable Local Taxi Service",
    metaDescription:
      "Airds Taxi & Maxi Cabs provides 24/7 reliable transport. We offer airport transfers, baby seats, and group maxi cabs. Book your safe Airds ride now. Call 1300 450 428!",
    heroTitle: "Airds Taxi & Maxi Cabs | 24/7 Reliable Local Taxi Service",
    heroDescription: (
      <>
        You can rely on our professional transport team anytime. We offer
        premium rides throughout the Airds area daily. Our drivers ensure you
        arrive at your destination safely. You will enjoy modern vehicles and
        very punctual pickups. We cater to families, corporate groups, and solo
        travellers. Experience the best
        <strong>
          {" "}
          Airds{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>
        </strong>{" "}
        service today.
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi in Airds",
    locationSectionTitle:
      "Trusted Taxi and Maxi Cab Services in Airds, 1 Hurley St, Campbelltown",
    locationSectionDescription: (
      <>
        Finding a dependable{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          local taxi service near me
        </Link>{" "}
        often feels difficult. You might face long wait times or sudden
        cancellations elsewhere. Our<strong>Airds taxi service</strong> solves
        these common travel frustrations immediately. We operate right near{" "}
        <strong>1 Hurley St, Campbelltown,</strong> for fast responses. You will
        never worry about missing an important flight again. Our team
        understands that reliability is your top priority. We use advanced
        dispatch technology to track every single ride. This ensures your Airds
        taxi cab service arrives exactly on time. You can book a ride for work
        or medical trips. We offer transparent pricing to keep your travel costs
        low. Our drivers maintain clean, comfortable cars for your total
        enjoyment. You get a stress-free journey across the entire Macarthur
        region. We prioritize your safety during late-night social outings or
        events. Trust our expertise for every local trip you need to take.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle:
      "Our Taxi and Maxi Services in Airds, 1 Hurley St, Campbelltown",
    serviceSubtitle: (
      <>
        Experience the most versatile transport options for your daily needs. We
        provide specialized vehicles for every occasion near 1 Hurley St. You
        can{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold  px-1">
          book a taxi
        </Link>
        easily through our website or phone. Our professional team handles group
        bookings and individual transfers with precision.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Your special day deserves the finest{" "}
            <strong> local taxi service Airds</strong>offers. We coordinate
            multiple vehicles to transport your guests between local venues. You
            can relax while our professional drivers handle the heavy traffic.
            We ensure every guest arrives on time for the ceremony. Our premium
            fleet adds a touch of class to your event.Here at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            You can enjoy a high-end experience with our premium sedan fleet.
            This service is perfect for those seeking extra comfort and style.
            Our drivers provide a discreet and professional atmosphere for your
            quiet journey. You will love the plush interiors of our premium
            fleet vehicles. We make every trip feel like a first-class
            experience for you.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety for your children is our absolute number one priority. We
            provide clean, compliant baby seats for all your family trips. You
            don't have to carry your own heavy child restraints anymore. Our
            drivers install the seats correctly before they reach your front
            door. We make family travel to the shops or doctors very simple.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Business professionals trust our Airds taxi and cab services for
            vital meetings. You can work comfortably in the back seat during
            your commute. We provide detailed receipts for all your company
            expense claims easily. Our punctuality ensures you never walk late
            into a boardroom session. We represent your business values through
            our high-quality, professional driving standards.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday stress-free with our reliable cruise terminal
            transport. We have plenty of room for all your heavy suitcases. Our
            drivers know the quickest routes to the Sydney ports from Airds. You
            won't have to navigate busy city traffic or expensive parking. We
            drop you right at the terminal doors for maximum convenience.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Getting to concerts or sports games is easy with our help. You can
            avoid the hassle of finding a park in crowds. We pick you up from
            your door and drop you close. Our Maxi cabs near me in Airds are
            perfect for your group. Enjoy the festivities while we take care of
            the driving for you.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Our maxi cab services Airds accommodate up to eleven passengers at
            once. This is the ultimate solution for large families or social
            groups. You can share the cost with friends to save significant
            money. We offer{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
            >
              CabCharge
            </Link>{" "}
            options for easy payment during your group trip. Your entire party
            travels together in one spacious, air-conditioned vehicle.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage large-scale transport for your staff and visiting clients.
            You can set up a corporate account for regular weekly bookings. Our
            fleet handles airport runs and inter-office transfers with great
            efficiency. We offer a dedicated service that aligns with your busy
            schedule. Your clients will appreciate the professional greeting and
            smooth ride we provide.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Airds, 1 Hurley St, Campbelltown Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Choosing the right vehicle makes your journey much more pleasant. We offer a diverse range of cars near 1 Hurley St to suit you. Our area covered includes all suburbs with various fleet choices. You can select a car based on your passenger count and luggage. We maintain our vehicles to the highest Australian safety standards daily. Our drivers take pride in keeping every car spotless for your use. Whether you need a quick sedan or a large maxi cab, we help. You will find the perfect ride for any local or long-distance trip.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo riders or couples. You get a
            compact car that navigates narrow Airds streets quickly. It is our
            most affordable option for your daily local commutes.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Treat yourself to an executive car for your next big event. You will
            enjoy extra legroom and a very quiet cabin environment. It is ideal
            for impressing clients or celebrating a special anniversary.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Choose this option if you have extra bags or groceries. You get more
            space than a sedan without needing a full van. It provides a smooth
            ride for small families heading out for the day.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This popular vehicle bridges the gap between a car and a van. You
            can seat up to seven passengers in total comfort. It is the favorite
            choice for school runs and small group outings.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest vehicle handles your big groups and bulky items easily.
            You can fit surfboards, bikes, or several large suitcases in the
            back. It is the best maxi cab near me for airport runs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide accessible vehicles with hydraulic hoists for your
            mobility needs. Our drivers are trained to assist passengers with
            disabilities with total care. You can travel with dignity and safety
            to any local destination.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Airds Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Airds taxi cab close to me?",
        answer: (
          <>
            You can call our 24/7 hotline at 1300 450 428 for immediate
            dispatch. We have drivers stationed near 1 Hurley St to reach you
            fast.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Airds available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question: "Can I pay with a credit card in your Airds taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link
              target="_blank"
              to="https://en.wikipedia.org/wiki/Cabcharge"
              className="underline px-1 font-bold"
            >
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Airds taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Airds vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question: "Can I book an Airds taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Airds{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>{" "}
            service operates 24 hours a day, 365 days a year. We never close,
            even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Airds taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
    ],
  },
  "ingleburn-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26460.13834357409!2d150.85813989999994!3d-34.00493044999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12eb6398af0615%3A0x5017d681632bb90!2sIngleburn%20NSW%202565%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769805961761!5m2!1sen!2sbd",
    pageTitle:
      "Ingleburn Taxi & Maxi Cabs – Affordable & Professional Cab Service",
    metaDescription:
      "Reliable Ingleburn Taxi & Maxi Cabs Professional airport transfers and group travel with baby seats Book your safe ride now Call 1300 450 428",
    heroTitle:
      "Ingleburn Taxi & Maxi Cabs – Affordable & Professional Cab Service",
    heroDescription: (
      <>
        Experience the best transport in <strong> Ingleburn </strong> with our
        reliable drivers. We offer Ingleburn{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        services for every travel need. You can book an Ingleburn taxi service
        for local or long trips. Our fleet includes spacious{" "}
        <strong>maxi cabs near me in Ingleburn</strong> for groups. We guarantee
        punctual arrivals and clean vehicles for your total comfort. Enjoy a
        stress-free journey with the top{" "}
        <strong>local taxi service Ingleburn</strong> offers.
      </>
    ),
    bookingFormTitle: "Book for Corporate Transport Service in Ingleburn",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services in Ingleburn",
    locationSectionDescription: (
      <>
        Finding a
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          local taxi service near me
        </Link>{" "}
        often feels quite stressful. Many passengers worry about late drivers or
        high surge pricing fees. You deserve a reliable
        <strong> Ingleburn taxi cab service</strong> that values your time. We
        provide professional transport solutions directly from our base in
        Ingleburn. Our team understands the local roads around 1 Hurley St very
        well. We eliminate the frustration of last-minute cancellations from
        ride-sharing apps. You get a guaranteed booking when you choose our
        Ingleburn taxi service. Our drivers maintain high standards of
        cleanliness for every single passenger. We offer fixed rates to ensure
        you never face hidden costs. Your safety remains our highest priority
        during late-night or early-morning trips. We support the multicultural
        community with friendly and respectful local drivers. You can trust us
        for daily commutes or special medical visits. We make booking a taxi
        service close to me fast and simple. Experience the difference with a
        team that truly cares about your ride.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Ingleburn",
    serviceSubtitle: (
      <>
        You can access a wide range of premium transport options today. We
        tailor our Ingleburn taxi and cab services to fit your schedule. Our
        team handles everything from quick local hops to long journeys. Enjoy
        the convenience of professional drivers who know the fastest local
        routes.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Your special day deserves the finest{" "}
            <strong> local taxi service Ingleburn </strong>offers. We coordinate
            multiple vehicles to transport your guests between local venues. You
            can relax while our professional drivers handle the heavy traffic.
            We ensure every guest arrives on time for the ceremony. Our premium
            fleet adds a touch of class to your event.Here at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            You can enjoy a high-end experience with our premium sedan fleet.
            This service is perfect for those seeking extra comfort and style.
            Our drivers provide a discreet and professional atmosphere for your
            quiet journey. You will love the plush interiors of our premium
            fleet vehicles. We make every trip feel like a first-class
            experience for you.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety for your children is our absolute number one priority. We
            provide clean, compliant baby seats for all your family trips. You
            don't have to carry your own heavy child restraints anymore. Our
            drivers install the seats correctly before they reach your front
            door. We make family travel to the shops or doctors very simple.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Business professionals trust our Ingleburn taxi and cab services for
            vital meetings. You can work comfortably in the back seat during
            your commute. We provide detailed receipts for all your company
            expense claims easily. Our punctuality ensures you never walk late
            into a boardroom session. We represent your business values through
            our high-quality, professional driving standards.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday stress-free with our reliable cruise terminal
            transport. We have plenty of room for all your heavy suitcases. Our
            drivers know the quickest routes to the Sydney ports from Ingleburn.
            You won't have to navigate busy city traffic or expensive parking.
            We drop you right at the terminal doors for maximum convenience.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Getting to concerts or sports games is easy with our help. You can
            avoid the hassle of finding a park in crowds. We pick you up from
            your door and drop you close. Our Maxi cabs near me in Ingleburn are
            perfect for your group. Enjoy the festivities while we take care of
            the driving for you.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Our maxi cab services Ingleburn accommodate up to eleven passengers
            at once. This is the ultimate solution for large families or social
            groups. You can share the cost with friends to save significant
            money. We offer CabCharge options for easy payment during your group
            trip. Your entire party travels together in one spacious,
            air-conditioned vehicle.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage large-scale transport for your staff and visiting clients.
            You can set up a corporate account for regular weekly bookings. Our
            fleet handles airport runs and inter-office transfers with great
            efficiency. We offer a dedicated service that aligns with your busy
            schedule. Your clients will appreciate the professional greeting and
            smooth ride we provide.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Ingleburn Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Choosing the right vehicle makes your journey much more enjoyable and relaxing. We offer a diverse fleet to meet every specific passenger requirement. You can select a car based on your group size or luggage. Our local taxi cab service near me features modern and well-maintained models. We invest in the latest technology to ensure your ride is safe. Every vehicle undergoes regular mechanical checks to prevent any unexpected road delays. You will find our cars clean, fresh, and ready for your trip. We take pride in offering the best fleet in the Ingleburn area.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo riders or couples. You get a
            compact car that navigates narrow Airds streets quickly. It is our
            most affordable option for your daily local commutes.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Treat yourself to an executive car for your next big event. You will
            enjoy extra legroom and a very quiet cabin environment. It is ideal
            for impressing clients or celebrating a special anniversary.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Choose this option if you have extra bags or groceries. You get more
            space than a sedan without needing a full van. It provides a smooth
            ride for small families heading out for the day.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This popular vehicle bridges the gap between a car and a van. You
            can seat up to seven passengers in total comfort. It is the favorite
            choice for school runs and small group outings.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest vehicle handles your big groups and bulky items easily.
            You can fit surfboards, bikes, or several large suitcases in the
            back. It is the best maxi cab near me for airport runs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide accessible vehicles with hydraulic hoists for your
            mobility needs. Our drivers are trained to assist passengers with
            disabilities with total care. You can travel with dignity and safety
            to any local destination.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Ingleburn Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Ingleburn taxi cab close to me?",
        answer: (
          <>
            You can call our 24/7 hotline at 1300 450 428 for immediate
            dispatch. We have drivers stationed near 1 Hurley St to reach you
            fast.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Ingleburn available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question:
          "Can I pay with a credit card in your Ingleburn taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link to="/cabcharge-taxi" className="underline px-1 font-bold">
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question: "Do your Ingleburn taxi and cab services accept CabCharge? ",
        answer: (
          <>
            OYes, we fully support CabCharge for all our corporate and
            government travel clients. It makes your
            <Link
              target="_blank"
              to="https://en.wikipedia.org/wiki/Business_travel"
              className="underline px-1 font-bold"
            >
              business trip
            </Link>{" "}
            payments very simple and completely cashless.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Ingleburn vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question:
          "Can I book an Ingleburn taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Ingleburn taxi service operates 24 hours a day, 365 days a year.
            We never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              vehicle
            </Link>{" "}
            safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Ingleburn taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
    ],
  },
  "oran-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52929.12490038304!2d150.74249319999998!3d-33.99072785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f17c6db613d5%3A0x5017d681632c510!2sOran%20Park%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769806220226!5m2!1sen!2sbd",
    pageTitle: "Oran Park Taxi & Maxi Cabs – 24/7 Reliable Local Taxi Service",
    metaDescription:
      "Reliable Oran Park Taxi & Maxi Cabs! Get 24/7 airport transfers and group rides with baby seats. Book your safe local ride now. Trusted professional drivers!",
    heroTitle: "Oran Park Taxi & Maxi Cabs – 24/7 Reliable Local Taxi Service",
    heroDescription: (
      <>
        Experience the best{" "}
        <strong>
          {" "}
          Oran Park{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>{" "}
        </strong>{" "}
        for every journey. You get professional drivers who know the local area
        perfectly. We provide clean, modern vehicles for your total comfort. Our
        team offers 24/7 support for all your travel needs. You can enjoy
        stress-free <strong>airport transfers </strong> and group trips. Trust
        the most reliable<strong> local taxi service Oran park</strong> today.
      </>
    ),
    bookingFormTitle: "Book for Corporate Transport Service in Oran Park",
    locationSectionTitle:
      "Trusted Taxi and Maxi Cab Services 1 Hurley St, Campbelltown, Australia",
    locationSectionDescription: (
      <>
        Finding a{" "}
        <strong>
          <Link
            to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
            className="underline font-semibold px-1"
          >
            taxi service near me
          </Link>{" "}
        </strong>{" "}
        often feels quite stressful. You might worry about late drivers or dirty
        car interiors. Our <strong> Oran Park Taxi & Maxi Cabs</strong>team
        solves these issues. We maintain a fleet of high-quality vehicles for
        your safety. You will receive a prompt pickup at 1 Hurley St,
        Campbelltown, Australia. Our drivers understand the importance of your
        daily schedule. We provide a local taxi service near me that you can
        trust. You can avoid the surge pricing of common ride-share apps. We
        offer transparent rates for every single passenger we serve. Our staff
        treats you with the highest level of respect. You will love our
        air-conditioned cars during the hot summer. We focus on being the top
        taxi cab service near me. You deserve a smooth ride to work or social
        events. Let us handle the traffic while you relax in back. Your
        satisfaction remains our biggest priority every single day of the year.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle:
      "Our Taxi and Maxi Services in 1 Hurley St, Campbelltown, Australia",
    serviceSubtitle: (
      <>
        You need a versatile taxi service close to me for different needs. We
        offer specialised transport solutions for every unique occasion you
        plan. Our Oran Park taxi and cab services cover everything from luxury
        to groups. You will enjoy a seamless experience with our professional
        local team.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Your special day deserves the finest{" "}
            <strong> local taxi service Oran Park </strong>offers. We coordinate
            multiple vehicles to transport your guests between local venues. You
            can relax while our professional drivers handle the heavy traffic.
            We ensure every guest arrives on time for the ceremony. Our premium
            fleet adds a touch of class to your event.Here at
            <Link
              to={`/services/wedding-transfer`}
              className="underline font-semibold  px-1"
            >
              wedding transfer page.
            </Link>{" "}
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            You can enjoy a high-end experience with our premium sedan fleet.
            This service is perfect for those seeking extra comfort and style.
            Our drivers provide a discreet and professional atmosphere for your
            quiet journey. You will love the plush interiors of our premium
            fleet vehicles. We make every trip feel like a first-class
            experience for you.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety for your children is our absolute number one priority. We
            provide clean, compliant baby seats for all your family trips. You
            don't have to carry your own heavy child restraints anymore. Our
            drivers install the seats correctly before they reach your front
            door. We make family travel to the shops or doctors very simple.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Business professionals trust our Oran Park taxi and cab services for
            vital meetings. You can work comfortably in the back seat during
            your commute. We provide detailed receipts for all your company
            expense claims easily. Our punctuality ensures you never walk late
            into a boardroom session. We represent your business values through
            our high-quality, professional driving standards.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday stress-free with our reliable cruise terminal
            transport. We have plenty of room for all your heavy suitcases. Our
            drivers know the quickest routes to the Sydney ports from Oran Park.
            You won't have to navigate busy city traffic or expensive parking.
            We drop you right at the terminal doors for maximum convenience.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Getting to concerts or sports games is easy with our help. You can
            avoid the hassle of finding a park in crowds. We pick you up from
            your door and drop you close. Our Maxi cabs near me in Oran Park are
            perfect for your group. Enjoy the festivities while we take care of
            the driving for you.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Our{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/?title=Maxicab&redirect=no`}
              className="underline font-semibold px-1"
            >
              Maxi Cabs
            </Link>{" "}
            services Oran Park accommodate up to eleven passengers at once. This
            is the ultimate solution for large families or social groups. You
            can share the cost with friends to save significant money. We offer
            CabCharge options for easy payment during your group trip. Your
            entire party travels together in one spacious, air-conditioned
            vehicle.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Coordinate your team building or off-site meetings with our
            professional fleet. We provide reliable transport for multiple
            employees simultaneously. Our Oran Park
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              Taxi
            </Link>
            cab is close to me, ensuring nobody is late. You can book in advance
            to secure your preferred travel times. We provide tax invoices for
            easy company expense reporting and tracking. Trust our expertise to
            handle your corporate logistics with total care.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Oran Park Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "Choosing the right vehicle makes your journey much more enjoyable and relaxing. We offer a diverse fleet to meet every specific passenger requirement. You can select a car based on your group size or luggage. Our local taxi cab service near me features modern and well-maintained models. We invest in the latest technology to ensure your ride is safe. Every vehicle undergoes regular mechanical checks to prevent any unexpected road delays. You will find our cars clean, fresh, and ready for your trip. We take pride in offering the best fleet in the Oran Park area.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo riders or couples. You get a
            compact car that navigates narrow Airds streets quickly. It is our
            most affordable option for your daily local commutes.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Treat yourself to an executive car for your next big event. You will
            enjoy extra legroom and a very quiet cabin environment. It is ideal
            for impressing clients or celebrating a special anniversary.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Choose this option if you have extra bags or groceries. You get more
            space than a sedan without needing a full van. It provides a smooth
            ride for small families heading out for the day.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This popular vehicle bridges the gap between a car and a van. You
            can seat up to seven passengers in total comfort. It is the favorite
            choice for school runs and small group outings.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest vehicle handles your big groups and bulky items easily.
            You can fit surfboards, bikes, or several large suitcases in the
            back. It is the best maxi cab near me for airport runs.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide accessible vehicles with hydraulic hoists for your
            mobility needs. Our drivers are trained to assist passengers with
            disabilities with total care. You can travel with dignity and safety
            to any local destination.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Oran Park Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Oran Park taxi cab close to me?",
        answer: (
          <>
            You can call our 24/7 hotline at 1300 450 428 for immediate
            dispatch. We have drivers stationed near 1 Hurley St to reach you
            fast.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Oran Park available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question:
          "Can I pay with a credit card in your Oran Park taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link to="/cabcharge-taxi" className="underline px-1 font-bold">
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Oran Park taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Oran Park vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question:
          "Can I book an Oran Park taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Oran Park taxi service operates 24 hours a day, 365 days a year.
            We never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Oran Park taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
    ],
  },
  "elderslie-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26443.73229282772!2d150.7160768999999!3d-34.05755289999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f0d49999b5c7%3A0x5017d681632b620!2sElderslie%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769806487887!5m2!1sen!2sbd",
    pageTitle: "Elderslie Taxi & Maxi Cabs – Reliable 24/7 Local Service",
    metaDescription:
      "Get 24/7 reliable rides with Elderslie Taxi & Maxi Cabs. We offer clean vehicles and expert local drivers. Call 1300 450 428 to book your premium ride now!",
    heroTitle: "Elderslie Taxi & Maxi Cabs – Reliable 24/7 Local Service",
    heroDescription: (
      <>
        <strong>
          Elderslie{" "}
          <Link
            to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
            className="underline font-semibold px-1"
          >
            Taxi & Maxi Cabs
          </Link>{" "}
        </strong>{" "}
        provides fast and dependable local transport for you. Our professional
        drivers ensure you reach your destination safely and on time. We offer a
        modern fleet ranging from sleek sedans to large vans. You can
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          book our
        </Link>{" "}
        services for airport runs or quick local trips. Experience premium
        comfort with our 24/7 availability across the entire Macarthur region.
        Your satisfaction remains our top priority for every single journey you
        take.
      </>
    ),
    bookingFormTitle: "Book for Corporate Transport Service in Elderslie",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services Elderslie",
    locationSectionDescription: (
      <>
        You deserve a transport partner that values your time and safety.
        Finding a reliable<strong> local taxi service Elderslie </strong> can
        often feel quite stressful. Many passengers worry about late arrivals or
        cars that never show up. I have seen many commuters stranded at stations
        due to unreliable apps. We solve these problems by providing a
        guaranteed <strong>Elderslie taxi service</strong>you can trust. Our
        drivers know the best routes around{" "}
        <strong>1 Hurley St, Campbelltown</strong>and beyond. We maintain our
        Taxi Cabs{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/fleet`}
          className="underline font-semibold px-1"
        >
          Premium Fleet
        </Link>{" "}
        to the highest mechanical standards. You will enjoy a clean,
        climate-controlled environment on every single trip. We focus on being
        the most dependable Elderslie taxi cab service for you. Our team treats
        every passenger with professional care and local expertise. You can
        relax knowing your driver is a fully licensed professional. We provide
        transparent pricing without any hidden surge fees or costs.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Elderslie",
    serviceSubtitle: (
      <>
        We provide a comprehensive range of transport solutions for your daily
        needs. Our team handles everything from quick errands to major corporate
        events. You get a personalized experience with our{" "}
        <strong>local taxi service near me.</strong>Explore our specialized
        services designed to make your travel much easier.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You will arrive at your venue in total style and comfort. We
            coordinate multiple vehicles to move your entire guest list safely.
            Our drivers ensure punctuality so your special day runs without any
            delays. You can trust our{" "}
            <strong>Elderslie taxi and cab services </strong>for your big event.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Treat yourself to a premium ride in our high-end corporate sedans.
            These vehicles offer extra legroom and a quiet space for your work.
            I recommend this service for VIP guests or special dinner dates. You
            will enjoy the smoothest ride available in the local Elderslie area.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Your child’s safety is our most important concern during any trip.
            We provide professionally installed child restraints for all ages
            upon your request. Just mention your needs during your Taxi Booking
            to ensure a safe ride. Parents love this convenience when traveling
            to medical appointments or family visits.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            We help you maintain a professional image with our reliable
            executive cars. Use our CabCharge Taxi Campbelltown options for easy
            and fast digital billing. We ensure you never miss an important
            board meeting or a flight. Our drivers provide a discreet and
            punctual service for all business professionals.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday early with a stress-free trip to the ship. We
            have plenty of room for all your heavy suitcases and bags. Our Maxi
            Cabs near me in Elderslie provide the perfect space for groups. We
            drop you right at the terminal door for ultimate convenience.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            {" "}
            Heading to a concert or a big game at the stadium? Avoid the massive
            parking crowds by choosing our professional Elderslie taxi cab
            service. We pick you up right after the event ends without any fuss.
            You and your friends can enjoy the night while we drive.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            You can move up to eleven people in one single vehicle. Our maxi cab
            services Elderslie are ideal for large family outings or parties.
            You save money by booking one large van instead of two small cars.
            We handle all your bulky gear and extra luggage with ease.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage your staff transport needs with total efficiency and care.
            Our team provides detailed invoices to help you track your travel
            spending. You can rely on us for consistent service across all your
            office locations. We prioritize your business schedule to keep your
            operations running smoothly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Elderslie Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        You want a vehicle that perfectly matches your specific travel
        requirements. Our diverse fleet ensures we have the right car for every
        passenger. I personally ensure each vehicle stays in pristine condition
        for your ride. We use the latest technology to track our fleet for your
        safety. You can choose from compact cars or very large multi-seater
        vans. We provide the most versatile{" "}
        <Link
          target="_blank"
          to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
          className="underline font-semibold px-1"
        >
          Taxi
        </Link>{" "}
        services near me for the community. Our drivers take great pride in
        keeping their cars clean. You will always feel comfortable and respected
        when you choose our service. We bridge the gap where public transport
        often fails you.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo travelers or small groups. You
            get a quick and efficient taxi service close to me anytime. These
            cars offer great fuel efficiency and a very smooth ride.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Step up to a higher standard of travel for your next trip. These
            cars feature leather interiors and extra premium features for your
            comfort. It is the ultimate way to travel through the Elderslie
            region.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            You get extra boot space for your groceries or sports gear. This
            option suits small families who have a few extra bags. It provides a
            more elevated seating position for a better view.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This modern people mover is a favorite for local family trips. It
            offers a very spacious interior with plenty of room for everyone.
            You will enjoy the modern safety features and smooth handling.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our maxi cab is the workhorse of our fleet for groups. It handles
            large crowds and heavy items without any struggle at all. You can
            book this for any group social outing or transfer.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We offer fully accessible vehicles for passengers with limited
            mobility. Our drivers are trained to assist you with total patience
            and care. You get a safe and reliable taxi service near me.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Elderslie Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Elderslie taxi cab close to me?",
        answer: (
          <>
            You can call us on 1300 450 428 for immediate service. We use GPS to
            send the nearest driver to your exact location.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Elderslie available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question:
          "Can I pay with a credit card in your Elderslie taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link to="/cabcharge-taxi" className="underline px-1 font-bold">
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Elderslie taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Elderslie vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question:
          "Can I book an Elderslie taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Elderslie taxi service operates 24 hours a day, 365 days a year.
            We never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question: "How much does a taxi cab service near me cost?  ",
        answer: (
          <>
            We offer fair and regulated pricing for all our local{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
            >
              trips.
            </Link>{" "}
            You will not encounter surge pricing, as is common on other apps.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question: "What areas do you cover besides Elderslie? ",
        answer: (
          <>
            We serve Campbelltown CBD, Macarthur, Leumeah, Minto, Ingleburn, and
            Ambarvale. Our fleet covers the entire region to help you travel.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Elderslie taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
    ],
  },
  "mount-annan-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26441.69032929234!2d150.7631658!3d-34.0640975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12e55889346653%3A0x5017d681632c220!2sMount%20Annan%20NSW%202567%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769806817654!5m2!1sen!2sbd",
    pageTitle: "Mount Annan Taxi & Maxi Cabs | Affordable Airport Transfers",
    metaDescription:
      "Get 24/7 reliability with Mount Annan Taxi & Maxi Cabs. We offer luxury sedans and large vans for any trip. Call 1300 450 428 to book your premium ride today!",
    heroTitle: "Mount Annan Taxi & Maxi Cabs | Affordable Airport Transfers",
    heroDescription: (
      <>
        Find your reliable ride with our professional local drivers today. We
        offer prompt pickups for all airport and local trips. Our fleet includes
        clean sedans and spacious vans for families. You can{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          book a ride easily
        </Link>
        through our simple online system. We serve the Mount Annan community
        with safe and affordable transport. Experience the best local travel
        service with our{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/fleet`}
          className="underline font-semibold px-1"
        >
          premium fleet of taxis and maxi cabs
        </Link>{" "}
        and a dedicated transport team.
      </>
    ),
    bookingFormTitle: "Book for Corporate Transport Service in Mount Annan NSW",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services Mount Annan NSW",
    locationSectionDescription: (
      <>
        You deserve a transport partner that values your time and safety.
        Finding a reliable<strong> local taxi service Mount Annan </strong> can
        often feel quite stressful. Many passengers worry about late arrivals or
        cars that never show up. I have seen many commuters stranded at stations
        due to unreliable apps. We solve these problems by providing a
        guaranteed <strong>Mount Annan taxi service</strong>you can trust. Our
        drivers know the best routes around{" "}
        <strong>1 Hurley St, Campbelltown</strong>and beyond. We maintain our
        Taxi Cabs Premium Fleet to the highest mechanical standards. You will
        enjoy a clean, climate-controlled environment on every single trip. We
        focus on being the most dependable Mount Annan taxi cab service for you.
        Our team treats every passenger with professional care and local
        expertise. You can relax knowing your driver is a fully licensed
        professional. We provide transparent pricing without any hidden surge
        fees or costs.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Mount Annan",
    serviceSubtitle: (
      <>
        We provide a comprehensive range of transport solutions for your daily
        needs. Our team handles everything from quick errands to major corporate
        events. You get a personalized experience with our{" "}
        <strong>local taxi service near me.</strong>Explore our specialized
        services designed to make your travel much easier.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You will arrive at your venue in total style and comfort. We
            coordinate multiple vehicles to move your entire guest list safely.
            Our drivers ensure punctuality so your special day runs without any
            delays. You can trust our{" "}
            <strong>Mount Annan taxi and cab services </strong>for your big
            event.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Treat yourself to a premium ride in our high-end corporate sedans.
            These vehicles offer extra legroom and a quiet space for your work.
            I recommend this service for VIP guests or special dinner dates. You
            will enjoy the smoothest ride available in the local Mount Annan
            area.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Your child’s safety is our most important concern during any trip.
            We provide professionally installed child restraints for all ages
            upon your request. Just mention your needs during your Taxi Booking
            to ensure a safe ride. Parents love this convenience when traveling
            to medical appointments or family visits.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            We help you maintain a professional image with our reliable
            executive cars. Use our CabCharge Taxi Campbelltown options for easy
            and fast digital billing. We ensure you never miss an important
            board meeting or a flight. Our drivers provide a discreet and
            punctual service for all business professionals.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday early with a stress-free trip to the ship. We
            have plenty of room for all your heavy suitcases and bags. Our Maxi
            Cabs near me in Mount Annan provide the perfect space for groups. We
            drop you right at the terminal door for ultimate convenience.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            {" "}
            Heading to a concert or a big game at the stadium? Avoid the massive
            parking crowds by choosing our professional Mount Annan taxi cab
            service. We pick you up right after the event ends without any fuss.
            You and your friends can enjoy the night while we drive.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            You can move up to eleven people in one single vehicle. Our maxi cab
            services Mount Annan are ideal for large family outings or parties.
            You save money by booking one large van instead of two small cars.
            We handle all your bulky gear and extra luggage with ease.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage your staff transport needs with total efficiency and care.
            Our team provides detailed invoices to help you track your travel
            spending. You can rely on us for consistent service across all your
            office locations. We prioritize your business schedule to keep your
            operations running smoothly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Mount Annan Taxi & Maxi Cabs",
    fleetSectionSubTitle: (
      <>
        You can choose the perfect vehicle from our diverse and modern fleet. I
        take great pride in maintaining our cars to the highest standards.
        Whether you need a{" "}
        <Link
          target="_blank"
          to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
          className="underline font-semibold px-1"
        >
          taxi cab
        </Link>{" "}
        service near me or a large van, we have it. Our Mount Annan taxi cab
        options near me include vehicles for every possible scenario. We ensure
        every ride is smooth, safe, and tailored to your personal requirements.
      </>
    ),
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is the perfect choice for solo travelers or small groups. You
            get a quick and efficient taxi service close to me anytime. These
            cars offer great fuel efficiency and a very smooth ride.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Step up to a higher standard of travel for your next trip. These
            cars feature leather interiors and extra premium features for your
            comfort. It is the ultimate way to travel through the Mount Annan
            region.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            You get extra boot space for your groceries or sports gear. This
            option suits small families who have a few extra bags. It provides a
            more elevated seating position for a better view.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This modern people mover is a favorite for local family trips. It
            offers a very spacious interior with plenty of room for everyone.
            You will enjoy the modern safety features and smooth handling.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our maxi cab is the workhorse of our fleet for groups. It handles
            large crowds and heavy items without any struggle at all. You can
            book this for any group social outing or transfer.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We offer fully accessible vehicles for passengers with limited
            mobility. Our drivers are trained to assist you with total patience
            and care. You get a safe and reliable taxi service near me.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Mount Annan Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Mount Annan taxi cab close to me?",
        answer: (
          <>
            You can call us on 1300 450 428 for immediate service. We use GPS to
            send the nearest driver to your exact location.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Mount Annan available for airport runs?",
        answer: (
          <>
            Yes, we provide spacious Maxi{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxi`}
              className="underline font-semibold px-1"
            >
              cabs
            </Link>{" "}
            near me in Mount Annan for all airports. We have enough room for
            your entire family and all your luggage.
          </>
        ),
      },
      {
        question:
          "Can I pay with a credit card in your Mount Annan taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link to="/cabcharge-taxi" className="underline px-1 font-bold">
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Mount Annan taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Mount Annan vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question:
          "Can I book an Mount Annan taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Mount Annan taxi service operates 24 hours a day, 365 days a
            year. We never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "What are the payment options for your Mount Annan taxi service? ",
        answer: (
          <>
            We accept cash, all major credit cards, and{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Cabcharge`}
              className="underline font-semibold px-1"
            >
              CabCharge
            </Link>{" "}
            Taxi Campbelltown. You will receive a digital or paper receipt for
            every single trip.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Mount Annan taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
    ],
  },
  "edmondson-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26472.864478934767!2d150.85649420000001!3d-33.964061949999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12eca9a09ef223%3A0x5017d681632b600!2sEdmondson%20Park%20NSW%202174%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769807112931!5m2!1sen!2sbd",
    pageTitle: "Best Edmondson Park Taxi & Maxi Cabs | Fast, Safe & Affordable",
    metaDescription:
      "Enjoy fast and safe rides with our local fleet. We offer 24/7 reliability and spacious maxi cabs for groups. Call 1300 450 428 to book your ride now!",
    heroTitle: "Best Edmondson Park Taxi & Maxi Cabs | Fast, Safe & Affordable",
    heroDescription: (
      <>
        You deserve a ride that arrives on time every single day. Our team
        provides reliable transport for residents throughout the growing
        Macarthur region. We offer clean sedans and spacious vans for all your
        travel needs. Experience professional service from drivers who truly
        know the local area. Whether you head to work or the airport, we ensure
        comfort. Book your next trip with the most trusted local fleet today via
        our
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Booking
        </Link>{" "}
        page.
      </>
    ),
    bookingFormTitle: "Book for Luxury Transfer in Edmondson Park",
    locationSectionTitle:
      "Trusted Taxi and Maxi Cab Services in Edmondson Park",
    locationSectionDescription: (
      <>
        You often face long wait times when booking a local taxi service near
        me. I see many passengers frustrated by unreliable apps that cancel last
        minute. Our Edmondson Park Taxi & Maxi Cabs service solves this problem
        with guaranteed punctuality. We focus on your safety and comfort during
        every single journey. You can rely on our taxi cab{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/area-covered`}
          className="underline font-semibold px-1"
        >
          service near me
        </Link>{" "}
        for any trip. My drivers understand the stress of catching a flight or
        meeting. We provide a transparent pricing model without any hidden surge
        fees today. You will appreciate our clean vehicles and polite,
        professional local drivers. We use the latest navigation to find the
        quickest possible routes. Your time is valuable, so we never make you
        wait long. Our team maintains the highest standards for Edmondson park
        taxi and cab services. We treat every passenger like a VIP from start to
        finish.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Edmondson Park",
    serviceSubtitle: (
      <>
        You can access a wide range of{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/corporate-transport-services`}
          className="underline font-semibold px-1"
        >
          professional transport solutions
        </Link>{" "}
        right now. We cater to every specific travel need with our modern local
        fleet. Our drivers ensure you reach your destination safely and very
        quickly. Choose from our specialized services listed below for your next
        trip.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Your special day requires perfectly timed and elegant transport for
            guests. I coordinate these trips to ensure everyone arrives at the
            venue together. You can relax knowing our{" "}
            <strong>Edmondson Park taxi service </strong>handles the logistics.
            We offer stylish vehicles that look great in your professional
            wedding photos.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Choose our Taxi Cabs Premium Fleet for a high-end travel experience
            today. You will enjoy leather seats and a quiet cabin for your
            journey. I recommend this service for romantic dinners or very
            important private events. Our drivers provide a discreet and
            professional service for every luxury client.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Safety remains our top priority when you travel with your little
            ones. We provide clean and secure child seats upon your request
            during booking. You won't have to carry your own heavy seat through
            the busy airport. I ensure every seat meets the strict Australian
            safety standards for your peace.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Impress your business clients with our reliable and professional
            Edmondson Park taxi cab service. We offer CabCharge Taxi
            Campbelltown options for easy and fast company billing. You can
            focus on your work while we handle the heavy morning traffic. Our
            drivers understand the importance of discretion and punctuality for
            all corporate trips.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday early with our seamless transfers to the Sydney
            ports. We have plenty of room for all your heavy suitcases and gear.
            I track the ship schedules to ensure we pick you up promptly. You
            will avoid the high costs of long-term parking at the busy terminal.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Heading to a concert or a big game at the local stadium? Our maxi
            cab services Edmondson Park are perfect for your entire group. You
            can all travel together and enjoy the pre-event excitement in one
            car. I ensure your driver finds the best drop-off spot near the main
            entrance.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Our Maxi Cabs are the ultimate solution for large families and
            groups. You will find plenty of legroom and space for your bulky
            items. I often suggest these for airport runs with more than four
            passengers. It is much cheaper than booking two separate small taxi
            services near me.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage your staff transport needs with total efficiency and clear
            reporting. You can set up a regular schedule for your team's daily
            commute. I provide detailed invoices to help you track your business
            travel expenses. Our Edmondson Park taxi and cab services keep your
            business moving every single day.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Edmondson Park Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "You can choose the perfect vehicle from our diverse and modern fleet. I take great pride in maintaining our cars to the highest standards. Whether you need a taxi cab service near me or a large van, we have it. Our Edmondson Park taxi cab close to me options include vehicles for every possible scenario. We ensure every ride is smooth, safe, and tailored to your personal requirements.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is our most popular choice for quick solo trips. It is a
            fuel-efficient and comfortable way to reach your local destination.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Elevate your travel experience with our premium executive sedan
            options. These cars offer extra comfort and style for your most
            important journeys.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Perfect for small families with a bit of extra luggage. You get more
            trunk space without needing a full-sized maxi cab near me.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This versatile vehicle comfortably seats up to seven passengers
            easily. I recommend this for airport transfers for families with
            several medium bags.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest option fits up to eleven people with ease. It is the
            best way to move a big group around Edmondson Park.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide specialized vehicles with hydraulic ramps for total
            accessibility. Our trained drivers ensure a safe and dignified
            journey for every passenger.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Edmondson Park Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Edmondson Park taxi cab close to me?",
        answer: (
          <>
            You can call us on 1300 450 428 for immediate service. We use GPS to
            send the nearest driver to your exact location.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Edmondson Park available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question:
          "Can I pay with a credit card in your Edmondson Park taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link to="/cabcharge-taxi" className="underline px-1 font-bold">
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Edmondson Park taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Edmondson Park vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question:
          "Can I book an Edmondson Park taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Edmondson Park taxi service operates 24 hours a day, 365 days a
            year. We never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question: "Can I use CabCharge for my business trip? ",
        answer: (
          <>
            We proudly accept CabCharge Taxi Campbelltown in all of our{" "}
            <Link
              target="_blank"
              to={`https://transportnsw.info/travel-info/ways-to-get-around/taxi-hire-vehicle/rank-hail-taxi-fares-charges`}
              className="underline font-semibold px-1"
            >
              vehicles.
            </Link>{" "}
            This makes paying for your business travel very simple and fast.
          </>
        ),
      },
      {
        question: "Why is your local taxi service near me the best? ",
        answer: (
          <>
            We offer reliability, clean cars, and professional{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
            >
              drivers
            </Link>{" "}
            who care. You get a premium experience at a very fair and honest
            price.
          </>
        ),
      },
    ],
  },
  "picton-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52813.68208287246!2d150.6006166!3d-34.175621400000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ffaa9d1de9ed%3A0x40609b490439130!2sPicton%20NSW%202571%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769807388270!5m2!1sen!2sbd",
    pageTitle: "Best Picton Taxi & Maxi Cabs | Fast, Safe & Affordable Rides",
    metaDescription:
      "Get reliable Picton Taxi & Maxi Cabs 24/7. Enjoy fixed rates, clean vans, and professional drivers. Call 1300 450 428 to book your safe ride in Picton now!",
    heroTitle: "Best Picton Taxi & Maxi Cabs | Fast, Safe & Affordable Rides",
    heroDescription: (
      <>
        You deserve a ride that arrives on time every single day. Our team
        provides the most reliable Picton{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs.
        </Link>{" "}
        for you. We offer clean cars and professional drivers for every local
        trip. Your safety remains our top priority during each journey we take.
        Experience stress-free travel with our dedicated local transport experts
        today. We handle your luggage and special needs with genuine care.You
        can easily{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          book a taxi online
        </Link>{" "}
        at any time for your convenience.
      </>
    ),
    bookingFormTitle: "Book for Luxury Transfer in Picton",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services Picton",
    locationSectionDescription: (
      <>
        You need a{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/corporate-transport-services`}
          className="underline font-semibold px-1"
        >
          transport partner
        </Link>{" "}
        that understands the unique roads of our region. I have driven these
        streets for years and know every shortcut available. Our Picton taxi and
        cab services eliminate the frustration of late arrivals or
        cancellations. You will find that our Picton taxi service prioritizes
        your schedule above all else. We solve common pain points like surge
        pricing and messy vehicles immediately. Many local residents trust us
        because we provide a consistent and honest experience. You can easily
        access our Taxi Booking system for any time of day. We focus on building
        long-term trust through excellent service and local expertise. Our
        drivers pass strict background checks to ensure your total peace of
        mind. You will enjoy a quiet, comfortable cabin while we navigate the
        traffic for you. We are the premier choice for anyone seeking a local
        taxi service Picton.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Picton",
    serviceSubtitle: (
      <>
        You can access a wide variety of travel options for any event. Our
        Picton taxi cab service covers everything from quick errands to
        long-distance trips. We provide specialized solutions for groups,
        families, and corporate professionals across the entire local area.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You will arrive at the venue looking sharp and feeling relaxed. We
            coordinate multiple Picton Taxi & Maxi Cabs to move all your guests
            safely. I personally manage the timing to ensure no one misses the
            "I do" moment. Your wedding party deserves the luxury and
            punctuality of our dedicated premium transport service.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            You can treat yourself to a high-end ride for special evenings out.
            Our Taxi Cabs Premium Fleet features top-tier sedans with pristine,
            leather-trimmed interiors. I ensure every luxury vehicle remains
            spotless and smells fresh for your total comfort. Enjoy a
            sophisticated atmosphere while our expert drivers handle the busy
            Picton road conditions.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Your child's safety is the most important part of any family trip.
            We provide pre-installed, Australian-standard baby seats for your
            convenience and peace of mind. Simply request a seat when you book
            your maxi cab services Picton through our website. I double-check
            every restraint to ensure a secure fit before we start the engine.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            You need to maintain a professional image when traveling for
            important business. Our drivers offer punctual pickups for all your
            meetings and city office transfers. We provide CabCharge Taxi
            Campbelltown and Picton options for easy, paperless company billing.
            I understand that your time is valuable, so we always take the most
            efficient routes.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            You can start your holiday early without the stress of expensive
            port parking. We offer plenty of room for all your heavy suitcases
            and carry-on bags. Our Maxi cabs near me in Picton provide a direct
            door-to-ship service for your family. I track the terminal schedules
            to ensure we arrive exactly when your ship docks.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            You won't have to worry about finding a parking spot at crowded
            venues. We drop you off right at the front gates of any major local
            event. Our team handles the post-event rush so you can head home
            without any long waits. I recommend booking in advance to secure
            your ride during busy festival seasons.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            You can fit up to eleven passengers in our spacious and clean vans.
            This is the perfect solution for friends heading to a night out
            together. Our maxi cab options save you money by avoiding the need
            for multiple cars. I assist every passenger with their bags to make
            the boarding process very fast.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            You will impress your clients with our reliable and high-quality
            transport solutions. We manage large group transfers for
            team-building events or site visits with ease. Our Service Areas We
            Cover include all major business hubs around the greater Picton
            region. I provide detailed receipts to make your travel expense
            claims simple and quick.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Picton Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "You deserve to ride in a vehicle that matches your specific travel needs. Our fleet offers everything from compact sedans to massive multi-seater vans for your convenience. I keep every car in top mechanical condition to prevent any unexpected breakdowns. You will experience a smooth ride thanks to our modern suspension systems and quiet engines. We offer the best taxi cab service near me by maintaining high standards for every single vehicle.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is our most popular choice for quick solo trips. It is a
            fuel-efficient and comfortable way to reach your local destination.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Elevate your travel experience with our premium executive sedan
            options. These cars offer extra comfort and style for your most
            important journeys.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Perfect for small families with a bit of extra luggage. You get more
            trunk space without needing a full-sized maxi cab near me.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This versatile vehicle comfortably seats up to seven passengers
            easily. I recommend this for airport transfers for families with
            several medium bags.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest option fits up to eleven people with ease. It is the
            best way to move a big group around Edmondson Park.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide specialized vehicles with hydraulic ramps for total
            accessibility. Our trained drivers ensure a safe and dignified
            journey for every passenger.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Picton Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Picton taxi cab close to me?",
        answer: (
          <>
            You can call us on 1300 450 428 for immediate service. We use GPS to
            send the nearest driver to your exact location.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Picton available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question: "Can I use CabCharge for my Picton taxi cab service? ",
        answer: (
          <>
            Yes, all our vehicles accept{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Cabcharge`}
              className="underline font-semibold px-1"
            >
              CabCharge
            </Link>{" "}
            Taxi Campbelltown and Picton payments for your convenience. This
            makes business travel much easier for you to manage.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Picton taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Picton vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question: "Can I book an Picton taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Picton taxi service operates 24 hours a day, 365 days a year. We
            never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Picton taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
      {
        question: "Do you provide child seats in your maxi cab? ",
        answer: (
          <>
            We offer{" "}
            <Link
              target="_blank"
              to={`https://www.nhtsa.gov/equipment/car-seats-and-booster-seats`}
              className="underline font-semibold px-1"
            >
              safe baby seats
            </Link>{" "}
            upon your request to keep your little ones protected. Please include
            your child's age when you make your booking.
          </>
        ),
      },
    ],
  },
  "kearns-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13227.753647882542!2d150.8013481!3d-34.01979180000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12eddae9a66805%3A0x5017d681632bbf0!2sKearns%20NSW%202558%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769807610202!5m2!1sen!2sbd",
    pageTitle: "Kearns Taxi & Maxi Cabs – 24/7 Reliable Local Service",
    metaDescription:
      "Enjoy reliable rides with Kearns Taxi & Maxi Cabs. We offer 24/7 local service and spacious vans. Call 1300 450 428 to book your professional driver now!",
    heroTitle: "Kearns Taxi & Maxi Cabs – 24/7 Reliable Local Service",
    heroDescription: (
      <>
        Experience the most{" "}
        <Link
          to={`https://campbelltowntaxicabs.com.au/services/corporate-transport-services`}
          className="underline font-semibold px-1"
        >
          reliable transport
        </Link>{" "}
        in the Macarthur region today. We offer prompt pickups for all local
        residents and visitors. Our fleet includes clean sedans and spacious
        vans for every need. You can book a ride 24/7 for any urgent trip. We
        prioritize your safety and comfort on every single suburban road. Trust
        our professional drivers to get you to your destination safely.
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi in Kearns",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services Kearns",
    locationSectionDescription: (
      <>
        You deserve a transport partner that values your precious time. Finding
        a Kearns taxi cab close to me shouldn't feel like a gamble. I have seen
        many passengers frustrated by unreliable apps and late arrivals. Our
        team at Kearns Taxi & Maxi Cabs solves these common travel headaches. We
        employ local drivers who know every street around 1 Hurley St,
        Campbelltown. You will receive a clean vehicle and a professional,
        friendly driver. We offer transparent pricing without the stress of
        hidden surge costs. Whether you need a quick trip or a long journey, we
        deliver. Our{" "}
        <Link to="/" className="underline font-bold px-1">
          {" "}
          Home page
        </Link>{" "}
        makes it easy to see our commitment to you. We handle your luggage with
        care and ensure a smooth ride. You can rely on us for medical
        appointments or grocery runs. Your safety remains our top priority
        during every local{" "}
        <Link to="/book-a-taxi" className="underline font-bold px-1">
          Taxi Booking
        </Link>{" "}
        you make with us.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Kearns",
    serviceSubtitle: (
      <>
        We provide comprehensive transport solutions for every possible local
        occasion. Our Kearns taxi and cab services cater to families,
        professionals, and groups. You get a tailored experience that fits your
        specific schedule perfectly.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You will arrive at the venue in style and comfort. We coordinate
            multiple vehicles to move your entire guest list safely. Our drivers
            ensure punctuality so the ceremony starts without any delays. You
            can relax knowing your transport is in expert, professional hands.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Enjoy a premium ride in our Taxi Cabs Premium Fleet for special
            nights. These high-end vehicles offer superior comfort and a very
            quiet cabin. I recommend this service for anniversaries or important
            corporate dinner events. You will make a great impression with our
            spotless, top-tier cars.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Your child's safety is our most important daily mission. We provide
            professionally installed infant and toddler seats upon your request.
            You don't have to carry your own heavy seat through the airport.
            This service gives parents total peace of mind during every single
            trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Business travelers value our efficiency and very high professional
            standards. We offer CabCharge Taxi Campbelltown options for easy and
            fast expense tracking. Your driver will choose the quickest routes
            to avoid heavy morning traffic. Stay productive in the back seat
            while we handle the busy roads.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday stress-free with our reliable port shuttle
            service. We provide plenty of room for all your heavy holiday
            suitcases. Our drivers monitor traffic to ensure you board your ship
            on time. You won't have to worry about expensive long-term parking
            fees anymore.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Heading to a concert or a big local sporting match? We provide easy
            transport to avoid the nightmare of event parking. Our team handles
            group pickups from multiple locations for your entire party. You can
            focus on the fun while we manage the navigation.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Our maxi cab services Kearns are perfect for large family groups.
            These vans fit up to eleven people and their bulky gear easily. I
            often suggest these for airport runs with lots of luggage. You save
            money by booking one large van instead of two.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage transport for large teams attending seminars or office
            functions. Our fleet can move dozens of employees across the city
            efficiently. We provide detailed invoicing to help your accounting
            team track travel costs. Trust our{" "}
            <Link to="/about" className="underline font-bold px-1">
              About Us
            </Link>{" "}
            history of excellence for your business.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle: "Executive Fleet Options by Kearns Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "You can choose the perfect vehicle from our diverse local fleet. We maintain our cars to the highest Australian safety standards daily. I personally ensure every cabin stays fresh and very clean for you. Our Kearns taxi cab service adapts to your unique luggage requirements. You will find a vehicle that fits your budget and style. We use modern technology to track every car for your safety. Experience the best local taxi service Kearns has to offer today. Our Service Areas We Cover page shows our wide reach.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            The best{" "}
            <Link
              target="_blank"
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
            >
              taxi
            </Link>{" "}
            service near me for individuals. It comfortably fits four passengers
            and two small bags.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Choose this from our{" "}
            <Link
              to={`https://campbelltowntaxicabs.com.au/fleet`}
              className="underline font-semibold px-1"
            >
              Taxi Cabs Premium Fleet
            </Link>
            for a VIP experience. You get extra legroom and a high-end interior
            for any trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Perfect for small families with a bit of extra luggage. You get more
            trunk space without needing a full-sized maxi cab near me.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This versatile vehicle comfortably seats up to seven passengers
            easily. I recommend this for airport transfers for families with
            several medium bags.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest option fits up to eleven people with ease. It is the
            best way to move a big group around Edmondson Park.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide specialized vehicles with hydraulic ramps for total
            accessibility. Our trained drivers ensure a safe and dignified
            journey for every passenger.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle: "Frequently Asked Questions About Kearns Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Kearns taxi cab close to me?",
        answer: (
          <>
            You can call us on 1300 450 428 for immediate service. We use GPS to
            send the nearest driver to your exact location.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Kearns available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question: "Can I use CabCharge for a taxi service near me?",
        answer: (
          <>
            We accept all
            <Link
              target="_blank"
              to="https://en.wikipedia.org/wiki/Cabcharge"
              className="underline px-1 font-bold"
            >
              CabCharge Taxi
            </Link>
            Campbelltown payments across all vehicles. This is perfect for our
            local business and corporate passengers.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Kearns taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Kearns vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question: "Can I book an Kearns taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Kearns taxi service operates 24 hours a day, 365 days a year. We
            never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Kearns taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
      {
        question: "What if I need to contact the office directly?",
        answer: (
          <>
            You can visit our{" "}
            <Link to="/contact" className="underline font-bold px-1">
              Contact us
            </Link>{" "}
            page for all our details. We are always happy to help with your
            travel questions.
          </>
        ),
      },
    ],
  },
  "gledswood-hills-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26457.406099336153!2d150.7787779!3d-34.0136991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f276f52efba3%3A0x5d41c50bf3f24e5f!2sGledswood%20Hills%20NSW%202557%2C%20Australia!5e0!3m2!1sen!2sbd!4v1769807839116!5m2!1sen!2sbd",
    pageTitle: "Gledswood Hills Taxi & Maxi Cabs – 24/7 Reliable Local Service",
    metaDescription:
      "Enjoy reliable rides with Gledswood Hills Taxi & Maxi Cabs. We offer 24/7 local service and spacious vans. Call 1300 450 428 to book your professional driver now!",
    heroTitle: "Gledswood Hills Taxi & Maxi Cabs – 24/7 Reliable Local Service",
    heroDescription: (
      <>
        Experience the most reliable transport in the Macarthur region today. We
        offer prompt pickups for all local residents and visitors. Our fleet
        includes clean sedans and spacious vans for every need. You can book a
        ride 24/7 for any urgent trip. We prioritize your safety and comfort on
        every single suburban road. Trust our professional drivers to get you to
        your destination safely.
      </>
    ),
    bookingFormTitle: "Book Taxi Maxi in Gledswood Hills",
    locationSectionTitle: "Trusted Taxi and Maxi Cab Services Gledswood Hills",
    locationSectionDescription: (
      <>
        You deserve a transport partner that values your precious time. Finding
        a Gledswood Hills taxi cab close to me shouldn't feel like a gamble. I
        have seen many passengers frustrated by unreliable apps and late
        arrivals. Our team at Gledswood Hills Taxi & Maxi Cabs solves these
        common travel headaches. We employ local drivers who know every street
        around 1 Hurley St, Campbelltown. You will receive a clean vehicle and a
        professional, friendly driver. We offer transparent pricing without the
        stress of hidden surge costs. Whether you need a quick trip or a long
        journey, we deliver. Our{" "}
        <Link to="/" className="underline font-bold px-1">
          {" "}
          Home page
        </Link>{" "}
        makes it easy to see our commitment to you. We handle your luggage with
        care and ensure a smooth ride. You can rely on us for medical
        appointments or grocery runs. Your safety remains our top priority
        during every local{" "}
        <Link to="/book-a-taxi" className="underline font-bold px-1">
          Taxi Booking
        </Link>{" "}
        you make with us.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Our Taxi and Maxi Services in Gledswood Hills",
    serviceSubtitle: (
      <>
        We provide comprehensive transport solutions for every possible local
        occasion. Our Gledswood Hills taxi and cab services cater to families,
        professionals, and groups. You get a tailored experience that fits your
        specific schedule perfectly.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            You will arrive at the venue in style and comfort. We coordinate
            multiple vehicles to move your entire guest list safely. Our drivers
            ensure punctuality so the ceremony starts without any delays. You
            can relax knowing your transport is in expert, professional hands.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Enjoy a premium ride in our Taxi Cabs Premium Fleet for special
            nights. These high-end vehicles offer superior comfort and a very
            quiet cabin. I recommend this service for anniversaries or important
            corporate dinner events. You will make a great impression with our
            spotless, top-tier cars.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Your child's safety is our most important daily mission. We provide
            professionally installed infant and toddler seats upon your request.
            You don't have to carry your own heavy seat through the airport.
            This service gives parents total peace of mind during every single
            trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Business travelers value our efficiency and very high professional
            standards. We offer CabCharge Taxi Campbelltown options for easy and
            fast expense tracking. Your driver will choose the quickest routes
            to avoid heavy morning traffic. Stay productive in the back seat
            while we handle the busy roads.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Start your holiday stress-free with our reliable port shuttle
            service. We provide plenty of room for all your heavy holiday
            suitcases. Our drivers monitor traffic to ensure you board your ship
            on time. You won't have to worry about expensive long-term parking
            fees anymore.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Heading to a concert or a big local sporting match? We provide easy
            transport to avoid the nightmare of event parking. Our team handles
            group pickups from multiple locations for your entire party. You can
            focus on the fun while we manage the navigation.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Our maxi cab services Gledswood Hills are perfect for large family
            groups. These vans fit up to eleven people and their bulky gear
            easily. I often suggest these for airport runs with lots of luggage.
            You save money by booking one large van instead of two.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            We manage transport for large teams attending seminars or office
            functions. Our fleet can move dozens of employees across the city
            efficiently. We provide detailed invoicing to help your accounting
            team track travel costs. Trust our{" "}
            <Link to="/about" className="underline font-bold px-1">
              About Us
            </Link>{" "}
            history of excellence for your business.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Never miss a flight with our taxi cab close to me service. Timely
            pickups, luggage support, and stress-free journeys are guaranteed.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/book-taxi-sydney-airport",
      },
    },
    fleetSectionTitle:
      "Executive Fleet Options by Gledswood Hills Taxi & Maxi Cabs",
    fleetSectionSubTitle:
      "You can choose the perfect vehicle from our diverse local fleet. We maintain our cars to the highest Australian safety standards daily. I personally ensure every cabin stays fresh and very clean for you. Our Gledswood Hills taxi cab service adapts to your unique luggage requirements. You will find a vehicle that fits your budget and style. We use modern technology to track every car for your safety. Experience the best local taxi service Gledswood Hills has to offer today. Our Service Areas We Cover page shows our wide reach.",

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            This is our most popular choice for quick solo trips. It is a
            fuel-efficient and comfortable way to reach your local destination.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Elevate your travel experience with our premium executive sedan
            options. These cars offer extra comfort and style for your most
            important journeys.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Perfect for small families with a bit of extra luggage. You get more
            trunk space without needing a full-sized maxi cab near me.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            This versatile vehicle comfortably seats up to seven passengers
            easily. I recommend this for airport transfers for families with
            several medium bags.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Our largest option fits up to eleven people with ease. It is the
            best way to move a big group around Edmondson Park.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            We provide specialized vehicles with hydraulic ramps for total
            accessibility. Our trained drivers ensure a safe and dignified
            journey for every passenger.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Gledswood Hills Taxi & Maxi Cabs",
    faqs: [
      {
        question: "How do I find an Gledswood Hills taxi cab close to me?",
        answer: (
          <>
            You can call us on 1300 450 428 for immediate service. We use GPS to
            send the nearest driver to your exact location.
          </>
        ),
      },
      {
        question:
          "Are your Maxi Cabs near me in Gledswood Hills available for airport runs?",
        answer: (
          <>
            Yes, we specialize in airport transfers for large groups and heavy
            luggage. You should book in advance to ensure a perfectly timed
            morning pickup.
          </>
        ),
      },
      {
        question:
          "Can I pay with a credit card in your Gledswood Hills taxi service?",
        answer: (
          <>
            Every vehicle in our fleet accepts all major credit cards and{" "}
            <Link to="/cabcharge-taxi" className="underline px-1 font-bold">
              CabCharge
            </Link>{" "}
            . You will receive an electronic or paper receipt for your records
            immediately.
          </>
        ),
      },
      {
        question: "Do you offer a local taxi service near me with baby seats?",
        answer: (
          <>
            We provide pre-installed baby seats upon request for all family
            bookings. Please mention the age of your child when you call our
            team.
          </>
        ),
      },
      {
        question:
          "What makes your Gledswood Hills taxi cab service safer than ride-sharing?",
        answer: (
          <>
            Our drivers are fully licensed professionals who undergo regular
            police background checks. We use{" "}
            <Link to="/about" className="underline px-1 font-bold">
              about us
            </Link>{" "}
            verified vehicles that meet strict government safety regulations.
          </>
        ),
      },
      {
        question:
          "How many people can fit in a maxi cab services Gledswood Hills vehicle?",
        answer: (
          <>
            Our Maxi Cabs can comfortably transport up to 11 passengers at one
            time. This makes them the most cost-effective choice for your large
            group travels.
          </>
        ),
      },
      {
        question:
          "Can I book an Gledswood Hills taxi and cab services ride in advance?",
        answer: (
          <>
            You can schedule your ride days or weeks ahead via our website. This
            guarantees your driver will be waiting at your door on time.
          </>
        ),
      },
      {
        question:
          "Is there a taxi service close to me available on public holidays?",
        answer: (
          <>
            Our Gledswood Hills taxi service operates 24 hours a day, 365 days a
            year. We never close, even on Christmas Day or New Year's Eve.
          </>
        ),
      },
      {
        question:
          "Do you provide a taxi service near me for medical appointments? ",
        answer: (
          <>
            We help many residents reach local hospitals and clinics for their
            appointments. Our drivers can assist you from your door to the
            vehicle safely.
          </>
        ),
      },
      {
        question:
          "Where is your main office located for the Gledswood Hills taxi cab service? ",
        answer: (
          <>
            Our primary hub is located at{" "}
            <strong>1 Hurley St, Campbelltown, Australia.</strong> This central
            location allows us to serve all surrounding suburbs very rapidly.
          </>
        ),
      },
      {
        question: "What if I need to contact the office directly?",
        answer: (
          <>
            You can visit our{" "}
            <Link to="/contact" className="underline font-bold px-1">
              Contact us
            </Link>{" "}
            page for all our details. We are always happy to help with your
            travel questions.
          </>
        ),
      },
    ],
  },
  "menangle-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26430.109320603777!2d150.7364255853791!3d-34.101194344409066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12e5469098fd8d%3A0x5017d681632c0c0!2sMenangle%20Park%20NSW%202563%2C%20Australia!5e0!3m2!1sen!2sbd!4v1772473365625!5m2!1sen!2sbd",
    pageTitle: "24/7 Menangle Taxi & Maxi Cabs | Local & Long-Distance Travel",
    metaDescription:
      "Reliable transport you can trust with Menangle Taxi & Maxi Cabs – On-time service, modern cars & maxi cabs available. Book now and ride with confidence",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Menangle Park for Fast Pick Up and Drop Off",
    heroDescription: (
      <>
        Need a dependable ride in Menangle Park? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Menangle Park deliver prompt pickups every single time. We handle
        your local travel with punctual service that never keeps you waiting.
        Our fleet suits solo riders and big groups alike. You get roomy vehicles
        with space for everyone plus luggage. No one gets left behind or
        squeezed into tight seats. We operate around the clock. Your flight
        might land at midnight. Your meeting could run until dawn. Either way,
        we show up. Choose our premium options for extra comfort. We also handle
        smooth Menangle Park pick up and drop off to keep your day on track. You
        avoid delays. You skip the stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your schedule first.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Menangle NSW",
    locationSectionTitle: "Reliable Taxi Service in Menangle Park for Groups",
    locationSectionDescription: (
      <>
        Travelling with family or mates? Our Menangle Park Taxi Service fits
        small and large groups perfectly. Everyone rides together in one
        vehicle. You skip the hassle of splitting into multiple cars. You avoid
        confusing coordination. With our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Menangle Park,
        </Link>
        every passenger enjoys a safe, comfy trip. You might head from Menangle
        Park to Sydney Airport. You might return home after a long journey. We
        stick to the schedule. Our drivers know the best routes. They dodge
        traffic snarls. They cut delays short. You can trust our Group Transport
        Menangle Park options when you need space, reliability, and clean
        vehicles. Booking takes seconds through our online portal. You get
        confirmation fast. You ride with peace of mind.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Menangle Park with Maxi Cabs: Local & Long Distance Travel",
    locationSection2Desctiption: (
      <>
        We believe cheap should not mean uncomfortable. Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Menangle Park offers fair rates with full transparency. You see the
        price before you book. You plan your budget with confidence. This helps
        when travelling with others. You can reserve a Maxi Cab for Group Travel
        that handles multiple passengers plus bags. Want something fancier?
        Upgrade to our premium service for a refined experience. Families can
        request a Baby Seat Taxi option. Your children ride in certified,
        properly fitted seats. Our drivers bring experience and courtesy. They
        assist with special needs. They help with luggage. From early morning
        flights to late-night arrivals, our 24/7 Taxi Menangle Park keeps you
        moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        commits to safe, reliable, stress-free transport for every rider.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Menangle Park",
    locationSection3Description: (
      <>
        Our Taxi Service in Menangle Park gives you generous legroom. You get
        ample luggage space. You relax even when the cab is full. You avoid
        cramped seating. You skip awkward bag arrangements. Your ride becomes
        pleasant. Choosing our Taxi & Maxi Cabs Services in Menangle Park lets
        your group focus on the journey. We specialise in{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          group transfers
        </Link>{" "}
        for families, social clubs, and work teams. Everyone arrives together.
        Booking is quick through our Menangle Park Cab Booking page. You
        organise transport ahead of time. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for timely, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with little ones. When style counts, our premium
        service delivers extra comfort. Every vehicle undergoes regular
        cleaning. We maintain strict standards. You enjoy smooth, secure travel
        without traffic worries.
      </>
    ),
    locationSection4Title:
      "Reliable Menangle Park Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore professional transport designed specifically for Menangle Park
        residents and visitors. Our comprehensive service menu delivers exactly
        what you need, whether you're catching a dawn flight or organising
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for twenty guests. We provide{" "}
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers
        </Link>{" "}
        with real-time flight monitoring, Maxi Cab Services accommodating up to
        eleven passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>
        options with certified restraints, and Local Taxi Service for daily
        errands. Business professionals depend on our Corporate Taxi Service,
        while luxury seekers choose our Premium Service. We specialise in
        Wedding Transport,{" "}
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and{" "}
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>
        services. Every journey includes transparent upfront pricing, genuine
        24/7 availability, and experienced local drivers who know Menangle Park
        intimately. From Door-to-Door Service to complex logistics, Campbelltown
        Taxi & Maxi Cabs combines deep local expertise with unwavering
        reliability—because your destination matters, and how you get there
        should feel effortless.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle:
      "Taxi and Maxi Cab Solutions Menangle Park for Every Occasion",
    serviceSubtitle: (
      <>
        We tailor transport to match your specific needs. Our Taxi & Maxi Cabs
        Services in Menangle Park support family holidays, group outings, and
        business travel. Safety and punctuality drive everything we do. Every
        vehicle looks professional. Every driver trains thoroughly. You rely on
        us for airport runs, special events, and business trips. Each ride stays
        simple and stress-free.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Menangle Park",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our{" "}
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Menangle Park
        </Link>
        makes every trip simple and accountable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, ideal for corporate
        travellers and authorised riders. Enjoy cashless processing, clear trip
        records, and smooth billing with every ride. Reliable transport backed
        by trusted Cabcharge payment options.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in spacious vehicles. Bridal parties, relatives, and guests
            enjoy elegant, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Choose our luxury option for VIP transfers, executive travel, and
            clients expecting higher privacy and comfort standards.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book vehicles with approved child seats. Young passengers
            stay secure throughout the journey.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Designed for meetings and group business travel. Punctual pickups
            support busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Menangle Park and cruise terminals. Ample
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Skip parking hassles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Menangle Park. Generous seating and
            luggage capacity keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-managed transfers from Menangle Park to Sydney Airport or
            business locations. Your team commutes without stress.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Dependable 24/7 option across Menangle Park for everyday trips,
            appointments, and leisure outings.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },
    fleetSectionTitle: "Premium Fleet for Your Menangle Park Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied vehicles matching your group size and comfort needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        prioritises safety, space, and smooth rides. Solo travellers find
        perfect fits. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for solo riders or couples seeking quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Menangle
            Park.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for VIPs and business guests who value privacy, premium
            leather seating, and refined presentation on every journey.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Strong choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Seats 6–7 passengers comfortably. Generous luggage capacity suits
            group transfers, family holidays, and extended trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for larger groups or big families wanting spacious, clean
            interiors and a completely relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with professionally trained drivers
            and proper safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Menangle Park",
    faqs: [
      {
        question: "What is a taxi maxi service in Menangle Park?",
        answer: (
          <>
            A maxi service uses larger vehicles seating up to 11 passengers. It
            suits groups, families, or anyone needing extra luggage space.
          </>
        ),
      },
      {
        question:
          "Can I book a taxi for an early morning flight from Menangle Park?",
        answer: (
          <>
            Yes. Our 24/7 Taxi Menangle Park operates round-the-clock. Book
            anytime. We track flight times. We adjust for delays.
          </>
        ),
      },
      {
        question: "Do you supply baby seats in Menangle Park taxis?",
        answer: (
          <>
            Absolutely. Request our Baby Seat Taxi option when booking. We
            provide certified, properly fitted child seats.
          </>
        ),
      },
      {
        question: "Is a luxury taxi available in Menangle Park?",
        answer: (
          <>
            Yes. Choose our premium service for executive travel, VIP guests, or
            special occasions requiring extra comfort.
          </>
        ),
      },
      {
        question:
          "How do I book a taxi for multiple passengers in Menangle Park?",
        answer: (
          <>
            Visit our online booking page. Select your vehicle size. Enter
            pickup details. Confirm in seconds.
          </>
        ),
      },
      {
        question: "Are your taxis suitable for luggage-heavy trips?",
        answer: (
          <>
            Definitely. Our Maxi Cab Services in Menangle Park and SUVs handle
            substantial baggage easily.
          </>
        ),
      },
      {
        question: "Do you provide corporate transport services?",
        answer: (
          <>
            Yes. Our Corporate{" "}
            <Link
              to="https://en.wikipedia.org/wiki/Taxis_of_Australia"
              className="px-1 underline font-bold"
              target="_blank"
            >
              Taxi
            </Link>{" "}
            Service offers punctual, professional rides for business travellers
            and teams.
          </>
        ),
      },
      {
        question: "Can I get an airport shuttle from Menangle Park?",
        answer: (
          <>
            We provide dedicated Airport Transfers in Menangle Park to Sydney
            Airport with meet-and-greet options.
          </>
        ),
      },
      {
        question: "Are your drivers qualified and professional?",
        answer: (
          <>
            All drivers hold proper licenses. They undergo background checks.
            They train in customer service and safety.
          </>
        ),
      },
      {
        question: "Is your Menangle Park taxi service budget-friendly?",
        answer: (
          <>
            Yes. We offer competitive, transparent pricing. No hidden fees. You
            know the cost before booking.
          </>
        ),
      },
    ],
  },
  "the-oaks-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52863.978704057125!2d150.5649918!3d-34.095174549999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12563278f911d1%3A0x5017d6816333ca0!2sThe%20Oaks%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774626076672!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Oak dale, NSW -  24/7 Rides & Airport Transfers",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Oakdale for airport transfers, group travel & corporate rides. Local expert drivers, fixed prices & 24/7 availability. Call now!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in The Oaks for 24 Hours a Day",
    heroDescription: (
      <>
        Looking for a trustworthy ride in The Oaks? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services in The Oaks
        </Link>
        guarantee swift collections each time you call. We manage your local
        journeys with on-time performance that respects your clock. Our vehicles
        accommodate single travellers and large parties equally well. You
        receive ample cabin space for passengers and baggage together. Nobody
        faces exclusion or uncomfortable squeezing inside. We run non-stop
        throughout the week. Your plane may touch down at 2 AM. Your conference
        might finish at sunrise. Regardless, we arrive promptly. Select our
        <Link
          to={`/services/luxury-transfer`}
          className="underline font-semibold px-1"
        >
          luxury tier
        </Link>{" "}
        for superior relaxation. We manage seamless The Oaks pick up and drop
        off to maintain your timetable. You dodge hold-ups. You escape tension.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        prioritizes your agenda always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in The Oaks NSW",
    locationSectionTitle: "Reliable Taxi Service in The Oaks",
    locationSectionDescription: (
      <>
        Heading out with relatives or friends? Our The Oaks Taxi Service
        accommodates compact and expansive groups ideally. All passengers share
        one automobile. You bypass the trouble of dividing into separate
        convoys. You eliminate complicated planning efforts. Through our
        specialized
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in The Oaks,
        </Link>
        each traveller experiences a secure, pleasant passage. Perhaps you
        depart from The Oaks toward Sydney Airport. Perhaps you head homeward
        following extensive travel. We honour timing commitments. Our chauffeurs
        understand optimal pathways. They circumvent congestion points. They
        minimize waiting periods. You may depend on our Group Transport The Oaks
        selections when requiring room, dependability, and tidy cabins.
        Reservations require moments via our digital platform. You obtain
        verification quickly. You travel with assuredness.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in The Oaks with Maxi Cabs: Group Travel & Tours",
    locationSection2Desctiption: (
      <>
        We insist that the economy must never signify inferior. Our Local Taxi
        Service in The Oaks presents reasonable charges with complete openness.
        You view costs before confirming. You arrange finances with certainty.
        This proves valuable when journeying alongside companions. You can
        secure a Maxi Cab for Group Travel, managing several riders plus
        suitcases. Prefer additional sophistication? Enhance our executive tier
        for polished travel. Households may ask for{" "}
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        provisions. Your youngsters travel in approved, correctly installed
        restraints. Our Drivers contribute skill and politeness. They support
        particular requirements. They aid with suitcases. From dawn departures
        to evening returns, our 24/7 Taxi The Oaks maintains your progress.
        Campbelltown Taxi & Maxi Cabs pledges secure, dependable, worry-free
        conveyance for all customers.
      </>
    ),
    locationSection3Title:
      "Comfortable Family, Corporate & Baby Seat Taxi Booking in The Oaks",
    locationSection3Description: (
      <>
        Our Taxi Service in The Oaks provides extensive leg stretching room. You
        receive plentiful storage areas. You unwind despite full passenger
        loads. You evade restricted seating positions. You prevent difficult
        luggage stacking. Your trip turns enjoyable. Opting for our Taxi & Maxi
        Cabs Services in The Oaks enables your party to concentrate on arrival.
        We focus on{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          collective transfers
        </Link>{" "}
        for households, community organizations, and professional units. All
        participants reach simultaneously. Securing transport happens rapidly
        through our The Oaks Cab Booking interface. You coordinate movement
        beforehand. Commercial visitors can utilize our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert journeys to appointments. Families incorporate Baby
        Seat Taxi selections for protected travel with infants. When elegance
        matters, our executive tier supplies additional relaxation. Each
        automobile receives frequent sanitation. We uphold rigorous benchmarks.
        You experience fluid, protected transit minus congestion concerns.
      </>
    ),
    locationSection4Title:
      "Reliable The Oaks Taxi & Maxi Cab: Premium Solutions for All Types of Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore professional mobility crafted particularly for The Oaks
        inhabitants and guests. Our extensive service catalogue supplies
        precisely what you require, whether catching sunrise flights or
        coordinating nuptial transport for numerous attendees. We deliver
        Airport Transfers in The Oaks featuring live flight tracking, Maxi Cab
        Services fitting eleven occupants, Baby Seat Taxi alternatives with
        verified harnesses, and{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>{" "}
        for routine tasks. Commerce specialists rely on our Corporate Taxi
        Service, whilst refinement seekers prefer our Premium Service. We
        concentrate on Wedding Transport, Event Transport, Cruise Transfers,
        Group Transport for substantial gatherings, and Wheelchair Accessible
        Taxi provisions. Each voyage incorporates clear preliminary pricing,
        authentic round-the-clock presence, and seasoned regional operators who
        understand The Oaks thoroughly. From Door-to-Door Taxi Service to
        intricate arrangements, Campbelltown Taxi & Maxi Cabs merges profound
        regional knowledge with steadfast consistency—because your endpoint
        counts, and arrival should feel seamless.
      </>
    ),
    locationSectionImg: corporateTripsImg,

    cabChargeSectionTitle: "CabCharge Taxi Near The Oaks",
    cabChargeSectionDesctiption: (
      <>
        Require adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in The Oaks
        </Link>
        renders each voyage straightforward and traceable. We welcome protected
        CabCharge Payments, encompassing the handy CabCharge Card, perfect for
        company travellers and permitted users. Appreciate cashless handling,
        distinct trip documentation, and effortless invoicing every time.
        Dependable mobility supported by established Cabcharge payment methods.
      </>
    ),
    serviceTitle: "Taxi and Maxi Cab Solutions The Oaks for Every Occasion",
    serviceSubtitle: (
      <>
        We customize transport to suit your particular demands. Our Taxi & Maxi
        Cabs Services in The Oaks facilitate family vacations, collective
        excursions, and{" "}
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          commercial trips.
        </Link>{" "}
        Protection and promptness guide our operations. Each automobile appears
        neat. Each operator prepares extensively. You count on us for terminal
        runs, distinctive celebrations, and professional journeys. Every trip
        remains uncomplicated and relaxed.
      </>
    ),
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Journey in expansive automobiles. Bridal gatherings, family members,
            and attendees appreciate stylish, relaxed transit toward and from
            locations.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our upscale alternative for distinguished transfers, leadership
            travel, and patrons anticipating elevated seclusion and ease
            standards.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households reserve automobiles with sanctioned child restraints.
            Juvenile passengers remain protected during travel.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for conferences and collective commercial movement. Timely
            collections assist demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate straightforward journeys between The Oaks and cruise
            terminals. Sufficient room manages passengers and baggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Employ our service for performances, celebrations, and social
            functions. Arrive punctually. Avoid parking difficulties.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger gatherings in The Oaks. Abundant seating and
            baggage capability keep parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, efficiently managed transfers from The Oaks to Sydney
            Airport or commercial sites. Your personnel commutes calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable round-the-clock choice throughout The Oaks for routine
            journeys, engagements, and recreational outings.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Critical circumstance? Our Emergency Taxi in The Oaks reacts
            rapidly. We emphasize your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your The Oaks Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from diverse automobiles matching your party dimensions and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our collection
        </Link>
        emphasizes protection, area, and gentle rides. Individual travellers
        discover ideal matches. Complete groups obtain appropriate selections,
        too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Suited for individual riders or pairs wanting peaceful, relaxed
            journeys with our trustworthy Door-to-Door Taxi Service throughout
            The Oaks.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for distinguished visitors and commercial guests who prize
            seclusion, superior leather seating, and sophisticated presentation
            on each trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Additional space for travellers and suitcases. Solid selection for
            families or modest groups proceeding to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Accommodates 6–7 travellers comfortably. Substantial baggage
            capacity fits collective transfers, family holidays, and prolonged
            journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Constructed for bigger gatherings or extensive families desiring
            expansive, clean interiors and an utterly relaxed travel experience
            collectively.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible mobility with expertly prepared operators and
            appropriate safety elements for all mobility requirements and ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in The Oaks",
    faqs: [
      {
        question:
          "How do I get from The Oaks to Sydney Airport without driving?",
        answer: (
          <>
            Our{" "}
            <Link
              to={`/services/book-taxi-sydney-airport`}
              className="underline font-semibold px-1"
            >
              Airport Transfers
            </Link>{" "}
            in The Oaks cover the 75-kilometre journey in about 70 minutes via
            the Hume Highway. We monitor traffic conditions and adjust pickup
            times. You relax while we handle the route.
          </>
        ),
      },
      {
        question: "What's the biggest vehicle you offer for my family reunion?",
        answer: (
          <>
            Our Maxi Cab Services in The Oaks seat 11 people with room for
            luggage and eskies. SUVs and wagons fit 7 passengers with extra
            cargo space. We match vehicles to your group size.
          </>
        ),
      },
      {
        question: "Can I book a taxi at 4 AM for my shift at Tahmoor Mine?",
        answer: (
          <>
            Yes. Our 24/7 Taxi The Oaks operates constantly. We understand
            mining rosters and early starts. Book online or call 1300 450 428
            anytime. Your ride arrives punctually.
          </>
        ),
      },
      {
        question:
          "Do you help with moving furniture between The Oaks and Picton?",
        answer: (
          <>
            Absolutely. Our{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            Cab for Group Travel transports bulky items safely. Mention
            oversized loads when booking. We send appropriate vehicles with
            adequate space.
          </>
        ),
      },
      {
        question:
          "Is your service suitable for elderly parents visiting doctors?",
        answer: (
          <>
            Yes. Our patient drivers assist with walkers and shopping bags.
            Wheelchair Accessible Taxi in The Oaks offers dignified, comfortable
            transport for seniors.
          </>
        ),
      },
      {
        question: "How much notice do you need for airport pickups?",
        answer: (
          <>
            Book The Oaks Cab Booking 2 hours ahead for guaranteed service.
            Last-minute requests? We often accommodate within 30 minutes based
            on driver availability.
          </>
        ),
      },
      {
        question: "Can I set up a regular commute to Campbelltown?",
        answer: (
          <>
            Yes. Our Corporate{" "}
            <Link
              to={`https://www.pointtopoint.nsw.gov.au/what-a-service-provider/taxi-service-providers`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Taxi
            </Link>{" "}
            Service offers discounted rates for weekly travellers. Establish an
            account. We prioritize your regular pickup slots consistently.
          </>
        ),
      },
      {
        question: "What happens if my flight gets delayed?",
        answer: (
          <>
            We track arrivals live. Your driver waits without extra charges for
            reasonable delays. Call us if significant changes occur. We adjust
            accordingly.
          </>
        ),
      },
      {
        question: "Do you carry child seats for weekend family trips?",
        answer: (
          <>
            Request our Baby Seat Taxi when reserving. We supply age-appropriate
            restraints installed correctly. Safety standards matter to us.
          </>
        ),
      },
      {
        question: "Why choose Campbelltown Taxi Cabs over app services?",
        answer: (
          <>
            We know The Oaks' rural roads, farm accesses, and shortcuts. Our
            drivers live locally. You get human service, fixed prices, and
            accountability every trip.
          </>
        ),
      },
    ],
  },
  "oak-dale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105751.858848578!2d150.50567975!3d-34.076035450000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1257028cdd5e3b%3A0x5017d6816333cc0!2sOakdale%20NSW%202570%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774627732723!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Oak dale, NSW -  24/7 Rides & Airport Transfers",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Oakdale for airport transfers, group travel & corporate rides. Local expert drivers, fixed prices & 24/7 availability. Call now!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Oakdale for Fast Travel",
    heroDescription: (
      <>
        Searching for solid transport around Oakdale? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Oakdale promise a rapid response whenever you ring. We handle your
        neighbourhood trips with clockwork timing that never disappoints. Our
        cars fit lone commuters and bulky crowds equally. You gain generous
        interior space for people and gear combined. Zero passengers face
        exclusion or tight squeezes inside. We roll day and night without pause.
        Your aircraft might arrive past midnight. Your shift could end near
        dawn. Whatever happens, we appear ready. Pick our deluxe grade for added
        relaxation. We execute flawless Oakdale pick up and drop off to protect
        your schedule. You sidestep setbacks. You ditch anxiety.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your timetable always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Oakdale NSW",
    locationSectionTitle: "Reliable Taxi Service in Oakdale for Groups",
    locationSectionDescription: (
      <>
        Taking kin or mates somewhere special? Our Oakdale Taxi Service suits
        tight-knit and sprawling groups ideally. Every rider shares one motor.
        You skip the nightmare of splitting into different autos. You erase
        messy coordination attempts. Via our dedicated
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Maxi Cab Services in Oakdale,
        </Link>
        each guest enjoys guarded, cushy passage. Maybe you leave Oakdale bound
        for Sydney Airport. Maybe you trek home after marathon travel. We keep
        our promises on timing. Our pilots know clever back routes. They steer
        around bottlenecks. They shrink delays fast. You can bank on our Group
        Transport Oakdale picks when wanting stretch, faithfulness, and spotless
        interiors. Locking in rides takes breaths through our web hub. You snag
        proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Oakdale Affordable Maxi Cab & Fast 24/7 Rides",
    locationSection2Desctiption: (
      <>
        We reckon that cheap ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Oakdale shows honest fares with nothing tucked away. You spot the
        damage upfront. You map your spending with poise. This helps heaps when
        moving with others. You can{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          book a Maxi Cab for Group Travel,
        </Link>{" "}
        taking multiple riders plus loads. Fancy something classier? Level up to
        our silver service for polished motoring. Clans may holler for Baby Seat
        Taxi extras. Your tots ride in tested, locked-down harnesses. Our
        wheelmen bring know-how and manners. They back unique needs. They lug
        your suitcases. From crack-of-dawn departures to dead-of-night returns,
        our 24/7 Taxi Oakdale keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, care-free hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Oakdale",
    locationSection3Description: (
      <>
        Our Taxi Service in Oakdale offers you a sprawling leg stretch. You
        claim mountains of stowage room. You decompress despite packed cabins.
        You duck squashed seating. You dodge tricky bag Tetris. Your trek grows
        pleasurable. Grabbing our{" "}
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Oakdale lets your mob focus on the voyage. We zero in on
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          batch transfers
        </Link>{" "}
        for clans, sporting clubs, and office crews. The whole gang lands
        together. Snaring wheels happens swiftly via our Oakdale Cab Booking
        portal. You sort movement early. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick runs to powwows. Tribes tag on Baby Seat Taxi choices
        for safer jaunts with bubs. When poshness counts, our silver service
        dishes extra cushiness. Every rig gets scrubbed routinely. We keep tough
        standards. You savour silky, shielded transit minus snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Oakdale Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro mobility shaped squarely for Oakdale locals and visitors.
        Our broad menu hands you exactly what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We furnish
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Oakdale
        </Link>{" "}
        boasting live plane tracking, Maxi Cab Services accommodating eleven
        souls,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        variants with ticked-off straps, and Local Taxi Service for daily
        chores. Trade heavyweights trust our Corporate Taxi Service, while swank
        seekers fancy our Premium Service. We nail Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty crowds, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each trip packs clear upfront tags, true round-the-clock
        coverage, and battle-hardened local steers who grok Oakdale inside-out.
        From Door-to-Door Taxi Service to knotty logistics, Campbelltown Taxi &
        Maxi Cabs blends deep turf smarts with rock-steady reliability—because
        your finish line matters, and getting there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Oakdale for Every Occasion",
    serviceSubtitle: (
      <>
        We twist transport to match your exact wants. Our Taxi & Maxi Cabs
        Services in Oakdale back clan holidays, mob outings, and biz travel.
        Safety and punctuality steer our shop. Each wagon looks schmick. Each
        steerer drills hard. You lean on us for terminal dashes, milestone
        bashes, and work missions. Every haul stays plain and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Oakdale",
    cabChargeSectionDesctiption: (
      <>
        Need bendy payment for job or private jaunts? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Oakdale
        </Link>
        makes every roll straightforward and accountable. We take shielded
        CabCharge Payments, including the nifty CabCharge Card, ace for company
        road warriors and approved spenders. Dig cashless dealing, crisp trip
        logs, and smooth billing each go. Faithful hauling backed by
        tried-and-true Cabcharge payment tricks.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Cruise in expansive rigs. Bridal parties, rellies, and invitees dig
            elegant, cushy lifts to and from spots.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Grab our high-end pick for VIP shuttles, exec travel, and punters
            expecting peak privacy and plushness.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families lock in rides with sanctioned kiddie harnesses. Tiny
            travellers stay buckled and safe throughout.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Built for boardrooms and batch biz movement. Punctual grabs back
            hectic diaries.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Dig breezy hops between Oakdale and cruise wharves. Ample volume
            handles passengers and gear jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for gigs, bashes, and social shindigs. Rock up on
            time. Skip parking wars.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Spot-on for heftier mobs in Oakdale. Generous perch and baggage
            slots keep tribes united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, slickly run transfers from Oakdale to Sydney Airport or biz
            hubs. Your squad commutes chill.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady round-the-clock choice across Oakdale for routine runs,
            bookings, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis moment? Our{" "}
            <Link to={`/`} className="underline font-semibold px-1">
              Emergency Taxi in Oakdale
            </Link>{" "}
            springs fast. We spotlight your safety and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Oakdale Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your crowd size and snug wants.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        highlights safety, stretch, and butter-smooth motoring. Solo trekkers
        find sweet fits. Full possession score apt choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for lone rangers or duos wanting hushed, cushy treks with
            our staunch Door-to-Door Taxi Service throughout Oakdale.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and biz guests who rate seclusion, plush
            hide seating, and swish presentation on each trek.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Bonus space for trekkers and suitcases. Sturdy pick for clans or
            small packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and stretched journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Knocked up for heftier gatherings or sprawling clans wanting
            expansive, fresh interiors and a totally mellow{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              travel experience.
            </Link>
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Delivers accessible hauling with expertly schooled steerers and
            proper safety bits for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle: "Frequently Asked Questions About Taxi Service in Oakdale",
    faqs: [
      {
        question: "What does a maxi cab service cost in Oakdale?",
        answer: (
          <>
            Maxi rates depend on distance and time. We quote transparently
            before you commit. No shocks later.
          </>
        ),
      },
      {
        question: "How early should I book an Oakdale airport taxi?",
        answer: (
          <>
            Book 24 hours ahead for peace. We accept short notice too, when
            possible. Flexibility matters.
          </>
        ),
      },
      {
        question: "Can I get a taxi with child booster seats in Oakdale?",
        answer: (
          <>
            Yes. Order our Baby Seat Taxi when reserving. We supply approved
            boosters for older kids.
          </>
        ),
      },
      {
        question: "Do you offer split payment for group rides?",
        answer: (
          <>
            One person pays initially. You sort splits privately. We keep
            billing simple and clear.
          </>
        ),
      },
      {
        question: "What happens if my flight lands early at Sydney Airport?",
        answer: (
          <>
            We track arrivals live. Your driver adjusts the pickup time. You
            never wait stranded.
          </>
        ),
      },
      {
        question: "Are pets allowed in Oakdale taxis?",
        answer: (
          <>
            Small pets in carriers are welcome. Notify us when booking. We
            accommodate service animals freely.
          </>
        ),
      },
      {
        question: "Can I request a female driver?",
        answer: (
          <>
            Ask when reserving. We honour requests when available. Your comfort
            drives our service.
          </>
        ),
      },
      {
        question: "Do you provide receipts for business claims?",
        answer: (
          <>
            Instantly emailed receipts follow every trip. Claim expenses easily.
            Records stay organised.
          </>
        ),
      },
      {
        question: "Is smoking permitted in your vehicles?",
        answer: (
          <>
            Strictly non-smoking fleet. Fresh cabins guaranteed. Violators face
            cleaning fees.
          </>
        ),
      },
      {
        question: "How do I modify my Oakdale booking?",
        answer: (
          <>
            Ring 1300 450 428 or use our web portal. Changes happen fast. We
            adapt quickly.
          </>
        ),
      },
      {
        question: "What areas beyond Oakdale do you reach?",
        answer: (
          <>
            We cover the Macarthur region wide. Wollongong, Sydney CBD, and the
            Southern Highlands are accessible.
          </>
        ),
      },
      {
        question: "Can I book recurring daily pickups?",
        answer: (
          <>
            Corporate accounts welcome regular schedules. Set repeating rides.
            We remember your routine.
          </>
        ),
      },
      {
        question: "Do your drivers help with shopping bags?",
        answer: (
          <>
            Absolutely. Steerers assist with parcels. Heavy loads receive extra
            hands.
          </>
        ),
      },
      {
        question: "What if I leave items in the taxi?",
        answer: (
          <>
            Contact us immediately. We trace vehicles fast. Lost property
            returns promptly.
          </>
        ),
      },
      {
        question: "Are your prices higher on public holidays?",
        answer: (
          <>
            Standard rates apply year-round. No holiday surcharges. Fairness
            matters always.
          </>
        ),
      },
    ],
  },
  "buxton-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52763.37742545782!2d150.53885240000002!3d-34.255915050000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b130062da3ed9e1%3A0x40609b490438e80!2sBuxton%20NSW%202571%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774628250468!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Buxton, NSW - Family, Group Travel & More",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Buxton for family travel, baby seat bookings & wedding transport. On-time pickups, fixed fares & local drivers. Book today!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Buxton for Smooth Travel",
    heroDescription: (
      <>
        Hunting for steady wheels around Buxton? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Buxton pledge lightning-fast arrivals every time you dial. We run
        your neighbourhood jaunts with military precision that never lets you
        down. Our motors suit solo voyagers and massive packs alike. You score
        cavernous cabin space for riders and kit combined. Not a single soul
        gets stranded or squashed inside. We roll non-stop day and night. Your
        jet might touch down at 3 AM. Your gig could wrap at sunrise. No matter
        what, we materialise pronto. Choose our elite tier for bonus plushness.
        We nail smooth Buxton pick up and drop off to guard your diary. You duck
        hold-ups. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        fights for your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Buxton NSW",
    locationSectionTitle: "Reliable Taxi Service in Buxton for Groups",
    locationSectionDescription: (
      <>
        Carting relatives or crew somewhere good? Our Buxton Taxi Service fits
        intimate and massive crowds perfectly. The whole bunch shares one
        machine. You dodge the chaos of fracturing into different cars. You kill
        confusing planning attempts. Through our committed
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Buxton,
        </Link>
        every traveller scores a protected, cosy passage. Perhaps you quit
        Buxton heading for Sydney Airport. Perhaps you drag home after epic
        journeys. We honour our timing word. Our captains know sneaky shortcuts.
        They bypass gridlock. They squash waiting times. You can trust our Group
        Transport Buxton selections when craving stretch, loyalty, and gleaming
        cabins. Securing rides takes ticks via our online gateway. You grab
        confirmation instantly. You float with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Buxton with Maxi Cabs: Local & Long Distance Cab",
    locationSection2Desctiption: (
      <>
        We swear that budget must never mean rubbish. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Buxton displays fair dinkum prices with zero hidden nasties. You see
        the tally upfront. You arrange your dollars with assurance. This proves
        gold when trekking with others. You can snag a{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel,
        </Link>
        hauling numerous riders plus loads. Keen on something fancier? Bump up
        to our gold service for refined cruising. Tribes may shout for{" "}
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        add-ons. Your littlies travel in certified, locked-in restraints. Our
        skippers bring wisdom and respect. They back special requests. They heft
        your bags. From sparrow's fart departures to witching hour returns, our
        24/7 Taxi Buxton keeps you mobile. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        promises secure, steady, zero-stress hauling for every punter.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Buxton",
    locationSection3Description: (
      <>
        Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Buxton
        </Link>{" "}
        offers you a sprawling stretch room. You snag heaps of stowage volume.
        You unwind despite chockers cabins. You escape compressed seating. You
        miss messy bag Jenga. Your trek becomes enjoyable. Snapping up our Taxi
        & Maxi Cabs Services in Buxton allows your tribe to focus on the
        expedition. We specialise in
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          batch transfers
        </Link>{" "}
        for families, footy teams, and office squads. Everyone rocks up united.
        Grabbing wheels happens pronto through our Buxton Cab Booking site. You
        arrange transport beforehand. Business roadies can hit our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, professional dashes to meetings. Mobs attach Baby Seat Taxi
        options for protected trips with ankle-biters. When class counts, our
        gold service serves extra cushiness. Every rig gets detailed regularly.
        We enforce strict benchmarks. You relish fluid, guarded transit minus
        traffic headaches.
      </>
    ),
    locationSection4Title:
      "Reliable Buxton Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Reveal pro hauling crafted squarely for Buxton locals and blow-ins. Our
        wide spread hands you precisely what you need, whether grabbing dawn
        flights or orchestrating
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding fleets
        </Link>{" "}
        for loads of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Buxton
        </Link>
        , flaunting live plane tracking, Maxi Cab Services accommodating eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved harnesses, and Local Taxi Service for everyday
        missions. Commerce bigwigs lean on our Corporate Taxi Service, while
        luxury chasers dig our Premium Service. We master Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        gear. Each haul packs transparent upfront tags, genuine round-the-clock
        cover, and seasoned local skippers who read Buxton like a book. From
        Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi & Maxi
        Cabs merges deep turf knowledge with unshakeable consistency—because
        your endpoint counts, and arriving there should feel like drifting on
        clouds.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Buxton for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your precise brief. Our{" "}
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Buxton back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks flash.
        Every skipper trains hard. You count on us for terminal sprints,
        landmark parties, and work jaunts. Each haul stays uncomplicated and
        mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Buxton",
    cabChargeSectionDesctiption: (
      <>
        After bendy billing for work or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Buxton
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the handy CabCharge Card, for company trekkers and
        authorised spenders. Rate cashless transactions, neat trip records, and
        painless billing for each run. Faithful hauling backed by proven
        Cabcharge payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Snag our luxury pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth hops between Buxton and cruise wharves. Generous volume
            handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for heftier crowds in Buxton. Ample perch and baggage
            capacity keep tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Buxton to Sydney Airport
            or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady round-the-clock option across Buxton for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Buxton reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Buxton Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        highlights safety, stretch, and cloud-soft cruising. Lone trekkers find
        ideal matches. Complete possesses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Buxton.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle: "Frequently Asked Questions About Taxi Service in Buxton",
    faqs: [
      {
        question: "How do I book a maxi cab for a Buxton wedding?",
        answer: (
          <>
            Ring 1300 450 428 or use our web form. Tell us your guest count. We
            lock in rides fast.
          </>
        ),
      },
      {
        question: "Can I get a taxi after midnight in Buxton?",
        answer: (
          <>
            Absolutely. Our 24/7{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Taxis_of_Australia`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Taxi
            </Link>{" "}
            Buxton never sleeps. We fetch you anytime. Night owls welcome.
          </>
        ),
      },
      {
        question: "Do your Buxton taxis carry sports equipment?",
        answer: (
          <>
            Yes.{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs handle bikes, boards, and gear. Mention size when booking. We
            prepare space.
          </>
        ),
      },
      {
        question: "Are your drivers locals who know Buxton well?",
        answer: (
          <>
            Our skippers live nearby. They know shortcuts. They avoid roadwork.
            You get savvy locals.
          </>
        ),
      },
      {
        question: "Can I pay with a card for Buxton airport runs?",
        answer: (
          <>
            Cards accepted. CabCharge welcome. Cash works too. Split bills are
            possible. Payment flexibility guaranteed.
          </>
        ),
      },
      {
        question: "Do you offer meet-and-greet at Sydney Airport?",
        answer: (
          <>
            Yes. Your skipper waits with a sign. We track delays. No extra
            charge for waiting.
          </>
        ),
      },
      {
        question: "What if my Buxton taxi is late?",
        answer: (
          <>
            We run on time. If rare delays hit, we call you. Your ride becomes a
            priority instantly.
          </>
        ),
      },
      {
        question: "Can I bring a pram without booking a baby seat?",
        answer: (
          <>
            Small prams fold into the boot space. For safety, book a Baby Seat
            Taxi with restraints. Kids ride securely.
          </>
        ),
      },
      {
        question: "Do you service Buxton on Christmas Day?",
        answer: (
          <>
            We roll 365 days. Public holidays included. Same rates apply. Book
            early for peak times.
          </>
        ),
      },
      {
        question: "How many passengers fit in your biggest taxi?",
        answer: (
          <>
            Our Maxi Taxi swallows eleven passengers. Eight bags fit too.
            Biggest group option available.
          </>
        ),
      },
      {
        question: "Can I request a quiet driver for Buxton trips?",
        answer: (
          <>
            Mention preferences when booking. We match your style. Professional
            skippers respect your space.
          </>
        ),
      },
      {
        question: "Do you offer corporate accounts for regular Buxton travel?",
        answer: (
          <>
            Business accounts available. Monthly billing. Priority booking.
            Streamlined expenses. We handle paperwork.
          </>
        ),
      },
      {
        question: "What areas surround Buxton do you cover?",
        answer: (
          <>
            We reach Wilton, Picton, Tahmoor, and beyond. The Macarthur region
            is our backyard. Ask about your suburb.
          </>
        ),
      },
      {
        question: "Can I book a return trip from Sydney Airport to Buxton?",
        answer: (
          <>
            Double bookings welcome. We schedule both legs. Your return skipper
            knows your flight. Seamless travel.
          </>
        ),
      },
      {
        question: "Are pets allowed in Buxton taxis?",
        answer: (
          <>
            Small pets in carriers are accepted. Service animals are always
            welcome. Tell us when booking. We prepare.
          </>
        ),
      },
    ],
  },
  "mossvale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105150.24078679329!2d150.3946812!3d-34.5549473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b139744aed82f79%3A0x40609b490439080!2sMoss%20Vale%20NSW%202577%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774628686173!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Moss vale, NSW - Local, Wedding & Corporate",
    metaDescription:
      "Need a ride? Taxi & Maxi Cabs Services in Moss Vale cover wedding transport, cruise transfers & group travel. Trusted local drivers & fixed prices. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Moss Vale for All Travel Needs",
    heroDescription: (
      <>
        Chasing dependable rides around Moss Vale? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Moss Vale guarantee swift collections each time you ring. We manage
        your local trips with razor-sharp timing that never disappoints. Our
        fleet fits lone travellers and huge parties equally. You gain massive
        cabin space for people and gear together. No passenger faces exclusion
        or tight squeezes inside. We operate non-stop all week. Your flight
        might land at 1 AM. Your event could finish at dawn. Either way, we
        appear ready. Pick our premium grade for extra comfort. We execute
        smooth Moss Vale pick up and drop off to protect your schedule. You
        avoid delays. You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Moss Vale NSW",
    locationSectionTitle: "Reliable Taxi Service in Moss Vale for Groups",
    locationSectionDescription: (
      <>
        Moving family or friends somewhere nice? Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Moss Vale Taxi Service
        </Link>{" "}
        suits small and large groups ideally. Everyone shares one vehicle. You
        bypass the hassle of splitting into multiple cars. You eliminate
        confusing coordination. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Moss Vale,
        </Link>
        each guest enjoys safe, comfy travel. Perhaps you leave Moss Vale bound
        for Sydney Airport. Perhaps you return home after a long trip. We stick
        to our promises. Our drivers know smart shortcuts. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Moss
        Vale options when needing space, reliability, and clean cars. Booking
        takes seconds via our online portal. You get confirmation fast. You ride
        with peace of mind.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Moss Vale with Maxi Cabs: Affordable Local & Long Distance Trips",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Moss Vale offers fair rates with full clarity. You see the price
        before booking. You plan your budget with confidence. This helps when
        travelling with others. You can book a Maxi Cab for Group Travel that
        handles many passengers plus bags. Want something nicer? Upgrade to our
        luxury service for refined travel. Families can request Baby Seat Taxi
        options. Your children ride in approved, properly fitted seats. Our
        drivers bring skill and courtesy. They help with special needs. They
        assist with luggage. From early morning flights to late-night arrivals,
        our 24/7 Taxi Moss Vale keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        commits to safe, reliable, stress-free transport for every rider.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Moss Vale",
    locationSection3Description: (
      <>
        Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Moss Vale
        </Link>
        gives you generous legroom. You get ample luggage space. You relax even
        when the cab is full. You avoid cramped seating. You skip awkward bag
        arrangements. Your ride becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Moss Vale lets your group focus on the journey. We
        specialise in
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          group transfers
        </Link>{" "}
        for families, sports teams, and work crews. Everyone arrives together.
        Booking is quick through our Moss Vale Cab Booking page. You organise
        transport ahead of time. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for timely, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with little ones. When style matters, our{" "}
        <Link
          to={`/services/luxury-transfer`}
          className="underline font-semibold px-1"
        >
          luxury service delivers
        </Link>{" "}
        extra comfort. Every vehicle undergoes regular cleaning. We maintain
        strict standards. You enjoy smooth, secure travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Moss Vale Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore professional transport designed specifically for Moss Vale
        residents and visitors. Our comprehensive service menu delivers exactly
        what you need, whether catching a dawn flight or organising
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Moss Vale
        </Link>{" "}
        with real-time flight monitoring, Maxi Cab Services accommodating up to
        eleven passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        errands. Business professionals depend on our Corporate Taxi Service,
        while luxury seekers choose our Premium Service. We specialise in{" "}
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          Wedding Transport,
        </Link>
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every journey includes transparent upfront pricing, genuine
        24/7 availability, and experienced local drivers who know Moss Vale
        intimately. From Door-to-Door Taxi Service to complex logistics,
        Campbelltown Taxi & Maxi Cabs combines deep local expertise with
        unwavering reliability—because your destination matters, and how you get
        there should feel effortless.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Moss Vale for Every Occasion",
    serviceSubtitle: (
      <>
        We tailor transport to match your specific needs. Our{" "}
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Moss Vale support family holidays, group outings, and business
        travel. Safety and punctuality drive everything we do. Every vehicle
        looks professional. Every driver trains thoroughly. You rely on us for
        airport runs, special events, and business trips. Each ride stays simple
        and stress-free.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Moss Vale",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Moss Vale
        </Link>
        makes every trip simple and accountable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, ideal for corporate
        travellers and authorised riders. Enjoy cashless processing, clear trip
        records, and smooth billing with every ride. Reliable transport backed
        by trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in spacious vehicles. Bridal parties, relatives, and guests
            enjoy elegant, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Choose our luxury option for VIP transfers, executive travel, and
            clients expecting higher privacy and comfort standards.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book vehicles with approved child seats. Young passengers
            stay secure throughout the journey.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Designed for meetings and group business travel. Punctual pickups
            support busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Moss Vale and cruise terminals. Ample space
            handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Skip parking hassles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Moss Vale. Generous seating and luggage
            capacity keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-managed transfers from Moss Vale to Sydney Airport or
            business locations. Your team commutes without stress.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Dependable 24/7 option across Moss Vale for everyday trips,
            appointments, and leisure outings.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent situation? Our Emergency Taxi in Moss Vale responds quickly.
            We prioritise your safety and speed.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Moss Vale Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied vehicles matching your group size and comfort needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        prioritises safety, space, and smooth rides. Solo travellers find
        perfect fits. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for solo riders or couples seeking quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Moss Vale.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for VIPs and business guests who value privacy, premium
            leather seating, and refined presentation on every journey.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Strong choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Seats 6–7 passengers comfortably. Generous luggage capacity suits
            group transfers, family holidays, and extended trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for larger groups or big families wanting spacious, clean
            interiors and a completely relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with professionally trained drivers
            and proper{" "}
            <Link
              to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              safety
            </Link>{" "}
            features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Moss Vale",
    faqs: [
      {
        question: "What makes your Moss Vale taxi service reliable?",
        answer: (
          <>
            We track flights live. We train drivers hard. We clean cars daily.
            Punctuality matters most.
          </>
        ),
      },
      {
        question: "Can I book a taxi for wine tours around Moss Vale?",
        answer: (
          <>
            Yes. Our drivers know Southern Highlands wineries. Plan your route.
            We handle driving safely.
          </>
        ),
      },
      {
        question: "Do you offer fixed rates for Moss Vale airport trips?",
        answer: (
          <>
            We quote upfront. No meter surprises. Know your cost before riding.
            Budget with confidence.
          </>
        ),
      },
      {
        question: "How do I request a baby seat in Moss Vale?",
        answer: (
          <>
            Mention age and weight when booking. We fit the correct restraints.
            Safety comes first always.
          </>
        ),
      },
      {
        question: "Can your taxis handle golf clubs and bulky gear?",
        answer: (
          <>
            Maxi cabs swallow golf bags easily. Tell us the equipment size. We
            bring the right vehicle.
          </>
        ),
      },
      {
        question: "Do Moss Vale drivers know routes to Canberra Airport?",
        answer: (
          <>
            Yes. We service Canberra trips. Drivers know both airports.
            Alternative travel sorted.
          </>
        ),
      },
      {
        question: "What happens if I cancel my Moss Vale booking?",
        answer: (
          <>
            Call us ASAP. No charges for early notice. Fair policy for changes.
            We understand plans shift.
          </>
        ),
      },
      {
        question: "Are your Moss Vale taxis available on public holidays?",
        answer: (
          <>
            We run every day. Holidays included. Book early for busy dates. Same
            great service.
          </>
        ),
      },
      {
        question: "Can I book multiple taxis for large Moss Vale events?",
        answer: (
          <>
            Fleet coordination available. Weddings and conferences covered. We
            manage group logistics smoothly.
          </>
        ),
      },
      {
        question: "Do you provide receipts for business travel claims?",
        answer: (
          <>
            Instant email receipts sent. ATO compliant. Claim expenses easily.
            Records stay organised.
          </>
        ),
      },
      {
        question: "How far is Moss Vale from Sydney Airport?",
        answer: (
          <>
            The journey takes roughly 90 minutes. Traffic affects timing. We
            plan routes smartly. Arrive relaxed.
          </>
        ),
      },
      {
        question:
          "Can I request a specific driver for regular Moss Vale trips?",
        answer: (
          <>
            Ask when booking. We note preferences. Same driver when possible.
            Build rapport over time.
          </>
        ),
      },
      {
        question: "Do you service Moss Vale train station pickups?",
        answer: (
          <>
            Yes. We meet trains on time. Platform pickups arranged. Connect your
            journey seamlessly.
          </>
        ),
      },
      {
        question: "What payment methods work for Moss Vale taxis?",
        answer: (
          <>
            Cash, card, and CabCharge accepted. Corporate accounts welcome.
            Split payments are possible. Flexibility guaranteed.
          </>
        ),
      },
      {
        question: "Are pets permitted in Moss Vale taxis?",
        answer: (
          <>
            Small pets in carriers are allowed. Service animals are always
            welcome. Mention when booking. We prepare space.
          </>
        ),
      },
    ],
  },

  "mittagong-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105150.24078679329!2d150.3946812!3d-34.5549473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b13a172adf68a3f%3A0x50609b490442450!2sMittagong%20NSW%202575%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774629056355!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Mittagong, NSW - 24/7 Airport & Group",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Mittagong for airport transfers, wheelchair accessible rides & emergency taxi. Fixed fares, local drivers, always on time. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Mittagong for Safe, Reliable Rides",
    heroDescription: (
      <>
        After solid transport around Mittagong? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Mittagong promise a rapid pickup every time you call. We handle your
        local runs with clockwork precision that never fails. Our vehicles suit
        lone commuters and big crowds equally well. You get heaps of cabin space
        for riders and luggage combined. Nobody gets left out or crammed inside.
        We run day and night without stopping. Your plane might touch down at
        midnight. Your function could end at daybreak. Either way, we show up
        fast. Choose our top-tier option for extra comfort. We manage smooth
        Mittagong pick up and drop off to keep your diary on track. You dodge
        delays. You drop the stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your schedule completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Mittagong NSW",
    locationSectionTitle: "Reliable Taxi Service in Mittagong for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere good? Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Mittagong Taxi Service
        </Link>{" "}
        fits tight and large groups perfectly. The whole crew shares one car.
        You skip the nightmare of breaking into separate vehicles. You kill
        messy planning efforts. Through our committed
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Mittagong,
        </Link>
        every passenger scores safe, cushy travel. Maybe you head from Mittagong
        toward Sydney Airport. Maybe you trek home after long hauls. We keep our
        word on timing. Our operators know clever back streets. They steer
        around bottlenecks. They shrink wait times. You can bank on our Group
        Transport Mittagong picks when wanting stretch, trust, and spotless
        interiors. Locking in rides takes moments via our web hub. You snag
        proof straight away. You cruise with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Mittagong with Maxi Cabs for Everyone",
    locationSection2Desctiption: (
      <>
        We reckon that budget must never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Mittagong shows honest fares with nothing hidden. You see costs
        upfront. You sort your spending with assurance. This proves handy when
        moving with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>
        , taking multiple riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your little ones travel in ticked-off, locked-down harnesses.
        Our wheelmen bring know-how and manners. They back special requests.
        They heft your bags. From crack-of-dawn flights to late returns, our
        24/7 Taxi Mittagong keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Mittagong",
    locationSection3Description: (
      <>
        Our Taxi Service in Mittagong offers you a sprawling stretch of room.
        You claim mountains of stowage volume. You unwind despite packed cabins.
        You duck squashed seating. You miss tricky bag stacking. Your trip turns
        enjoyable. Grabbing our Taxi & Maxi Cabs Services in Mittagong lets your
        mob focus on the voyage. We zero in on batch transfers for households,
        sporting clubs, and office squads. The whole gang lands together.
        Snaring wheels happens swiftly through our Mittagong Cab Booking portal.
        You arrange movement beforehand. Corporate nomads can tap our Corporate
        Taxi Service for sharp, slick runs to powwows. Mobs attach Baby Seat
        Taxi choices for protected trips with bubs. When elegance counts, our
        silver service dishes extra cushiness. Every rig gets detailed
        routinely. We enforce tough benchmarks. You relish fluid, guarded
        transit minus snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Mittagong Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro mobility crafted squarely for Mittagong locals and blow-ins.
        Our broad spread hands you precisely what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding fleets
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Mittagong
        </Link>{" "}
        flaunting live plane tracking, Maxi Cab Services accommodating eleven
        occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and Local Taxi Service for daily missions.
        Trade heavyweights lean on our Corporate Taxi Service, while refinement
        chasers dig our Premium Service. We master Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        <Link
          to={`/services/cruise-terminal-transfer`}
          className="underline font-semibold px-1"
        >
          Cruise Transfers,
        </Link>{" "}
        Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Mittagong like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Mittagong for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Mittagong back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Mittagong",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Mittagong
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth hops between Mittagong and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for heftier crowds in Mittagong. Ample perch and baggage
            capacity keep tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Mittagong to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis hits? Our{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Emergency Taxi
            </Link>{" "}
            in Mittagong reacts instantly. We spotlight your protection and
            velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Mittagong Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete possesses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Mittagong.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Mittagong",
    faqs: [
      {
        question: "How do I book a taxi from Mittagong to Sydney Airport?",
        answer: (
          <>
            Ring 1300 450 428 or book online. Tell us your flight time. We track
            delays. Pickup adjusts automatically.
          </>
        ),
      },
      {
        question: "Can I get a maxi cab for Mittagong shopping trips?",
        answer: (
          <>
            Yes. We haul bulky purchases. IKEA, homemaker centres, no problem.
            Maxi cabs swallow big loads easily.
          </>
        ),
      },
      {
        question:
          "Do your Mittagong drivers know Bowral and the surrounding towns?",
        answer: (
          <>
            Absolutely. We know the Southern Highlands intimately. Bowral, Moss
            Vale, Berrima. Regional{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              travel
            </Link>{" "}
            sorted.
          </>
        ),
      },
      {
        question: "What if my train arrives late at Mittagong station?",
        answer: (
          <>
            We monitor train schedules. Your driver waits. No extra charge for
            delays. Connection guaranteed.
          </>
        ),
      },
      {
        question: "Can I book a taxi for Mittagong hospital visits?",
        answer: (
          <>
            Regular medical trips welcome. We know local hospitals. Patient
            transport handled with care. Book recurring rides.
          </>
        ),
      },
      {
        question: "Do you offer set prices for Mittagong to Canberra trips?",
        answer: (
          <>
            Fixed rates available. Know the cost upfront. No meter anxiety.
            Business travel simplified.
          </>
        ),
      },
      {
        question: "How do I request a wheelchair taxi in Mittagong?",
        answer: (
          <>
            Mention mobility needs when booking. We send a proper{" "}
            <Link
              to={`https://www.pointtopoint.nsw.gov.au/what-a-service-provider/taxi-service-providers`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              vehicle.
            </Link>
            Drivers assist with boarding. Comfort assured.
          </>
        ),
      },
      {
        question: "Are your Mittagong taxis pet-friendly?",
        answer: (
          <>
            Small pets in carriers are accepted. Service animals are always
            welcome. Mention when booking. We prepare space.
          </>
        ),
      },
      {
        question: "Can I split fares between multiple passengers?",
        answer: (
          <>
            One person pays initially. You sort splits privately. We keep
            billing simple. Groups are managed easily.
          </>
        ),
      },
      {
        question: "What makes your Mittagong service different from rideshare?",
        answer: (
          <>
            Professional drivers. Local knowledge. Phone bookings accepted. No
            surge pricing. Personal service guaranteed.
          </>
        ),
      },
      {
        question: "Do you provide taxis for Mittagong school runs?",
        answer: (
          <>
            Yes. Regular student transport is available. Baby seats fitted.
            Safety priority. Parents trust us.
          </>
        ),
      },
      {
        question: "How early should I book for Mittagong wedding transport?",
        answer: (
          <>
            Book months ahead for peak seasons. We coordinate multiple vehicles.
            Your big day is covered.
          </>
        ),
      },
      {
        question: "Can I get a receipt for tax purposes?",
        answer: (
          <>
            Instant email receipts sent. ATO compliant. Business claims are
            easy. Records are organised automatically.
          </>
        ),
      },
      {
        question: "Do you service Mittagong on Christmas Day?",
        answer: (
          <>
            We operate 365 days. Public holidays included. Same rates apply.
            Festive travel sorted.
          </>
        ),
      },
      {
        question: "What happens if I leave belongings in the taxi?",
        answer: (
          <>
            Call us immediately. We trace the vehicle fast. Lost property
            returned promptly. Your items matter.
          </>
        ),
      },
    ],
  },
  "manly-vale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13264.517778075775!2d151.2660283!3d-33.7831553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12abc7edcbeb07%3A0x5017d681632bfc0!2sManly%20Vale%20NSW%202093%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774631744404!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Manly Vale, NSW - Cruise, Airport Transfers & Local",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Manly Vale for cruise transfers, wedding transport & 24/7 emergency taxi. Expert local drivers & transparent pricing. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Manly Vale for Local & Airport Travel",
    heroDescription: (
      <>
        After dependable transport around Manly Vale? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Manly Vale promise a rapid response every time you call. We handle
        your local trips with military precision that never disappoints. Our
        vehicles suit lone commuters and huge crowds equally well. You gain
        generous cabin space for riders and luggage combined. Nobody faces
        exclusion or tight squeezes inside. We operate day and night without
        pause. Your plane might land at midnight. Your function could end at
        dawn. Either way, we show up ready. Select our elite tier for added
        comfort. We execute flawless Manly Vale pick up and drop off to protect
        your schedule. You avoid delays. You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        prioritises your timetable always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Manly Vale NSW",
    locationSectionTitle: "Reliable Taxi Service in Manly Vale for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Manly Vale Taxi Service
        </Link>
        accommodates small and large groups ideally. Everyone rides together in
        one car. You bypass the hassle of splitting into multiple vehicles. You
        eliminate confusing coordination. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Manly Vale,
        </Link>
        each guest enjoys safe, comfortable travel. Perhaps you depart Manly
        Vale bound for Sydney Airport. Perhaps you return home after a long
        trip. We stick to our promises. Our drivers know the best routes. They
        avoid traffic jams. They minimise waiting time. You can trust our Group
        Transport Manly Vale options when needing space, reliability, and clean
        interiors. Booking takes seconds via our online portal. You receive
        confirmation quickly. You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Manly Vale with Affordable Maxi Cabs & Local Travel",
    locationSection2Desctiption: (
      <>
        We believe affordable should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Manly Vale offers fair rates with complete transparency. You see the
        price before booking. You plan your budget with assurance. This helps
        when travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that handles multiple passengers plus bags. Want something nicer?
        Upgrade to our{" "}
        <Link
          to={`/services/luxury-transfer`}
          className="underline font-semibold px-1"
        >
          luxury service
        </Link>{" "}
        for refined travel. Families can request
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers bring experience and courtesy. They assist with special needs.
        They help with luggage. From early morning flights to late-night
        arrivals, our 24/7 Taxi Manly Vale keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        commits to safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Manly Vale",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Manly Vale
        </Link>{" "}
        provides ample legroom. You get plenty of luggage space. You relax even
        when the vehicle is full. You avoid cramped seating. You miss awkward
        bag arrangements. Your journey becomes pleasant. Choosing our Taxi &
        Maxi Cabs Services in Manly Vale lets your group focus on the trip. We
        specialise in group transfers for families, sports teams, and work
        crews. Everyone arrives together. Booking is swift through our Manly
        Vale Cab Booking page. You organise transport in advance. Business
        travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, professional rides to meetings. Families add Baby Seat
        Taxi options for safer trips with young children. When style matters,
        our luxury service delivers extra comfort. Every vehicle receives
        regular cleaning. We maintain high standards. You enjoy smooth, secure
        travel without traffic concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Manly Vale Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Discover{" "}
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          professional transport
        </Link>{" "}
        designed specifically for Manly Vale residents and visitors. Our
        comprehensive range delivers exactly what you need, whether catching an
        early flight or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Manly Vale
        </Link>{" "}
        with real-time flight monitoring, Maxi Cab Services accommodating up to
        eleven passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        errands. Business professionals rely on our Corporate Taxi Service,
        while luxury seekers choose our Premium Service. We specialise in
        Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, genuine 24/7
        availability, and experienced local drivers who know Manly Vale
        thoroughly. From Door-to-Door Taxi Service to complex logistics,
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi & Maxi Cabs
        </Link>{" "}
        combines deep local knowledge with consistent reliability—because your
        destination matters, and arriving there should feel effortless.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Manly Vale for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your specific requirements. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Manly Vale support family holidays, group outings, and business
        travel. Safety and punctuality guide our operations. Every vehicle looks
        professional. Every driver trains thoroughly. You depend on us for
        airport transfers, special celebrations, and business trips. Each ride
        remains simple and relaxed.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Manly Vale",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Manly Vale
        </Link>
        makes every journey simple and traceable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, perfect for corporate
        travellers and authorised users. Enjoy cashless transactions, clear trip
        records, and straightforward billing every time. Dependable transport
        backed by trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in spacious vehicles. Bridal parties, relatives, and guests
            enjoy elegant, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Choose our luxury option for VIP transfers, executive travel, and
            clients expecting superior privacy and comfort standards.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families reserve vehicles with approved child seats. Young
            passengers remain secure throughout the journey.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Designed for meetings and group business travel. Timely collections
            support demanding schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth journeys between Manly Vale and the cruise terminals.
            Plenty of space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            punctually. Avoid parking difficulties.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Manly Vale. Generous seating and luggage
            capacity keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Manly Vale to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Manly Vale for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent situation? Our Emergency Taxi in Manly Vale responds rapidly.
            We prioritise your safety and speed.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Manly Vale Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from varied vehicles matching your group size and comfort
        preferences.{" "}
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        emphasises safety, space, and smooth journeys. Solo travellers find
        ideal options. Full groups receive suitable choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for individual riders or couples seeking peaceful,
            comfortable trips with our reliable Door-to-Door Taxi Service
            throughout Manly Vale.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Ideal for VIPs and business guests who value privacy, quality
            leather seating, and polished presentation on every journey.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Additional room for passengers and luggage. Excellent choice for
            families or small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Substantial luggage capacity suits
            group transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Constructed for larger groups or big families wanting spacious,
            clean interiors and a completely relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with professionally trained drivers
            and appropriate safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Manly Vale",
    faqs: [
      {
        question: "How do I get from Manly Vale to Sydney Airport quickly?",
        answer: (
          <>
            Book with us. We know the fastest routes. Avoid Spit Bridge delays.
            Flight tracking included. Arrive relaxed.
          </>
        ),
      },
      {
        question: "Can I book a taxi for Manly Vale beach trips?",
        answer: (
          <>
            Yes. We service nearby beaches. Manly, Freshwater, Curl Curl.
            Surfboards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              maxi
            </Link>{" "}
            cabs. Beach days sorted.
          </>
        ),
      },
      {
        question: "Do your drivers know Balgowlah and Fairlight shortcuts?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Back streets mapped. Traffic
            avoided. You get savvy route planners.
          </>
        ),
      },
      {
        question: "What if I need a taxi during Manly Vale's peak hour?",
        answer: (
          <>
            We plan. Alternative routes are ready. Your pickup stays on time.
            Rush hour is handled professionally.
          </>
        ),
      },
      {
        question: "Can I request a female driver for Manly Vale trips?",
        answer: (
          <>
            Ask when booking. We accommodate when possible. Your comfort drives
            our service. Preferences noted.
          </>
        ),
      },
      {
        question: "Do you offer Manly Vale to North Sydney direct?",
        answer: (
          <>
            Yes. Direct business district runs. Fixed rates available. Avoid
            parking hassles. Arrive ready for meetings.
          </>
        ),
      },
      {
        question: "How do I arrange wheelchair transport in Manly Vale?",
        answer: (
          <>
            State needs when calling. Proper vehicle dispatched. Drivers assist
            carefully. Accessibility guaranteed with dignity.
          </>
        ),
      },
      {
        question: "Are your Manly Vale taxis suitable for elderly passengers?",
        answer: (
          <>
            Yes. Patient assistance. Comfortable seating. Step help provided.
            Regular medical trip bookings are warmly accepted.
          </>
        ),
      },
      {
        question: "Can I set up corporate accounts for Manly Vale travel?",
        answer: (
          <>
            Business accounts available. Monthly statements. Priority service.
            Expense management simplified. Professional standards maintained.
          </>
        ),
      },
      {
        question: "What makes you different from rideshare in Manly Vale?",
        answer: (
          <>
            Phone bookings accepted. Fixed pricing. Local knowledge. No surge
            charges. Personalised service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Manly Vale school transport services?",
        answer: (
          <>
            Yes. Regular student pickups. Safety seats fitted. Punctuality
            assured. Parents trust our reliable service.
          </>
        ),
      },
      {
        question: "How early should I book wedding cars for Manly Vale?",
        answer: (
          <>
            Secure months ahead for summer. Multiple vehicles coordinated. Your
            celebration transport is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Manly Vale airport runs?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options are provided.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed every time.
          </>
        ),
      },
      {
        question:
          "Do you service all Manly Vale streets including cul-de-sacs?",
        answer: (
          <>
            Yes. Every address found. Narrow streets navigated. Your location is
            reached without confusion or delay.
          </>
        ),
      },
    ],
  },
  "dee-why-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13269.49475506125!2d151.29102504999994!3d-33.75100814999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d55874e2bee61%3A0x5017d681632b440!2sDee%20Why%20NSW%202099%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774632276221!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Dee Why, NSW - 24/7 Corporate, Group Rides & Local",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Dee Why for corporate taxi, group travel & baby seat bookings. Fixed prices, on-time pickups & local expert drivers. Book today!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Dee Why for Every Need",
    heroDescription: (
      <>
        Hunting for solid wheels around Dee Why? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Dee Why pledge lightning-fast grabs each time you dial. We run your
        neighbourhood jaunts with razor-sharp timing that never slips. Our
        motors fit lone voyagers and massive packs equally. You cop heaps of
        cabin space for bodies and bags combined. Not one soul gets stranded or
        crammed inside. We roll day and night without stopping. Your aircraft
        might touch down at 3 AM. Your shift could wrap at sunrise. Whatever
        happens, we materialise pronto. Grab our top-tier choice for bonus
        relaxation. We pull off slick Dee Why pick up and drop off to guard your
        diary. You sidestep setbacks. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your agenda completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Dee Why NSW",
    locationSectionTitle: "Reliable Taxi Service in Dee Why for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere good? Our Dee Why Taxi Service fits
        tight and large crowds spot on. The whole bunch shares one wagon. You
        miss the nightmare of breaking into separate convoys. You kill messy
        planning attempts. Through our committed
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Dee Why,
        </Link>
        every punter scores a protected, cushy passage. Maybe you blast out of
        Dee Why toward Sydney Airport. Maybe you drag home after marathon
        journeys. We honour our word on clocks. Our pilots know clever back
        routes. They steer around bottlenecks. They shrink delays fast. You can
        bank on our Group Transport Dee Why picks when wanting stretch,
        faithfulness, and sparkling cabins. Locking in rides takes ticks via our
        web hub. You snag proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Dee Why with Maxi Cabs: Fast Local & Long Distance Ride",
    locationSection2Desctiption: (
      <>
        We reckon that budget must never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Dee Why shows honest fares with nothing hidden. You eyeball costs
        upfront. You map your spending with poise. This proves handy when
        trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>
        , taking stacks of riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        steerers bring know-how and manners. They back particular needs. They
        heft your suitcases. From crack-of-dawn flights to late returns, our
        24/7 Taxi Dee Why keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Dee Why",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Dee Why
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck squashed seating.
        You dodge tricky bag Jenga. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Dee Why lets your mob focus on the voyage.
        We zero in on batch transfers for clans, surf clubs, and office squads.
        The full gang lands united. Grabbing wheels happens swiftly through our
        Dee Why Cab Booking portal. You sort the movement beforehand. Corporate
        nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When poshness counts, our silver
        service dishes extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, guarded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Dee Why Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro mobility crafted squarely for Dee Why locals and blow-ins.
        Our broad spread hands you precisely what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding fleets
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Dee Why
        </Link>{" "}
        flaunting live plane tracking, Maxi Cab Services accommodating eleven
        occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and Local Taxi Service for daily missions.
        Trade heavyweights lean on our Corporate Taxi Service, while refinement
        chasers dig our Premium Service. We master Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Dee Why like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Dee Why for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Dee Why back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Dee Why",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Dee Why
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth hops between Dee Why and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for heftier crowds in Dee Why. Ample perch and baggage
            capacity keep tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Dee Why to Sydney Airport
            or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady round-the-clock option across Dee Why for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Dee Why reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Dee Why Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        highlights{" "}
        <Link
          to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
          target="_blank"
        >
          safety,
        </Link>
        stretch, and butter-smooth cruising. Lone trekkers find ideal matches.
        Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door{" "}
            <Link
              to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Taxi
            </Link>{" "}
            Service throughout Dee Why.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle: "Frequently Asked Questions About Taxi Service in Dee Why",
    faqs: [
      {
        question:
          "How do I get from Dee Why to Sydney Airport early in the morning?",
        answer: (
          <>
            Book ahead. We track flights live. Pickup adjusts for delays. You
            relax. We handle timing.
          </>
        ),
      },
      {
        question: "Can your taxis carry surfboards from Dee Why beaches?",
        answer: (
          <>
            Yes. Maxi cabs swallow long boards. Manly, Curl Curl, Freshwater
            trips. Surf gear fits easily.
          </>
        ),
      },
      {
        question: "Do you know shortcuts around Pittwater Road traffic?",
        answer: (
          <>
            Absolutely. Dee Why locals. Back streets mapped. Gridlock avoided.
            You get clever route planners.
          </>
        ),
      },
      {
        question: "What if my Dee Why flight lands at midnight?",
        answer: (
          <>
            We operate 24/7. Night arrivals welcome. The driver waits with a
            sign. Safe journey home guaranteed.
          </>
        ),
      },
      {
        question: "Can I book a taxi for Dee Why RSL club trips?",
        answer: (
          <>
            Yes. Regular club runs. Social events covered. Safe ride home. No
            parking worries.
          </>
        ),
      },
      {
        question: "How do I arrange a maxi cab for Dee Why shopping centres?",
        answer: (
          <>
            Ring 1300 450 428. Mention bulky items. We bring the right wagon.
            IKEA, Warringah Mall sorted.
          </>
        ),
      },
      {
        question:
          "Are your Dee Why drivers familiar with Brookvale and Narraweena?",
        answer: (
          <>
            Northern Beaches born and bred. Every suburb is known. Shortcuts
            found. You get local experts.
          </>
        ),
      },
      {
        question: "Can I request a baby seat for Dee Why childcare runs?",
        answer: (
          <>
            Mention age when booking. Correct restraint fitted. Safety checked.
            Your child is protected.
          </>
        ),
      },
      {
        question: "Do you offer set prices for Dee Why corporate travel?",
        answer: (
          <>
            Business accounts available. Fixed rates. Monthly billing. Expense
            reports simplified. Professional service.
          </>
        ),
      },
      {
        question: "What makes you better than Uber in Dee Why?",
        answer: (
          <>
            Phone bookings. No surge pricing. Local knowledge. Personal service.
            We know your area.
          </>
        ),
      },
      {
        question: "Can I get a wheelchair taxi in Dee Why urgently?",
        answer: (
          <>
            Call and state needs. Proper vehicle sent. Skippers assist with
            boarding. Dignity is maintained always.
          </>
        ),
      },
      {
        question: "Do you service Dee Why lagoon and beachfront addresses?",
        answer: (
          <>
            Yes. All locations found. Narrow streets navigated. Your pickup
            happens without confusion.
          </>
        ),
      },
      {
        question: "How early should I book wedding cars for Dee Why?",
        answer: (
          <>
            Secure months ahead. Spring weddings busy. Multiple vehicles
            coordinated. Your day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay cash for Dee Why airport trips?",
        answer: (
          <>
            Cash welcome. Cards accepted. CabCharge available. Corporate
            accounts, too. Flexible options.
          </>
        ),
      },
      {
        question: "What happens if I cancel my Dee Why booking?",
        answer: (
          <>
            Call us ASAP. Fair policy applies. No charge for notice. We
            understand plans shift.
          </>
        ),
      },
    ],
  },

  "brookvale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13267.686647193257!2d151.26933269999998!3d-33.76269015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12aa60c415d069%3A0x5017d681632ae70!2sBrookvale%20NSW%202100%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774632585935!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Brookvale, NSW -  24/7 Local, Airport & Wedding Transport",
    metaDescription:
      "Choose Taxi & Maxi Cabs Services in Brookvale for airport transfers, wedding transport & wheelchair accessible rides. 24/7 service, fixed fares. Call us now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Brookvale for All Travel Needs",
    heroDescription: (
      <>
        Need dependable wheels around Brookvale? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Brookvale promise rapid grabs every time you dial. We run your
        neighbourhood trips with clockwork accuracy that never slips. Our
        vehicles suit lone rangers and massive crews equally. You can pack loads
        of cabin space for bodies and bags together. Not one person gets left
        out or jammed inside. We roll day and night without stopping. Your jet
        might touch down at midnight. Your function could wrap at sunrise.
        Whatever happens, we materialise pronto. Grab our top-shelf choice for
        bonus relaxation. We pull off a slick Brookvale pick up and drop off to
        guard your diary. You sidestep setbacks. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your agenda completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Brookvale NSW",
    locationSectionTitle: "Reliable Taxi Service in Brookvale for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere flash? Our Brookvale Taxi Service fits
        tiny and bulky groups spot on. The whole lot shares one wagon. You miss
        the headache of fracturing into different motors. You wipe out tricky
        planning efforts. Through our devoted
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Brookvale,
        </Link>
        every punter scores guarded, cushy passage. Maybe you blast out of
        Brookvale toward Sydney Airport. Maybe you drag home after marathon
        journeys. We honour our word on clocks. Our captains know clever back
        routes. They steer around bottlenecks. They shrink delays fast. You can
        bank on our Group Transport Brookvale selections when wanting stretch,
        faithfulness, and sparkling cabins. Locking in rides takes ticks via our
        web hub. You snag proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Brookvale with Maxi Cabs: Fast Local & Long Distance Ride",
    locationSection2Desctiption: (
      <>
        We reckon that low cost ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Brookvale shows honest fares with zero secrets tucked away. You
        eyeball costs upfront. You map your spending with poise. This proves
        handy when trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        taking stacks of riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may holler for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your ankle-biters ride in ticked-off, locked-down harnesses. Our
        steerers bring know-how and manners. They back particular needs. They
        heft your suitcases. From crack-of-dawn flights to late returns, our
        24/7 Taxi Brookvale keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Brookvale",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Brookvale
        </Link>{" "}
        hands you a sprawling stretch room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Brookvale lets your mob focus on the
        voyage. We zero in on batch transfers for clans, footy squads, and
        office units. The full gang lands united. Grabbing wheels happens
        swiftly through our Brookvale Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with little ones. When poshness counts, our silver
        service dishes extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Brookvale Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find pro transport made for Brookvale locals and visitors. Our full
        range of services gives just what you need, whether you're catching a
        dawn flight or sorting
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for heaps of guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Brookvale
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting eleven people,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        picks with safe clips, and Local Taxi Service for daily jobs. Business
        pros use our Corporate Taxi Service, while luxury hunters pick our
        Premium Service. We do Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for big crowds, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        help. Every trip has clear upfront costs, real 24/7 service, and smart
        local drivers who know Brookvale well. From Door-to-Door Taxi Service to
        tricky plans, Campbelltown Taxi & Maxi Cabs blends deep local know-how
        with steady reliability—because your destination matters, and getting
        there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Brookvale for Every Occasion",
    serviceSubtitle: (
      <>
        We shape transport to match your exact needs. Our Taxi & Maxi Cabs
        Services in Brookvale help family breaks, group trips, and work travel.{" "}
        <Link
          to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
          target="_blank"
        >
          Safety
        </Link>{" "}
        and being on time guide all we do. Every car looks good. Every driver
        trains well. You count on us for airport runs, special days, and
        business trips. Each ride stays simple and calm.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Brookvale",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Brookvale
        </Link>
        makes every trip simple and accountable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, ideal for corporate
        travellers and authorised riders. Enjoy cashless processing, clear trip
        records, and smooth billing with every ride. Reliable transport backed
        by trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in big cars. Bridal parties, family, and friends enjoy nice,
            comfy trips to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury choice for VIP moves, boss travel, and guests
            wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with safe child seats. Young ones stay secure all
            the way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group work trips. On-time pickups help busy
            days.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth trips between Brookvale and cruise docks. Big space
            fits people and bags together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for shows, parties, and social events. Get there on
            time. Skip parking stress.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Great for bigger groups in Brookvale. Lots of seats and bag space
            keep all together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-run moves from Brookvale to Sydney Airport or work spots.
            Your team travels with no stress.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady 24/7 choice across Brookvale for daily trips, bookings, and
            fun out.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Brookvale Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from mixed cars to match your group size and comfort needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        puts safety, space, and soft rides first. Solo riders find good fits.
        Full groups get the right choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Good for lone riders or pairs wanting quiet, soft trips with our
            steady Door-to-Door Taxi Service all through Brookvale.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who like privacy, soft leather
            seats, and sharp looks on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More room for people and bags. Top choice for families or small
            groups heading to Sydney Airport in comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers nicely. Big bag space suits group moves, family
            holidays, and long hauls.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for larger groups or big families wanting spacious, clean
            interiors and a totally chilled travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Delivers accessible transport with fully trained drivers and proper
            safety gear for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Brookvale",
    faqs: [
      {
        question: "How do I reach Sydney Airport from the industrial area?",
        answer: (
          <>
            Our Airport Transfers in Brookvale navigate the Warringah Mall
            bypass efficiently. We pick up from factories and warehouses.
            Typically 35 minutes to domestic terminals.
          </>
        ),
      },
      {
        question: "Can your maxi cabs transport my trade tools and materials?",
        answer: (
          <>
            Our{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            Cab Services in Brookvale accommodate bulky equipment. Utes and
            wagons available. We service tradespeople across the Northern
            Beaches daily.
          </>
        ),
      },
      {
        question: "Do you operate during Warringah Mall trading hours?",
        answer: (
          <>
            Yes. Our 24/7 Taxi Brookvale runs constantly. We know loading dock
            locations and pickup zones. Shop without parking stress.
          </>
        ),
      },
      {
        question: "What's the best way to transport my team to a conference?",
        answer: (
          <>
            Our Corporate Taxi Service coordinates multiple Maxi Cab for Group
            Travel vehicles. We manage business teams to CBD meetings and
            airport departures seamlessly.
          </>
        ),
      },
      {
        question: "Can I book wheelchair transport for medical appointments?",
        answer: (
          <>
            Absolutely. Our Wheelchair Accessible Taxi in Brookvale provides
            dignified, reliable healthcare transport. We accommodate mobility
            scooters and walking frames with care.
          </>
        ),
      },
      {
        question: "How do I organize transport for my child's sports team?",
        answer: (
          <>
            Our Group Transport Brookvale safely conveys junior teams to away
            games. Parents receive driver details. We ensure punctual, secure
            travel for young athletes.
          </>
        ),
      },
      {
        question: "What happens if my flight is delayed?",
        answer: (
          <>
            We track arrivals live. Your Emergency Taxi in Brookvale waits
            without extra charges for reasonable delays. Call us if plans change
            significantly.
          </>
        ),
      },
      {
        question: "Do you offer account facilities for local businesses?",
        answer: (
          <>
            Yes. Our Corporate Taxi Service provides Brookvale enterprises with
            monthly billing and priority access. Simplify your company travel
            management.
          </>
        ),
      },
      {
        question: "Can I transport my motorcycle to the mechanic?",
        answer: (
          <>
            Our specialized vehicles accommodate bikes securely. Mention
            transport needs when using Brookvale Cab. We handle delicate cargo
            with expertise.
          </>
        ),
      },
      {
        question: "Why trust local taxis in an industrial zone?",
        answer: (
          <>
            We know Brookvale's factory addresses, loading restrictions, and
            business hours. Apps often cancel industrial pickups. We show
            up—guaranteed.
          </>
        ),
      },
    ],
  },
  "curl-curl-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13266.522159492964!2d151.28905399999996!3d-33.77021189999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12aaf2371204c5%3A0x5017d681632b3a0!2sCurl%20Curl%20NSW%202096%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774633275043!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Curl Curl, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Curl Curl for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Curl Curl for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Curl Curl? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Curl Curl deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed
        inside. We run day and night without stopping. Your flight might land at
        2 AM. Your shift could end at sunrise. Either way, we show up fast.
        Choose our luxury option for extra comfort. We manage smooth Curl Curl
        pick up and drop off to keep your schedule on track. You avoid delays.
        You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Curl Curl NSW",
    locationSectionTitle: "Reliable Taxi Service in Curl Curl for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Curl Curl Taxi Service
        suits small and large groups perfectly. Everyone travels together in one
        car. You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Curl Curl,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Curl Curl
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Curl Curl with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Curl Curl offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade
        to our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Curl Curl keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Curl Curl",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Curl Curl
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Curl Curl lets your group focus on the journey. We
        specialise in group transfers for families, sports teams, and work
        groups. Everyone arrives together. Booking is fast through our Curl Curl
        Cab Booking page. You arrange transport early. Business travellers can
        use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly.
        We keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Curl Curl Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Curl Curl residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Curl Curl
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Curl Curl well.
        From Door-to-Door Taxi Service to complex plans, Campbelltown Taxi &
        Maxi Cabs combines deep local knowledge with steady reliability—because
        your destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Curl Curl for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Curl Curl support family holidays, group outings, and business
        travel. Safety and punctuality guide everything we do. Every vehicle
        looks neat. Every driver trains well. You depend on us for airport
        trips, special events, and work journeys. Each ride stays simple and
        relaxed.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Curl Curl",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Curl Curl
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests
            enjoy nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Curl Curl and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Curl Curl. Roomy seating and luggage
            space keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Curl Curl to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Curl Curl for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Curl Curl responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Curl Curl Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable
            trips with our reliable Door-to-Door Taxi Service throughout Curl
            Curl.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality
            leather seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Curl Curl",
    faqs: [
      {
        question: "Which coastal spots near Curl Curl do you cover?",
        answer: (
          <>
            We service Curl Curl Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Curl Curl to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Curl Curl surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question:
          "What if I need a taxi for the Curl Curl dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Curl Curl trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Curl Curl Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Curl Curl taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Curl Curl business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Curl Curl?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Curl Curl to Palm Beach direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question:
          "How early should I book wedding cars for Curl Curl ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Curl Curl airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question:
          "Do you service all Curl Curl streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
  "freshwater-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13265.619742028272!2d151.28490449999998!3d-33.77603985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12aa4fa9d99673%3A0x5017d681632b9a0!2sFreshwater%20NSW%202096%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774634015107!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Freshwater, NSW - Group & Corporate Transfers",
    metaDescription:
      "Need a ride in Freshwater? Our Taxi & Maxi Cabs Services cover group travel, corporate taxi & emergency rides. Local drivers, clean cabs & 24/7 service. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Freshwater - Your 24-Hour Transport Partner",
    heroDescription: (
      <>
        After solid transport around Freshwater? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Freshwater promise a rapid response every time you dial. We run your
        neighbourhood trips with clockwork precision that never slips. Our cars
        fit lone commuters and huge crowds equally well. You gain generous cabin
        space for riders and gear combined. Nobody gets stranded or jammed
        inside. We operate non-stop every single day. Your plane might touch
        down at midnight. Your function could finish at dawn. Either way, we
        appear promptly. Select our elite tier for added comfort. We execute
        flawless Freshwater pick up and drop off to protect your schedule. You
        avoid hold-ups. You shed anxiety.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your timetable always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Freshwater NSW",
    locationSectionTitle:
      "Reliable Taxi Service in Freshwater for Large Groups",
    locationSectionDescription: (
      <>
        Carting family or mates somewhere special? Our Freshwater Taxi Service
        accommodates intimate and sprawling groups perfectly. Everyone shares
        one vehicle. You dodge the chaos of splitting into different cars. You
        erase messy coordination efforts. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Freshwater,
        </Link>
        each guest enjoys safe, cosy travel. Perhaps you depart Freshwater bound
        for Sydney Airport. Perhaps you head homeward after long voyages. We
        honour our timing commitments. Our drivers know smart shortcuts. They
        bypass traffic snarls. They cut delays short. You can trust our Group
        Transport Freshwater options when needing space, dependability, and
        spotless interiors. Booking takes moments via our online portal. You
        receive confirmation fast. You ride with peace of mind.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Freshwater with Best Maxi Cabs for Group Travel",
    locationSection2Desctiption: (
      <>
        We reckon that low cost ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Freshwater shows honest fares with nothing hidden. You view costs
        upfront. You arrange your dollars with confidence. This proves valuable
        when trekking with others. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        hauling multiple riders plus loads. Fancy something classier? Upgrade to
        our silver service for refined motoring. Households may request
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your little ones travel in certified, properly fitted
        restraints. Our operators bring know-how and courtesy. They assist with
        particular needs. They lug your suitcases. From crack-of-dawn flights to
        late returns, our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          24/7 Taxi
        </Link>{" "}
        Freshwater keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate Travel & Baby Seat Taxi Booking in Freshwater, NSW",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Freshwater
        </Link>{" "}
        offers you a sprawling stretch of room. You claim ample stowage volume.
        You unwind despite packed cabins. You duck compressed seating. You miss
        awkward bag arrangements. Your trek grows pleasant. Snapping up our Taxi
        & Maxi Cabs Services in Freshwater lets your tribe focus on the voyage.
        We zero in on batch transfers for clans, sporting clubs, and office
        units. The whole gang lands together. Grabbing wheels happens swiftly
        through our Freshwater Cab Booking site. You sort movement ahead of
        time. Corporate roadies can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with youngsters. When elegance counts, our silver
        service dishes extra cushiness. Every rig gets scrubbed routinely. We
        enforce strict benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Freshwater Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro mobility crafted squarely for Freshwater locals and
        visitors. Our broad range hands you precisely what you crave, whether
        snagging red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Freshwater
        </Link>{" "}
        flaunting live plane tracking, Maxi Cab Services accommodating eleven
        occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved harnesses, and Local Taxi Service for daily
        missions. Trade heavyweights lean on our Corporate Taxi Service, while
        refinement chasers dig our Premium Service. We master Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional pilots who read Freshwater like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like drifting on
        clouds.
      </>
    ),
    locationSectionImg: corporateTripsImg,

    serviceTitle: "Taxi and Maxi Cab Solutions Freshwater for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our Taxi & Maxi Cabs
        Services in Freshwater back clan getaways, mob adventures, and corporate
        travel. Protection and promptness pilot our operation. Every wagon looks
        schmick. Every captain trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Freshwater",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Freshwater
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, crisp trip logs, and
        painless billing for each run. Faithful hauling backed by proven
        Cabcharge payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, comfy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth hops between Freshwater and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for heftier crowds in Freshwater. Ample perch and baggage
            capacity keep tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Freshwater to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady round-the-clock option across Freshwater for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Freshwater reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
    fleetSectionTitle: "Premium Fleet for Your Freshwater Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable
            trips with our reliable Door-to-Door Taxi Service throughout
            Freshwater.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality
            leather seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Freshwater",
    faqs: [
      {
        question: "Which coastal spots near Freshwater do you cover?",
        answer: (
          <>
            We service Freshwater Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Freshwater to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Freshwater surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question:
          "What if I need a taxi for the Freshwater dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Freshwater trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Freshwater Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Freshwater taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question:
          "Can I set up account billing for Freshwater business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Freshwater?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Freshwater to Palm Beach direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question:
          "How early should I book wedding cars for Freshwater ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Freshwater airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question:
          "Do you service all Freshwater streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
  "narrabeen-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52763.37742545782!2d151.2968524!3d-33.71291505!2m3!1f0!2f2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ab5e5cbb3f1f%3A0x40609b49043b640!2sNarrabeen%20NSW%202101%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774628250468!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Narrabeen, NSW - 24/7 Airport & Cruise Rides",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Narrabeen for airport transfers, cruise trips, group travel & baby seat bookings. Fixed fares, local drivers & 24/7 service.",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Narrabeen - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Narrabeen? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Narrabeen ensure speedy collections whenever you ring. We manage your
        area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Narrabeen pick up and drop off to guard your diary. You miss setbacks.
        You lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Narrabeen NSW",
    locationSectionTitle: "Reliable Taxi Service in Narrabeen for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Narrabeen Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Narrabeen,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Narrabeen
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Narrabeen selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Narrabeen with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Narrabeen displays reasonable charges with complete openness. You
        view prices beforehand. You arrange your money with certainty. This aids
        when moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Narrabeen maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Narrabeen",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Narrabeen
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Narrabeen allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Narrabeen Cab Booking
        site. You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Narrabeen Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Narrabeen locals and guests.
        Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Narrabeen
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Narrabeen
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Narrabeen for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Narrabeen assist family breaks, crowd adventures, and
        company trips. Security and timeliness steer our tasks. Every machine
        appears orderly. Every guide prepares extensively. You lean on us for
        terminal journeys, notable celebrations, and work ventures. Each passage
        stays plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Narrabeen",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Narrabeen
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Narrabeen and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Narrabeen. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Narrabeen to Sydney Airport
            or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Narrabeen for normal journeys,
            engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Narrabeen answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Narrabeen Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Narrabeen.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Narrabeen",
    faqs: [
      {
        question: "Which spots near Narrabeen do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Narrabeen caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Narrabeen seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question: "Can I book recurring trips for Narrabeen dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question: "How do I request vehicles for Narrabeen surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Narrabeen taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Narrabeen sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Narrabeen driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Narrabeen to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Narrabeen taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "warriewood-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26558.0424956684!2d151.27655248402925!3d-33.689399482454924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d54ec7dca3b07%3A0x5017d681632ceb0!2sWarriewood%20NSW%202102%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774635993318!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Warriewood, NSW - Baby Seat & Family Rides",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Warriewood for family travel, baby seat taxi & group rides. On-time pickups, transparent pricing & expert local drivers. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Warriewood for Reliable Rides",
    heroDescription: (
      <>
        Chasing a lift around Warriewood? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Warriewood answer fast when you ring. We move locals with clockwork
        timing that never slips. Our fleet suits one person or big crowds
        equally. You score heaps of space for mates and gear together. Nobody
        gets stuck outside or squashed inside. We roll all hours, every day.
        Planes land at midnight. Jobs finish at dawn. We still reach you quick.
        Pick our fancy grade for extra ease. We handle slick Warriewood pick up
        and drop off to save your diary. You dodge slowdowns. You drop the
        worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your plans completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Warriewood NSW",
    locationSectionTitle: "Reliable Taxi Service in Warriewood for Groups",
    locationSectionDescription: (
      <>
        Shifting relatives or crew somewhere good? Our Warriewood Taxi Service
        fits tiny and huge mobs spot on. The whole lot packs into one wagon. You
        skip the pain of splitting into different motors. You kill a messy
        organisation. Through our set
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Warriewood,
        </Link>
        every punter gains safe, cushy passage. Perhaps you blast out of
        Warriewood toward Sydney Airport. Perhaps you drag home after long
        hauls. We keep our word on clocks. Our drivers know sneaky detours. They
        skirt gridlock. They squash delays. You can bank on our Group Transport
        Warriewood picks when wanting stretch, faith, and sparkling cabins.
        Locking in rides takes ticks via our web hub. You snag proof instantly.
        You float with assurance.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Warriewood with Affordable Maxi Cab & Fast Airport Rides",
    locationSection2Desctiption: (
      <>
        That cheap ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Warriewood shows honest charges with nothing hidden. You eyeball
        costs upfront. You map your spending with poise. This proves gold when
        trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        hauling stacks of riders plus loads. Fancy something posher? Bump up to
        our silver grade for polished trips. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        wheelmen bring wisdom and manners. They back particular needs. They heft
        your suitcases. From crack-of-dawn flights to late returns, our 24/7
        Taxi Warriewood keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Warriewood",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Warriewood
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Warriewood lets your mob focus on the
        voyage. We zero in on batch transfers for clans, surf clubs, and office
        squads. The full gang lands united. Grabbing wheels happens swiftly
        through our Warriewood Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When class counts, our silver
        grade dishes have extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Warriewood Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro hauling crafted squarely for Warriewood locals and blow-ins.
        Our broad spread hands you precisely what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Warriewood
        </Link>
        , flaunting live plane tracking,
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services
        </Link>{" "}
        accommodating eleven occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>{" "}
        for daily missions. Trade heavyweights lean on our Corporate Taxi
        Service, while refinement chasers dig our Premium Service. We master
        Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Warriewood like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Warriewood for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Warriewood back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Warriewood",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Warriewood
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transport",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Premium Service",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Taxi Service",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Transfers",
        description: (
          <>
            Enjoy smooth hops between Warriewood and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transport",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Cab Services",
        description: (
          <>
            Perfect for heftier crowds in Warriewood. Ample perch and baggage
            capacity keeps tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Warriewood to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Steady round-the-clock option across Warriewood for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi in Warriewood",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Warriewood reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Warriewood Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our garage
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Warriewood.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "SUV or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Accessible Taxi in Warriewood",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Warriewood",
    faqs: [
      {
        question: "Which Warriewood retail spots do you service?",
        answer: (
          <>
            We reach Warriewood Square. Garden centres nearby. Bunnings trips
            are common. Shopping transport easy.
          </>
        ),
      },
      {
        question: "How do I reach Mona Vale Hospital from Warriewood?",
        answer: (
          <>
            Direct routes available. Medical priority given. Patient comfort is
            considered. Regular health trips are welcome.
          </>
        ),
      },
      {
        question: "Can I book transport for Warriewood BMX track events?",
        answer: (
          <>
            Yes. Gear and bikes are carried. Youth groups accommodated. Early
            morning starts are arranged. Sports specialists.
          </>
        ),
      },
      {
        question: "Do you know the Warriewood Valley back streets?",
        answer: (
          <>
            Absolutely. Valley roads mastered. Shortcuts found. Traffic avoided.
            Local knowledge guaranteed.
          </>
        ),
      },
      {
        question: "What makes Warriewood different from Narrabeen?",
        answer: (
          <>
            The valley setting is unique. Shopping hub central. Quieter
            residential feel. We understand the area.
          </>
        ),
      },
      {
        question: "Can I get a taxi from Warriewood to Terrey Hills?",
        answer: (
          <>
            Yes. Inland connections available. Rural route knowledge. Fixed
            prices offered. Explore comfortably.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport with bulky items from homemaker stores?",
        answer: (
          <>
            Mention size when booking. We send right wagon. Loading help
            provided. Big items sorted.
          </>
        ),
      },
      {
        question:
          "Are your Warriewood taxis suitable for seniors with walkers?",
        answer: (
          <>
            Patient assistance given. Time provided. Comfortable entry. Regular
            medical trips are supported.
          </>
        ),
      },
      {
        question: "Do you service Warriewood late at night?",
        answer: (
          <>
            24/7 operation. Night pickups normal. Safe return guaranteed. Valley
            streets navigated easily.
          </>
        ),
      },
      {
        question:
          "Can I request a specific vehicle type for Warriewood airport runs?",
        answer: (
          <>
            Ask when booking. Preferences noted. Sedan or maxi arranged. Your
            choice matters.
          </>
        ),
      },
      {
        question:
          "How early should I secure wedding transport from Warriewood?",
        answer: (
          <>
            Book months ahead. Spring dates are busy. Multiple cars coordinated.
            Your celebration is covered.
          </>
        ),
      },
      {
        question: "Do you provide Warriewood to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney link. Express option available. Commuter
            bookings accepted. Reliable daily.
          </>
        ),
      },
      {
        question: "Can I bring my dog to Warriewood vet appointments?",
        answer: (
          <>
            Small pets in carriers are welcome. Service animals exempt. Mention
            when booking. We prepare.
          </>
        ),
      },
      {
        question: "What happens if Sydney Airport flights change suddenly?",
        answer: (
          <>
            We track live updates.{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Driver
            </Link>{" "}
            adjusts. No extra charges. Seamless pickup maintained.
          </>
        ),
      },
      {
        question:
          "Do you cover all Warriewood addresses, including cul-de-sacs?",
        answer: (
          <>
            Every street is found. Dead ends navigated. Your location reached.
            No confusion.
          </>
        ),
      },
    ],
  },
  "mona-vale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26561.859200764364!2d151.30090155!3d-33.67704605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d54977b5e3239%3A0x5017d681632c190!2sMona%20Vale%20NSW%202103%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774719708388!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Mona Vale, NSW - Baby Seat & Family Rides",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Mona Vale for family travel, baby seat taxi & group rides. On-time pickups, transparent pricing & expert local drivers. Call now!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Mona Vale for Reliable Rides",
    heroDescription: (
      <>
        Chasing a lift around Mona Vale? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Mona Vale answer fast when you ring. We move locals with clockwork
        timing that never slips. Our fleet suits one person or big crowds
        equally. You score heaps of space for mates and gear together. Nobody
        gets stuck outside or squashed inside. We roll all hours, every day.
        Planes land at midnight. Jobs finish at dawn. We still reach you quick.
        Pick our fancy grade for extra ease. We handle slick Mona Vale pick up
        and drop off to save your diary. You dodge slowdowns. You drop the
        worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your plans completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Mona Vale NSW",
    locationSectionTitle: "Reliable Taxi Service in Mona Vale for Groups",
    locationSectionDescription: (
      <>
        Shifting relatives or crew somewhere good? Our Mona Vale Taxi Service
        fits tiny and huge mobs spot on. The whole lot packs into one wagon. You
        skip the pain of splitting into different motors. You kill a messy
        organisation. Through our set
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Mona Vale,
        </Link>
        every punter gains safe, cushy passage. Perhaps you blast out of Mona
        Vale toward Sydney Airport. Perhaps you drag home after long hauls. We
        keep our word on clocks. Our drivers know sneaky detours. They skirt
        gridlock. They squash delays. You can bank on our Group Transport Mona
        Vale picks when wanting stretch, faith, and sparkling cabins. Locking in
        rides takes ticks via our web hub. You snag proof instantly. You float
        with assurance.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Mona Vale with Affordable Maxi Cab & Fast Airport Rides",
    locationSection2Desctiption: (
      <>
        That cheap ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Mona Vale shows honest charges with nothing hidden. You eyeball costs
        upfront. You map your spending with poise. This proves gold when
        trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        hauling stacks of riders plus loads. Fancy something posher? Bump up to
        our silver grade for polished trips. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        wheelmen bring wisdom and manners. They back particular needs. They heft
        your suitcases. From crack-of-dawn flights to late returns, our 24/7
        Taxi Mona Vale keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Mona Vale",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Mona Vale
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Mona Vale lets your mob focus on the
        voyage. We zero in on batch transfers for clans, surf clubs, and office
        squads. The full gang lands united. Grabbing wheels happens swiftly
        through our Mona Vale Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When class counts, our silver
        grade dishes have extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Mona Vale Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro hauling crafted squarely for Mona Vale locals and blow-ins.
        Our broad spread hands you precisely what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Mona Vale
        </Link>
        , flaunting live plane tracking,
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services
        </Link>{" "}
        accommodating eleven occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>{" "}
        for daily missions. Trade heavyweights lean on our Corporate Taxi
        Service, while refinement chasers dig our Premium Service. We master
        Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Mona Vale like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Mona Vale for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Mona Vale back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Mona Vale",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Mona Vale
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transport",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Premium Service",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Taxi Service",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Transfers",
        description: (
          <>
            Enjoy smooth hops between Mona Vale and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transport",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Cab Services",
        description: (
          <>
            Perfect for heftier crowds in Mona Vale. Ample perch and baggage
            capacity keeps tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Mona Vale to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Steady round-the-clock option across Mona Vale for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi in Mona Vale",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Mona Vale reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Mona Vale Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our garage
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Mona Vale.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "SUV or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Accessible Taxi in Mona Vale",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Mona Vale",
    faqs: [
      {
        question: "Which Mona Vale retail spots do you service?",
        answer: (
          <>
            We reach Mona Vale Square. Garden centres nearby. Bunnings trips are
            common. Shopping transport easy.
          </>
        ),
      },
      {
        question: "How do I reach Mona Vale Hospital from Mona Vale?",
        answer: (
          <>
            Direct routes available. Medical priority given. Patient comfort is
            considered. Regular health trips are welcome.
          </>
        ),
      },
      {
        question: "Can I book transport for Mona Vale BMX track events?",
        answer: (
          <>
            Yes. Gear and bikes are carried. Youth groups accommodated. Early
            morning starts are arranged. Sports specialists.
          </>
        ),
      },
      {
        question: "Do you know the Mona Vale Valley back streets?",
        answer: (
          <>
            Absolutely. Valley roads mastered. Shortcuts found. Traffic avoided.
            Local knowledge guaranteed.
          </>
        ),
      },
      {
        question: "What makes Mona Vale different from Narrabeen?",
        answer: (
          <>
            The valley setting is unique. Shopping hub central. Quieter
            residential feel. We understand the area.
          </>
        ),
      },
      {
        question: "Can I get a taxi from Mona Vale to Terrey Hills?",
        answer: (
          <>
            Yes. Inland connections available. Rural route knowledge. Fixed
            prices offered. Explore comfortably.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport with bulky items from homemaker stores?",
        answer: (
          <>
            Mention size when booking. We send right wagon. Loading help
            provided. Big items sorted.
          </>
        ),
      },
      {
        question: "Are your Mona Vale taxis suitable for seniors with walkers?",
        answer: (
          <>
            Patient assistance given. Time provided. Comfortable entry. Regular
            medical trips are supported.
          </>
        ),
      },
      {
        question: "Do you service Mona Vale late at night?",
        answer: (
          <>
            24/7 operation. Night pickups normal. Safe return guaranteed. Valley
            streets navigated easily.
          </>
        ),
      },
      {
        question:
          "Can I request a specific vehicle type for Mona Vale airport runs?",
        answer: (
          <>
            Ask when booking. Preferences noted. Sedan or maxi arranged. Your
            choice matters.
          </>
        ),
      },
      {
        question: "How early should I secure wedding transport from Mona Vale?",
        answer: (
          <>
            Book months ahead. Spring dates are busy. Multiple cars coordinated.
            Your celebration is covered.
          </>
        ),
      },
      {
        question: "Do you provide Mona Vale to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney link. Express option available. Commuter
            bookings accepted. Reliable daily.
          </>
        ),
      },
      {
        question: "Can I bring my dog to Mona Vale vet appointments?",
        answer: (
          <>
            Small pets in carriers are welcome. Service animals exempt. Mention
            when booking. We prepare.
          </>
        ),
      },
      {
        question: "What happens if Sydney Airport flights change suddenly?",
        answer: (
          <>
            We track live updates.{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Driver
            </Link>{" "}
            adjusts. No extra charges. Seamless pickup maintained.
          </>
        ),
      },
      {
        question:
          "Do you cover all Mona Vale addresses, including cul-de-sacs?",
        answer: (
          <>
            Every street is found. Dead ends navigated. Your location reached.
            No confusion.
          </>
        ),
      },
    ],
  },
  "avalon-beach-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26576.777860802653!2d151.32770035000001!3d-33.628720799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b72ad32d4410349%3A0x5017d681632ac40!2sAvalon%20Beach%20NSW%202107%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774719852461!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Avalon Beach, NSW - Baby Seat & Family Rides",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Avalon Beach for family travel, baby seat taxi & group rides. On-time pickups, transparent pricing & expert local drivers. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Avalon Beach for Reliable Rides",
    heroDescription: (
      <>
        Chasing a lift around Avalon Beach? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Avalon Beach answer fast when you ring. We move locals with clockwork
        timing that never slips. Our fleet suits one person or big crowds
        equally. You score heaps of space for mates and gear together. Nobody
        gets stuck outside or squashed inside. We roll all hours, every day.
        Planes land at midnight. Jobs finish at dawn. We still reach you quick.
        Pick our fancy grade for extra ease. We handle slick Avalon Beach pick
        up and drop off to save your diary. You dodge slowdowns. You drop the
        worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your plans completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Avalon Beach NSW",
    locationSectionTitle: "Reliable Taxi Service in Avalon Beach for Groups",
    locationSectionDescription: (
      <>
        Shifting relatives or crew somewhere good? Our Avalon Beach Taxi Service
        fits tiny and huge mobs spot on. The whole lot packs into one wagon. You
        skip the pain of splitting into different motors. You kill a messy
        organisation. Through our set
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Avalon Beach,
        </Link>
        every punter gains safe, cushy passage. Perhaps you blast out of Avalon
        Beach toward Sydney Airport. Perhaps you drag home after long hauls. We
        keep our word on clocks. Our drivers know sneaky detours. They skirt
        gridlock. They squash delays. You can bank on our Group Transport Avalon
        Beach picks when wanting stretch, faith, and sparkling cabins. Locking
        in rides takes ticks via our web hub. You snag proof instantly. You
        float with assurance.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Avalon Beach with Affordable Maxi Cab & Fast Airport Rides",
    locationSection2Desctiption: (
      <>
        That cheap ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Avalon Beach shows honest charges with nothing hidden. You eyeball
        costs upfront. You map your spending with poise. This proves gold when
        trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        hauling stacks of riders plus loads. Fancy something posher? Bump up to
        our silver grade for polished trips. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        wheelmen bring wisdom and manners. They back particular needs. They heft
        your suitcases. From crack-of-dawn flights to late returns, our 24/7
        Taxi Avalon Beach keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Avalon Beach",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Avalon Beach
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Avalon Beach lets your mob focus on the
        voyage. We zero in on batch transfers for clans, surf clubs, and office
        squads. The full gang lands united. Grabbing wheels happens swiftly
        through our Avalon Beach Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When class counts, our silver
        grade dishes have extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Avalon Beach Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro hauling crafted squarely for Avalon Beach locals and
        blow-ins. Our broad spread hands you precisely what you crave, whether
        snagging red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Avalon Beach
        </Link>
        , flaunting live plane tracking,
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services
        </Link>{" "}
        accommodating eleven occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>{" "}
        for daily missions. Trade heavyweights lean on our Corporate Taxi
        Service, while refinement chasers dig our Premium Service. We master
        Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Avalon Beach like a
        book. From Door-to-Door Taxi Service to tangled logistics, Campbelltown
        Taxi & Maxi Cabs merges deep turf smarts with rock-steady
        consistency—because your finish line counts, and arriving there should
        feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Avalon Beach for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Avalon Beach back clan getaways, mob adventures, and corporate
        travel. Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Avalon Beach",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Avalon Beach
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transport",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Premium Service",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Taxi Service",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Transfers",
        description: (
          <>
            Enjoy smooth hops between Avalon Beach and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transport",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Cab Services",
        description: (
          <>
            Perfect for heftier crowds in Avalon Beach. Ample perch and baggage
            capacity keeps tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Avalon Beach to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Steady round-the-clock option across Avalon Beach for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi in Avalon Beach",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Avalon Beach reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Avalon Beach Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our garage
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Avalon Beach.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "SUV or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Accessible Taxi in Avalon Beach",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Avalon Beach",
    faqs: [
      {
        question: "Which Avalon Beach retail spots do you service?",
        answer: (
          <>
            We reach Avalon Beach Square. Garden centres nearby. Bunnings trips
            are common. Shopping transport easy.
          </>
        ),
      },
      {
        question: "How do I reach Avalon Beach Hospital from Avalon Beach?",
        answer: (
          <>
            Direct routes available. Medical priority given. Patient comfort is
            considered. Regular health trips are welcome.
          </>
        ),
      },
      {
        question: "Can I book transport for Avalon Beach BMX track events?",
        answer: (
          <>
            Yes. Gear and bikes are carried. Youth groups accommodated. Early
            morning starts are arranged. Sports specialists.
          </>
        ),
      },
      {
        question: "Do you know the Avalon Beach Valley back streets?",
        answer: (
          <>
            Absolutely. Valley roads mastered. Shortcuts found. Traffic avoided.
            Local knowledge guaranteed.
          </>
        ),
      },
      {
        question: "What makes Avalon Beach different from Narrabeen?",
        answer: (
          <>
            The valley setting is unique. Shopping hub central. Quieter
            residential feel. We understand the area.
          </>
        ),
      },
      {
        question: "Can I get a taxi from Avalon Beach to Terrey Hills?",
        answer: (
          <>
            Yes. Inland connections available. Rural route knowledge. Fixed
            prices offered. Explore comfortably.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport with bulky items from homemaker stores?",
        answer: (
          <>
            Mention size when booking. We send right wagon. Loading help
            provided. Big items sorted.
          </>
        ),
      },
      {
        question:
          "Are your Avalon Beach taxis suitable for seniors with walkers?",
        answer: (
          <>
            Patient assistance given. Time provided. Comfortable entry. Regular
            medical trips are supported.
          </>
        ),
      },
      {
        question: "Do you service Avalon Beach late at night?",
        answer: (
          <>
            24/7 operation. Night pickups normal. Safe return guaranteed. Valley
            streets navigated easily.
          </>
        ),
      },
      {
        question:
          "Can I request a specific vehicle type for Avalon Beach airport runs?",
        answer: (
          <>
            Ask when booking. Preferences noted. Sedan or maxi arranged. Your
            choice matters.
          </>
        ),
      },
      {
        question:
          "How early should I secure wedding transport from Avalon Beach?",
        answer: (
          <>
            Book months ahead. Spring dates are busy. Multiple cars coordinated.
            Your celebration is covered.
          </>
        ),
      },
      {
        question: "Do you provide Avalon Beach to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney link. Express option available. Commuter
            bookings accepted. Reliable daily.
          </>
        ),
      },
      {
        question: "Can I bring my dog to Avalon Beach vet appointments?",
        answer: (
          <>
            Small pets in carriers are welcome. Service animals exempt. Mention
            when booking. We prepare.
          </>
        ),
      },
      {
        question: "What happens if Sydney Airport flights change suddenly?",
        answer: (
          <>
            We track live updates.{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Driver
            </Link>{" "}
            adjusts. No extra charges. Seamless pickup maintained.
          </>
        ),
      },
      {
        question:
          "Do you cover all Avalon Beach addresses, including cul-de-sacs?",
        answer: (
          <>
            Every street is found. Dead ends navigated. Your location reached.
            No confusion.
          </>
        ),
      },
    ],
  },
  "newport-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26568.242669614378!2d151.31434525!3d-33.65637589999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d53455c3a2f95%3A0x5017d681632c340!2sNewport%20NSW%202106%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774719986599!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Newport, NSW - 24/7 Airport & Cruise Rides",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Newport for airport transfers, cruise trips, group travel & baby seat bookings. Fixed fares, local drivers & 24/7 service.",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Newport - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Newport? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Newport ensure speedy collections whenever you ring. We manage your
        area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Newport pick up and drop off to guard your diary. You miss setbacks. You
        lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Newport NSW",
    locationSectionTitle: "Reliable Taxi Service in Newport for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Newport Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Newport,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Newport
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Newport selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Newport with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Newport displays reasonable charges with complete openness. You view
        prices beforehand. You arrange your money with certainty. This aids when
        moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Newport maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Newport",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Newport
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Newport allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Newport Cab Booking site.
        You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Newport Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Newport locals and guests.
        Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Newport
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Newport
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Newport for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Newport assist family breaks, crowd adventures, and company
        trips. Security and timeliness steer our tasks. Every machine appears
        orderly. Every guide prepares extensively. You lean on us for terminal
        journeys, notable celebrations, and work ventures. Each passage stays
        plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Newport",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Newport
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Newport and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Newport. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Newport to Sydney Airport
            or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Newport for normal journeys,
            engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Newport answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Newport Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Newport.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle: "Frequently Asked Questions About Taxi Service in Newport",
    faqs: [
      {
        question: "Which spots near Newport do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Newport caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Newport seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question: "Can I book recurring trips for Newport dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question: "How do I request vehicles for Newport surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Newport taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Newport sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Newport driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Newport to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Newport taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "palm-beach-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26586.05330899043!2d151.32613139999998!3d-33.59864439999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d52ad5a1ce9a5%3A0x5017d681632c5b0!2sPalm%20Beach%20NSW%202108%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774720093198!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Palm Beach, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Palm Beach for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Palm Beach for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Palm Beach? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Palm Beach deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed
        inside. We run day and night without stopping. Your flight might land at
        2 AM. Your shift could end at sunrise. Either way, we show up fast.
        Choose our luxury option for extra comfort. We manage smooth Palm Beach
        pick up and drop off to keep your schedule on track. You avoid delays.
        You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Palm Beach NSW",
    locationSectionTitle: "Reliable Taxi Service in Palm Beach for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Palm Beach Taxi Service
        suits small and large groups perfectly. Everyone travels together in one
        car. You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Palm Beach,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Palm Beach
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Palm Beach with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Palm Beach offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade
        to our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Palm Beach keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Palm Beach",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Palm Beach
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Palm Beach lets your group focus on the journey. We
        specialise in group transfers for families, sports teams, and work
        groups. Everyone arrives together. Booking is fast through our Palm
        Beach Cab Booking page. You arrange transport early. Business travellers
        can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly.
        We keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Palm Beach Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Palm Beach residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Palm Beach
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Palm Beach well.
        From Door-to-Door Taxi Service to complex plans, Campbelltown Taxi &
        Maxi Cabs combines deep local knowledge with steady reliability—because
        your destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Palm Beach for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Palm Beach support family holidays, group outings, and business
        travel. Safety and punctuality guide everything we do. Every vehicle
        looks neat. Every driver trains well. You depend on us for airport
        trips, special events, and work journeys. Each ride stays simple and
        relaxed.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Palm Beach",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Palm Beach
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests
            enjoy nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Palm Beach and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Palm Beach. Roomy seating and luggage
            space keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Palm Beach to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Palm Beach for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Palm Beach responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Palm Beach Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable
            trips with our reliable Door-to-Door Taxi Service throughout Palm
            Beach.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality
            leather seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Palm Beach",
    faqs: [
      {
        question: "Which coastal spots near Palm Beach do you cover?",
        answer: (
          <>
            We service Palm Beach Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Palm Beach to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Palm Beach surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question:
          "What if I need a taxi for the Palm Beach dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Palm Beach trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Palm Beach Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Palm Beach taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question:
          "Can I set up account billing for Palm Beach business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Palm Beach?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Palm Beach to Palm Beach direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question:
          "How early should I book wedding cars for Palm Beach ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Palm Beach airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question:
          "Do you service all Palm Beach streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
  "collaroy-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13271.886948939953!2d151.30339439999997!3d-33.73554695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d5542782277f1%3A0x5017d681632b250!2sCollaroy%20NSW%202097%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774720221386!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Collaroy, NSW -  24/7 Local, Airport & Wedding Transport",
    metaDescription:
      "Choose Taxi & Maxi Cabs Services in Collaroy for airport transfers, wedding transport & wheelchair accessible rides. 24/7 service, fixed fares. Call us now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Collaroy for All Travel Needs",
    heroDescription: (
      <>
        Need dependable wheels around Collaroy? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Collaroy promise rapid grabs every time you dial. We run your
        neighbourhood trips with clockwork accuracy that never slips. Our
        vehicles suit lone rangers and massive crews equally. You can pack loads
        of cabin space for bodies and bags together. Not one person gets left
        out or jammed inside. We roll day and night without stopping. Your jet
        might touch down at midnight. Your function could wrap at sunrise.
        Whatever happens, we materialise pronto. Grab our top-shelf choice for
        bonus relaxation. We pull off a slick Collaroy pick up and drop off to
        guard your diary. You sidestep setbacks. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your agenda completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Collaroy NSW",
    locationSectionTitle: "Reliable Taxi Service in Collaroy for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere flash? Our Collaroy Taxi Service fits
        tiny and bulky groups spot on. The whole lot shares one wagon. You miss
        the headache of fracturing into different motors. You wipe out tricky
        planning efforts. Through our devoted
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Collaroy,
        </Link>
        every punter scores guarded, cushy passage. Maybe you blast out of
        Collaroy toward Sydney Airport. Maybe you drag home after marathon
        journeys. We honour our word on clocks. Our captains know clever back
        routes. They steer around bottlenecks. They shrink delays fast. You can
        bank on our Group Transport Collaroy selections when wanting stretch,
        faithfulness, and sparkling cabins. Locking in rides takes ticks via our
        web hub. You snag proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Collaroy with Maxi Cabs: Fast Local & Long Distance Ride",
    locationSection2Desctiption: (
      <>
        We reckon that low cost ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Collaroy shows honest fares with zero secrets tucked away. You
        eyeball costs upfront. You map your spending with poise. This proves
        handy when trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        taking stacks of riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may holler for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your ankle-biters ride in ticked-off, locked-down harnesses. Our
        steerers bring know-how and manners. They back particular needs. They
        heft your suitcases. From crack-of-dawn flights to late returns, our
        24/7 Taxi Collaroy keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Collaroy",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Collaroy
        </Link>{" "}
        hands you a sprawling stretch room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Collaroy lets your mob focus on the voyage.
        We zero in on batch transfers for clans, footy squads, and office units.
        The full gang lands united. Grabbing wheels happens swiftly through our
        Collaroy Cab Booking portal. You sort the movement beforehand. Corporate
        nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with little ones. When poshness counts, our silver
        service dishes extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Collaroy Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find pro transport made for Collaroy locals and visitors. Our full range
        of services gives just what you need, whether you're catching a dawn
        flight or sorting
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for heaps of guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Collaroy
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting eleven people,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        picks with safe clips, and Local Taxi Service for daily jobs. Business
        pros use our Corporate Taxi Service, while luxury hunters pick our
        Premium Service. We do Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for big crowds, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        help. Every trip has clear upfront costs, real 24/7 service, and smart
        local drivers who know Collaroy well. From Door-to-Door Taxi Service to
        tricky plans, Campbelltown Taxi & Maxi Cabs blends deep local know-how
        with steady reliability—because your destination matters, and getting
        there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Collaroy for Every Occasion",
    serviceSubtitle: (
      <>
        We shape transport to match your exact needs. Our Taxi & Maxi Cabs
        Services in Collaroy help family breaks, group trips, and work travel.{" "}
        <Link
          to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
          target="_blank"
        >
          Safety
        </Link>{" "}
        and being on time guide all we do. Every car looks good. Every driver
        trains well. You count on us for airport runs, special days, and
        business trips. Each ride stays simple and calm.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Collaroy",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Collaroy
        </Link>
        makes every trip simple and accountable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, ideal for corporate
        travellers and authorised riders. Enjoy cashless processing, clear trip
        records, and smooth billing with every ride. Reliable transport backed
        by trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in big cars. Bridal parties, family, and friends enjoy nice,
            comfy trips to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury choice for VIP moves, boss travel, and guests
            wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with safe child seats. Young ones stay secure all
            the way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group work trips. On-time pickups help busy
            days.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth trips between Collaroy and cruise docks. Big space fits
            people and bags together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for shows, parties, and social events. Get there on
            time. Skip parking stress.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Great for bigger groups in Collaroy. Lots of seats and bag space
            keep all together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-run moves from Collaroy to Sydney Airport or work spots.
            Your team travels with no stress.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady 24/7 choice across Collaroy for daily trips, bookings, and
            fun out.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Collaroy Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from mixed cars to match your group size and comfort needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        puts safety, space, and soft rides first. Solo riders find good fits.
        Full groups get the right choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Good for lone riders or pairs wanting quiet, soft trips with our
            steady Door-to-Door Taxi Service all through Collaroy.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who like privacy, soft leather
            seats, and sharp looks on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More room for people and bags. Top choice for families or small
            groups heading to Sydney Airport in comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers nicely. Big bag space suits group moves, family
            holidays, and long hauls.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for larger groups or big families wanting spacious, clean
            interiors and a totally chilled travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Delivers accessible transport with fully trained drivers and proper
            safety gear for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Collaroy",
    faqs: [
      {
        question: "How do I reach Sydney Airport from the industrial area?",
        answer: (
          <>
            Our Airport Transfers in Collaroy navigate the Warringah Mall bypass
            efficiently. We pick up from factories and warehouses. Typically 35
            minutes to domestic terminals.
          </>
        ),
      },
      {
        question: "Can your maxi cabs transport my trade tools and materials?",
        answer: (
          <>
            Our{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            Cab Services in Collaroy accommodate bulky equipment. Utes and
            wagons available. We service tradespeople across the Northern
            Beaches daily.
          </>
        ),
      },
      {
        question: "Do you operate during Warringah Mall trading hours?",
        answer: (
          <>
            Yes. Our 24/7 Taxi Collaroy runs constantly. We know loading dock
            locations and pickup zones. Shop without parking stress.
          </>
        ),
      },
      {
        question: "What's the best way to transport my team to a conference?",
        answer: (
          <>
            Our Corporate Taxi Service coordinates multiple Maxi Cab for Group
            Travel vehicles. We manage business teams to CBD meetings and
            airport departures seamlessly.
          </>
        ),
      },
      {
        question: "Can I book wheelchair transport for medical appointments?",
        answer: (
          <>
            Absolutely. Our Wheelchair Accessible Taxi in Collaroy provides
            dignified, reliable healthcare transport. We accommodate mobility
            scooters and walking frames with care.
          </>
        ),
      },
      {
        question: "How do I organize transport for my child's sports team?",
        answer: (
          <>
            Our Group Transport Collaroy safely conveys junior teams to away
            games. Parents receive driver details. We ensure punctual, secure
            travel for young athletes.
          </>
        ),
      },
      {
        question: "What happens if my flight is delayed?",
        answer: (
          <>
            We track arrivals live. Your Emergency Taxi in Collaroy waits
            without extra charges for reasonable delays. Call us if plans change
            significantly.
          </>
        ),
      },
      {
        question: "Do you offer account facilities for local businesses?",
        answer: (
          <>
            Yes. Our Corporate Taxi Service provides Collaroy enterprises with
            monthly billing and priority access. Simplify your company travel
            management.
          </>
        ),
      },
      {
        question: "Can I transport my motorcycle to the mechanic?",
        answer: (
          <>
            Our specialized vehicles accommodate bikes securely. Mention
            transport needs when using Collaroy Cab. We handle delicate cargo
            with expertise.
          </>
        ),
      },
      {
        question: "Why trust local taxis in an industrial zone?",
        answer: (
          <>
            We know Collaroy's factory addresses, loading restrictions, and
            business hours. Apps often cancel industrial pickups. We show
            up—guaranteed.
          </>
        ),
      },
    ],
  },

  "collaroy-plateau-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13272.658312458134!2d151.28955390000004!3d-33.73056014999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b0d5576bc0658b7%3A0x5017d681632b260!2sCollaroy%20Plateau%20NSW%202097%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774720745357!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Collaroy Plateau, NSW - Baby Seat & Family Rides",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Collaroy Plateau for family travel, baby seat taxi & group rides. On-time pickups, transparent pricing & expert local drivers. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Collaroy Plateau for Reliable Rides",
    heroDescription: (
      <>
        Chasing a lift around Collaroy Plateau? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Collaroy Plateau answer fast when you ring. We move locals with
        clockwork timing that never slips. Our fleet suits one person or big
        crowds equally. You score heaps of space for mates and gear together.
        Nobody gets stuck outside or squashed inside. We roll all hours, every
        day. Planes land at midnight. Jobs finish at dawn. We still reach you
        quick. Pick our fancy grade for extra ease. We handle slick Collaroy
        Plateau pick up and drop off to save your diary. You dodge slowdowns.
        You drop the worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your plans completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Collaroy Plateau NSW",
    locationSectionTitle:
      "Reliable Taxi Service in Collaroy Plateau for Groups",
    locationSectionDescription: (
      <>
        Shifting relatives or crew somewhere good? Our Collaroy Plateau Taxi
        Service fits tiny and huge mobs spot on. The whole lot packs into one
        wagon. You skip the pain of splitting into different motors. You kill a
        messy organisation. Through our set
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Collaroy Plateau,
        </Link>
        every punter gains safe, cushy passage. Perhaps you blast out of
        Collaroy Plateau toward Sydney Airport. Perhaps you drag home after long
        hauls. We keep our word on clocks. Our drivers know sneaky detours. They
        skirt gridlock. They squash delays. You can bank on our Group Transport
        Collaroy Plateau picks when wanting stretch, faith, and sparkling
        cabins. Locking in rides takes ticks via our web hub. You snag proof
        instantly. You float with assurance.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Collaroy Plateau with Affordable Maxi Cab & Fast Airport Rides",
    locationSection2Desctiption: (
      <>
        That cheap ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Collaroy Plateau shows honest charges with nothing hidden. You
        eyeball costs upfront. You map your spending with poise. This proves
        gold when trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        hauling stacks of riders plus loads. Fancy something posher? Bump up to
        our silver grade for polished trips. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        wheelmen bring wisdom and manners. They back particular needs. They heft
        your suitcases. From crack-of-dawn flights to late returns, our 24/7
        Taxi Collaroy Plateau keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Collaroy Plateau",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Collaroy Plateau
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Collaroy Plateau lets your mob focus on the
        voyage. We zero in on batch transfers for clans, surf clubs, and office
        squads. The full gang lands united. Grabbing wheels happens swiftly
        through our Collaroy Plateau Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When class counts, our silver
        grade dishes have extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Collaroy Plateau Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro hauling crafted squarely for Collaroy Plateau locals and
        blow-ins. Our broad spread hands you precisely what you crave, whether
        snagging red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Collaroy Plateau
        </Link>
        , flaunting live plane tracking,
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services
        </Link>{" "}
        accommodating eleven occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>{" "}
        for daily missions. Trade heavyweights lean on our Corporate Taxi
        Service, while refinement chasers dig our Premium Service. We master
        Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Collaroy Plateau like a
        book. From Door-to-Door Taxi Service to tangled logistics, Campbelltown
        Taxi & Maxi Cabs merges deep turf smarts with rock-steady
        consistency—because your finish line counts, and arriving there should
        feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle:
      "Taxi and Maxi Cab Solutions Collaroy Plateau for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Collaroy Plateau back clan getaways, mob adventures, and corporate
        travel. Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Collaroy Plateau",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Collaroy Plateau
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transport",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Premium Service",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Taxi Service",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Transfers",
        description: (
          <>
            Enjoy smooth hops between Collaroy Plateau and cruise wharves.
            Generous volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transport",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Cab Services",
        description: (
          <>
            Perfect for heftier crowds in Collaroy Plateau. Ample perch and
            baggage capacity keeps tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Collaroy Plateau to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Steady round-the-clock option across Collaroy Plateau for routine
            runs, appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi in Collaroy Plateau",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Collaroy Plateau reacts
            instantly. We spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Collaroy Plateau Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our garage
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Collaroy
            Plateau.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "SUV or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Accessible Taxi in Collaroy Plateau",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Collaroy Plateau",
    faqs: [
      {
        question: "Which Collaroy Plateau retail spots do you service?",
        answer: (
          <>
            We reach Collaroy Plateau Square. Garden centres nearby. Bunnings
            trips are common. Shopping transport easy.
          </>
        ),
      },
      {
        question:
          "How do I reach Collaroy Plateau Hospital from Collaroy Plateau?",
        answer: (
          <>
            Direct routes available. Medical priority given. Patient comfort is
            considered. Regular health trips are welcome.
          </>
        ),
      },
      {
        question: "Can I book transport for Collaroy Plateau BMX track events?",
        answer: (
          <>
            Yes. Gear and bikes are carried. Youth groups accommodated. Early
            morning starts are arranged. Sports specialists.
          </>
        ),
      },
      {
        question: "Do you know the Collaroy Plateau Valley back streets?",
        answer: (
          <>
            Absolutely. Valley roads mastered. Shortcuts found. Traffic avoided.
            Local knowledge guaranteed.
          </>
        ),
      },
      {
        question: "What makes Collaroy Plateau different from Narrabeen?",
        answer: (
          <>
            The valley setting is unique. Shopping hub central. Quieter
            residential feel. We understand the area.
          </>
        ),
      },
      {
        question: "Can I get a taxi from Collaroy Plateau to Terrey Hills?",
        answer: (
          <>
            Yes. Inland connections available. Rural route knowledge. Fixed
            prices offered. Explore comfortably.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport with bulky items from homemaker stores?",
        answer: (
          <>
            Mention size when booking. We send right wagon. Loading help
            provided. Big items sorted.
          </>
        ),
      },
      {
        question:
          "Are your Collaroy Plateau taxis suitable for seniors with walkers?",
        answer: (
          <>
            Patient assistance given. Time provided. Comfortable entry. Regular
            medical trips are supported.
          </>
        ),
      },
      {
        question: "Do you service Collaroy Plateau late at night?",
        answer: (
          <>
            24/7 operation. Night pickups normal. Safe return guaranteed. Valley
            streets navigated easily.
          </>
        ),
      },
      {
        question:
          "Can I request a specific vehicle type for Collaroy Plateau airport runs?",
        answer: (
          <>
            Ask when booking. Preferences noted. Sedan or maxi arranged. Your
            choice matters.
          </>
        ),
      },
      {
        question:
          "How early should I secure wedding transport from Collaroy Plateau?",
        answer: (
          <>
            Book months ahead. Spring dates are busy. Multiple cars coordinated.
            Your celebration is covered.
          </>
        ),
      },
      {
        question: "Do you provide Collaroy Plateau to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney link. Express option available. Commuter
            bookings accepted. Reliable daily.
          </>
        ),
      },
      {
        question: "Can I bring my dog to Collaroy Plateau vet appointments?",
        answer: (
          <>
            Small pets in carriers are welcome. Service animals exempt. Mention
            when booking. We prepare.
          </>
        ),
      },
      {
        question: "What happens if Sydney Airport flights change suddenly?",
        answer: (
          <>
            We track live updates.{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Driver
            </Link>{" "}
            adjusts. No extra charges. Seamless pickup maintained.
          </>
        ),
      },
      {
        question:
          "Do you cover all Collaroy Plateau addresses, including cul-de-sacs?",
        answer: (
          <>
            Every street is found. Dead ends navigated. Your location reached.
            No confusion.
          </>
        ),
      },
    ],
  },

  "forestville-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13272.658312458134!2d151.28955390000004!3d-33.73056014999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12a99f56d8b471%3A0x5017d681632b790!2sForestville%20NSW%202087%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721062596!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Forestville, NSW - 24/7 Airport & Cruise Rides",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Forestville for airport transfers, cruise trips, group travel & baby seat bookings. Fixed fares, local drivers & 24/7 service.",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Forestville - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Forestville? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Forestville ensure speedy collections whenever you ring. We manage
        your area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Forestville pick up and drop off to guard your diary. You miss setbacks.
        You lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Forestville NSW",
    locationSectionTitle:
      "Reliable Taxi Service in Forestville for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Forestville Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Forestville,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Forestville
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Forestville selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Forestville with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Forestville displays reasonable charges with complete openness. You
        view prices beforehand. You arrange your money with certainty. This aids
        when moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Forestville maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Forestville",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Forestville
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Forestville allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Forestville Cab Booking
        site. You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Forestville Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Forestville locals and
        guests. Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Forestville
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Forestville
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Forestville for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Forestville assist family breaks, crowd adventures, and
        company trips. Security and timeliness steer our tasks. Every machine
        appears orderly. Every guide prepares extensively. You lean on us for
        terminal journeys, notable celebrations, and work ventures. Each passage
        stays plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Forestville",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Forestville
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Forestville and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Forestville. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Forestville to Sydney
            Airport or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Forestville for normal
            journeys, engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Forestville answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Forestville Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Forestville.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Forestville",
    faqs: [
      {
        question: "Which spots near Forestville do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Forestville caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Forestville seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question:
          "Can I book recurring trips for Forestville dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question:
          "How do I request vehicles for Forestville surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Forestville taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Forestville sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Forestville driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Forestville to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Forestville taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "casula-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26476.569397785093!2d150.89682525!3d-33.952155899999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1294e7f6bd51b7%3A0x5017d681632b060!2sCasula%20NSW%202170%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721270257!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Casula, NSW - 24/7 Airport & Cruise Rides",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Casula for airport transfers, cruise trips, group travel & baby seat bookings. Fixed fares, local drivers & 24/7 service.",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Casula - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Casula? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Casula ensure speedy collections whenever you ring. We manage your
        area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Casula pick up and drop off to guard your diary. You miss setbacks. You
        lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Casula NSW",
    locationSectionTitle: "Reliable Taxi Service in Casula for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Casula Taxi Service fits
        compact and large crowds ideally. All people share one automobile. You
        escape the trouble of dividing into separate cars. You remove complex
        organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Casula,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Casula
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Casula selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Casula with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Casula displays reasonable charges with complete openness. You view
        prices beforehand. You arrange your money with certainty. This aids when
        moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Casula maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Casula",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Casula
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Casula allows your party to concentrate
        on the route. We centre on collective transfers for households, athletic
        clubs, and office teams. The entire set reaches unity. Getting wheels
        occurs promptly via our Casula Cab Booking site. You prepare movement in
        advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Casula Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Casula locals and guests.
        Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Casula
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Casula
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Casula for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Casula assist family breaks, crowd adventures, and company
        trips. Security and timeliness steer our tasks. Every machine appears
        orderly. Every guide prepares extensively. You lean on us for terminal
        journeys, notable celebrations, and work ventures. Each passage stays
        plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Casula",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Casula
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Casula and ship terminals.
            Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Casula. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Casula to Sydney Airport or
            company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Casula for normal journeys,
            engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Casula answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Casula Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Casula.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle: "Frequently Asked Questions About Taxi Service in Casula",
    faqs: [
      {
        question: "Which spots near Casula do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Casula caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Casula seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question: "Can I book recurring trips for Casula dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question: "How do I request vehicles for Casula surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Casula taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Casula sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Casula driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Casula to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Casula taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "prestons-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26479.86507232355!2d150.87325145000003!3d-33.94156189999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129492f9974d17%3A0x5017d681632c740!2sPrestons%20NSW%202170%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721371752!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Prestons, NSW - 24/7 Airport & Cruise Rides",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Prestons for airport transfers, cruise trips, group travel & baby seat bookings. Fixed fares, local drivers & 24/7 service.",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Prestons - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Prestons? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Prestons ensure speedy collections whenever you ring. We manage your
        area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Prestons pick up and drop off to guard your diary. You miss setbacks.
        You lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Prestons NSW",
    locationSectionTitle: "Reliable Taxi Service in Prestons for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Prestons Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Prestons,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Prestons
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Prestons selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Prestons with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Prestons displays reasonable charges with complete openness. You view
        prices beforehand. You arrange your money with certainty. This aids when
        moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Prestons maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Prestons",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Prestons
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Prestons allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Prestons Cab Booking site.
        You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Prestons Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Prestons locals and guests.
        Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Prestons
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Prestons
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Prestons for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Prestons assist family breaks, crowd adventures, and company
        trips. Security and timeliness steer our tasks. Every machine appears
        orderly. Every guide prepares extensively. You lean on us for terminal
        journeys, notable celebrations, and work ventures. Each passage stays
        plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Prestons",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Prestons
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Prestons and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Prestons. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Prestons to Sydney Airport
            or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Prestons for normal journeys,
            engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Prestons answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Prestons Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Prestons.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Prestons",
    faqs: [
      {
        question: "Which spots near Prestons do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Prestons caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Prestons seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question: "Can I book recurring trips for Prestons dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question: "How do I request vehicles for Prestons surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Prestons taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Prestons sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Prestons driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Prestons to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Prestons taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "hoxton-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13241.742698670692!2d150.85991315!3d-33.929920949999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1293634ad09595%3A0x5017d681632bb10!2sHoxton%20Park%20NSW%202171%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721547646!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Hoxton Park - Local & Airport Ride Experts",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Hoxton Park for local travel, airport transfers & corporate taxi. Clean vehicles, fixed pricing & on-time drivers. Call now!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Hoxton Park - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Hoxton Park? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Hoxton Park ensure speedy collections whenever you ring. We manage
        your area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Hoxton Park pick up and drop off to guard your diary. You miss setbacks.
        You lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Hoxton Park NSW",
    locationSectionTitle:
      "Reliable Taxi Service in Hoxton Park for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Hoxton Park Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Hoxton Park,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Hoxton Park
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Hoxton Park selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Hoxton Park with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Hoxton Park displays reasonable charges with complete openness. You
        view prices beforehand. You arrange your money with certainty. This aids
        when moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Hoxton Park maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Hoxton Park",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Hoxton Park
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Hoxton Park allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Hoxton Park Cab Booking
        site. You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Hoxton Park Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Hoxton Park locals and
        guests. Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Hoxton Park
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Hoxton Park
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Hoxton Park for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Hoxton Park assist family breaks, crowd adventures, and
        company trips. Security and timeliness steer our tasks. Every machine
        appears orderly. Every guide prepares extensively. You lean on us for
        terminal journeys, notable celebrations, and work ventures. Each passage
        stays plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Hoxton Park",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Hoxton Park
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Hoxton Park and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Hoxton Park. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Hoxton Park to Sydney
            Airport or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Hoxton Park for normal
            journeys, engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Hoxton Park answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Hoxton Park Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Hoxton Park.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Hoxton Park",
    faqs: [
      {
        question: "Which spots near Hoxton Park do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Hoxton Park caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Hoxton Park seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question:
          "Can I book recurring trips for Hoxton Park dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question:
          "How do I request vehicles for Hoxton Park surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Hoxton Park taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Hoxton Park sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Hoxton Park driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Hoxton Park to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Hoxton Park taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "cecil-hills-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26496.67758032376!2d150.84428655000002!3d-33.88747244999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1293ef56b04055%3A0x5017d681632b090!2sCecil%20Hills%20NSW%202171%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721648609!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Cecil Hills - Local & Airport Ride Experts",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Cecil Hills for local travel, airport transfers & corporate taxi. Clean vehicles, fixed pricing & on-time drivers. Call now!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Cecil Hills - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Cecil Hills? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Cecil Hills ensure speedy collections whenever you ring. We manage
        your area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Cecil Hills pick up and drop off to guard your diary. You miss setbacks.
        You lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Cecil Hills NSW",
    locationSectionTitle:
      "Reliable Taxi Service in Cecil Hills for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Cecil Hills Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Cecil Hills,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Cecil Hills
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Cecil Hills selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Cecil Hills with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Cecil Hills displays reasonable charges with complete openness. You
        view prices beforehand. You arrange your money with certainty. This aids
        when moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Cecil Hills maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Cecil Hills",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Cecil Hills
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Cecil Hills allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Cecil Hills Cab Booking
        site. You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Cecil Hills Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Cecil Hills locals and
        guests. Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Cecil Hills
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Cecil Hills
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Cecil Hills for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Cecil Hills assist family breaks, crowd adventures, and
        company trips. Security and timeliness steer our tasks. Every machine
        appears orderly. Every guide prepares extensively. You lean on us for
        terminal journeys, notable celebrations, and work ventures. Each passage
        stays plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Cecil Hills",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Cecil Hills
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Cecil Hills and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Cecil Hills. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Cecil Hills to Sydney
            Airport or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Cecil Hills for normal
            journeys, engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Cecil Hills answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Cecil Hills Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Cecil Hills.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Cecil Hills",
    faqs: [
      {
        question: "Which spots near Cecil Hills do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Cecil Hills caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Cecil Hills seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question:
          "Can I book recurring trips for Cecil Hills dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question:
          "How do I request vehicles for Cecil Hills surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Cecil Hills taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Cecil Hills sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Cecil Hills driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Cecil Hills to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Cecil Hills taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },
  "wetherill-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26510.801108475524!2d150.89841339999998!3d-33.84197519999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129705bb6b75d7%3A0x5017d681632cfe0!2sWetherill%20Park%20NSW%202164%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721786782!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Wetherill - Local & Airport Ride Experts",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Wetherill for local travel, airport transfers & corporate taxi. Clean vehicles, fixed pricing & on-time drivers. Call now!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Wetherill - Book Now",
    heroDescription: (
      <>
        Looking for trusted rides around Wetherill? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Wetherill ensure speedy collections whenever you ring. We manage your
        area trips with exact timing that never falters. Our cars suit
        individual travellers and big parties equally. You receive wide cabin
        space for passengers and belongings together. No one faces exclusion or
        tight spots inside. We work all hours without pause. Your plane might
        arrive at 3 AM. Your job could finish at dawn. Either way, we reach you
        quickly. Select our high-end choice for added ease. We handle smooth
        Wetherill pick up and drop off to guard your diary. You miss setbacks.
        You lose worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        values your schedule always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Wetherill NSW",
    locationSectionTitle: "Reliable Taxi Service in Wetherill for Large Groups",
    locationSectionDescription: (
      <>
        Bringing loved ones or pals somewhere good? Our Wetherill Taxi Service
        fits compact and large crowds ideally. All people share one automobile.
        You escape the trouble of dividing into separate cars. You remove
        complex organisational efforts. Through our focused
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Wetherill,
        </Link>
        every rider gains a secure, pleasant passage. Maybe you exit Wetherill
        toward Sydney Airport. Maybe you return home after lengthy journeys. We
        follow our timing pledges. Our Drivers know clever detours. They
        sidestep congestion points. They reduce delays fast. You can depend on
        our Group Transport Wetherill selections when requiring room,
        trustworthiness, and tidy interiors. Securing transport takes moments
        through our digital platform. You obtain verification rapidly. You
        journey with assurance.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Wetherill with Maxi Cabs: Family trips and long-distance commutes",
    locationSection2Desctiption: (
      <>
        We hold that budget must never equal poor quality. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Wetherill displays reasonable charges with complete openness. You
        view prices beforehand. You arrange your money with certainty. This aids
        when moving with companions. You can reserve a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        carrying numerous riders plus loads. Desire something superior? Move up
        to our deluxe option for polished trips. Homes may seek
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        additions. Your youngsters sit in checked, correctly secured restraints.
        Our Drivers bring skill and politeness. They support specific
        requirements. They shift your bags. From sunrise departures to evening
        returns, our 24/7 Taxi Wetherill maintains your progress. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        guarantees protected, consistent, calm transport for all users.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Wetherill",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Wetherill
        </Link>{" "}
        offers an extensive stretching area. You gain abundant storage spots.
        You rest despite filled cabins. You evade restricted seating. You bypass
        the difficult luggage stacking. Your travel turns agreeable. Grabbing
        our Taxi & Maxi Cabs Services in Wetherill allows your party to
        concentrate on the route. We centre on collective transfers for
        households, athletic clubs, and office teams. The entire set reaches
        unity. Getting wheels occurs promptly via our Wetherill Cab Booking
        site. You prepare movement in advance. Commerce movers can access our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for punctual, expert dashes to conferences. Homes include Baby Seat Taxi
        picks for guarded trips with infants. When refinement matters, our
        deluxe option provides added softness. Every automobile receives
        frequent washing. We apply firm guidelines. You experience easy,
        defended transit without road concerns.
      </>
    ),
    locationSection4Title:
      "Reliable Wetherill Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Explore expert movement shaped directly for Wetherill locals and guests.
        Our complete selection delivers precisely what you seek, whether
        capturing dawn flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          marriage transport
        </Link>{" "}
        for many invitees. We supply
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Wetherill
        </Link>{" "}
        featuring current flight watching, Maxi Cab Services holding eleven
        riders,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        varieties with verified harnesses, and Local Taxi Service for regular
        duties. Trade leaders use our Corporate Taxi Service, while elegance
        hunters pick our Premium Service. We excel at Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for sizeable gatherings, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        arrangements. Each trip contains obvious initial costs, true all-hours
        availability, and practised nearby Drivers who understand Wetherill
        completely. From Door-to-Door Taxi Service to involved coordination,
        Campbelltown Taxi & Maxi Cabs joins thorough area know-how with solid
        dependability—because your endpoint counts, and reaching it should seem
        simple.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Wetherill for Every Occasion",
    serviceSubtitle: (
      <>
        We form movements to fit your particular demands. Our Taxi & Maxi Cabs
        Services in Wetherill assist family breaks, crowd adventures, and
        company trips. Security and timeliness steer our tasks. Every machine
        appears orderly. Every guide prepares extensively. You lean on us for
        terminal journeys, notable celebrations, and work ventures. Each passage
        stays plain and unworried.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Wetherill",
    cabChargeSectionDesctiption: (
      <>
        Want an adaptable settlement for employment or private journeys? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Wetherill
        </Link>
        renders each trip clear and followable. We take guarded CabCharge
        Payments, including the useful CabCharge Card, excellent for
        organisation travellers and permitted spenders. Value electronic
        dealings, distinct travel records, and straightforward invoicing every
        occasion. Trustworthy movement supported by established Cabcharge
        payment methods.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in large automobiles. Marriage groups, relations, and attendees
            appreciate attractive, relaxed transport to and from places.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Take our superior selection for important transfers, leadership
            travel, and customers expecting elevated seclusion and satisfaction.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Residences arrange rides with sanctioned child restraints. Little
            ones remain buckled secure the entire distance.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Developed for meeting rooms and group company movement. Prompt
            gatherings aid demanding timetables.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Appreciate effortless connections between Wetherill and ship
            terminals. Sufficient area manages riders and suitcases jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Engage our service for performances, gatherings, and community
            meetings. Reach punctually. Miss parking troubles.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Suited for bigger assemblies in Wetherill. Substantial sitting and
            suitcase room keeps parties united.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Guarded, efficiently handled shifts from Wetherill to Sydney Airport
            or company spots. Your staff travels calmly.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Constant all-hours choice throughout Wetherill for normal journeys,
            engagements, and pleasure walks.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Pressing requirement? Our Emergency Taxi in Wetherill answers
            immediately. We highlight your protection and haste.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Wetherill Transfer",
    fleetSectionSubTitle: (
      <>
        Select from varied automobiles matching your gathering size and ease
        preferences.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        stresses protection, area, and gentle journeys. Individual explorers
        find appropriate matches. Complete sets receive fitting choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Right for lone travellers or duos desiring peaceful, easy trips with
            our dependable Door-to-Door Taxi Service across Wetherill.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Fine for distinguished visitors and commerce guests who prize
            isolation, quality hide seating, and neat appearance on every
            outing.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Added room for explorers and cases. Strong pick for families or
            limited groups heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Contains 6–7 explorers comfortably. Big suitcase space suits group
            shifts, family vacations, and drawn-out tours.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Made for larger assemblies or extended families wanting open, clean
            insides and an utterly unwound travel experience united.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Furnishes reachable movement with correctly taught Drivers and
            appropriate protection elements for all mobility requirements and
            ease.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Wetherill",
    faqs: [
      {
        question: "Which spots near Wetherill do you reach?",
        answer: (
          <>
            We cover Collaroy, Dee Why, Mona Vale. The coastal strip is
            well-known. Your destination was reached smoothly.
          </>
        ),
      },
      {
        question: "How do I arrange early morning airport runs?",
        answer: (
          <>
            Book the night before. We confirm the pickup time. Track your
            flight. Adjust if delayed. Sleep peacefully.
          </>
        ),
      },
      {
        question: "Can I transport camping gear to Wetherill caravan parks?",
        answer: (
          <>
            Yes. Tents, chairs, and coolers fit. Maxi cabs handle bulky loads.
            Outdoor holidays are supported.
          </>
        ),
      },
      {
        question: "Do you know alternate routes during bridge closures?",
        answer: (
          <>
            Absolutely. Pittwater Road diversions mapped. Traffic updates
            monitored. You arrive despite disruptions.
          </>
        ),
      },
      {
        question: "What makes your service ideal for Wetherill seniors?",
        answer: (
          <>
            Patient drivers. Assistance given. Comfortable vehicles. Medical
            appointment specialists. Respectful care.
          </>
        ),
      },
      {
        question: "Can I book recurring trips for Wetherill dialysis patients?",
        answer: (
          <>
            Regular medical transport is welcome. Same driver preference noted.
            Reliable schedule maintained. Health priority.
          </>
        ),
      },
      {
        question: "How do I request vehicles for Wetherill surf school groups?",
        answer: (
          <>
            Multiple bookings coordinated. Board racks are available. Early
            morning starts. Youth transport specialists.
          </>
        ),
      },
      {
        question: "Are your prices higher during the summer holidays?",
        answer: (
          <>
            Rates stay constant year-round. No seasonal surcharges. Fair pricing
            guaranteed. Budget confidently.
          </>
        ),
      },
      {
        question: "Can I pay by phone for Wetherill taxi bookings?",
        answer: (
          <>
            Card payments accepted. Phone pre-payment available. Receipts are
            emailed instantly. Business claims are easy.
          </>
        ),
      },
      {
        question: "Do you service Wetherill sports clubs after late games?",
        answer: (
          <>
            Yes. Team transport arranged. Equipment carried. Safe return
            guaranteed. Club accounts welcomed.
          </>
        ),
      },
      {
        question: "How far ahead should I secure wedding transport?",
        answer: (
          <>
            Book three months early. Spring dates fill fast. Multiple cars
            coordinated. Your celebration secured.
          </>
        ),
      },
      {
        question: "Can I bring my pram without folding it?",
        answer: (
          <>
            Large prams fit in maxi cabs. Mention when booking. We prepare
            space. Family travel made simple.
          </>
        ),
      },
      {
        question: "What happens if my Wetherill driver is delayed?",
        answer: (
          <>
            We monitor traffic. Alternative routes are ready. You receive
            updates. Rare delays are explained quickly.
          </>
        ),
      },
      {
        question: "Do you offer a direct service from Wetherill to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney connections. Express routes are available.
            Commuter bookings accepted. Reliable daily service.
          </>
        ),
      },
      {
        question: "Are small pets permitted in Wetherill taxis?",
        answer: (
          <>
            Carriers required. Service animals exempt. Mention when booking. We
            accommodate animal companions.
          </>
        ),
      },
    ],
  },

  "smithfield-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26508.823289370055!2d150.93846150000002!3d-33.84834975000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1297c4de9d1fcf%3A0x5017d681632cb20!2sSmithfield%20NSW%202164%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774721943634!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Smithfield, NSW - Baby Seat & Family Rides",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Smithfield for family travel, baby seat taxi & group rides. On-time pickups, transparent pricing & expert local drivers. Call now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Smithfield for Reliable Rides",
    heroDescription: (
      <>
        Chasing a lift around Smithfield? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Smithfield answer fast when you ring. We move locals with clockwork
        timing that never slips. Our fleet suits one person or big crowds
        equally. You score heaps of space for mates and gear together. Nobody
        gets stuck outside or squashed inside. We roll all hours, every day.
        Planes land at midnight. Jobs finish at dawn. We still reach you quick.
        Pick our fancy grade for extra ease. We handle slick Smithfield pick up
        and drop off to save your diary. You dodge slowdowns. You drop the
        worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your plans completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Smithfield NSW",
    locationSectionTitle: "Reliable Taxi Service in Smithfield for Groups",
    locationSectionDescription: (
      <>
        Shifting relatives or crew somewhere good? Our Smithfield Taxi Service
        fits tiny and huge mobs spot on. The whole lot packs into one wagon. You
        skip the pain of splitting into different motors. You kill a messy
        organisation. Through our set
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Smithfield,
        </Link>
        every punter gains safe, cushy passage. Perhaps you blast out of
        Smithfield toward Sydney Airport. Perhaps you drag home after long
        hauls. We keep our word on clocks. Our drivers know sneaky detours. They
        skirt gridlock. They squash delays. You can bank on our Group Transport
        Smithfield picks when wanting stretch, faith, and sparkling cabins.
        Locking in rides takes ticks via our web hub. You snag proof instantly.
        You float with assurance.
      </>
    ),
    locationSection2Title:
      "Taxi Service in Smithfield with Affordable Maxi Cab & Fast Airport Rides",
    locationSection2Desctiption: (
      <>
        That cheap ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Smithfield shows honest charges with nothing hidden. You eyeball
        costs upfront. You map your spending with poise. This proves gold when
        trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        hauling stacks of riders plus loads. Fancy something posher? Bump up to
        our silver grade for polished trips. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        wheelmen bring wisdom and manners. They back particular needs. They heft
        your suitcases. From crack-of-dawn flights to late returns, our 24/7
        Taxi Smithfield keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Smithfield",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Smithfield
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Smithfield lets your mob focus on the
        voyage. We zero in on batch transfers for clans, surf clubs, and office
        squads. The full gang lands united. Grabbing wheels happens swiftly
        through our Smithfield Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When class counts, our silver
        grade dishes have extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Smithfield Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro hauling crafted squarely for Smithfield locals and blow-ins.
        Our broad spread hands you precisely what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding convoys
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Smithfield
        </Link>
        , flaunting live plane tracking,
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services
        </Link>{" "}
        accommodating eleven occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>{" "}
        for daily missions. Trade heavyweights lean on our Corporate Taxi
        Service, while refinement chasers dig our Premium Service. We master
        Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Smithfield like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Smithfield for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Smithfield back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Smithfield",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Smithfield
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transport",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Premium Service",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Taxi Service",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Transfers",
        description: (
          <>
            Enjoy smooth hops between Smithfield and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transport",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Cab Services",
        description: (
          <>
            Perfect for heftier crowds in Smithfield. Ample perch and baggage
            capacity keeps tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Smithfield to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Local Taxi Service",
        description: (
          <>
            Steady round-the-clock option across Smithfield for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi in Smithfield",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Smithfield reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Smithfield Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our garage
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Smithfield.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "SUV or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Accessible Taxi in Smithfield",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Smithfield",
    faqs: [
      {
        question: "Which Smithfield retail spots do you service?",
        answer: (
          <>
            We reach Smithfield Square. Garden centres nearby. Bunnings trips
            are common. Shopping transport easy.
          </>
        ),
      },
      {
        question: "How do I reach Mona Vale Hospital from Smithfield?",
        answer: (
          <>
            Direct routes available. Medical priority given. Patient comfort is
            considered. Regular health trips are welcome.
          </>
        ),
      },
      {
        question: "Can I book transport for Smithfield BMX track events?",
        answer: (
          <>
            Yes. Gear and bikes are carried. Youth groups accommodated. Early
            morning starts are arranged. Sports specialists.
          </>
        ),
      },
      {
        question: "Do you know the Smithfield Valley back streets?",
        answer: (
          <>
            Absolutely. Valley roads mastered. Shortcuts found. Traffic avoided.
            Local knowledge guaranteed.
          </>
        ),
      },
      {
        question: "What makes Smithfield different from Narrabeen?",
        answer: (
          <>
            The valley setting is unique. Shopping hub central. Quieter
            residential feel. We understand the area.
          </>
        ),
      },
      {
        question: "Can I get a taxi from Smithfield to Terrey Hills?",
        answer: (
          <>
            Yes. Inland connections available. Rural route knowledge. Fixed
            prices offered. Explore comfortably.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport with bulky items from homemaker stores?",
        answer: (
          <>
            Mention size when booking. We send right wagon. Loading help
            provided. Big items sorted.
          </>
        ),
      },
      {
        question:
          "Are your Smithfield taxis suitable for seniors with walkers?",
        answer: (
          <>
            Patient assistance given. Time provided. Comfortable entry. Regular
            medical trips are supported.
          </>
        ),
      },
      {
        question: "Do you service Smithfield late at night?",
        answer: (
          <>
            24/7 operation. Night pickups normal. Safe return guaranteed. Valley
            streets navigated easily.
          </>
        ),
      },
      {
        question:
          "Can I request a specific vehicle type for Smithfield airport runs?",
        answer: (
          <>
            Ask when booking. Preferences noted. Sedan or maxi arranged. Your
            choice matters.
          </>
        ),
      },
      {
        question:
          "How early should I secure wedding transport from Smithfield?",
        answer: (
          <>
            Book months ahead. Spring dates are busy. Multiple cars coordinated.
            Your celebration is covered.
          </>
        ),
      },
      {
        question: "Do you provide Smithfield to Hornsby?",
        answer: (
          <>
            Yes. Northern Sydney link. Express option available. Commuter
            bookings accepted. Reliable daily.
          </>
        ),
      },
      {
        question: "Can I bring my dog to Smithfield vet appointments?",
        answer: (
          <>
            Small pets in carriers are welcome. Service animals exempt. Mention
            when booking. We prepare.
          </>
        ),
      },
      {
        question: "What happens if Sydney Airport flights change suddenly?",
        answer: (
          <>
            We track live updates.{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Driver`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Driver
            </Link>{" "}
            adjusts. No extra charges. Seamless pickup maintained.
          </>
        ),
      },
      {
        question:
          "Do you cover all Smithfield addresses, including cul-de-sacs?",
        answer: (
          <>
            Every street is found. Dead ends navigated. Your location reached.
            No confusion.
          </>
        ),
      },
    ],
  },

  "fairfield-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26502.400030663855!2d150.9510356!3d-33.86904475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1297dcd7e39cbd%3A0x5017d681632b6f0!2sFairfield%20NSW%202165%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774722347705!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Fairfield, NSW -  24/7 Local, Airport & Wedding Transport",
    metaDescription:
      "Choose Taxi & Maxi Cabs Services in Fairfield for airport transfers, wedding transport & wheelchair accessible rides. 24/7 service, fixed fares. Call us now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Fairfield for All Travel Needs",
    heroDescription: (
      <>
        Need dependable wheels around Fairfield? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Fairfield promise rapid grabs every time you dial. We run your
        neighbourhood trips with clockwork accuracy that never slips. Our
        vehicles suit lone rangers and massive crews equally. You can pack loads
        of cabin space for bodies and bags together. Not one person gets left
        out or jammed inside. We roll day and night without stopping. Your jet
        might touch down at midnight. Your function could wrap at sunrise.
        Whatever happens, we materialise pronto. Grab our top-shelf choice for
        bonus relaxation. We pull off a slick Fairfield pick up and drop off to
        guard your diary. You sidestep setbacks. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your agenda completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Fairfield NSW",
    locationSectionTitle: "Reliable Taxi Service in Fairfield for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere flash? Our Fairfield Taxi Service fits
        tiny and bulky groups spot on. The whole lot shares one wagon. You miss
        the headache of fracturing into different motors. You wipe out tricky
        planning efforts. Through our devoted
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Fairfield,
        </Link>
        every punter scores guarded, cushy passage. Maybe you blast out of
        Fairfield toward Sydney Airport. Maybe you drag home after marathon
        journeys. We honour our word on clocks. Our captains know clever back
        routes. They steer around bottlenecks. They shrink delays fast. You can
        bank on our Group Transport Fairfield selections when wanting stretch,
        faithfulness, and sparkling cabins. Locking in rides takes ticks via our
        web hub. You snag proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Fairfield with Maxi Cabs: Fast Local & Long Distance Ride",
    locationSection2Desctiption: (
      <>
        We reckon that low cost ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Fairfield shows honest fares with zero secrets tucked away. You
        eyeball costs upfront. You map your spending with poise. This proves
        handy when trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        taking stacks of riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may holler for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your ankle-biters ride in ticked-off, locked-down harnesses. Our
        steerers bring know-how and manners. They back particular needs. They
        heft your suitcases. From crack-of-dawn flights to late returns, our
        24/7 Taxi Fairfield keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Fairfield",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Fairfield
        </Link>{" "}
        hands you a sprawling stretch room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Fairfield lets your mob focus on the
        voyage. We zero in on batch transfers for clans, footy squads, and
        office units. The full gang lands united. Grabbing wheels happens
        swiftly through our Fairfield Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with little ones. When poshness counts, our silver
        service dishes extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Fairfield Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find pro transport made for Fairfield locals and visitors. Our full
        range of services gives just what you need, whether you're catching a
        dawn flight or sorting
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for heaps of guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Fairfield
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting eleven people,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        picks with safe clips, and Local Taxi Service for daily jobs. Business
        pros use our Corporate Taxi Service, while luxury hunters pick our
        Premium Service. We do Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for big crowds, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        help. Every trip has clear upfront costs, real 24/7 service, and smart
        local drivers who know Fairfield well. From Door-to-Door Taxi Service to
        tricky plans, Campbelltown Taxi & Maxi Cabs blends deep local know-how
        with steady reliability—because your destination matters, and getting
        there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Fairfield for Every Occasion",
    serviceSubtitle: (
      <>
        We shape transport to match your exact needs. Our Taxi & Maxi Cabs
        Services in Fairfield help family breaks, group trips, and work travel.{" "}
        <Link
          to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
          target="_blank"
        >
          Safety
        </Link>{" "}
        and being on time guide all we do. Every car looks good. Every driver
        trains well. You count on us for airport runs, special days, and
        business trips. Each ride stays simple and calm.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Fairfield",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Fairfield
        </Link>
        makes every trip simple and accountable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, ideal for corporate
        travellers and authorised riders. Enjoy cashless processing, clear trip
        records, and smooth billing with every ride. Reliable transport backed
        by trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in big cars. Bridal parties, family, and friends enjoy nice,
            comfy trips to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury choice for VIP moves, boss travel, and guests
            wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with safe child seats. Young ones stay secure all
            the way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group work trips. On-time pickups help busy
            days.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth trips between Fairfield and cruise docks. Big space
            fits people and bags together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for shows, parties, and social events. Get there on
            time. Skip parking stress.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Great for bigger groups in Fairfield. Lots of seats and bag space
            keep all together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-run moves from Fairfield to Sydney Airport or work spots.
            Your team travels with no stress.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady 24/7 choice across Fairfield for daily trips, bookings, and
            fun out.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Fairfield Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from mixed cars to match your group size and comfort needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        puts safety, space, and soft rides first. Solo riders find good fits.
        Full groups get the right choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Good for lone riders or pairs wanting quiet, soft trips with our
            steady Door-to-Door Taxi Service all through Fairfield.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who like privacy, soft leather
            seats, and sharp looks on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More room for people and bags. Top choice for families or small
            groups heading to Sydney Airport in comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers nicely. Big bag space suits group moves, family
            holidays, and long hauls.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for larger groups or big families wanting spacious, clean
            interiors and a totally chilled travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Delivers accessible transport with fully trained drivers and proper
            safety gear for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Fairfield",
    faqs: [
      {
        question: "How do I reach Sydney Airport from the industrial area?",
        answer: (
          <>
            Our Airport Transfers in Fairfield navigate the Warringah Mall
            bypass efficiently. We pick up from factories and warehouses.
            Typically 35 minutes to domestic terminals.
          </>
        ),
      },
      {
        question: "Can your maxi cabs transport my trade tools and materials?",
        answer: (
          <>
            Our{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            Cab Services in Fairfield accommodate bulky equipment. Utes and
            wagons available. We service tradespeople across the Northern
            Beaches daily.
          </>
        ),
      },
      {
        question: "Do you operate during Warringah Mall trading hours?",
        answer: (
          <>
            Yes. Our 24/7 Taxi Fairfield runs constantly. We know loading dock
            locations and pickup zones. Shop without parking stress.
          </>
        ),
      },
      {
        question: "What's the best way to transport my team to a conference?",
        answer: (
          <>
            Our Corporate Taxi Service coordinates multiple Maxi Cab for Group
            Travel vehicles. We manage business teams to CBD meetings and
            airport departures seamlessly.
          </>
        ),
      },
      {
        question: "Can I book wheelchair transport for medical appointments?",
        answer: (
          <>
            Absolutely. Our Wheelchair Accessible Taxi in Fairfield provides
            dignified, reliable healthcare transport. We accommodate mobility
            scooters and walking frames with care.
          </>
        ),
      },
      {
        question: "How do I organize transport for my child's sports team?",
        answer: (
          <>
            Our Group Transport Fairfield safely conveys junior teams to away
            games. Parents receive driver details. We ensure punctual, secure
            travel for young athletes.
          </>
        ),
      },
      {
        question: "What happens if my flight is delayed?",
        answer: (
          <>
            We track arrivals live. Your Emergency Taxi in Fairfield waits
            without extra charges for reasonable delays. Call us if plans change
            significantly.
          </>
        ),
      },
      {
        question: "Do you offer account facilities for local businesses?",
        answer: (
          <>
            Yes. Our Corporate Taxi Service provides Fairfield enterprises with
            monthly billing and priority access. Simplify your company travel
            management.
          </>
        ),
      },
      {
        question: "Can I transport my motorcycle to the mechanic?",
        answer: (
          <>
            Our specialized vehicles accommodate bikes securely. Mention
            transport needs when using Fairfield Cab. We handle delicate cargo
            with expertise.
          </>
        ),
      },
      {
        question: "Why trust local taxis in an industrial zone?",
        answer: (
          <>
            We know Fairfield's factory addresses, loading restrictions, and
            business hours. Apps often cancel industrial pickups. We show
            up—guaranteed.
          </>
        ),
      },
    ],
  },
  "cabramatta-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26502.400030663855!2d150.9510356!3d-33.86904475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12960bccf8fc39%3A0x5017d681632aee0!2sCabramatta%20NSW%202166%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774722770732!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Cabramatta, NSW -  24/7 Local, Airport & Wedding Transport",
    metaDescription:
      "Choose Taxi & Maxi Cabs Services in Cabramatta for airport transfers, wedding transport & wheelchair accessible rides. 24/7 service, fixed fares. Call us now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Cabramatta for All Travel Needs",
    heroDescription: (
      <>
        Need dependable wheels around Cabramatta? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Cabramatta promise rapid grabs every time you dial. We run your
        neighbourhood trips with clockwork accuracy that never slips. Our
        vehicles suit lone rangers and massive crews equally. You can pack loads
        of cabin space for bodies and bags together. Not one person gets left
        out or jammed inside. We roll day and night without stopping. Your jet
        might touch down at midnight. Your function could wrap at sunrise.
        Whatever happens, we materialise pronto. Grab our top-shelf choice for
        bonus relaxation. We pull off a slick Cabramatta pick up and drop off to
        guard your diary. You sidestep setbacks. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your agenda completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Cabramatta NSW",
    locationSectionTitle: "Reliable Taxi Service in Cabramatta for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere flash? Our Cabramatta Taxi Service fits
        tiny and bulky groups spot on. The whole lot shares one wagon. You miss
        the headache of fracturing into different motors. You wipe out tricky
        planning efforts. Through our devoted
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Cabramatta,
        </Link>
        every punter scores guarded, cushy passage. Maybe you blast out of
        Cabramatta toward Sydney Airport. Maybe you drag home after marathon
        journeys. We honour our word on clocks. Our captains know clever back
        routes. They steer around bottlenecks. They shrink delays fast. You can
        bank on our Group Transport Cabramatta selections when wanting stretch,
        faithfulness, and sparkling cabins. Locking in rides takes ticks via our
        web hub. You snag proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Cabramatta with Maxi Cabs: Fast Local & Long Distance Ride",
    locationSection2Desctiption: (
      <>
        We reckon that low cost ought never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Cabramatta shows honest fares with zero secrets tucked away. You
        eyeball costs upfront. You map your spending with poise. This proves
        handy when trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        taking stacks of riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may holler for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your ankle-biters ride in ticked-off, locked-down harnesses. Our
        steerers bring know-how and manners. They back particular needs. They
        heft your suitcases. From crack-of-dawn flights to late returns, our
        24/7 Taxi Cabramatta keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Cabramatta",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Cabramatta
        </Link>{" "}
        hands you a sprawling stretch room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck compressed seating.
        You dodge messy bag Tetris. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Cabramatta lets your mob focus on the
        voyage. We zero in on batch transfers for clans, footy squads, and
        office units. The full gang lands united. Grabbing wheels happens
        swiftly through our Cabramatta Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with little ones. When poshness counts, our silver
        service dishes extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, shielded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Cabramatta Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find pro transport made for Cabramatta locals and visitors. Our full
        range of services gives just what you need, whether you're catching a
        dawn flight or sorting
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for heaps of guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Cabramatta
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting eleven people,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        picks with safe clips, and Local Taxi Service for daily jobs. Business
        pros use our Corporate Taxi Service, while luxury hunters pick our
        Premium Service. We do Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for big crowds, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        help. Every trip has clear upfront costs, real 24/7 service, and smart
        local drivers who know Cabramatta well. From Door-to-Door Taxi Service
        to tricky plans, Campbelltown Taxi & Maxi Cabs blends deep local
        know-how with steady reliability—because your destination matters, and
        getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Cabramatta for Every Occasion",
    serviceSubtitle: (
      <>
        We shape transport to match your exact needs. Our Taxi & Maxi Cabs
        Services in Cabramatta help family breaks, group trips, and work travel.{" "}
        <Link
          to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
          target="_blank"
        >
          Safety
        </Link>{" "}
        and being on time guide all we do. Every car looks good. Every driver
        trains well. You count on us for airport runs, special days, and
        business trips. Each ride stays simple and calm.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Cabramatta",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal travel? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Cabramatta
        </Link>
        makes every trip simple and accountable. We accept secure CabCharge
        Payments, including the convenient CabCharge Card, ideal for corporate
        travellers and authorised riders. Enjoy cashless processing, clear trip
        records, and smooth billing with every ride. Reliable transport backed
        by trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Ride in big cars. Bridal parties, family, and friends enjoy nice,
            comfy trips to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury choice for VIP moves, boss travel, and guests
            wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with safe child seats. Young ones stay secure all
            the way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group work trips. On-time pickups help busy
            days.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth trips between Cabramatta and cruise docks. Big space
            fits people and bags together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for shows, parties, and social events. Get there on
            time. Skip parking stress.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Great for bigger groups in Cabramatta. Lots of seats and bag space
            keep all together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-run moves from Cabramatta to Sydney Airport or work
            spots. Your team travels with no stress.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady 24/7 choice across Cabramatta for daily trips, bookings, and
            fun out.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Cabramatta Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from mixed cars to match your group size and comfort needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        puts safety, space, and soft rides first. Solo riders find good fits.
        Full groups get the right choices too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Good for lone riders or pairs wanting quiet, soft trips with our
            steady Door-to-Door Taxi Service all through Cabramatta.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who like privacy, soft leather
            seats, and sharp looks on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            More room for people and bags. Top choice for families or small
            groups heading to Sydney Airport in comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers nicely. Big bag space suits group moves, family
            holidays, and long hauls.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for larger groups or big families wanting spacious, clean
            interiors and a totally chilled travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Delivers accessible transport with fully trained drivers and proper
            safety gear for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Cabramatta",
    faqs: [
      {
        question: "How do I reach Sydney Airport from the industrial area?",
        answer: (
          <>
            Our Airport Transfers in Cabramatta navigate the Warringah Mall
            bypass efficiently. We pick up from factories and warehouses.
            Typically 35 minutes to domestic terminals.
          </>
        ),
      },
      {
        question: "Can your maxi cabs transport my trade tools and materials?",
        answer: (
          <>
            Our{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            Cab Services in Cabramatta accommodate bulky equipment. Utes and
            wagons available. We service tradespeople across the Northern
            Beaches daily.
          </>
        ),
      },
      {
        question: "Do you operate during Warringah Mall trading hours?",
        answer: (
          <>
            Yes. Our 24/7 Taxi Cabramatta runs constantly. We know loading dock
            locations and pickup zones. Shop without parking stress.
          </>
        ),
      },
      {
        question: "What's the best way to transport my team to a conference?",
        answer: (
          <>
            Our Corporate Taxi Service coordinates multiple Maxi Cab for Group
            Travel vehicles. We manage business teams to CBD meetings and
            airport departures seamlessly.
          </>
        ),
      },
      {
        question: "Can I book wheelchair transport for medical appointments?",
        answer: (
          <>
            Absolutely. Our Wheelchair Accessible Taxi in Cabramatta provides
            dignified, reliable healthcare transport. We accommodate mobility
            scooters and walking frames with care.
          </>
        ),
      },
      {
        question: "How do I organize transport for my child's sports team?",
        answer: (
          <>
            Our Group Transport Cabramatta safely conveys junior teams to away
            games. Parents receive driver details. We ensure punctual, secure
            travel for young athletes.
          </>
        ),
      },
      {
        question: "What happens if my flight is delayed?",
        answer: (
          <>
            We track arrivals live. Your Emergency Taxi in Cabramatta waits
            without extra charges for reasonable delays. Call us if plans change
            significantly.
          </>
        ),
      },
      {
        question: "Do you offer account facilities for local businesses?",
        answer: (
          <>
            Yes. Our Corporate Taxi Service provides Cabramatta enterprises with
            monthly billing and priority access. Simplify your company travel
            management.
          </>
        ),
      },
      {
        question: "Can I transport my motorcycle to the mechanic?",
        answer: (
          <>
            Our specialized vehicles accommodate bikes securely. Mention
            transport needs when using Cabramatta Cab. We handle delicate cargo
            with expertise.
          </>
        ),
      },
      {
        question: "Why trust local taxis in an industrial zone?",
        answer: (
          <>
            We know Cabramatta's factory addresses, loading restrictions, and
            business hours. Apps often cancel industrial pickups. We show
            up—guaranteed.
          </>
        ),
      },
    ],
  },
  "canley-vale-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26493.319434305286!2d150.93596875!3d-33.898282399999985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b1296192dfa0f67%3A0x5017d681632af90!2sCanley%20Vale%20NSW%202166%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774723400616!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Canley Vale, NSW - 24/7 Corporate, Group Rides & Local",
    metaDescription:
      "Reliable Taxi & Maxi Cabs Services in Canley Vale for corporate taxi, group travel & baby seat bookings. Fixed prices, on-time pickups & local expert drivers. Book today!",
    heroTitle: "24/7 Taxi & Maxi Cabs Services in Canley Vale for Every Need",
    heroDescription: (
      <>
        Hunting for solid wheels around Canley Vale? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Canley Vale pledge lightning-fast grabs each time you dial. We run
        your neighbourhood jaunts with razor-sharp timing that never slips. Our
        motors fit lone voyagers and massive packs equally. You cop heaps of
        cabin space for bodies and bags combined. Not one soul gets stranded or
        crammed inside. We roll day and night without stopping. Your aircraft
        might touch down at 3 AM. Your shift could wrap at sunrise. Whatever
        happens, we materialise pronto. Grab our top-tier choice for bonus
        relaxation. We pull off slick Canley Vale pick up and drop off to guard
        your diary. You sidestep setbacks. You shed worry.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        champions your agenda completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Canley Vale NSW",
    locationSectionTitle: "Reliable Taxi Service in Canley Vale for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere good? Our Canley Vale Taxi Service fits
        tight and large crowds spot on. The whole bunch shares one wagon. You
        miss the nightmare of breaking into separate convoys. You kill messy
        planning attempts. Through our committed
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Canley Vale,
        </Link>
        every punter scores a protected, cushy passage. Maybe you blast out of
        Canley Vale toward Sydney Airport. Maybe you drag home after marathon
        journeys. We honour our word on clocks. Our pilots know clever back
        routes. They steer around bottlenecks. They shrink delays fast. You can
        bank on our Group Transport Canley Vale picks when wanting stretch,
        faithfulness, and sparkling cabins. Locking in rides takes ticks via our
        web hub. You snag proof instantly. You cruise with certainty.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Canley Vale with Maxi Cabs: Fast Local & Long Distance Ride",
    locationSection2Desctiption: (
      <>
        We reckon that budget must never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Canley Vale shows honest fares with nothing hidden. You eyeball costs
        upfront. You map your spending with poise. This proves handy when
        trekking with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>
        , taking stacks of riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your littlies travel in ticked-off, locked-down harnesses. Our
        steerers bring know-how and manners. They back particular needs. They
        heft your suitcases. From crack-of-dawn flights to late returns, our
        24/7 Taxi Canley Vale keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Canley Vale",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Canley Vale
        </Link>{" "}
        offers you a sprawling stretch of room. You claim mountains of stowage
        volume. You unwind despite chockers cabins. You duck squashed seating.
        You dodge tricky bag Jenga. Your trek grows enjoyable. Snapping up our
        Taxi & Maxi Cabs Services in Canley Vale lets your mob focus on the
        voyage. We zero in on batch transfers for clans, surf clubs, and office
        squads. The full gang lands united. Grabbing wheels happens swiftly
        through our Canley Vale Cab Booking portal. You sort the movement
        beforehand. Corporate nomads can tap our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for sharp, slick dashes to powwows. Mobs attach Baby Seat Taxi choices
        for protected jaunts with ankle-biters. When poshness counts, our silver
        service dishes extra cushiness. Every rig gets detailed routinely. We
        enforce tough benchmarks. You relish fluid, guarded transit minus
        snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Canley Vale Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro mobility crafted squarely for Canley Vale locals and
        blow-ins. Our broad spread hands you precisely what you crave, whether
        snagging red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding fleets
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Canley Vale
        </Link>{" "}
        flaunting live plane tracking, Maxi Cab Services accommodating eleven
        occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and Local Taxi Service for daily missions.
        Trade heavyweights lean on our Corporate Taxi Service, while refinement
        chasers dig our Premium Service. We master Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Canley Vale like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Canley Vale for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Canley Vale back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Canley Vale",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Canley Vale
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth hops between Canley Vale and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for heftier crowds in Canley Vale. Ample perch and baggage
            capacity keep tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Canley Vale to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Steady round-the-clock option across Canley Vale for routine runs,
            appointments, and leisure strolls.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis hits? Our Emergency Taxi in Canley Vale reacts instantly. We
            spotlight your protection and velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Canley Vale Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        highlights{" "}
        <Link
          to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
          className="underline font-semibold px-1"
          target="_blank"
        >
          safety,
        </Link>
        stretch, and butter-smooth cruising. Lone trekkers find ideal matches.
        Complete posses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door{" "}
            <Link
              to={`https://www.nhtsa.gov/ten-tips-for-safe-driving`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Taxi
            </Link>{" "}
            Service throughout Canley Vale.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Canley Vale",
    faqs: [
      {
        question:
          "How do I get from Canley Vale to Sydney Airport early in the morning?",
        answer: (
          <>
            Book ahead. We track flights live. Pickup adjusts for delays. You
            relax. We handle timing.
          </>
        ),
      },
      {
        question: "Can your taxis carry surfboards from Canley Vale beaches?",
        answer: (
          <>
            Yes. Maxi cabs swallow long boards. Manly, Curl Curl, Freshwater
            trips. Surf gear fits easily.
          </>
        ),
      },
      {
        question: "Do you know shortcuts around Pittwater Road traffic?",
        answer: (
          <>
            Absolutely. Canley Vale locals. Back streets mapped. Gridlock
            avoided. You get clever route planners.
          </>
        ),
      },
      {
        question: "What if my Canley Vale flight lands at midnight?",
        answer: (
          <>
            We operate 24/7. Night arrivals welcome. The driver waits with a
            sign. Safe journey home guaranteed.
          </>
        ),
      },
      {
        question: "Can I book a taxi for Canley Vale RSL club trips?",
        answer: (
          <>
            Yes. Regular club runs. Social events covered. Safe ride home. No
            parking worries.
          </>
        ),
      },
      {
        question:
          "How do I arrange a maxi cab for Canley Vale shopping centres?",
        answer: (
          <>
            Ring 1300 450 428. Mention bulky items. We bring the right wagon.
            IKEA, Warringah Mall sorted.
          </>
        ),
      },
      {
        question:
          "Are your Canley Vale drivers familiar with Brookvale and Narraweena?",
        answer: (
          <>
            Northern Beaches born and bred. Every suburb is known. Shortcuts
            found. You get local experts.
          </>
        ),
      },
      {
        question: "Can I request a baby seat for Canley Vale childcare runs?",
        answer: (
          <>
            Mention age when booking. Correct restraint fitted. Safety checked.
            Your child is protected.
          </>
        ),
      },
      {
        question: "Do you offer set prices for Canley Vale corporate travel?",
        answer: (
          <>
            Business accounts available. Fixed rates. Monthly billing. Expense
            reports simplified. Professional service.
          </>
        ),
      },
      {
        question: "What makes you better than Uber in Canley Vale?",
        answer: (
          <>
            Phone bookings. No surge pricing. Local knowledge. Personal service.
            We know your area.
          </>
        ),
      },
      {
        question: "Can I get a wheelchair taxi in Canley Vale urgently?",
        answer: (
          <>
            Call and state needs. Proper vehicle sent. Skippers assist with
            boarding. Dignity is maintained always.
          </>
        ),
      },
      {
        question: "Do you service Canley Vale lagoon and beachfront addresses?",
        answer: (
          <>
            Yes. All locations found. Narrow streets navigated. Your pickup
            happens without confusion.
          </>
        ),
      },
      {
        question: "How early should I book wedding cars for Canley Vale?",
        answer: (
          <>
            Secure months ahead. Spring weddings busy. Multiple vehicles
            coordinated. Your day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay cash for Canley Vale airport trips?",
        answer: (
          <>
            Cash welcome. Cards accepted. CabCharge available. Corporate
            accounts, too. Flexible options.
          </>
        ),
      },
      {
        question: "What happens if I cancel my Canley Vale booking?",
        answer: (
          <>
            Call us ASAP. Fair policy applies. No charge for notice. We
            understand plans shift.
          </>
        ),
      },
    ],
  },

  "bonnyrigg-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26497.45956105009!2d150.95045914999997!3d-33.88495479999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12942142bec6e9%3A0x5017d681632adb0!2sBonnyrigg%20NSW%202177%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774723488516!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Bonnyrigg, NSW - 24/7 Airport & Group",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Bonnyrigg for airport transfers, wheelchair accessible rides & emergency taxi. Fixed fares, local drivers, always on time. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Bonnyrigg for Safe, Reliable Rides",
    heroDescription: (
      <>
        After solid transport around Bonnyrigg? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Bonnyrigg promise a rapid pickup every time you call. We handle your
        local runs with clockwork precision that never fails. Our vehicles suit
        lone commuters and big crowds equally well. You get heaps of cabin space
        for riders and luggage combined. Nobody gets left out or crammed inside.
        We run day and night without stopping. Your plane might touch down at
        midnight. Your function could end at daybreak. Either way, we show up
        fast. Choose our top-tier option for extra comfort. We manage smooth
        Bonnyrigg pick up and drop off to keep your diary on track. You dodge
        delays. You drop the stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        backs your schedule completely.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Bonnyrigg NSW",
    locationSectionTitle: "Reliable Taxi Service in Bonnyrigg for Groups",
    locationSectionDescription: (
      <>
        Shifting kin or mates somewhere good? Our{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Bonnyrigg Taxi Service
        </Link>{" "}
        fits tight and large groups perfectly. The whole crew shares one car.
        You skip the nightmare of breaking into separate vehicles. You kill
        messy planning efforts. Through our committed
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Bonnyrigg,
        </Link>
        every passenger scores safe, cushy travel. Maybe you head from Bonnyrigg
        toward Sydney Airport. Maybe you trek home after long hauls. We keep our
        word on timing. Our operators know clever back streets. They steer
        around bottlenecks. They shrink wait times. You can bank on our Group
        Transport Bonnyrigg picks when wanting stretch, trust, and spotless
        interiors. Locking in rides takes moments via our web hub. You snag
        proof straight away. You cruise with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Bonnyrigg with Maxi Cabs for Everyone",
    locationSection2Desctiption: (
      <>
        We reckon that budget must never mean nasty. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Bonnyrigg shows honest fares with nothing hidden. You see costs
        upfront. You sort your spending with assurance. This proves handy when
        moving with others. You can secure a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>
        , taking multiple riders plus loads. Fancy something classier? Level up
        to our silver service for polished motoring. Tribes may shout for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        extras. Your little ones travel in ticked-off, locked-down harnesses.
        Our wheelmen bring know-how and manners. They back special requests.
        They heft your bags. From crack-of-dawn flights to late returns, our
        24/7 Taxi Bonnyrigg keeps you rolling. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        vows secure, steady, zero-stress hauling for every client.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Bonnyrigg",
    locationSection3Description: (
      <>
        Our Taxi Service in Bonnyrigg offers you a sprawling stretch of room.
        You claim mountains of stowage volume. You unwind despite packed cabins.
        You duck squashed seating. You miss tricky bag stacking. Your trip turns
        enjoyable. Grabbing our Taxi & Maxi Cabs Services in Bonnyrigg lets your
        mob focus on the voyage. We zero in on batch transfers for households,
        sporting clubs, and office squads. The whole gang lands together.
        Snaring wheels happens swiftly through our Bonnyrigg Cab Booking portal.
        You arrange movement beforehand. Corporate nomads can tap our Corporate
        Taxi Service for sharp, slick runs to powwows. Mobs attach Baby Seat
        Taxi choices for protected trips with bubs. When elegance counts, our
        silver service dishes extra cushiness. Every rig gets detailed
        routinely. We enforce tough benchmarks. You relish fluid, guarded
        transit minus snarl-ups.
      </>
    ),
    locationSection4Title:
      "Reliable Bonnyrigg Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Uncover pro mobility crafted squarely for Bonnyrigg locals and blow-ins.
        Our broad spread hands you precisely what you crave, whether snagging
        red-eye flights or masterminding
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding fleets
        </Link>{" "}
        for heaps of guests. We dish up
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Bonnyrigg
        </Link>{" "}
        flaunting live plane tracking, Maxi Cab Services accommodating eleven
        occupants,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        styles with approved straps, and Local Taxi Service for daily missions.
        Trade heavyweights lean on our Corporate Taxi Service, while refinement
        chasers dig our Premium Service. We master Wedding Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        <Link
          to={`/services/cruise-terminal-transfer`}
          className="underline font-semibold px-1"
        >
          Cruise Transfers,
        </Link>{" "}
        Group Transport for hefty mobs, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        setups. Each haul packs clear upfront tags, genuine round-the-clock
        cover, and seasoned regional operators who read Bonnyrigg like a book.
        From Door-to-Door Taxi Service to tangled logistics, Campbelltown Taxi &
        Maxi Cabs merges deep turf smarts with rock-steady consistency—because
        your finish line counts, and arriving there should feel like floating.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions Bonnyrigg for Every Occasion",
    serviceSubtitle: (
      <>
        We mould transport to fit your exact brief. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Bonnyrigg back clan getaways, mob adventures, and corporate travel.
        Protection and promptness pilot our operation. Every wagon looks
        schmick. Every skipper trains hard. You count on us for terminal
        sprints, landmark parties, and work jaunts. Every haul stays
        uncomplicated and mellow.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Bonnyrigg",
    cabChargeSectionDesctiption: (
      <>
        Require bendy billing for job or private treks? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Bonnyrigg
        </Link>
        renders every journey plain and traceable. We accept shielded CabCharge
        Payments, including the nifty CabCharge Card, ace for company trekkers
        and authorised spenders. Dig cashless dealing, neat trip logs, and
        painless billing each run. Faithful hauling backed by proven Cabcharge
        payment smarts.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Float in expansive motors. Bridal gangs, relatives, and guests score
            stylish, cushy lifts toward and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Snag our high-end pick for VIP shuttles, exec travel, and punters
            expecting top-shelf privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Households book rides with ticked-off kiddie harnesses. Small fry
            stay buckled safe the whole way.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Created for boardrooms and batch corporate movement. On-time
            collections back frantic schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy smooth hops between Bonnyrigg and cruise wharves. Generous
            volume handles passengers and luggage jointly.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Tap our service for concerts, shindigs, and social bashes. Arrive
            bang on time. Skip parking nightmares.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Perfect for heftier crowds in Bonnyrigg. Ample perch and baggage
            capacity keep tribes together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Protected, slickly managed transfers from Bonnyrigg to Sydney
            Airport or corporate sites. Your crew commutes relaxed.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Crisis hits? Our{" "}
            <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
              Emergency Taxi
            </Link>{" "}
            in Bonnyrigg reacts instantly. We spotlight your protection and
            velocity.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Bonnyrigg Transfer",
    fleetSectionSubTitle: (
      <>
        Pick from mixed motors matching your party dimensions and snug
        requirements.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        highlights safety, stretch, and butter-smooth cruising. Lone trekkers
        find ideal matches. Complete possesses land suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Spot-on for solo operators or pairs wanting peaceful, cushy jaunts
            with our reliable Door-to-Door Taxi Service throughout Bonnyrigg.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Cracker for high-flyers and business guests who prize seclusion,
            premium hide seating, and polished presentation on every jaunt.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra territory for trekkers and suitcases. Solid choice for clans
            or compact packs heading to Sydney Airport with ease.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Houses 6–7 trekkers comfortably. Hefty baggage holds suits batch
            transfers, clan holidays, and extended journeys.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for heftier gatherings or sprawling clans wanting expansive,
            fresh interiors and a totally chilled travel experience.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Supplies accessible hauling with expertly drilled skippers and a
            proper safety kit for all mobility needs and snugness.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Bonnyrigg",
    faqs: [
      {
        question: "How do I book a taxi from Bonnyrigg to Sydney Airport?",
        answer: (
          <>
            Ring 1300 450 428 or book online. Tell us your flight time. We track
            delays. Pickup adjusts automatically.
          </>
        ),
      },
      {
        question: "Can I get a maxi cab for Bonnyrigg shopping trips?",
        answer: (
          <>
            Yes. We haul bulky purchases. IKEA, homemaker centres, no problem.
            Maxi cabs swallow big loads easily.
          </>
        ),
      },
      {
        question:
          "Do your Bonnyrigg drivers know Bowral and the surrounding towns?",
        answer: (
          <>
            Absolutely. We know the Southern Highlands intimately. Bowral, Moss
            Vale, Berrima. Regional{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Road_trip`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              travel
            </Link>{" "}
            sorted.
          </>
        ),
      },
      {
        question: "What if my train arrives late at Bonnyrigg station?",
        answer: (
          <>
            We monitor train schedules. Your driver waits. No extra charge for
            delays. Connection guaranteed.
          </>
        ),
      },
      {
        question: "Can I book a taxi for Bonnyrigg hospital visits?",
        answer: (
          <>
            Regular medical trips welcome. We know local hospitals. Patient
            transport handled with care. Book recurring rides.
          </>
        ),
      },
      {
        question: "Do you offer set prices for Bonnyrigg to Canberra trips?",
        answer: (
          <>
            Fixed rates available. Know the cost upfront. No meter anxiety.
            Business travel simplified.
          </>
        ),
      },
      {
        question: "How do I request a wheelchair taxi in Bonnyrigg?",
        answer: (
          <>
            Mention mobility needs when booking. We send a proper{" "}
            <Link
              to={`https://www.pointtopoint.nsw.gov.au/what-a-service-provider/taxi-service-providers`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              vehicle.
            </Link>
            Drivers assist with boarding. Comfort assured.
          </>
        ),
      },
      {
        question: "Are your Bonnyrigg taxis pet-friendly?",
        answer: (
          <>
            Small pets in carriers are accepted. Service animals are always
            welcome. Mention when booking. We prepare space.
          </>
        ),
      },
      {
        question: "Can I split fares between multiple passengers?",
        answer: (
          <>
            One person pays initially. You sort splits privately. We keep
            billing simple. Groups are managed easily.
          </>
        ),
      },
      {
        question: "What makes your Bonnyrigg service different from rideshare?",
        answer: (
          <>
            Professional drivers. Local knowledge. Phone bookings accepted. No
            surge pricing. Personal service guaranteed.
          </>
        ),
      },
      {
        question: "Do you provide taxis for Bonnyrigg school runs?",
        answer: (
          <>
            Yes. Regular student transport is available. Baby seats fitted.
            Safety priority. Parents trust us.
          </>
        ),
      },
      {
        question: "How early should I book for Bonnyrigg wedding transport?",
        answer: (
          <>
            Book months ahead for peak seasons. We coordinate multiple vehicles.
            Your big day is covered.
          </>
        ),
      },
      {
        question: "Can I get a receipt for tax purposes?",
        answer: (
          <>
            Instant email receipts sent. ATO compliant. Business claims are
            easy. Records are organised automatically.
          </>
        ),
      },
      {
        question: "Do you service Bonnyrigg on Christmas Day?",
        answer: (
          <>
            We operate 365 days. Public holidays included. Same rates apply.
            Festive travel sorted.
          </>
        ),
      },
      {
        question: "What happens if I leave belongings in the taxi?",
        answer: (
          <>
            Call us immediately. We trace the vehicle fast. Lost property
            returned promptly. Your items matter.
          </>
        ),
      },
    ],
  },
  "edensor-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13249.66362626739!2d150.87752469999992!3d-33.87894094999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12915f7e5e3031%3A0x5017d681632b5e0!2sEdensor%20Park%20NSW%202176%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774723647956!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Edensor Park, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Edensor Park for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Edensor Park for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Edensor Park? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Edensor Park deliver quick pickups every time you call. We handle
        your local trips with sharp timing that never fails. Our vehicles fit
        single travellers and large groups equally well. You get plenty of cabin
        space for people and luggage together. No one gets left out or squeezed
        inside. We run day and night without stopping. Your flight might land at
        2 AM. Your shift could end at sunrise. Either way, we show up fast.
        Choose our luxury option for extra comfort. We manage smooth Edensor
        Park pick up and drop off to keep your schedule on track. You avoid
        delays. You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Edensor Park NSW",
    locationSectionTitle: "Reliable Taxi Service in Edensor Park for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Edensor Park Taxi Service
        suits small and large groups perfectly. Everyone travels together in one
        car. You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Edensor Park,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Edensor
        Park for Sydney Airport. Maybe you head home after long trips. We keep
        our promises on timing. Our drivers know the best routes. They avoid
        traffic jams. They cut the waiting time. You can trust our Group
        Transport Curl Curl options when you need space, reliability, and clean
        cars. Booking takes seconds through our online system. You get
        confirmation quickly. You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Edensor Park with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Edensor Park offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade
        to our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Edensor Park keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Edensor Park",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Edensor Park
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Edensor Park lets your group focus on the journey. We
        specialise in group transfers for families, sports teams, and work
        groups. Everyone arrives together. Booking is fast through our Edensor
        Park Cab Booking page. You arrange transport early. Business travellers
        can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly.
        We keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Edensor Park Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Edensor Park residents and
        visitors. Our full range gives you exactly what you need, whether
        catching early flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Edensor Park
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Edensor Park well.
        From Door-to-Door Taxi Service to complex plans, Campbelltown Taxi &
        Maxi Cabs combines deep local knowledge with steady reliability—because
        your destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle:
      "Taxi and Maxi Cab Solutions, Edensor Park for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Edensor Park support family holidays, group outings, and business
        travel. Safety and punctuality guide everything we do. Every vehicle
        looks neat. Every driver trains well. You depend on us for airport
        trips, special events, and work journeys. Each ride stays simple and
        relaxed.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Edensor Park",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Edensor Park
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests
            enjoy nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Edensor Park and cruise terminals. Plenty
            of space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Edensor Park. Roomy seating and luggage
            space keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Edensor Park to Sydney Airport
            or business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Edensor Park for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Edensor Park responds fast. We
            put your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Edensor Park Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable
            trips with our reliable Door-to-Door Taxi Service throughout Edensor
            Park.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality
            leather seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Edensor Park",
    faqs: [
      {
        question: "Which coastal spots near Edensor Park do you cover?",
        answer: (
          <>
            We service Edensor Park Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport from Edensor Park to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Edensor Park surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question:
          "What if I need a taxi for the Edensor Park dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question:
          "Can I ask for the same driver for regular Edensor Park trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question:
          "How do I organise wheelchair transport to Edensor Park Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Edensor Park taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question:
          "Can I set up account billing for Edensor Park business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Edensor Park?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Edensor Park to Edensor Park direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question:
          "How early should I book wedding cars for Edensor Park ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question:
          "Can I pay with CabCharge for Edensor Park airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question:
          "Do you service all Edensor Park streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
  "bossley-park-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13252.261433221578!2d150.8839509!3d-33.86220644999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12914506fe2a77%3A0x5017d681632add0!2sBossley%20Park%20NSW%202176%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774723839130!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Bossley Park, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Bossley Park for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Bossley Park for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Bossley Park? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Bossley Park deliver quick pickups every time you call. We handle
        your local trips with sharp timing that never fails. Our vehicles fit
        single travellers and large groups equally well. You get plenty of cabin
        space for people and luggage together. No one gets left out or squeezed
        inside. We run day and night without stopping. Your flight might land at
        2 AM. Your shift could end at sunrise. Either way, we show up fast.
        Choose our luxury option for extra comfort. We manage smooth Bossley
        Park pick up and drop off to keep your schedule on track. You avoid
        delays. You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Bossley Park NSW",
    locationSectionTitle: "Reliable Taxi Service in Bossley Park for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Bossley Park Taxi Service
        suits small and large groups perfectly. Everyone travels together in one
        car. You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Bossley Park,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Bossley
        Park for Sydney Airport. Maybe you head home after long trips. We keep
        our promises on timing. Our drivers know the best routes. They avoid
        traffic jams. They cut the waiting time. You can trust our Group
        Transport Curl Curl options when you need space, reliability, and clean
        cars. Booking takes seconds through our online system. You get
        confirmation quickly. You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Bossley Park with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Bossley Park offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade
        to our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Bossley Park keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Bossley Park",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Bossley Park
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Bossley Park lets your group focus on the journey. We
        specialise in group transfers for families, sports teams, and work
        groups. Everyone arrives together. Booking is fast through our Bossley
        Park Cab Booking page. You arrange transport early. Business travellers
        can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly.
        We keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Bossley Park Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Bossley Park residents and
        visitors. Our full range gives you exactly what you need, whether
        catching early flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Bossley Park
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Bossley Park well.
        From Door-to-Door Taxi Service to complex plans, Campbelltown Taxi &
        Maxi Cabs combines deep local knowledge with steady reliability—because
        your destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle:
      "Taxi and Maxi Cab Solutions, Bossley Park for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Bossley Park support family holidays, group outings, and business
        travel. Safety and punctuality guide everything we do. Every vehicle
        looks neat. Every driver trains well. You depend on us for airport
        trips, special events, and work journeys. Each ride stays simple and
        relaxed.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Bossley Park",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Bossley Park
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests
            enjoy nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Bossley Park and cruise terminals. Plenty
            of space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Bossley Park. Roomy seating and luggage
            space keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Bossley Park to Sydney Airport
            or business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Bossley Park for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Bossley Park responds fast. We
            put your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Bossley Park Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable
            trips with our reliable Door-to-Door Taxi Service throughout Bossley
            Park.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality
            leather seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Bossley Park",
    faqs: [
      {
        question: "Which coastal spots near Bossley Park do you cover?",
        answer: (
          <>
            We service Bossley Park Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question:
          "How do I arrange transport from Bossley Park to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Bossley Park surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question:
          "What if I need a taxi for the Bossley Park dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question:
          "Can I ask for the same driver for regular Bossley Park trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question:
          "How do I organise wheelchair transport to Bossley Park Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Bossley Park taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question:
          "Can I set up account billing for Bossley Park business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Bossley Park?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Bossley Park to Bossley Park direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question:
          "How early should I book wedding cars for Bossley Park ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question:
          "Can I pay with CabCharge for Bossley Park airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question:
          "Do you service all Bossley Park streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
  "abbotsbury-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13252.261433221578!2d150.8839509!3d-33.86220644999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129142a76b5753%3A0x5017d681632aae0!2sAbbotsbury%20NSW%202176%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774723906404!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Abbotsbury, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Abbotsbury for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Abbotsbury for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Abbotsbury? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Abbotsbury deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed
        inside. We run day and night without stopping. Your flight might land at
        2 AM. Your shift could end at sunrise. Either way, we show up fast.
        Choose our luxury option for extra comfort. We manage smooth Abbotsbury
        pick up and drop off to keep your schedule on track. You avoid delays.
        You skip stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Abbotsbury NSW",
    locationSectionTitle: "Reliable Taxi Service in Abbotsbury for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Abbotsbury Taxi Service
        suits small and large groups perfectly. Everyone travels together in one
        car. You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Abbotsbury,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Abbotsbury
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Abbotsbury with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Local Taxi Service
        </Link>
        in Abbotsbury offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade
        to our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Abbotsbury keeps you moving. Campbelltown{" "}
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Abbotsbury",
    locationSection3Description: (
      <>
        Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi Service in Abbotsbury
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Abbotsbury lets your group focus on the journey. We
        specialise in group transfers for families, sports teams, and work
        groups. Everyone arrives together. Booking is fast through our
        Abbotsbury Cab Booking page. You arrange transport early. Business
        travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly.
        We keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Abbotsbury Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Abbotsbury residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Abbotsbury
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Abbotsbury well.
        From Door-to-Door Taxi Service to complex plans, Campbelltown Taxi &
        Maxi Cabs combines deep local knowledge with steady reliability—because
        your destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Abbotsbury for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Abbotsbury support family holidays, group outings, and business
        travel. Safety and punctuality guide everything we do. Every vehicle
        looks neat. Every driver trains well. You depend on us for airport
        trips, special events, and work journeys. Each ride stays simple and
        relaxed.
      </>
    ),

    cabChargeSectionTitle: "CabCharge Taxi Near Abbotsbury",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link to={`/cabcharge-taxi`} className="underline font-semibold px-1">
          CabCharge Taxi Service in Abbotsbury
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),

    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests
            enjoy nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },

      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },

      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },

      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },

      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Abbotsbury and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },

      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },

      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Abbotsbury. Roomy seating and luggage
            space keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },

      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Abbotsbury to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },

      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Abbotsbury for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },

      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Abbotsbury responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },

    fleetSectionTitle: "Premium Fleet for Your Abbotsbury Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),

    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable
            trips with our reliable Door-to-Door Taxi Service throughout
            Abbotsbury.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },

      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality
            leather seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },

      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },

      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },

      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },

      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },

    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Abbotsbury",
    faqs: [
      {
        question: "Which coastal spots near Abbotsbury do you cover?",
        answer: (
          <>
            We service Abbotsbury Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in{" "}
            <Link
              to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
              className="underline font-semibold px-1"
              target="_blank"
            >
              Maxi
            </Link>{" "}
            cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Abbotsbury to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Abbotsbury surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question:
          "What if I need a taxi for the Abbotsbury dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Abbotsbury trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Abbotsbury Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Abbotsbury taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question:
          "Can I set up account billing for Abbotsbury business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Abbotsbury?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Abbotsbury to Abbotsbury direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question:
          "How early should I book wedding cars for Abbotsbury ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Abbotsbury airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question:
          "Do you service all Abbotsbury streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
  ...allLocationsData2,
};
